(function() {
    'use strict';

    angular
        .module('consulatApp', [
            'ngStorage',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'angularMoment',
            'ui-notification',
            'chart.js',
            'signature',
            'tmh.dynamicLocale',
            'ngImgCrop'
            // App

   // 'app.dashboard'

        ])
        .constant('_', window._) // Ajout de la librairie lodash
        .run(run);

        run.$inject = ['stateHandler', 'translationHandler','Notification','$rootScope'];

        function run(stateHandler, translationHandler,Notification,$rootScope) {
            stateHandler.initialize();
            translationHandler.initialize();
            $rootScope.$on('consulatApp.httpError', function(event, err) {
                console.log(err);
                if (err && err.data && err.status !== 500) {
                    if(err.data.message!="Not Found")
                        Notification.error(err.data.message);
                } else if (err.status === 500) {
                    Notification.error("Nous avons rencontré une erreur.");
                }
            });
        }
        angular.module('consulatApp').config(appConfig);

        appConfig.$inject = ['ChartJsProvider'];

        function appConfig(ChartJsProvider) {
            // Configure all charts
            ChartJsProvider.setOptions({
                colors: ['#34A853', '#DCDCDC', '#FBBC05', '#EA4235', '#FDB45C', '#4284F4', '#4D5360']
            });
            Chart.defaults.global.responsive = true;

            Chart.defaults.global.scaleFontFamily = $.urbanApp.font;

            Chart.defaults.global.scaleFontSize = 10;

            Chart.defaults.global.tooltipFillColor = $.urbanApp.primary;

            Chart.defaults.global.tooltipFontFamily = $.urbanApp.font;

            Chart.defaults.global.tooltipFontSize = 12;

            Chart.defaults.global.tooltipTitleFontFamily = $.urbanApp.font;

            Chart.defaults.global.tooltipTitleFontSize = 13;

            Chart.defaults.global.tooltipTitleFontStyle = '700';

            Chart.defaults.global.tooltipCornerRadius = 2;
        }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('vote', {
            parent: 'app',
            url: '/vote/:userPhone/:zone',
            data: {
                authorities: ['ROLE_VOTE','ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/vote/vote.html',
                    controller: 'VoteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
// (function() {
//     'use strict';
//     angular
//         .module('consulatApp')
//         .factory('Vote', Vote);

//     Vote.$inject = ['$resource'];

//     function Poste ($resource) {
//         var resourceUrl =  'api/postes/:id';

//         return $resource(resourceUrl, {}, {
//             'query': { method: 'GET', isArray: true},
//             'get': {
//                 method: 'GET',
//                 transformResponse: function (data) {
//                     if (data) {
//                         data = angular.fromJson(data);
//                     }
//                     return data;
//                 }
//             },
//             'update': { method:'PUT' }
//         });
//     }
// })();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('VoteController', VoteController);

        VoteController.$inject = ['$scope','Consulat','$stateParams','TableService','MemberCandidats','MembersSaveVote','Auth'];

    function VoteController($scope,Consulat,$stateParams,TableService,MemberCandidats,MembersSaveVote,Auth) {

        var vm = this;
        vm.voter = voter;
        console.log($stateParams);
        vm.userZone = $stateParams.zone; 
        vm.userPhone = $stateParams.userPhone; 
        vm.vote = false;
        vm.logout = logout;

       function voter(candidatId)
        {
       
                MembersSaveVote.get({
                    candidatId: candidatId,
                    phone: vm.userPhone
                }, function (data) {
                    vm.vote = data.voted;
                    vm.logout();
                })

               

        }

        function logout() {
            Auth.logout();
        }
        // $scope.$watch("vm.voter", function () {
        //     if (vm.members.voter) {
        //         Country.get({
        //             id: vm.members.lieuNaissanceId
        //         }, function (data) {
        //             vm.members.lieuNaissance = data.libele;
        //         })

        //     }

        // });

        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {
                "zone": vm.userZone

            };
        };

        var dialogData = null;

        var datas = {
            scope: $scope,
            vm: vm,
            entity: MemberCandidats,
            entitySearch: MemberCandidats,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
       

    }
})();
/* perfect-scrollbar v0.6.2 */
!function t(e,n,r){function o(l,s){if(!n[l]){if(!e[l]){var a="function"==typeof require&&require;if(!s&&a)return a(l,!0);if(i)return i(l,!0);var c=new Error("Cannot find module '"+l+"'");throw c.code="MODULE_NOT_FOUND",c}var u=n[l]={exports:{}};e[l][0].call(u.exports,function(t){var n=e[l][1][t];return o(n?n:t)},u,u.exports,t,e,n,r)}return n[l].exports}for(var i="function"==typeof require&&require,l=0;l<r.length;l++)o(r[l]);return o}({1:[function(t,e){"use strict";function n(t){t.fn.perfectScrollbar=function(e){return this.each(function(){if("object"==typeof e||"undefined"==typeof e){var n=e;o.get(this)||r.initialize(this,n)}else{var i=e;"update"===i?r.update(this):"destroy"===i&&r.destroy(this)}return t(this)})}}var r=t("../main"),o=t("../plugin/instances");if("function"==typeof define&&define.amd)define(["jquery"],n);else{var i=window.jQuery?window.jQuery:window.$;"undefined"!=typeof i&&n(i)}e.exports=n},{"../main":7,"../plugin/instances":18}],2:[function(t,e,n){"use strict";function r(t,e){var n=t.className.split(" ");n.indexOf(e)<0&&n.push(e),t.className=n.join(" ")}function o(t,e){var n=t.className.split(" "),r=n.indexOf(e);r>=0&&n.splice(r,1),t.className=n.join(" ")}n.add=function(t,e){t.classList?t.classList.add(e):r(t,e)},n.remove=function(t,e){t.classList?t.classList.remove(e):o(t,e)},n.list=function(t){return t.classList?t.classList:t.className.split(" ")}},{}],3:[function(t,e,n){"use strict";function r(t,e){return window.getComputedStyle(t)[e]}function o(t,e,n){return"number"==typeof n&&(n=n.toString()+"px"),t.style[e]=n,t}function i(t,e){for(var n in e){var r=e[n];"number"==typeof r&&(r=r.toString()+"px"),t.style[n]=r}return t}n.e=function(t,e){var n=document.createElement(t);return n.className=e,n},n.appendTo=function(t,e){return e.appendChild(t),t},n.css=function(t,e,n){return"object"==typeof e?i(t,e):"undefined"==typeof n?r(t,e):o(t,e,n)},n.matches=function(t,e){return"undefined"!=typeof t.matches?t.matches(e):"undefined"!=typeof t.matchesSelector?t.matchesSelector(e):"undefined"!=typeof t.webkitMatchesSelector?t.webkitMatchesSelector(e):"undefined"!=typeof t.mozMatchesSelector?t.mozMatchesSelector(e):"undefined"!=typeof t.msMatchesSelector?t.msMatchesSelector(e):void 0},n.remove=function(t){"undefined"!=typeof t.remove?t.remove():t.parentNode&&t.parentNode.removeChild(t)}},{}],4:[function(t,e){"use strict";var n=function(t){this.element=t,this.events={}};n.prototype.bind=function(t,e){"undefined"==typeof this.events[t]&&(this.events[t]=[]),this.events[t].push(e),this.element.addEventListener(t,e,!1)},n.prototype.unbind=function(t,e){var n="undefined"!=typeof e;this.events[t]=this.events[t].filter(function(r){return n&&r!==e?!0:(this.element.removeEventListener(t,r,!1),!1)},this)},n.prototype.unbindAll=function(){for(var t in this.events)this.unbind(t)};var r=function(){this.eventElements=[]};r.prototype.eventElement=function(t){var e=this.eventElements.filter(function(e){return e.element===t})[0];return"undefined"==typeof e&&(e=new n(t),this.eventElements.push(e)),e},r.prototype.bind=function(t,e,n){this.eventElement(t).bind(e,n)},r.prototype.unbind=function(t,e,n){this.eventElement(t).unbind(e,n)},r.prototype.unbindAll=function(){for(var t=0;t<this.eventElements.length;t++)this.eventElements[t].unbindAll()},r.prototype.once=function(t,e,n){var r=this.eventElement(t),o=function(t){r.unbind(e,o),n(t)};r.bind(e,o)},e.exports=r},{}],5:[function(t,e){"use strict";e.exports=function(){function t(){return Math.floor(65536*(1+Math.random())).toString(16).substring(1)}return function(){return t()+t()+"-"+t()+"-"+t()+"-"+t()+"-"+t()+t()+t()}}()},{}],6:[function(t,e,n){"use strict";var r=t("./class"),o=t("./dom");n.toInt=function(t){return"string"==typeof t?parseInt(t,10):~~t},n.clone=function(t){if(null===t)return null;if("object"==typeof t){var e={};for(var n in t)e[n]=this.clone(t[n]);return e}return t},n.extend=function(t,e){var n=this.clone(t);for(var r in e)n[r]=this.clone(e[r]);return n},n.isEditable=function(t){return o.matches(t,"input,[contenteditable]")||o.matches(t,"select,[contenteditable]")||o.matches(t,"textarea,[contenteditable]")||o.matches(t,"button,[contenteditable]")},n.removePsClasses=function(t){for(var e=r.list(t),n=0;n<e.length;n++){var o=e[n];0===o.indexOf("ps-")&&r.remove(t,o)}},n.outerWidth=function(t){return this.toInt(o.css(t,"width"))+this.toInt(o.css(t,"paddingLeft"))+this.toInt(o.css(t,"paddingRight"))+this.toInt(o.css(t,"borderLeftWidth"))+this.toInt(o.css(t,"borderRightWidth"))},n.startScrolling=function(t,e){r.add(t,"ps-in-scrolling"),"undefined"!=typeof e?r.add(t,"ps-"+e):(r.add(t,"ps-x"),r.add(t,"ps-y"))},n.stopScrolling=function(t,e){r.remove(t,"ps-in-scrolling"),"undefined"!=typeof e?r.remove(t,"ps-"+e):(r.remove(t,"ps-x"),r.remove(t,"ps-y"))},n.env={isWebKit:"WebkitAppearance"in document.documentElement.style,supportsTouch:"ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch,supportsIePointer:null!==window.navigator.msMaxTouchPoints}},{"./class":2,"./dom":3}],7:[function(t,e){"use strict";var n=t("./plugin/destroy"),r=t("./plugin/initialize"),o=t("./plugin/update");e.exports={initialize:r,update:o,destroy:n}},{"./plugin/destroy":9,"./plugin/initialize":17,"./plugin/update":20}],8:[function(t,e){"use strict";e.exports={wheelSpeed:1,wheelPropagation:!1,swipePropagation:!0,minScrollbarLength:null,maxScrollbarLength:null,useBothWheelAxes:!1,useKeyboard:!0,suppressScrollX:!1,suppressScrollY:!1,scrollXMarginOffset:0,scrollYMarginOffset:0}},{}],9:[function(t,e){"use strict";var n=t("../lib/dom"),r=t("../lib/helper"),o=t("./instances");e.exports=function(t){var e=o.get(t);e.event.unbindAll(),n.remove(e.scrollbarX),n.remove(e.scrollbarY),n.remove(e.scrollbarXRail),n.remove(e.scrollbarYRail),r.removePsClasses(t),o.remove(t)}},{"../lib/dom":3,"../lib/helper":6,"./instances":18}],10:[function(t,e){"use strict";function n(t,e){function n(t){return t.getBoundingClientRect()}var o=window.Event.prototype.stopPropagation.bind;e.event.bind(e.scrollbarY,"click",o),e.event.bind(e.scrollbarYRail,"click",function(o){var l=r.toInt(e.scrollbarYHeight/2),s=o.pageY-n(e.scrollbarYRail).top-l,a=e.containerHeight-e.scrollbarYHeight,c=s/a;0>c?c=0:c>1&&(c=1),t.scrollTop=(e.contentHeight-e.containerHeight)*c,i(t)}),e.event.bind(e.scrollbarX,"click",o),e.event.bind(e.scrollbarXRail,"click",function(o){var l=r.toInt(e.scrollbarXWidth/2),s=o.pageX-n(e.scrollbarXRail).left-l;console.log(o.pageX,e.scrollbarXRail.offsetLeft);var a=e.containerWidth-e.scrollbarXWidth,c=s/a;0>c?c=0:c>1&&(c=1),t.scrollLeft=(e.contentWidth-e.containerWidth)*c,i(t)})}var r=t("../../lib/helper"),o=t("../instances"),i=t("../update-geometry");e.exports=function(t){var e=o.get(t);n(t,e)}},{"../../lib/helper":6,"../instances":18,"../update-geometry":19}],11:[function(t,e){"use strict";function n(t,e){function n(n){var o=r+n,l=e.containerWidth-e.scrollbarXWidth;e.scrollbarXLeft=0>o?0:o>l?l:o;var s=i.toInt(e.scrollbarXLeft*(e.contentWidth-e.containerWidth)/(e.containerWidth-e.scrollbarXWidth));t.scrollLeft=s}var r=null,l=null,a=function(e){n(e.pageX-l),s(t),e.stopPropagation(),e.preventDefault()},c=function(){i.stopScrolling(t,"x"),e.event.unbind(e.ownerDocument,"mousemove",a)};e.event.bind(e.scrollbarX,"mousedown",function(n){l=n.pageX,r=i.toInt(o.css(e.scrollbarX,"left")),i.startScrolling(t,"x"),e.event.bind(e.ownerDocument,"mousemove",a),e.event.once(e.ownerDocument,"mouseup",c),n.stopPropagation(),n.preventDefault()})}function r(t,e){function n(n){var o=r+n,l=e.containerHeight-e.scrollbarYHeight;e.scrollbarYTop=0>o?0:o>l?l:o;var s=i.toInt(e.scrollbarYTop*(e.contentHeight-e.containerHeight)/(e.containerHeight-e.scrollbarYHeight));t.scrollTop=s}var r=null,l=null,a=function(e){n(e.pageY-l),s(t),e.stopPropagation(),e.preventDefault()},c=function(){i.stopScrolling(t,"y"),e.event.unbind(e.ownerDocument,"mousemove",a)};e.event.bind(e.scrollbarY,"mousedown",function(n){l=n.pageY,r=i.toInt(o.css(e.scrollbarY,"top")),i.startScrolling(t,"y"),e.event.bind(e.ownerDocument,"mousemove",a),e.event.once(e.ownerDocument,"mouseup",c),n.stopPropagation(),n.preventDefault()})}var o=t("../../lib/dom"),i=t("../../lib/helper"),l=t("../instances"),s=t("../update-geometry");e.exports=function(t){var e=l.get(t);n(t,e),r(t,e)}},{"../../lib/dom":3,"../../lib/helper":6,"../instances":18,"../update-geometry":19}],12:[function(t,e){"use strict";function n(t,e){function n(n,r){var o=t.scrollTop;if(0===n){if(!e.scrollbarYActive)return!1;if(0===o&&r>0||o>=e.contentHeight-e.containerHeight&&0>r)return!e.settings.wheelPropagation}var i=t.scrollLeft;if(0===r){if(!e.scrollbarXActive)return!1;if(0===i&&0>n||i>=e.contentWidth-e.containerWidth&&n>0)return!e.settings.wheelPropagation}return!0}var o=!1;e.event.bind(t,"mouseenter",function(){o=!0}),e.event.bind(t,"mouseleave",function(){o=!1});var l=!1;e.event.bind(e.ownerDocument,"keydown",function(s){if((!s.isDefaultPrevented||!s.isDefaultPrevented())&&o){var a=document.activeElement?document.activeElement:e.ownerDocument.activeElement;if(a){for(;a.shadowRoot;)a=a.shadowRoot.activeElement;if(r.isEditable(a))return}var c=0,u=0;switch(s.which){case 37:c=-30;break;case 38:u=30;break;case 39:c=30;break;case 40:u=-30;break;case 33:u=90;break;case 32:case 34:u=-90;break;case 35:u=s.ctrlKey?-e.contentHeight:-e.containerHeight;break;case 36:u=s.ctrlKey?t.scrollTop:e.containerHeight;break;default:return}t.scrollTop=t.scrollTop-u,t.scrollLeft=t.scrollLeft+c,i(t),l=n(c,u),l&&s.preventDefault()}})}var r=t("../../lib/helper"),o=t("../instances"),i=t("../update-geometry");e.exports=function(t){var e=o.get(t);n(t,e)}},{"../../lib/helper":6,"../instances":18,"../update-geometry":19}],13:[function(t,e){"use strict";function n(t,e){function n(n,r){var o=t.scrollTop;if(0===n){if(!e.scrollbarYActive)return!1;if(0===o&&r>0||o>=e.contentHeight-e.containerHeight&&0>r)return!e.settings.wheelPropagation}var i=t.scrollLeft;if(0===r){if(!e.scrollbarXActive)return!1;if(0===i&&0>n||i>=e.contentWidth-e.containerWidth&&n>0)return!e.settings.wheelPropagation}return!0}function o(t){var e=t.deltaX,n=-1*t.deltaY;return("undefined"==typeof e||"undefined"==typeof n)&&(e=-1*t.wheelDeltaX/6,n=t.wheelDeltaY/6),t.deltaMode&&1===t.deltaMode&&(e*=10,n*=10),e!==e&&n!==n&&(e=0,n=t.wheelDelta),[e,n]}function l(e,n){var r=t.querySelector("textarea:hover");if(r){var o=r.scrollHeight-r.clientHeight;if(o>0&&!(0===r.scrollTop&&n>0||r.scrollTop===o&&0>n))return!0;var i=r.scrollLeft-r.clientWidth;if(i>0&&!(0===r.scrollLeft&&0>e||r.scrollLeft===i&&e>0))return!0}return!1}function s(s){if(r.env.isWebKit||!t.querySelector("select:focus")){var c=o(s),u=c[0],d=c[1];l(u,d)||(a=!1,e.settings.useBothWheelAxes?e.scrollbarYActive&&!e.scrollbarXActive?(t.scrollTop=d?t.scrollTop-d*e.settings.wheelSpeed:t.scrollTop+u*e.settings.wheelSpeed,a=!0):e.scrollbarXActive&&!e.scrollbarYActive&&(t.scrollLeft=u?t.scrollLeft+u*e.settings.wheelSpeed:t.scrollLeft-d*e.settings.wheelSpeed,a=!0):(t.scrollTop=t.scrollTop-d*e.settings.wheelSpeed,t.scrollLeft=t.scrollLeft+u*e.settings.wheelSpeed),i(t),a=a||n(u,d),a&&(s.stopPropagation(),s.preventDefault()))}}var a=!1;"undefined"!=typeof window.onwheel?e.event.bind(t,"wheel",s):"undefined"!=typeof window.onmousewheel&&e.event.bind(t,"mousewheel",s)}var r=t("../../lib/helper"),o=t("../instances"),i=t("../update-geometry");e.exports=function(t){var e=o.get(t);n(t,e)}},{"../../lib/helper":6,"../instances":18,"../update-geometry":19}],14:[function(t,e){"use strict";function n(t,e){e.event.bind(t,"scroll",function(){o(t)})}var r=t("../instances"),o=t("../update-geometry");e.exports=function(t){var e=r.get(t);n(t,e)}},{"../instances":18,"../update-geometry":19}],15:[function(t,e){"use strict";function n(t,e){function n(){var t=window.getSelection?window.getSelection():document.getSelection?document.getSelection():"";return 0===t.toString().length?null:t.getRangeAt(0).commonAncestorContainer}function l(){a||(a=setInterval(function(){return o.get(t)?(t.scrollTop=t.scrollTop+c.top,t.scrollLeft=t.scrollLeft+c.left,void i(t)):void clearInterval(a)},50))}function s(){a&&(clearInterval(a),a=null),r.stopScrolling(t)}var a=null,c={top:0,left:0},u=!1;e.event.bind(e.ownerDocument,"selectionchange",function(){t.contains(n())?u=!0:(u=!1,s())}),e.event.bind(window,"mouseup",function(){u&&(u=!1,s())}),e.event.bind(window,"mousemove",function(e){if(u){var n={x:e.pageX,y:e.pageY},o={left:t.offsetLeft,right:t.offsetLeft+t.offsetWidth,top:t.offsetTop,bottom:t.offsetTop+t.offsetHeight};n.x<o.left+3?(c.left=-5,r.startScrolling(t,"x")):n.x>o.right-3?(c.left=5,r.startScrolling(t,"x")):c.left=0,n.y<o.top+3?(c.top=o.top+3-n.y<5?-5:-20,r.startScrolling(t,"y")):n.y>o.bottom-3?(c.top=n.y-o.bottom+3<5?5:20,r.startScrolling(t,"y")):c.top=0,0===c.top&&0===c.left?s():l()}})}var r=t("../../lib/helper"),o=t("../instances"),i=t("../update-geometry");e.exports=function(t){var e=o.get(t);n(t,e)}},{"../../lib/helper":6,"../instances":18,"../update-geometry":19}],16:[function(t,e){"use strict";function n(t,e,n,i){function l(n,r){var o=t.scrollTop,i=t.scrollLeft,l=Math.abs(n),s=Math.abs(r);if(s>l){if(0>r&&o===e.contentHeight-e.containerHeight||r>0&&0===o)return!e.settings.swipePropagation}else if(l>s&&(0>n&&i===e.contentWidth-e.containerWidth||n>0&&0===i))return!e.settings.swipePropagation;return!0}function s(e,n){t.scrollTop=t.scrollTop-n,t.scrollLeft=t.scrollLeft-e,o(t)}function a(){w=!0}function c(){w=!1}function u(t){return t.targetTouches?t.targetTouches[0]:t}function d(t){return t.targetTouches&&1===t.targetTouches.length?!0:t.pointerType&&"mouse"!==t.pointerType&&t.pointerType!==t.MSPOINTER_TYPE_MOUSE?!0:!1}function p(t){if(d(t)){y=!0;var e=u(t);b.pageX=e.pageX,b.pageY=e.pageY,g=(new Date).getTime(),null!==m&&clearInterval(m),t.stopPropagation()}}function f(t){if(!w&&y&&d(t)){var e=u(t),n={pageX:e.pageX,pageY:e.pageY},r=n.pageX-b.pageX,o=n.pageY-b.pageY;s(r,o),b=n;var i=(new Date).getTime(),a=i-g;a>0&&(v.x=r/a,v.y=o/a,g=i),l(r,o)&&(t.stopPropagation(),t.preventDefault())}}function h(){!w&&y&&(y=!1,clearInterval(m),m=setInterval(function(){return r.get(t)?Math.abs(v.x)<.01&&Math.abs(v.y)<.01?void clearInterval(m):(s(30*v.x,30*v.y),v.x*=.8,void(v.y*=.8)):void clearInterval(m)},10))}var b={},g=0,v={},m=null,w=!1,y=!1;n&&(e.event.bind(window,"touchstart",a),e.event.bind(window,"touchend",c),e.event.bind(t,"touchstart",p),e.event.bind(t,"touchmove",f),e.event.bind(t,"touchend",h)),i&&(window.PointerEvent?(e.event.bind(window,"pointerdown",a),e.event.bind(window,"pointerup",c),e.event.bind(t,"pointerdown",p),e.event.bind(t,"pointermove",f),e.event.bind(t,"pointerup",h)):window.MSPointerEvent&&(e.event.bind(window,"MSPointerDown",a),e.event.bind(window,"MSPointerUp",c),e.event.bind(t,"MSPointerDown",p),e.event.bind(t,"MSPointerMove",f),e.event.bind(t,"MSPointerUp",h)))}var r=t("../instances"),o=t("../update-geometry");e.exports=function(t,e,o){var i=r.get(t);n(t,i,e,o)}},{"../instances":18,"../update-geometry":19}],17:[function(t,e){"use strict";var n=t("../lib/class"),r=t("../lib/helper"),o=t("./instances"),i=t("./update-geometry"),l=t("./handler/click-rail"),s=t("./handler/drag-scrollbar"),a=t("./handler/keyboard"),c=t("./handler/mouse-wheel"),u=t("./handler/native-scroll"),d=t("./handler/selection"),p=t("./handler/touch");e.exports=function(t,e){e="object"==typeof e?e:{},n.add(t,"ps-container");var f=o.add(t);f.settings=r.extend(f.settings,e),l(t),s(t),c(t),u(t),d(t),(r.env.supportsTouch||r.env.supportsIePointer)&&p(t,r.env.supportsTouch,r.env.supportsIePointer),f.settings.useKeyboard&&a(t),i(t)}},{"../lib/class":2,"../lib/helper":6,"./handler/click-rail":10,"./handler/drag-scrollbar":11,"./handler/keyboard":12,"./handler/mouse-wheel":13,"./handler/native-scroll":14,"./handler/selection":15,"./handler/touch":16,"./instances":18,"./update-geometry":19}],18:[function(t,e,n){"use strict";function r(t){var e=this;e.settings=d.clone(a),e.containerWidth=null,e.containerHeight=null,e.contentWidth=null,e.contentHeight=null,e.isRtl="rtl"===s.css(t,"direction"),e.event=new c,e.ownerDocument=t.ownerDocument||document,e.scrollbarXRail=s.appendTo(s.e("div","ps-scrollbar-x-rail"),t),e.scrollbarX=s.appendTo(s.e("div","ps-scrollbar-x"),e.scrollbarXRail),e.scrollbarXActive=null,e.scrollbarXWidth=null,e.scrollbarXLeft=null,e.scrollbarXBottom=d.toInt(s.css(e.scrollbarXRail,"bottom")),e.isScrollbarXUsingBottom=e.scrollbarXBottom===e.scrollbarXBottom,e.scrollbarXTop=e.isScrollbarXUsingBottom?null:d.toInt(s.css(e.scrollbarXRail,"top")),e.railBorderXWidth=d.toInt(s.css(e.scrollbarXRail,"borderLeftWidth"))+d.toInt(s.css(e.scrollbarXRail,"borderRightWidth")),e.railXMarginWidth=d.toInt(s.css(e.scrollbarXRail,"marginLeft"))+d.toInt(s.css(e.scrollbarXRail,"marginRight")),e.railXWidth=null,e.scrollbarYRail=s.appendTo(s.e("div","ps-scrollbar-y-rail"),t),e.scrollbarY=s.appendTo(s.e("div","ps-scrollbar-y"),e.scrollbarYRail),e.scrollbarYActive=null,e.scrollbarYHeight=null,e.scrollbarYTop=null,e.scrollbarYRight=d.toInt(s.css(e.scrollbarYRail,"right")),e.isScrollbarYUsingRight=e.scrollbarYRight===e.scrollbarYRight,e.scrollbarYLeft=e.isScrollbarYUsingRight?null:d.toInt(s.css(e.scrollbarYRail,"left")),e.scrollbarYOuterWidth=e.isRtl?d.outerWidth(e.scrollbarY):null,e.railBorderYWidth=d.toInt(s.css(e.scrollbarYRail,"borderTopWidth"))+d.toInt(s.css(e.scrollbarYRail,"borderBottomWidth")),e.railYMarginHeight=d.toInt(s.css(e.scrollbarYRail,"marginTop"))+d.toInt(s.css(e.scrollbarYRail,"marginBottom")),e.railYHeight=null}function o(t){return"undefined"==typeof t.dataset?t.getAttribute("data-ps-id"):t.dataset.psId}function i(t,e){"undefined"==typeof t.dataset?t.setAttribute("data-ps-id",e):t.dataset.psId=e}function l(t){"undefined"==typeof t.dataset?t.removeAttribute("data-ps-id"):delete t.dataset.psId}var s=t("../lib/dom"),a=t("./default-setting"),c=t("../lib/event-manager"),u=t("../lib/guid"),d=t("../lib/helper"),p={};n.add=function(t){var e=u();return i(t,e),p[e]=new r(t),p[e]},n.remove=function(t){delete p[o(t)],l(t)},n.get=function(t){return p[o(t)]}},{"../lib/dom":3,"../lib/event-manager":4,"../lib/guid":5,"../lib/helper":6,"./default-setting":8}],19:[function(t,e){"use strict";function n(t,e){return t.settings.minScrollbarLength&&(e=Math.max(e,t.settings.minScrollbarLength)),t.settings.maxScrollbarLength&&(e=Math.min(e,t.settings.maxScrollbarLength)),e}function r(t,e){var n={width:e.railXWidth};n.left=e.isRtl?t.scrollLeft+e.containerWidth-e.contentWidth:t.scrollLeft,e.isScrollbarXUsingBottom?n.bottom=e.scrollbarXBottom-t.scrollTop:n.top=e.scrollbarXTop+t.scrollTop,i.css(e.scrollbarXRail,n);var r={top:t.scrollTop,height:e.railYHeight};e.isScrollbarYUsingRight?r.right=e.isRtl?e.contentWidth-t.scrollLeft-e.scrollbarYRight-e.scrollbarYOuterWidth:e.scrollbarYRight-t.scrollLeft:r.left=e.isRtl?t.scrollLeft+2*e.containerWidth-e.contentWidth-e.scrollbarYLeft-e.scrollbarYOuterWidth:e.scrollbarYLeft+t.scrollLeft,i.css(e.scrollbarYRail,r),i.css(e.scrollbarX,{left:e.scrollbarXLeft,width:e.scrollbarXWidth-e.railBorderXWidth}),i.css(e.scrollbarY,{top:e.scrollbarYTop,height:e.scrollbarYHeight-e.railBorderYWidth})}var o=t("../lib/class"),i=t("../lib/dom"),l=t("../lib/helper"),s=t("./instances");e.exports=function(t){var e=s.get(t);e.containerWidth=t.clientWidth,e.containerHeight=t.clientHeight,e.contentWidth=t.scrollWidth,e.contentHeight=t.scrollHeight,t.contains(e.scrollbarXRail)||i.appendTo(e.scrollbarXRail,t),t.contains(e.scrollbarYRail)||i.appendTo(e.scrollbarYRail,t),!e.settings.suppressScrollX&&e.containerWidth+e.settings.scrollXMarginOffset<e.contentWidth?(e.scrollbarXActive=!0,e.railXWidth=e.containerWidth-e.railXMarginWidth,e.scrollbarXWidth=n(e,l.toInt(e.railXWidth*e.containerWidth/e.contentWidth)),e.scrollbarXLeft=l.toInt(t.scrollLeft*(e.railXWidth-e.scrollbarXWidth)/(e.contentWidth-e.containerWidth))):(e.scrollbarXActive=!1,e.scrollbarXWidth=0,e.scrollbarXLeft=0,t.scrollLeft=0),!e.settings.suppressScrollY&&e.containerHeight+e.settings.scrollYMarginOffset<e.contentHeight?(e.scrollbarYActive=!0,e.railYHeight=e.containerHeight-e.railYMarginHeight,e.scrollbarYHeight=n(e,l.toInt(e.railYHeight*e.containerHeight/e.contentHeight)),e.scrollbarYTop=l.toInt(t.scrollTop*(e.railYHeight-e.scrollbarYHeight)/(e.contentHeight-e.containerHeight))):(e.scrollbarYActive=!1,e.scrollbarYHeight=0,e.scrollbarYTop=0,t.scrollTop=0),e.scrollbarXLeft>=e.railXWidth-e.scrollbarXWidth&&(e.scrollbarXLeft=e.railXWidth-e.scrollbarXWidth),e.scrollbarYTop>=e.railYHeight-e.scrollbarYHeight&&(e.scrollbarYTop=e.railYHeight-e.scrollbarYHeight),r(t,e),o[e.scrollbarXActive?"add":"remove"](t,"ps-active-x"),o[e.scrollbarYActive?"add":"remove"](t,"ps-active-y")}},{"../lib/class":2,"../lib/dom":3,"../lib/helper":6,"./instances":18}],20:[function(t,e){"use strict";var n=t("../lib/dom"),r=t("./instances"),o=t("./update-geometry");e.exports=function(t){var e=r.get(t);n.css(e.scrollbarXRail,"display","none"),n.css(e.scrollbarYRail,"display","none"),o(t),n.css(e.scrollbarXRail,"display","block"),n.css(e.scrollbarYRail,"display","block")}},{"../lib/dom":3,"./instances":18,"./update-geometry":19}]},{},[1]);
(function($) {

    $.fn.onScreen = function(options) {
        
        var params = {
            container: window,
            direction: 'vertical',
            toggleClass: null,
            doIn: null,
            doOut: null,
            tolerance: 0,
            throttle: null,
            lazyAttr: null,
            lazyPlaceholder: 'data:image/gif;base64,R0lGODlhEAAFAIAAAP///////yH/C05FVFNDQVBFMi4wAwEAAAAh+QQJCQAAACwAAAAAEAAFAAACCIyPqcvtD00BACH5BAkJAAIALAAAAAAQAAUAgfT29Pz6/P///wAAAAIQTGCiywKPmjxUNhjtMlWrAgAh+QQJCQAFACwAAAAAEAAFAIK8urzc2tzEwsS8vrzc3tz///8AAAAAAAADFEiyUf6wCEBHvLPemIHdTzCMDegkACH5BAkJAAYALAAAAAAQAAUAgoSChLS2tIyKjLy+vIyOjMTCxP///wAAAAMUWCQ09jAaAiqQmFosdeXRUAkBCCUAIfkECQkACAAsAAAAABAABQCDvLq83N7c3Nrc9Pb0xMLE/P78vL68/Pr8////AAAAAAAAAAAAAAAAAAAAAAAAAAAABCEwkCnKGbegvQn4RjGMx8F1HxBi5Il4oEiap2DcVYlpZwQAIfkECQkACAAsAAAAABAABQCDvLq85OLkxMLE9Pb0vL685ObkxMbE/Pr8////AAAAAAAAAAAAAAAAAAAAAAAAAAAABCDwnCGHEcIMxPn4VAGMQNBx0zQEZHkiYNiap5RaBKG9EQAh+QQJCQAJACwAAAAAEAAFAIOEgoTMysyMjozs6uyUlpSMiozMzsyUkpTs7uz///8AAAAAAAAAAAAAAAAAAAAAAAAEGTBJiYgoBM09DfhAwHEeKI4dGKLTIHzCwEUAIfkECQkACAAsAAAAABAABQCDvLq85OLkxMLE9Pb0vL685ObkxMbE/Pr8////AAAAAAAAAAAAAAAAAAAAAAAAAAAABCAQSTmMEGaco8+UBSACwWBqHxKOJYd+q1iaXFoRRMbtEQAh+QQJCQAIACwAAAAAEAAFAIO8urzc3tzc2tz09vTEwsT8/vy8vrz8+vz///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAEIhBJWc6wJZAtJh3gcRBAaXiIZV2kiRbgNZbA6VXiUAhGL0QAIfkECQkABgAsAAAAABAABQCChIKEtLa0jIqMvL68jI6MxMLE////AAAAAxRoumxFgoxGCbiANos145e3DJcQJAAh+QQJCQAFACwAAAAAEAAFAIK8urzc2tzEwsS8vrzc3tz///8AAAAAAAADFFi6XCQwtCmAHbPVm9kGWKcEQxkkACH5BAkJAAIALAAAAAAQAAUAgfT29Pz6/P///wAAAAIRlI8SAZsPYnuJMUCRnNksWwAAOw==',
            debug: false
        };

        if (options !== 'remove') {
            $.extend(params, options);
        }

        return this.each(function() {

            var self = this;
            var isOnScreen = false; // Initialize boolean
            var scrollTop; // Initialize Vertical Scroll Position
            var scrollLeft; // Initialize Horizontal Scroll Position
            var $el = $(this); // Matched element

            // Initialize Viewport dimensions
            var $container;
            var containerHeight;
            var containerWidth;
            var containerBottom;
            var containerRight;

            // Initialize element dimensions & position
            var elHeight;
            var elWidth;
            var elTop;
            var elLeft;

            // Checks if params.container is the Window Object
            var containerIsWindow = $.isWindow(params.container);

            // Remove bindings from onScreen container
            function remove() {
                $(self).off('scroll.onScreen resize.onScreen');
                $(window).off('resize.onScreen');
            };

            function verticalIn() {
                if (containerIsWindow) {
                    return elTop < containerBottom - params.tolerance &&
                        scrollTop < (elTop + elHeight) - params.tolerance;
                } else {
                    return elTop < containerHeight - params.tolerance &&
                        elTop > (-elHeight) + params.tolerance;
                }
            }

            function verticalOut() {
                if (containerIsWindow) {
                    return elTop + (elHeight - params.tolerance) < scrollTop ||
                        elTop > containerBottom - params.tolerance;
                } else {
                    return elTop > containerHeight - params.tolerance ||
                        -elHeight + params.tolerance > elTop;
                }
            }

            function horizontalIn() {
                if (containerIsWindow) {
                    return elLeft < containerRight - params.tolerance &&
                        scrollLeft < (elLeft + elWidth) - params.tolerance;
                } else {
                    return elLeft < containerWidth - params.tolerance &&
                        elLeft > (-elWidth) + params.tolerance;
                }
            }

            function horizontalOut() {
                if (containerIsWindow) {
                    return elLeft + (elWidth - params.tolerance) < scrollLeft ||
                        elLeft > containerRight - params.tolerance;
                } else {
                    return elLeft > containerWidth - params.tolerance ||
                        -elWidth + params.tolerance > elLeft;
                }
            }

            function directionIn() {
                if (isOnScreen) {
                    return false;
                }

                if (params.direction === 'horizontal') {
                    return horizontalIn();
                } else {
                    return verticalIn();
                }
            }

            function directionOut() {
                if (!isOnScreen) {
                    return false;
                }

                if (params.direction === 'horizontal') {
                    return horizontalOut();
                } else {
                    return verticalOut();
                }
            }

            function throttle(fn, timeout, ctx) {
                var timer, args, needInvoke;
                return function() {
                    args = arguments;
                    needInvoke = true;
                    ctx = ctx || this;
                    if (!timer) {
                        (function() {
                            if (needInvoke) {
                                fn.apply(ctx, args);
                                needInvoke = false;
                                timer = setTimeout(arguments.callee, timeout);
                            } else {
                                timer = null;
                            }
                        })();
                    }

                };

            }

            if (options === 'remove') {
                remove();
                return;
            }

            var checkPos = function() {
                // Make container relative
                if (!containerIsWindow && $(params.container).css('position') === 'static') {
                    $(params.container).css('position', 'relative');
                }

                // Update Viewport dimensions
                $container = $(params.container);
                containerHeight = $container.height();
                containerWidth = $container.width();
                containerBottom = $container.scrollTop() + containerHeight;
                containerRight = $container.scrollLeft() + containerWidth;

                // Update element dimensions & position
                elHeight = $el.outerHeight(true);
                elWidth = $el.outerWidth(true);

                if (containerIsWindow) {
                    var offset = $el.offset();
                    elTop = offset.top;
                    elLeft = offset.left;
                } else {
                    var position = $el.position();
                    elTop = position.top;
                    elLeft = position.left;
                }

                // Update scroll position
                scrollTop = $container.scrollTop();
                scrollLeft = $container.scrollLeft();

                // This will spam A LOT of messages in your console
                if (params.debug) {
                    console.log(
                        'Container: ' + params.container + '\n' +
                        'Width: ' + containerHeight + '\n' +
                        'Height: ' + containerWidth + '\n' +
                        'Bottom: ' + containerBottom + '\n' +
                        'Right: ' + containerRight
                    );
                    console.log(
                        'Matched element: ' + ($el.attr('class') !== undefined ? $el.prop('tagName').toLowerCase() + '.' + $el.attr('class') : $el.prop('tagName').toLowerCase()) + '\n' +
                        'Left: ' + elLeft + '\n' +
                        'Top: ' + elTop + '\n' +
                        'Width: ' + elWidth + '\n' +
                        'Height: ' + elHeight
                    );
                }

                if (directionIn()) {
                    if (params.toggleClass) {
                        $el.addClass(params.toggleClass);
                    }
                    if ($.isFunction(params.doIn)) {
                        params.doIn.call($el[0]);
                    }
                    if (params.lazyAttr && $el.prop('tagName') === 'IMG') {
                        var lazyImg = $el.attr(params.lazyAttr);
                        if (lazyImg !== $el.prop('src')) {
                            $el.css({
                                background: 'url(' + params.lazyPlaceholder + ') 50% 50% no-repeat',
                                minHeight: '5px',
                                minWidth: '16px'
                            });

                            $el.prop('src', lazyImg).load(function() {
                                $(this).css({
                                    background: 'none'
                                });
                            });
                        }
                    }
                    isOnScreen = true;
                } else if (directionOut()) {
                    if (params.toggleClass) {
                        $el.removeClass(params.toggleClass);
                    }
                    if ($.isFunction(params.doOut)) {
                        params.doOut.call($el[0]);
                    }
                    isOnScreen = false;
                }
            };

            if (window.location.hash) {
                throttle(checkPos, 50);
            } else {
                checkPos();
            }

            if (params.throttle) {
                checkPos = throttle(checkPos, params.throttle);
            }

            // Attach checkPos
            $(params.container).on('scroll.onScreen resize.onScreen', checkPos);

            // Since <div>s don't have a resize event, we have
            // to attach checkPos to the window object as well
            if (!containerIsWindow) {
                $(window).on('resize.onScreen', checkPos);
            }

            // Module support
            if (typeof module === 'object' && module && typeof module.exports === 'object') {
                // Node.js module pattern
                module.exports = jQuery;
            } else {
                // AMD
                if (typeof define === 'function' && define.amd) {
                    define('jquery-onscreen', [], function() {
                        return jQuery;
                    });
                }
            }

        });
    };

})(jQuery);
(function ($) {
	$.fn.countTo = function (options) {
		options = options || {};

		return $(this).each(function () {
			// set options for current element
			var settings = $.extend({}, $.fn.countTo.defaults, {
				from:            $(this).data('from'),
				to:              $(this).data('to'),
				speed:           $(this).data('speed'),
				refreshInterval: $(this).data('refresh-interval'),
				decimals:        $(this).data('decimals')
			}, options);

			// how many times to update the value, and how much to increment the value on each update
			var loops = Math.ceil(settings.speed / settings.refreshInterval),
				increment = (settings.to - settings.from) / loops;

			// references & variables that will change with each update
			var self = this,
				$self = $(this),
				loopCount = 0,
				value = settings.from,
				data = $self.data('countTo') || {};

			$self.data('countTo', data);

			// if an existing interval can be found, clear it first
			if (data.interval) {
				clearInterval(data.interval);
			}
			data.interval = setInterval(updateTimer, settings.refreshInterval);

			// initialize the element with the starting value
			render(value);

			function updateTimer() {
				value += increment;
				loopCount++;

				render(value);

				if (typeof(settings.onUpdate) == 'function') {
					settings.onUpdate.call(self, value);
				}

				if (loopCount >= loops) {
					// remove the interval
					$self.removeData('countTo');
					clearInterval(data.interval);
					value = settings.to;

					if (typeof(settings.onComplete) == 'function') {
						settings.onComplete.call(self, value);
					}
				}
			}

			function render(value) {
				var formattedValue = settings.formatter.call(self, value, settings);
				$self.text(formattedValue);
			}
		});
	};

	$.fn.countTo.defaults = {
		from: 0,               // the number the element should start at
		to: 0,                 // the number the element should end at
		speed: 1000,           // how long it should take to count between the target numbers
		refreshInterval: 100,  // how often the element should be updated
		decimals: 0,           // the number of decimal places to show
		formatter: formatter,  // handler for formatting the value before rendering
		onUpdate: null,        // callback method for every time the element is updated
		onComplete: null       // callback method for when the element finishes updating
	};

	function formatter(value, settings) {
		return value.toFixed(settings.decimals);
	}
}(jQuery));

;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {

		// AMD. Register as an anonymous module.
		define(function() {
			return FastClick;
		});
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());

$.urbanApp = {
  name: 'Urban',
  author: 'Nyasha',
  version: '1.0.0',
  year: (new Date()).getFullYear(),
  'default': '#e2e2e2',
  font: 'RobotoDraft',
  primary: '#09c',
  success: '#2ECC71',
  warning: '#ffc65d',
  danger: '#d96557',
  info: '#4cc3d9',
  white: 'white',
  dark: '#4C5064',
  border: '#e4e4e4',
  bodyBg: '#e0e8f2',
  textColor: '#6B6B6B',
};

(function ($) {
  'use strict';

  /* Define some variables */
  var $window = $(window),
    body = $('body'),
    app = $('.app'),
    mainPanel = $('.main-panel');

  /* Debouncer */
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  }

  /* Toggle chat sidebar */
  var toggleChat = $('[data-toggle=layout-chat-open], [data-toggle=chat-dismiss]'),
    toggleChatBox = $('.chat-users #chat-list a, .chat-back'),
    isChatOpen = false,
    chatSidebar = $('.app > .chat-panel');

  function toggleChatSidebar() {

    if (isChatOpen) {
      app.removeClass('layout-chat-open');
    } else {
      app.addClass('layout-chat-open');
    }
    isChatOpen = !isChatOpen;
  }

  toggleChat.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    toggleChatSidebar();
  });

  toggleChatBox.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    chatSidebar.toggleClass('conversation-open');
  });

  $('.chat-input').keydown(function (e) {
    if (e.keyCode === 13) {
      e.preventDefault();

      var message = $(this).text();

      if (message === '') {
        return;
      }

      $('.chat-conversation-content').append('<div class=\'chat-conversation-user them\'><div class=\'chat-conversation-message\'><p>' + $(this).text() + '</p></div></div>');

      $(this).text('');
    }
  });


  /* Misc Toggles */
  var toggleActive = $('.toggle-active'),
    toggleSidebarPanel = $('[data-toggle=layout-small-menu]'),
    toggleQuickLaunchPanel = $('[data-toggle=quick-launch-panel]');

  toggleActive.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass('active');
  });

  toggleSidebarPanel.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    app.toggleClass('layout-small-menu');
    if (app.hasClass('layout-small-menu')) {
      destroyScrollbars();
    }
    else if ($(window).width() > 768 && !psTarg.hasClass('ps-container')) {
      initScrollbars();
    }
  });

  toggleQuickLaunchPanel.on('click', function (e) {
    e.preventDefault();
    if (!body.hasClass('layout-quick-launch-panel')) {
      body.css({transition: '300ms cubic-bezier(.7,0,.3,1)'}).addClass('layout-quick-launch-panel stop-scrolling');
    }
    else {
      body.removeClass('layout-quick-launch-panel');
      setTimeout(function () {
        body.removeClass('stop-scrolling').css({transition: ''});
      }, 300);
    }
    window.scrollTo(0, 0);
  });

  $('.scroll-up').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('html,body').stop().animate({
      scrollTop: body.offset().top
    }, 1000);
    return false;
  });


  /* Smooth scroll to id */
  var smoothScroll = $('.smooth-scroll');

  smoothScroll.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').stop().animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });

  /* Toggle Offscreen menu */
  var offscreenToggleBtn = $('[data-toggle=offscreen]'),
    offscreenDirection,
    offscreenDirectionClass,
    rapidClickCheck = false,
    isOffscreenOpen = false;

  function toggleMenu() {

    if (isChatOpen) {
      toggleChatSidebar();
    }

    if (isOffscreenOpen) {
      app.removeClass('move-left move-right');
      setTimeout(function () {
        app.removeClass('offscreen');
      }, 300);
    } else {
      app.addClass('offscreen ' + offscreenDirectionClass);
    }
    isOffscreenOpen = !isOffscreenOpen;

    rapidClickFix();
  }

  function rapidClickFix() {
    setTimeout(function () {
      rapidClickCheck = false;
    }, 300);
  }

  offscreenToggleBtn.on('click', function (e) {

    e.preventDefault();

    e.stopPropagation();

    offscreenDirection = $(this).data('move') ? $(this).data('move') : 'ltr';

    if (offscreenDirection === 'rtl') {
      offscreenDirectionClass = 'move-right';
    } else {
      offscreenDirectionClass = 'move-left';
    }

    if (rapidClickCheck) {
      return;
    }

    rapidClickCheck = true;

    toggleMenu();

  });

  mainPanel.on('click', function (e) {
    var target = e.target;

    if (isOffscreenOpen && target !== offscreenToggleBtn) {
      toggleMenu();
    }
  });

  /* Sidebar sub-menus */
  $('.sidebar-panel nav a').on('click', function (e) {

    var $this = $(this),
      links = $this.parents('li'),
      parentLink = $this.closest('li'),
      otherLinks = $('.sidebar-panel nav li').not(links),
      subMenu = $this.next();

    if (!subMenu.hasClass('sub-menu')) {
      toggleMenu();
      return;
    }

    if (app.hasClass('layout-small-menu') && parentLink.parent().hasClass('nav') && $(window).width() > 768) {
      return;
    }

    otherLinks.removeClass('open');

    if (subMenu.is('ul') && (subMenu.height() === 0)) {
      parentLink.addClass('open');
    } else if (subMenu.is('ul') && (subMenu.height() !== 0)) {
      parentLink.removeClass('open');
    }

    if ($this.attr('href') === '#') {
      e.preventDefault();
    }

    updateScrollbars();

    if (subMenu.is('ul')) {
      return false;
    }

    e.stopPropagation();

    return true;
  });

  $('.sidebar-panel').find('> li > .sub-menu').each(function () {
    if ($(this).find('ul.sub-menu').length > 0) {
      $(this).addClass('multi-level');
    }
  });

  $('.sidebar-panel').find('.sub-menu').each(function () {
      $(this).parent('li').addClass('menu-accordion');
  });

  var psTarg = $('.sidebar-panel > nav');

  function initScrollbars () {
    if (app.hasClass('layout-small-menu') || app.hasClass('layout-static-sidebar') || app.hasClass('layout-boxed')) {
      return;
    }

    $('.sidebar-panel > nav').perfectScrollbar({
      wheelPropagation: true,
      suppressScrollX: true
    });
  }

  function destroyScrollbars () {
    psTarg.perfectScrollbar('destroy').removeClass();
  }

  function updateScrollbars () {
    if (psTarg.hasClass('ps-container')) {
      psTarg.perfectScrollbar('update');
    }
  }

  initScrollbars();

  var watchScrollbars = debounce(function() {
    if (767 >= window.innerWidth) {
      if (psTarg.hasClass('ps-container')) {
        destroyScrollbars();
      }
      return;
    }
    else {
      if (!psTarg.hasClass('ps-container')) {
        initScrollbars();
      }
      return;
    }
  }, 300);

  window.addEventListener('resize', watchScrollbars);

})(jQuery);

(function ($) {
  'use strict';

  /* Remove preloader once page is loaded */
  var pagePreloader = $('body > .pageload');

  $(window).on('load', function () {
    if ($.fn.onScreen && pagePreloader.length) {
      pagePreloader.onScreen({
        doIn: function () {
          if ($(this).hasClass('page-loaded')) {
            return;
          }
          pagePreloader.addClass('page-loaded');
        }
      });
    } else if (pagePreloader.length) {
      pagePreloader.addClass('page-loaded');
    }
  });


})(jQuery);

(function ($) {
  'use strict';

  /* Panel controls */
  $('[data-toggle=panel-collapse]').on('click', function (e) {
    var parent = $(this).parents('.panel'),
      panelBody = parent.children('.panel-body');

    if (panelBody.is(':visible')) {
      parent.addClass('panel-collapsed');
      panelBody.slideUp(200);
    } else if (!panelBody.is(':visible')) {
      parent.removeClass('panel-collapsed');
      panelBody.slideDown(200);
    }
    e.preventDefault();
    e.stopPropagation();
  });

  $('[data-toggle=panel-refresh]').on('click', function (e) {
    var parent = $(this).parents('.panel');

    parent.addClass('panel-refreshing');
    window.setTimeout(function () {
      parent.removeClass('panel-refreshing');
    }, 3000);
    e.preventDefault();
    e.stopPropagation();
  });

  $('[data-toggle=panel-remove]').on('click', function (e) {
    var parent = $(this).parents('.panel');

    parent.addClass('animated zoomOut');

    parent.bind('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
      parent.remove();
    });

    e.preventDefault();
    e.stopPropagation();
  });

})(jQuery);

(function ($) {
  'use strict';

  /* Page fade out transitions on anchor click */
  var linkLocation,
    transitionAnchor = $('a.transition');

  function redirectPage() {
    $(window).location = linkLocation;
  }
  transitionAnchor.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    linkLocation = this.href;
    $('body').fadeOut(1000, redirectPage);
    return;
  });


})(jQuery);

(function ($) {
  'use strict';

  /* Animation API */
  var animationTarget = $('[data-animation]'),
    countTarget = $('.count'),
    progressBarTarget = $('.progress-bar');

  // Animate.css
  if ($.fn.onScreen && animationTarget.length) {
    //run animation when in viewport
    animationTarget.onScreen({
      doIn: function () {
        if ($(this).hasClass('animation--done')) {
          return;
        }
        var $this = $(this),
          animation = $this.data('animation') || 'fadeIn',
          delay = $this.data('delay') || 0;

        setTimeout(function () {
          $this.addClass('animation--done animated ' + animation);
        }, delay);
      }
    });
  } else if (animationTarget.length) {
    animationTarget.each(function () {
      if ($(this).hasClass('animation--done')) {
        return;
      }
      var $this = $(this),
        animation = $this.data('animation') || 'fadeIn',
        delay = $this.data('delay') || 0;

      setTimeout(function () {
        $this.addClass('animation--done animated ' + animation);
      }, delay);
    });
  }

  // Animated numbers
  if ($.fn.onScreen && countTarget.length) {
    /* count up when in viewport */
    countTarget.each(function () {
      var $this = $(this);
      $this.onScreen({
        doIn: function () {
          $this.countTo({
            onComplete: function () {
              $this.removeClass('count');
            }
          });
        },
      });
    });
  } else if (countTarget.length) {
    countTarget.each(function () {
      var $this = $(this);
      $this.countTo({
        onComplete: function () {
          $this.removeClass('count');
        }
      });
    });
  }

  // Animated progress bars
  if ($.fn.onScreen && progressBarTarget.length) {
    /* animate width when in viewport */
    progressBarTarget.onScreen({
      doIn: function () {
        if ($(this).hasClass('animation--done')) {
          return;
        }
        var $this = $(this),
          percent = $this.data('percent');
        $this.addClass('animation--done').animate({
          width: Math.ceil(percent) + '%'
        }, 800, 'easeInCubic');
      }
    });
  } else if (progressBarTarget.length) {
    progressBarTarget.each(function () {
      if ($(this).hasClass('animation--done')) {
        return;
      }
      var $this = $(this),
        percent = $this.data('percent');
      $this.addClass('animation--done').animate({
        width: Math.ceil(percent) + '%'
      }, 800, 'easeInCubic');
    });
  }

})(jQuery);

(function ($) {
  'use strict';

  /* Accordion UI Element */
  var accordionBody = $('.accordion > .accordion-container > .accordion-body'),
    accordionTitleTarget = $('.accordion > .accordion-container > .accordion-title > a');

  if ($('.accordion').length) {
    accordionBody.hide();

    $('.accordion').each(function () {
      $(this).find('.accordion-body').first().show();
      $(this).find('.accordion-container').first().addClass('active');
    });
  }

  accordionTitleTarget.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var thisParent = $(this).parent();

    if (!$(this).closest('.accordion').hasClass('accordion-toggle')) {
      $(this).closest('.accordion').find('.accordion-body').slideUp();
      $(this).closest('.accordion').find('.accordion-container').removeClass('active');
    }

    if (thisParent.next().css('display') !== 'block') {
      thisParent.next().slideDown();
      thisParent.parent().addClass('active');

      return false;
    } else if (thisParent.next().css('display') === 'block') {

      thisParent.next().slideUp();
      thisParent.parent().removeClass('active');

      return false;
    }
    return false;

  });

})(jQuery);

(function () {
    'use strict';

    angular
        .module('consulatApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('consulatApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            identity2: identity2,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();
            console.log("in........");
            console.log(force);
            console.log(deferred);
            
            if (force === true) {
                console.log("force........");

                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);
                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            console.log(deferred);
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }


        function identity2 () {
            var deferred = $q.defer();
        
            var fakeUser = {
                name: "user",     
                phone: "", 
                authorities: ["ROLE_VOTE"] 
            }
            _identity = fakeUser;
            _authenticated = true;
            deferred.resolve(_identity);

            return deferred.promise;

        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            loginPhone: loginPhone,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            $state.go('home-election');
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginPhone (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();
            var fakeUser = {
                name: "user",     
                phone: "", 
                authorities: ["ROLE_USER"] 
            }
            AuthServerProvider.loginPhone(credentials)
                .then(function(account) {
                    loginThen(fakeUser);
                })
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));
            
            function loginThen (data) {
                Principal.identity2().then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginPhone:loginPhone,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {

            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginPhone (credentials) {
            console.log(credentials);
            var data = {
                username: "credentials.username",
                password: "credentials.password",
                rememberMe: "credentials.rememberMe"
            };
            
            return $http.post('api/authenticatePhone', credentials).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
             
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    console.log("oioioioioioi");

                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, false);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();
             console.log("token auth");
            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                console.log("token auth2");

                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }
            console.log("token auth3");

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {

            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('SidebarController', SidebarController);
    SidebarController.$inject = ['$http', '$scope', 'Principal', '$state', 'Notification'];

    function SidebarController($http, $scope, Principal, $state, Notification) {
        var vs = this;

        vs.passwordChanged = true;
        vs.hasChangePassword = hasChangePassword;
        vs.init = init;

        Principal.identity().then(function(account) {
            if(account==null){
                vs.isAuthenticated = Principal.isAuthenticated;
            }else{
                if(account.resetKey==null){
                    vs.isAuthenticated = Principal.isAuthenticated;
                }else{
                    vs.isAuthenticated = null;
                }
            }
        });

       function hasChangePassword() {
            $http.get('api/account/has_change_password').then(function(data) {
                if (data.data === true) {
                    vs.passwordChanged = true;
                } else {
                    vs.passwordChanged = false;
                    $state.go('password');
                }
            }, function() {
                vs.passwordChanged = true;
            });
        }
        function init() {
            //Code du fichier toggle.js

            /* Define some variables */
            var $window = $(window),
                body = $('body'),
                app = $('.app'),
                mainPanel = $('.main-panel');

            /* Debouncer */
            function debounce(func, wait, immediate) {
                var timeout;
                return function() {
                    var context = this,
                        args = arguments;
                    var later = function() {
                        timeout = null;
                        if (!immediate) {
                            func.apply(context, args);
                        }
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) {
                        func.apply(context, args);
                    }
                };
            }

            /* Toggle chat sidebar */
            var toggleChat = $('[data-toggle=layout-chat-open], [data-toggle=chat-dismiss]'),
                toggleChatBox = $('.chat-users #chat-list a, .chat-back'),
                isChatOpen = false,
                chatSidebar = $('.app > .chat-panel');

            function toggleChatSidebar() {

                if (isChatOpen) {
                    app.removeClass('layout-chat-open');
                } else {
                    app.addClass('layout-chat-open');
                }
                isChatOpen = !isChatOpen;
            }

            toggleChat.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                toggleChatSidebar();
            });

            toggleChatBox.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                chatSidebar.toggleClass('conversation-open');
            });

            $('.chat-input').keydown(function(e) {
                if (e.keyCode === 13) {
                    e.preventDefault();

                    var message = $(this).text();

                    if (message === '') {
                        return;
                    }

                    $('.chat-conversation-content').append('<div class=\'chat-conversation-user them\'><div class=\'chat-conversation-message\'><p>' + $(this).text() + '</p></div></div>');

                    $(this).text('');
                }
            });


            /* Misc Toggles */
            var toggleActive = $('.toggle-active'),
                toggleSidebarPanel = $('[data-toggle=layout-small-menu]'),
                toggleQuickLaunchPanel = $('[data-toggle=quick-launch-panel]');

            toggleActive.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).toggleClass('active');
            });

            app.toggleClass('layout-small-menu');

            toggleSidebarPanel.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                app.toggleClass('layout-small-menu');
                if (app.hasClass('layout-small-menu')) {
                    destroyScrollbars();
                } else if ($(window).width() > 768 && !psTarg.hasClass('ps-container')) {
                    initScrollbars();
                } else {
                    console.log("***Largeur inférieure à 768px dans toggleSidebarPanel click listener : " + $(window).width());
                }
            });

            toggleQuickLaunchPanel.on('click', function(e) {
                e.preventDefault();
                if (!body.hasClass('layout-quick-launch-panel')) {
                    body.css({
                        transition: '300ms cubic-bezier(.7,0,.3,1)'
                    }).addClass('layout-quick-launch-panel stop-scrolling');
                } else {
                    body.removeClass('layout-quick-launch-panel');
                    setTimeout(function() {
                        body.removeClass('stop-scrolling').css({
                            transition: ''
                        });
                    }, 300);
                }
                window.scrollTo(0, 0);
            });

            $('.scroll-up').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $('html,body').stop().animate({
                    scrollTop: body.offset().top
                }, 1000);
                return false;
            });


            /* Smooth scroll to id */
            var smoothScroll = $('.smooth-scroll');

            smoothScroll.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        $('html,body').stop().animate({
                            scrollTop: target.offset().top
                        }, 1000);
                        return false;
                    }
                }
            });

            /* Toggle Offscreen menu */
            var offscreenToggleBtn = $('[data-toggle=offscreen]'),
                offscreenDirection,
                offscreenDirectionClass,
                rapidClickCheck = false,
                isOffscreenOpen = false;

            function toggleMenu() {

                if (isChatOpen) {
                    toggleChatSidebar();
                }

                if (isOffscreenOpen) {
                    app.removeClass('move-left move-right');
                    setTimeout(function() {
                        app.removeClass('offscreen');
                    }, 300);
                } else {
                    app.addClass('offscreen ' + offscreenDirectionClass);
                }
                isOffscreenOpen = !isOffscreenOpen;

                rapidClickFix();
            }

            function rapidClickFix() {
                setTimeout(function() {
                    rapidClickCheck = false;
                }, 300);
            }

            offscreenToggleBtn.on('click', function(e) {

                e.preventDefault();

                e.stopPropagation();

                offscreenDirection = $(this).data('move') ? $(this).data('move') : 'ltr';

                if (offscreenDirection === 'rtl') {
                    offscreenDirectionClass = 'move-right';
                } else {
                    offscreenDirectionClass = 'move-left';
                }

                if (rapidClickCheck) {
                    return;
                }

                rapidClickCheck = true;

                toggleMenu();

            });

            mainPanel.on('click', function(e) {
                var target = e.target;

                if (isOffscreenOpen && target !== offscreenToggleBtn) {
                    toggleMenu();
                }
            });

            /* Sidebar sub-menus */
            $('.sidebar-panel nav a').on('click', function(e) {

                var $this = $(this),
                    links = $this.parents('li'),
                    parentLink = $this.closest('li'),
                    otherLinks = $('.sidebar-panel nav li').not(links),
                    subMenu = $this.next();

                if (!subMenu.hasClass('sub-menu')) {
                    toggleMenu();
                    return;
                }

                if (app.hasClass('layout-small-menu') && parentLink.parent().hasClass('nav') && $(window).width() > 768) {
                    return;
                }

                otherLinks.removeClass('open');

                if (subMenu.is('ul') && (subMenu.height() === 0)) {
                    parentLink.addClass('open');
                } else if (subMenu.is('ul') && (subMenu.height() !== 0)) {
                    parentLink.removeClass('open');
                }

                if ($this.attr('href') === '#') {
                    e.preventDefault();
                }

                updateScrollbars();

                if (subMenu.is('ul')) {
                    return false;
                }

                e.stopPropagation();

                return true;
            });

            $('.sidebar-panel').find('> li > .sub-menu').each(function() {
                if ($(this).find('ul.sub-menu').length > 0) {
                    $(this).addClass('multi-level');
                }
            });

            $('.sidebar-panel').find('.sub-menu').each(function() {
                $(this).parent('li').addClass('menu-accordion');
            });

            var psTarg = $('.sidebar-panel > nav');

            function initScrollbars() {
                if (app.hasClass('layout-small-menu') || app.hasClass('layout-static-sidebar') || app.hasClass('layout-boxed')) {
                    return;
                }

                $('.sidebar-panel > nav').perfectScrollbar({
                    wheelPropagation: true,
                    suppressScrollX: true
                });
            }

            function destroyScrollbars() {
                psTarg.perfectScrollbar('destroy').removeClass();
            }

            function updateScrollbars() {
                if (psTarg.hasClass('ps-container')) {
                    psTarg.perfectScrollbar('update');
                }
            }

            initScrollbars();

            var watchScrollbars = debounce(function() {
                //console.log("***Windows resizing with width = " + window.innerWidth);
                if (768 >= window.innerWidth) {
                    if (psTarg.hasClass('ps-container')) {
                        destroyScrollbars();
                    }
                    return;
                } else {
                    if (!psTarg.hasClass('ps-container')) {
                        initScrollbars();
                    }
                    return;
                }
            }, 300);

            window.addEventListener('resize', watchScrollbars);
        }

        $scope.$on('authenticationSuccess', function() {
            Principal.identity().then(function(account) {
                if(account.resetKey==null){
                    vs.isAuthenticated = Principal.isAuthenticated;
                    if (vs.isAuthenticated()) {
                        vs.hasChangePassword();
                    }
                }else{
                    vs.isAuthenticated = null;
                }
            });
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

"use strict";


angular.module('app.layout', ['ui.router'])

.config(function ($stateProvider, $urlRouterProvider) {


    $stateProvider
        .state('app', {
            abstract: true,
            views: {
                root: {
                    templateUrl: 'app/layout/layout.tpl.html'
                }
            }
        });
    $urlRouterProvider.otherwise('/dashboard');

})


"use strict";

angular.module('consulatApp').directive('languageSelector', function(Language){
    return {
        restrict: "EA",
        replace: true,
        templateUrl: "app/layout/language/language-selector.tpl.html",
        scope: true
    }
});
"use strict";

angular.module('consulatApp').controller("LanguagesCtrl",  function LanguagesCtrl($scope, $rootScope, $log, Language){

    $rootScope.lang = {};
    
    Language.getLanguages(function(data){

        $rootScope.currentLanguage = data[0];

        $rootScope.languages = data;

        Language.getLang(data[0].key,function(data){

            $rootScope.lang = data;
        });

    });

    $scope.selectLanguage = function(language){
        $rootScope.currentLanguage = language;
        
        Language.getLang(language.key,function(data){

            $rootScope.lang = data;
            
        });
    }

    $rootScope.getWord = function(key){
        if(angular.isDefined($rootScope.lang[key])){
            return $rootScope.lang[key];
        } 
        else {
            return key;
        }
    }

});
"use strict";

angular.module('consulatApp').factory('Language', function($http, APP_CONFIG){

	function getLanguage(key, callback) {

		$http.get(APP_CONFIG.apiRootUrl + '/langs/' + key + '.json').success(function(data){

			callback(data);
			
		}).error(function(){

			$log.log('Error');
			callback([]);

		});

	}

	function getLanguages(callback) {

		$http.get(APP_CONFIG.apiRootUrl + '/languages.json').success(function(data){

			callback(data);
			
		}).error(function(){

			$log.log('Error');
			callback([]);

		});

	}

	return {
		getLang: function(type, callback) {
			getLanguage(type, callback);
		},
		getLanguages:function(callback){
			getLanguages(callback);
		}
	}

});
(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

// (function() {
//     'use strict';

//     angular
//         .module('consulatApp')
//         .config(stateConfig);

//     stateConfig.$inject = ['$stateProvider'];

//     function stateConfig($stateProvider) {
//         $stateProvider.state('home-election', {
//             parent: 'app',
//             url: '/election',
//             data: {
//                 authorities: []
//             },
//             views: {
//                 'content@': {
//                     templateUrl: 'app/home-election/home-election.html',
//                     controller: 'HomeElectionController',
//                     controllerAs: 'vm'
//                 }
//             },
//             resolve: {
//                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
//                     $translatePartialLoader.addPart('home');
//                     return $translate.refresh();
//                 }]
//             }
//         })
//     }
// })();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('HomeElectionController', HomeElectionController);

        HomeElectionController.$inject = ['$scope', 'Principal','DateUtils','$location', 'LoginService', '$state','MembreServiceTop10','MembreServiceTop10Even','$rootScope','Auth','$http','ConsulatTop1'];

    function HomeElectionController ($scope, Principal,DateUtils,$location, LoginService, $state,MembreServiceTop10,MembreServiceTop10Even,$rootScope,Auth,$http,ConsulatTop1) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.periodeDebut = null;
        vm.periodeFin = null;
        vm.token = null;
        vm.otp = null;
        vm.etat
        vm.getOtp = getOtp;
        vm.codeOtp = null;
        vm.zoneId = null;



        vm.authenticationError = false;
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.phoneNumber = null;

        const user = {

          };
        vm.fakeUser = {
            name: "user",     
            phone: "", 
            authorities: ["ROLE_VOTE"] 
        }



        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }



        // $scope.$on('authenticationSuccess', function() {
        //     getAccount();
        // });

        // getAccount();

        // function getAccount() {

        //     Principal.identity().then(function(account) {
        //         vm.account = account;
        //         vm.isAuthenticated = Principal.isAuthenticated;
        //         if(account!=null){
        //             vm.consulat = ConsulatTop1.get();
        //             console.log(vm.account);
        //         var result = vm.account.authorities.find(function(n){
        //             return n==='ROLE_MEMBRE';
        //         });

        //         if(result=="ROLE_MEMBRE"){
        //             vm.manageCharts();

        //         }
        //         }


        //     });
        // }
        function register () {
            $state.go('register');
        }

        function getOtp () {
             $http.post('api/sendOtp', { phoneNumber: vm.phoneNumber }).then(function (response) {
                vm.otp = Object.keys(response.data)[0];;  
                vm.zoneId = response.data[vm.otp];            
                console.log(response);
            });



            // function authenticateSuccess (data, status, headers) {

            //     var bearerToken = headers('Authorization');
            //     if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
            //         console.log("oioioioioioi");

            //         var jwt = bearerToken.slice(7, bearerToken.length);
            //         service.storeAuthenticationToken(jwt, phone.rememberMe);
            //         return jwt;
            //     }
            // }
        }

        function login (event) {
            event.preventDefault();
            console.log(vm.phoneNumber)
            var credentials = {
                phoneNumber: vm.phoneNumber,     
                code: vm.codeOtp, 
            }
            Auth.loginPhone(credentials).then(function (response) {
                
                //vm.token = response.data.id_token;
                
                // Principal.authenticate(vm.fakeUser).then(function() {
                //    console.log(account);
                // $location.path('/vote').search({ userPhone: vm.phoneNumber });
                 $state.go('vote', { userPhone: vm.phoneNumber,  zone: vm.zoneId });
    
                // });               
            }).catch(function () {
                vm.authenticationError = true;
            });

        }


        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        function getAccount() {

            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if(account!=null){
                    console.log(vm.account);
                var result = vm.account.authorities.find(function(n){
                    return n==='ROLE_MEMBRE';
                });
                }


            });
        }



        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal','DateUtils', 'LoginService', '$state','MembreServiceTop10','MembreServiceTop10Even','$rootScope','Auth','$http','ConsulatTop1'];

    function HomeController ($scope, Principal,DateUtils, LoginService, $state,MembreServiceTop10,MembreServiceTop10Even,$rootScope,Auth,$http,ConsulatTop1) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.manageCharts = manageCharts;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.periodeDebut = null;
        vm.periodeFin = null;




        vm.authenticationError = false;
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        vm.dateFinEstAvantDateDebut = function () {
            var debut = new moment(vm.periodeDebut);
            var fin = new moment(vm.periodeFin);
            return fin.isBefore(debut);
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }






        vm.list=MembreServiceTop10.query();

        vm.listEven=MembreServiceTop10Even.query();
        console.log(vm.list);
        console.log(vm.listEven);


        $scope.$watch("vm.periodeFin", function(fin) {
            if(fin!=null){
                vm.manageCharts();
        }
        });






        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {

            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if(account!=null){
                    vm.consulat = ConsulatTop1.get();
                    console.log(vm.account);
                var result = vm.account.authorities.find(function(n){
                    return n==='ROLE_MEMBRE';
                });

                if(result=="ROLE_MEMBRE"){
                    vm.manageCharts();

                }
                }


            });
        }
        function register () {
            $state.go('register');
        }




        function manageCharts() {
            /*Gestion des graphes de statistiques*/

            vm.membreSexe = {};
            vm.membreAssoc = {};
            vm.etatMembre = {};
            vm.membreArrivee = {};
            vm.trancheAge = {};


            vm.trancheAge.labels = [];
            vm.trancheAge.data = [];
            vm.trancheAge.options = {
                legend: {
                    display: false,
                    position: 'up'
                }
            };

            vm.membreSexe.labels = [];
            vm.membreSexe.data = [];
            vm.membreSexe.options = {
                legend: {
                    display: true,
                    position: 'left'
                }
            };

            vm.membreAssoc.labels = [];
            vm.membreAssoc.data = [];
            vm.membreAssoc.options = {
                legend: {
                    display: false,
                    position: 'left'
                }
            };

            vm.etatMembre.labels = [];
            vm.etatMembre.data = [];
            vm.etatMembre.options = {
                legend: {
                    display: false,
                    position: 'left'
                }
            };

            vm.membreArrivee.labels = [];
            vm.membreArrivee.data = [];
            vm.membreArrivee.options = {
                legend: {
                    display: true,
                    position: 'left'
                }
            };


         /*   vm.poseEffectue.labels = [];
            vm.poseEffectue.data = [];
            vm.poseEffectue.options = {
                legend: {
                    display: false,
                    position: 'top'
                }
            };*/

            $http.get("api/statistiques/dateNaissanceMembers", {params: {}}).then(
                function(response) {
                    console.log(response.data);
                    vm.trancheAge.labels = response.data.age;
                    vm.trancheAge.data = response.data.data;
                }
            );

            $http.get("api/statistiques/dateArriveeMembers", {params: {debut: vm.periodeDebut,fin:vm.periodeFin}}).then(
                function(response) {
                    console.log(response.data);
                    vm.membreArrivee.labels = response.data.total;
                    vm.membreArrivee.data = response.data.data;
                }
            );

            $http.get("api/statistiques/membreSexe", {params: {}}).then(
                function(response) {
                    console.log(response.data);
                    vm.membreSexe.labels = response.data.etats;
                    vm.membreSexe.data = response.data.data;
                }
            );

            $http.get("api/statistiques/assocMembers", {params: {}}).then(
                function(response) {
                    console.log(response.data);
                    vm.membreAssoc.labels = response.data.types;
                    vm.membreAssoc.data = response.data.data;
                }
            );

            $http.get("api/statistiques/etatMembers", {params: {}}).then(
                function(response) {
                    console.log(response.data);
                    vm.etatMembre.labels = response.data.etats;
                    vm.etatMembre.data = response.data.data;
                }
            );


        }









        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                /*
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }*/

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }



        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
















    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ZoneDialogController', ZoneDialogController);

    ZoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Zone', 'StatesAll', 'StatesByZone'];

    function ZoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,Zone, StatesAll, StatesByZone) {
        var vm = this;

        vm.zone = entity;

        vm.clear = clear;
        vm.save = save;
        vm.states = StatesAll.query();


        if(vm.zone.id!=null)
        {
        StatesByZone.query({
            id: vm.zone.id
        }, function (data) {
            vm.zone.etats = data ;
        })
    }
       

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.zone.id !== null) {
                Zone.update(vm.zone, onSaveSuccess, onSaveError);
            } else {
                Zone.save(vm.zone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:zoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.colums = [{
            name: 'libelle',
            title: 'Libelle'
        }];


        $scope.$watch("vm.etatId", function (ids) {

            StatesAll.query(function (data) {
                vm.etats = data;
                //console.log(vm.etats);
            })


            if (angular.isDefined(ids)) {
                vm.zone.etats = [];
                angular.forEach(ids, function (value, index) {
                    var auth = _.find(vm.etats, {'id': value});
                    vm.zone.etats.push(auth);
                });
            }
        });


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ZoneDetailController', ZoneDetailController);

    ZoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Zone', 'States', 'City'];

    function ZoneDetailController($scope, $rootScope, $stateParams, previousState, entity, Zone, States, City) {
        var vm = this;

        vm.zone = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:zoneUpdate', function(event, result) {
            vm.zone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ZoneDeleteController',ZoneDeleteController);

    ZoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Zone'];

    function ZoneDeleteController($uibModalInstance, entity, Zone) {
        var vm = this;

        vm.zone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Zone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('zone', {
            parent: 'entity',
            url: '/zone?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'zones'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zone/zone.html',
                    controller: 'ZoneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('zone-detail', {
            parent: 'zone',
            url: '/zone/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'zone'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zone/zone-detail.html',
                    controller: 'ZoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Zone', function($stateParams, Zone) {
                    return Zone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'zone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('zone-detail.edit', {
            parent: 'zone-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-dialog.html',
                    controller: 'ZoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zone', function(Zone) {
                            return Zone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zone.new', {
            parent: 'zone',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-dialog.html',
                    controller: 'ZoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                libele: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('zone', null, { reload: 'zone' });
                }, function() {
                    $state.go('zone');
                });
            }]
        })
        .state('zone.edit', {
            parent: 'zone',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-dialog.html',
                    controller: 'ZoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zone', function(Zone) {
                            return Zone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zone', null, { reload: 'zone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zone.delete', {
            parent: 'zone',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-delete-dialog.html',
                    controller: 'ZoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Zone', function(Zone) {
                            return Zone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zone', null, { reload: 'zone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Zone', Zone);

    Zone.$inject = ['$resource'];

    function Zone ($resource) {
        var resourceUrl =  'api/zone/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ZoneController', ZoneController);

    ZoneController.$inject = ['$scope', 'Zone', 'TableService'];

    function ZoneController($scope, Zone, TableService) {

        var vm = this;

        var addItemData ={
            templateUrl: 'app/entities/zone/zone-dialog.html',
            controller: 'ZoneDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'mg',
            resolve: {
                entity: function () {
                    return {
                        id: null,
                        libele: null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/zone/zone-dialog.html',
            controller: 'ZoneDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/entities/zone/zone-delete-dialog.html',
            controller: 'ZoneDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

          var detailItemData = {
            templateUrl: 'app/entities/zone/zone-detail.html',
            controller: 'ZoneDetailController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null, //valeur déterminé à l'appel de la boite
                 isViewing: true
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Zone,
            entitySearch: Zone,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('UserExtraForgotPassController', UserExtraForgotPassController);

        UserExtraForgotPassController.$inject = ['ProfilByUser', '$scope', 'Notification', 'User', 'Consulat', 'Profil', 'Members'];

    function UserExtraForgotPassController (ProfilByUser, $scope, Notification, User, Consulat, Profil, Members) {
       
        var vm = this;

        vm.save = save;
    
     
       
        function onSaveSuccess(result) {
            vm.isSaving = false;
        }



        //Pour une modification effectué par un assistant
        

        function onSaveError() {
            vm.isSaving = false;
   
        }

        function save() {
            vm.isSaving = true;
  
                if(vm.confirmEmail !== vm.email) {
                    Notification.error("L'email' et sa confirmation ne sont pas égaux !");
                    onSaveError();
                }else{
                User.update(vm.user, onSaveSuccess, onSaveError);
                }
           
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('UserExtraDialogController', UserExtraDialogController);

    UserExtraDialogController.$inject = ['ProfilByUser','UserExtraConnected', '$scope', '$uibModalInstance', 'isEdit', 'isViewing', 'entity', 'Notification', 'User', 'Consulat', 'Profil', 'Members'];

    function UserExtraDialogController (ProfilByUser,UserExtraConnected, $scope, $uibModalInstance,isEdit, isViewing, entity, Notification, User, Consulat, Profil, Members) {

        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.test = test;
        vm.user = entity;
        vm.esDefini=null;
        vm.isEdit = isEdit;
        vm.uniteorgimanets = [];
        vm.profils= [];
        vm.modifPassword = false;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.isViewing = isViewing;
        vm.organisationId = null;
        vm.loadProgressBar = loadProgressBar;

        vm.utilisateur = UserExtraConnected.query();

        if(UserExtraConnected.query().id==null)
        {
            ProfilByUser.query({
            }, function(datas) {
                if (datas != null && datas.length==1) {
                    vm.profils = datas;
                    vm.user.profilId = vm.profils[0].id;
                }
            });
        }
    

        window.VerifaliaWidgetConfig = {
            appKey: '048e195278a540bba8758accb811a8b7'
        };



        vm.isVue = function() {
            return vm.isViewing == true;
        }

        function test() {


        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        if(!vm.isViewing && !vm.isEdit){
            vm.modifPassword = true;
        }


        function loadProfils() {
            ProfilByUser.query({
            }, function(datas) {
                if (datas != null) {
                    vm.profils = datas;
                }
            });
        }


        //Pour une modification effectué par un assistant

        var userAll = {};
            if (vm.user.id != null) {
                vm.esDefini=true;
                userAll = vm.user;
                vm.user = {};
                //Les informations de UserDTO
                vm.user.login = userAll.userDTO.login;
                vm.user.firstName = userAll.userDTO.firstName;
                vm.user.lastName = userAll.userDTO.lastName;
                vm.user.email = userAll.userDTO.email;
                vm.user.activated = userAll.userDTO.activated
                vm.user.authorities = userAll.userDTO.authorities;
                vm.user.id = userAll.userDTO.id;
                //Les informations de UserExtra
                vm.user.code = userAll.userDTO.code;
                vm.user.telephone = userAll.telephone;
                vm.user.photo = userAll.photo;
                //vm.user.userExtraId = userAll.id;
                vm.user.photoContentType = userAll.photoContentType;
                vm.user.profilId = userAll.profilId;
                vm.user.consulatId = userAll.consulatId,
                vm.user.profilNom = userAll.profilNom;
                vm.user.consulatNom = userAll.consulatNom;

            }


        function onSaveError() {
            vm.isSaving = false;

        }

        function save() {
            vm.isSaving = true;

            if (vm.user.id !== null) {
                if(vm.modifPassword && (vm.confirmPassword !== vm.user.password) ){
                    Notification.error("Le mot de passe et sa confirmation ne sont pas égaux !");
                    onSaveError();
                }else{
                User.update(vm.user, onSaveSuccess, onSaveError);
                }
            } else {
                if (vm.confirmPassword == vm.user.password) {
                    User.save(vm.user, onSaveSuccess, onSaveError);
                } else {
                    Notification.error("Le mot de passe et sa confirmation ne sont pas égaux !");
                    onSaveError();
                }
            }
        }



        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.consulatColums = [{
            name: 'code',
            title: 'Code'
        }, {
            name: 'nom',
            title: 'Nom'
        }];

        $scope.$on("onLoadConsulat", function() {
            loadConsulats()
            if(vm.utilisateur.id!=null)
            {
            vm.user.profilId=null;
            }
           vm.profils= [];
        });

        function loadConsulats() {
            Consulat.query({}, function(data) {
                if (data != null) {
                    vm.consulats = [];
                    vm.consulats = data;
                }
            });
        }




        vm.profilsColums = [{
            name: 'nom',
            title: 'Nom'
        }]

        $scope.$on("onLoadProfil", function() {
                    loadProfils();
            }
        )

        function changePasswordProgressBar(ev) {
            // less than 8 characters
            var wrost = 7,
                // minimum 8 characters
                bad = /(?=.{8,}).*/,
                //Alpha Numeric plus minimum 8
                good = /^(?=\S*?[a-z])(?=\S*?[0-9])\S{8,}$/,
                //Must contain at least one upper case letter, one lower case letter and (one number OR one special char).
                better = /^(?=\S*?[A-Z])(?=\S*?[a-z])((?=\S*?[0-9])|(?=\S*?[^\w\*]))\S{8,}$/,
                //Must contain at least one upper case letter, one lower case letter and (one number AND one special char).
                best = /^(?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9])(?=\S*?[^\w\*])\S{8,}$/,
                password = $(ev.target).val(),
                strength = '0',
                progressClass = 'progress-bar progress-bar-',
                ariaMsg = '0% Complete (danger)',
                $progressBarElement = $('#password-progress-bar');

            if (best.test(password) === true) {
                strength = '100%';
                progressClass += 'success';
                ariaMsg = '100% Complete (success)';
            } else if (better.test(password) === true) {
                strength = '80%';
                progressClass += 'info';
                ariaMsg = '80% Complete (info)';
            } else if (good.test(password) === true) {
                strength = '50%';
                progressClass += 'warning';
                ariaMsg = '50% Complete (warning)';
            } else if (bad.test(password) === true) {
                strength = '30%';
                progressClass += 'warning';
                ariaMsg = '30% Complete (warning)';
            } else if (password.length >= 1 && password.length <= wrost) {
                strength = '10%';
                progressClass += 'danger';
                ariaMsg = '10% Complete (danger)';
            } else if (password.length < 1) {
                strength = '0';
                progressClass += 'danger';
                ariaMsg = '0% Complete (danger)';
            }

            $progressBarElement.removeClass().addClass(progressClass);
            $progressBarElement.attr('aria-valuenow', strength);
            $progressBarElement.css('width', strength);
            $progressBarElement.find('span.sr-only').text(ariaMsg);
        }

        function loadProgressBar() {
            $(document).ready(function () {
                $(".pwd").first().on('keyup', changePasswordProgressBar);
            });
        }

        loadProgressBar();
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('UserExtraDetailController', UserExtraDetailController);

    UserExtraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'UserExtra', 'User', 'Consulat', 'Profil', 'Members'];

    function UserExtraDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, UserExtra, User, Consulat, Profil, Members) {
        var vm = this;

        vm.userExtra = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('consulatApp:userExtraUpdate', function(event, result) {
            vm.userExtra = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('UserExtraDeleteController',UserExtraDeleteController);

    UserExtraDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserExtra'];

    function UserExtraDeleteController($uibModalInstance, entity, UserExtra) {
        var vm = this;

        vm.userExtra = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserExtra.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-extra', {
            parent: 'entity',
            url: '/user-extra?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'UserExtras'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-extra/user-extras.html',
                    controller: 'UserExtraController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userExtra');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-extra-detail', {
            parent: 'user-extra',
            url: '/user-extra/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'UserExtra'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-extra/user-extra-detail.html',
                    controller: 'UserExtraDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'UserExtra', function($stateParams, UserExtra) {
                    return UserExtra.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'user-extra',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('user-extra-detail.edit', {
            parent: 'user-extra-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-extra/user-extra-dialog.html',
                    controller: 'UserExtraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserExtra', function(UserExtra) {
                            return UserExtra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-extra.new', {
            parent: 'user-extra',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-extra/user-extra-dialog.html',
                    controller: 'UserExtraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                telephone: null,
                                photo: null,
                                photoContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-extra', null, { reload: 'user-extra' });
                }, function() {
                    $state.go('user-extra');
                });
            }]
        })
        .state('user-extra.edit', {
            parent: 'user-extra',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-extra/user-extra-dialog.html',
                    controller: 'UserExtraDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserExtra', function(UserExtra) {
                            return UserExtra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-extra', null, { reload: 'user-extra' });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('forgot_pass', {
            parent: 'app',
            url: '/forgot-password',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-extra/user-extra-forgot-pass.html',
                    controller: 'UserExtraForgotPassController',
                    controllerAs: 'vm'
                }
            }
        })



        .state('user-extra.delete', {
            parent: 'user-extra',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-extra/user-extra-delete-dialog.html',
                    controller: 'UserExtraDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserExtra', function(UserExtra) {
                            return UserExtra.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-extra', null, { reload: 'user-extra' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('UserExtra', UserExtra)
        .factory('UserExtraConnected', UserExtraConnected);

    UserExtra.$inject = ['$resource'];
    UserExtraConnected.$inject = ['$resource'];

    function UserExtra ($resource) {
        var resourceUrl =  'api/user-extras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function UserExtraConnected ($resource) {
        var resourceUrl =  'api/user-extras/connected';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }






})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('UserExtraController', UserExtraController);

    UserExtraController.$inject = [ '$scope','UserExtra', 'Principal','TableService'];

    function UserExtraController( $scope,UserExtra, Principal,TableService) {

        var vm = this;
        var datas = {};
   
      
        vm.currentAccount=null;
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });
        vm.setActive=function setActive (userExtra, isActivated) {
           var user = userExtra.userDTO;
            user.activated = isActivated;
            user.telephone=userExtra.userExtraDTO.telephone;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }
        


          function _update(srcObj, destObj) {
            for (var key in destObj) {
                destObj[key] = srcObj[key];
            }
          }


        var addItemData = {
            templateUrl: 'app/entities/user-extra/user-extra-dialog.html',
            controller: 'UserExtraDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: function () {
                    return {
                        code: null,
                        telephone: null,
                        photo: null,
                        photoContentType: null,
                        id: null,
                        login: null,
                        firstName: null,
                        lastName: null,
                        email: null,
                        activated: true,
                        langKey: null,
                        createdBy: null,
                        createdDate: null,
                        lastModifiedBy: null,
                        lastModifiedDate: null,
                        profilId:null,
                        consulatId:null
                        //agenceId:vm.agencePolice.id
                    };
                },
                isViewing: function () {
                    return false;
                },
                isEdit: function () {
                    return false;
                }
            }
        };

        /**
         *Modification d'un élément
         */

        var editItemData = {
            templateUrl: 'app/entities/user-extra/user-extra-dialog.html',
            controller: 'UserExtraDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null,
                isViewing: function () {
                    return false;
                },
                isEdit: function () {
                    return true;
                }
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData = {
            templateUrl: 'app/entities/user-extra/user-extra-delete-dialog.html',
            controller: 'UserExtraDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        var detailItemData = {
            templateUrl: 'app/entities/user-extra/user-extra-dialog.html',
            controller: 'UserExtraDialogController',
            controllerAs: 'vm',
            size: 'md',
            resolve: {
                ACTION: function () {
                    return vm.action;
                },
                isViewing: function () {
                    return true;
                },
                isEdit: function () {
                    return false;
                },
                entity: null //valeur déterminé à l'appel de la boite,
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function () {
            return {

            };
        };

        var entityParams = function () {
            return{
                organisationId:vm.organisationId
            };
        };

            datas = {
                scope: $scope,
                vm: vm,
                entity: UserExtra,
                entitySearch: UserExtra,
                dialogData: dialogData,
                entitySearchParams: entitySearchParams,
                entityParams: entityParams
            };
            TableService.init(datas);

            vm.initInfo = function() {
                vm.loadAll();
            };
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('TypeAssociationDialogController', TypeAssociationDialogController);

    TypeAssociationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeAssociation'];

    function TypeAssociationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeAssociation) {
        var vm = this;

        vm.typeAssociation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeAssociation.id !== null) {
                TypeAssociation.update(vm.typeAssociation, onSaveSuccess, onSaveError);
            } else {
                TypeAssociation.save(vm.typeAssociation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:typeAssociationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('TypeAssociationDetailController', TypeAssociationDetailController);

    TypeAssociationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TypeAssociation'];

    function TypeAssociationDetailController($scope, $rootScope, $stateParams, previousState, entity, TypeAssociation) {
        var vm = this;

        vm.typeAssociation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:typeAssociationUpdate', function(event, result) {
            vm.typeAssociation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('TypeAssociationDeleteController',TypeAssociationDeleteController);

    TypeAssociationDeleteController.$inject = ['$uibModalInstance', 'entity', 'TypeAssociation'];

    function TypeAssociationDeleteController($uibModalInstance, entity, TypeAssociation) {
        var vm = this;

        vm.typeAssociation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TypeAssociation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('type-association', {
            parent: 'entity',
            url: '/type-association?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.typeAssociation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/type-association/type-associations.html',
                    controller: 'TypeAssociationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeAssociation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-association-detail', {
            parent: 'type-association',
            url: '/type-association/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.typeAssociation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/type-association/type-association-detail.html',
                    controller: 'TypeAssociationDetailController',
                    controllerAs: 'vm'

               }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeAssociation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TypeAssociation', function($stateParams, TypeAssociation) {
                    return TypeAssociation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'type-association',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('type-association-detail.edit', {
            parent: 'type-association-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type-association/type-association-dialog.html',
                    controller: 'TypeAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeAssociation', function(TypeAssociation) {
                            return TypeAssociation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-association-test.new', {
            parent: 'type-association',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type-association/type-association-dialog.html',
                    controller: 'TypeAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-association', null, { reload: 'type-association' });
                }, function() {
                    $state.go('type-association');
                });
            }]
        })
        .state('type-association.edit', {
            parent: 'type-association',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type-association/type-association-dialog.html',
                    controller: 'TypeAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeAssociation', function(TypeAssociation) {
                            return TypeAssociation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-association', null, { reload: 'type-association' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-association.delete', {
            parent: 'type-association',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/type-association/type-association-delete-dialog.html',
                    controller: 'TypeAssociationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeAssociation', function(TypeAssociation) {
                            return TypeAssociation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-association', null, { reload: 'type-association' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('TypeAssociation', TypeAssociation);

    TypeAssociation.$inject = ['$resource'];

    function TypeAssociation ($resource) {
        var resourceUrl =  'api/type-associations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('TypeAssociationController', TypeAssociationController);

    TypeAssociationController.$inject = ['$state', 'TypeAssociation', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TypeAssociationController($state, TypeAssociation, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            TypeAssociation.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.typeAssociations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('StatesDialogController', StatesDialogController);

    StatesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'States', 'City', 'Country'];

    function StatesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, States, City, Country) {
        var vm = this;

        vm.states = entity;
        vm.clear = clear;
        vm.save = save;
      


        vm.countryColumns = [{
            name: 'libele',
            title: 'Libelle'
        }];
        $scope.$on("onLoadCountries", function () {

        });
        loadCountries();

        function loadCountries() {
            Country.query({
                size: 10000
            }, function (data) {
                if (data != null) {
                    vm.countries = [];
                    vm.countries = data;
                }
            });


           // vm.members.lieuNaissance = test.libele;
        }









        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.states.id !== null) {
                States.update(vm.states, onSaveSuccess, onSaveError);
            } else {
                States.save(vm.states, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:cityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('StatesDetailController', StatesDetailController);

    StatesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'States', 'City', 'Country'];

    function StatesDetailController($scope, $rootScope, $stateParams, previousState, entity, States, City, Country) {
        var vm = this;

        vm.states = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:statesUpdate', function(event, result) {
            vm.states = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('StatesDeleteController',StatesDeleteController);

    StatesDeleteController.$inject = ['$uibModalInstance', 'entity', 'States'];

    function StatesDeleteController($uibModalInstance, entity, States) {
        var vm = this;

        vm.states = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            States.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('states', {
            parent: 'entity',
            url: '/states?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'States'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/states/states.html',
                    controller: 'StatesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('states');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('states-detail', {
            parent: 'states',
            url: '/states/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'States'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/states/states-detail.html',
                    controller: 'StatesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'States', function($stateParams, States) {
                    return States.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'states',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('states-detail.edit', {
            parent: 'states-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/states/states-dialog.html',
                    controller: 'StatesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['States', function(States) {
                            return States.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('states.new', {
            parent: 'states',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/states/states-dialog.html',
                    controller: 'StatesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                libelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('states', null, { reload: 'states' });
                }, function() {
                    $state.go('states');
                });
            }]
        })
        .state('states.edit', {
            parent: 'states',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/states/states-dialog.html',
                    controller: 'StatesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['States', function(States) {
                            return States.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('states', null, { reload: 'states' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('states.delete', {
            parent: 'states',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/states/states-delete-dialog.html',
                    controller: 'StatesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['States', function(States) {
                            return States.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('states', null, { reload: 'states' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('States', States)
        .factory('StatesByCountry', StatesByCountry)
        .factory('StatesByZone', StatesByZone)
        .factory('StatesAll', StatesAll);

    States.$inject = ['$resource'];
    StatesByCountry.$inject = ['$resource'];
    StatesByZone.$inject = ['$resource'];
    StatesAll.$inject = ['$resource'];


    function StatesByCountry ($resource) {
        var resourceUrl =  'api/states/country/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function StatesByZone ($resource) {
        var resourceUrl =  'api/states/zone/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function States ($resource) {
        var resourceUrl =  'api/states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }


    function StatesAll ($resource) {
        var resourceUrl =  'api/states/all';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('StatesController', StatesController);

    StatesController.$inject = ['$scope', 'States', 'TableService'];

    function StatesController($scope, States, TableService) {

        var vm = this;

        var addItemData ={
            templateUrl: 'app/entities/states/states-dialog.html',
            controller: 'StatesDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'mg',
            resolve: {
                entity: function () {
                    return {
                        id: null,
                        libelle: null,
                        countryLibelle: null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/states/states-dialog.html',
            controller: 'StatesDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/entities/states/states-delete-dialog.html',
            controller: 'StatesDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

          var detailItemData = {
            templateUrl: 'app/entities/city/city-detail.html',
            controller: 'CityDetailController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null, //valeur déterminé à l'appel de la boite
                 isViewing: true
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: States,
            entitySearch: States,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();
(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ProfilDialogController', ProfilDialogController);

    ProfilDialogController.$inject = ['Principal', '$scope', '$uibModalInstance', 'entity', 'Profil'];

    function ProfilDialogController (Principal, $scope, $uibModalInstance, entity, Profil) {
        var vm = this;
        vm.profil = entity;
        vm.clear = clear;
        vm.save = save;
        vm.isAdminG = false;
        vm.authorities = [];
        vm.uos = [];

        vm.hasRole = function (role) {
            return vm.authorities_user.indexOf(role) != -1
        }
        vm.profil_authorities = null;
        if (vm.profil.id != null) {
            vm.profil_authorities = vm.profil.authorities;
        }
        /*
           Si l'utilisateur connecte n'est pas un l'admin generale on recupere les roles de son profil
         */
        Principal.identity().then(function (account) {
            //Le compte de l'utilisateur connecte
            vm.currentAccount = account;
            vm.authorities_user = vm.currentAccount.authorities;
            if (vm.hasRole("ROLE_ADMIN")) {
                vm.isAdminG = true;

                vm.authorities = vm.authorities_user;
                var i = 0;
                vm.auth = [];
                angular.forEach(vm.authorities, function (value, index) {
                    if(value!="ROLE_ADMIN")
                    {
                    var v = {};
                    v.name = value;
                    i++;
                    v.id = i;
                    vm.auth.push(v);
                    }
                });
                majUserRoles();


            } else {
                /*
                    On recupere l'organisation de l'utilisateur connecte et les organisations fils de celui
                    s'il est pere
                 */
                vm.authorities = vm.authorities_user;
                var i = 0;
                vm.auth = [];
                angular.forEach(vm.authorities, function (value, index) {
                    var v = {};
                    v.name = value;
                    i++;
                    v.id = i;
                    vm.auth.push(v);
                });
                majUserRoles();
            }
        });

        function majUserRoles() {

            if (angular.isDefined(vm.profil) && vm.profil != null) {
                if (vm.profil.id != null) {
                    vm.authIds = [];
                    angular.forEach(vm.profil.authorities, function (value, index) {
                        var auth = _.find(vm.auth, { 'name': value });
                        if(angular.isDefined(auth)) {
                            vm.authIds.push(auth.id);
                        }
                    });
                }
            }

        }

        /*
        Si l'utilisateur connecte est l'admin generale on recupere les roles
        de l'organisation selectionne
       */
      /*  $scope.$watch("vm.profil.organisationId", function (organisationId) {
            if(angular.isDefined(organisationId)){
                vm.authorities=[];
                RequestUtils.GetRolesOfTypeUniteOrganisation.query({id:organisationId}, function (datas) {
                    console.log("liste des roles");
                    if (datas != null) {
                        var i = 0;
                        vm.auth = [];
                        angular.forEach(datas, function (value, index) {
                            i++;
                            value.id = i;
                            vm.auth.push(value);
                            vm.authorities.push(value.name);
                        });
                    }
                    majUserRoles();
                });
            }
        });*/


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        /*
            Comparer deux liste
        */
        function isSame(arrayOne, arrayTwo) {
            var a = arrayOne,
                b = arrayTwo;

            if (arrayOne.length <= arrayTwo.length) {
                a = arrayTwo;
                b = arrayOne;
            }
            return _.isEmpty(_.difference(a.sort(), b.sort()));
        }


        /*
           Enregistrement ou mise à jour
        */
        function save() {
            vm.isSaving = true;
            if (vm.profil.id != null) {
                vm.profil.profilsChange = !isSame(vm.profil.authorities, vm.profil_authorities);
                vm.isSaving = false;
            }
            if (vm.profil.id !== null) {
                Profil.update(vm.profil, onSaveSuccess, onSaveError);
            } else {
                Profil.save(vm.profil, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('imanetApp:profilUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.roleColums = [{
            name: 'name',
            title: 'Role'
        }];

        $scope.$on("onLoadRoles", function () {

        });

        $scope.$watch("vm.authIds",function (ids) {
            if(angular.isDefined(ids)){
                vm.profil.authorities = [];
                angular.forEach(ids,function (value,index) {
                    var auth = _.find(vm.auth,{'id':value});
                    vm.profil.authorities.push(auth.name);
                });
            }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ProfilDetailController', ProfilDetailController);

    ProfilDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Profil', 'Authority', 'User'];

    function ProfilDetailController($scope, $rootScope, $stateParams, previousState, entity, Profil, Authority, User) {
        var vm = this;

        vm.profil = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:profilUpdate', function(event, result) {
            vm.profil = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ProfilDeleteController',ProfilDeleteController);

    ProfilDeleteController.$inject = ['$uibModalInstance', 'entity', 'Profil'];

    function ProfilDeleteController($uibModalInstance, entity, Profil) {
        var vm = this;

        vm.profil = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Profil.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profil', {
            parent: 'entity',
            url: '/profil?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Profils'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profil/profils.html',
                    controller: 'ProfilController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('profil');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('profil-detail', {
            parent: 'profil',
            url: '/profil/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Profil'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profil/profil-detail.html',
                    controller: 'ProfilDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Profil', function($stateParams, Profil) {
                    return Profil.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profil',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('profil-detail.edit', {
            parent: 'profil-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profil/profil-dialog.html',
                    controller: 'ProfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Profil', function(Profil) {
                            return Profil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profil.new', {
            parent: 'profil',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profil/profil-dialog.html',
                    controller: 'ProfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('profil', null, { reload: 'profil' });
                }, function() {
                    $state.go('profil');
                });
            }]
        })
        .state('profil.edit', {
            parent: 'profil',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profil/profil-dialog.html',
                    controller: 'ProfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Profil', function(Profil) {
                            return Profil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profil', null, { reload: 'profil' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profil.delete', {
            parent: 'profil',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profil/profil-delete-dialog.html',
                    controller: 'ProfilDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Profil', function(Profil) {
                            return Profil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profil', null, { reload: 'profil' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Profil', Profil)
        .factory('ProfilByUser', ProfilByUser);


    Profil.$inject = ['$resource'];
    ProfilByUser.$inject = ['$resource'];

    
    function ProfilByUser ($resource) {
        var resourceUrl =  'api/profils/:byUserCreated';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function Profil ($resource) {
        var resourceUrl =  'api/profils/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ProfilController', ProfilController);

    ProfilController.$inject = ['$scope', 'Profil', 'TableService'];

    function ProfilController($scope, Profil, TableService) {

        var vm = this;

        var addItemData = {
            templateUrl: 'app/entities/profil/profil-dialog.html',
            controller: 'ProfilDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: function () {
                    return {
                        nom: null,
                        description: null,
                        id: null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/profil/profil-dialog.html',
            controller: 'ProfilDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData = {
            templateUrl: 'app/entities/profil/profil-delete-dialog.html',
            controller: 'ProfilDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        var detailItemData = {
            templateUrl: 'app/entities/profil/profil-detail.html',
            controller: 'ProfilDetailController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null, //valeur déterminé à l'appel de la boite
                isViewing: true
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function () {
            return {

            };
        };

        var entityParams = function () {
            return {
            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Profil,
            entitySearch:Profil,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };

        vm.initInfo = function () {
            vm.loadAll();
        };

        TableService.init(datas);



    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('PosteDialogController', PosteDialogController);

    PosteDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Poste', 'InfoPoste'];

    function PosteDialogController ($timeout, $scope, $uibModalInstance, entity, Poste, InfoPoste) {
        var vm = this;

        vm.poste = entity;
        vm.clear = clear;
        vm.save = save;
        vm.infopostes = InfoPoste.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.poste.id !== null) {
                Poste.update(vm.poste, onSaveSuccess, onSaveError);
            } else {
                Poste.save(vm.poste, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:posteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('PosteDetailController', PosteDetailController);

    PosteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Poste', 'InfoPoste'];

    function PosteDetailController($scope, $rootScope, $stateParams, previousState, entity, Poste, InfoPoste) {
        var vm = this;

        vm.poste = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:posteUpdate', function(event, result) {
            vm.poste = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('PosteDeleteController',PosteDeleteController);

    PosteDeleteController.$inject = ['$uibModalInstance', 'entity', 'Poste'];

    function PosteDeleteController($uibModalInstance, entity, Poste) {
        var vm = this;

        vm.poste = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Poste.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('poste', {
            parent: 'entity',
            url: '/poste?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Postes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/poste/postes.html',
                    controller: 'PosteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('poste');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('poste-detail', {
            parent: 'poste',
            url: '/poste/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Poste'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/poste/poste-detail.html',
                    controller: 'PosteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Poste', function($stateParams, Poste) {
                    return Poste.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'poste',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('poste-detail.edit', {
            parent: 'poste-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/poste/poste-dialog.html',
                    controller: 'PosteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Poste', function(Poste) {
                            return Poste.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('poste.new', {
            parent: 'poste',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/poste/poste-dialog.html',
                    controller: 'PosteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numero: null,
                                libelle: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('poste', null, { reload: 'poste' });
                }, function() {
                    $state.go('poste');
                });
            }]
        })
        .state('poste.edit', {
            parent: 'poste',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/poste/poste-dialog.html',
                    controller: 'PosteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Poste', function(Poste) {
                            return Poste.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('poste', null, { reload: 'poste' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('poste.delete', {
            parent: 'poste',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/poste/poste-delete-dialog.html',
                    controller: 'PosteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Poste', function(Poste) {
                            return Poste.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('poste', null, { reload: 'poste' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Poste', Poste);

    Poste.$inject = ['$resource'];

    function Poste ($resource) {
        var resourceUrl =  'api/postes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('PosteController', PosteController);

    PosteController.$inject = ['$scope', 'Poste', 'TableService'];

    function PosteController($scope, Poste, TableService) {

        var vm = this;

        var addItemData ={
            templateUrl: 'app/entities/poste/poste-dialog.html',
            controller: 'PosteDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'mg',
            resolve: {
                entity: function () {
                    return {
                        id: null,
                        numero:null,
                        libelle: null,
                        description:null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/poste/poste-dialog.html',
            controller: 'PosteDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/entities/poste/poste-delete-dialog.html',
            controller: 'PosteDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

          var detailItemData = {
            templateUrl: 'app/entities/poste/poste-detail.html',
            controller: 'PosteDetailController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null, //valeur déterminé à l'appel de la boite
                 isViewing: true
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Poste,
            entitySearch: Poste,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();
(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('PositionDialogController', PositionDialogController);

    PositionDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Position'];

    function PositionDialogController ($timeout, $scope, $uibModalInstance, entity, Position) {
        var vm = this;

        vm.position = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.position.id !== null) {
                Position.update(vm.position, onSaveSuccess, onSaveError);
            } else {
                Position.save(vm.position, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:positionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('PositionDetailController', PositionDetailController);

    PositionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Position', 'InfoPosition'];

    function PositionDetailController($scope, $rootScope, $stateParams, previousState, entity, Position, InfoPosition) {
        var vm = this;

        vm.position = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:positionUpdate', function(event, result) {
            vm.position = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('PositionDeleteController',PositionDeleteController);

    PositionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Position'];

    function PositionDeleteController($uibModalInstance, entity, Position) {
        var vm = this;

        vm.position = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Position.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('position', {
            parent: 'entity',
            url: '/position?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Position'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/position/position.html',
                    controller: 'PositionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('position-detail', {
            parent: 'position',
            url: '/position/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Position'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/position/position-detail.html',
                    controller: 'PositionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Position', function($stateParams, Position) {
                    return Position.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'position',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('position-detail.edit', {
            parent: 'position-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-dialog.html',
                    controller: 'PositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Position', function(Position) {
                            return Position.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('position.new', {
            parent: 'position',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-dialog.html',
                    controller: 'PositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numero: null,
                                libelle: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('position', null, { reload: 'position' });
                }, function() {
                    $state.go('position');
                });
            }]
        })
        .state('position.edit', {
            parent: 'position',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-dialog.html',
                    controller: 'PositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Position', function(Position) {
                            return Position.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('position', null, { reload: 'position' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('position.delete', {
            parent: 'position',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-delete-dialog.html',
                    controller: 'PositionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Position', function(Position) {
                            return Position.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('position', null, { reload: 'position' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Position', Position);

    Position.$inject = ['$resource'];

    function Position ($resource) {
        var resourceUrl =  'api/position/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('PositionController', PositionController);

    PositionController.$inject = ['$scope', 'Position', 'TableService'];

    function PositionController($scope, Position, TableService) {

        var vm = this;

        var addItemData ={
            templateUrl: 'app/entities/position/position-dialog.html',
            controller: 'PositionDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'mg',
            resolve: {
                entity: function () {
                    return {
                        id: null,
                        numero:null,
                        libelle: null,
                        description:null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/position/position-dialog.html',
            controller: 'PositionDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/entities/position/position-delete-dialog.html',
            controller: 'PositionDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

          var detailItemData = {
            templateUrl: 'app/entities/position/position-detail.html',
            controller: 'PositionDetailController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null, //valeur déterminé à l'appel de la boite
                 isViewing: true
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Position,
            entitySearch: Position,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();
(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MetierDialogController', MetierDialogController);

    MetierDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Metier'];

    function MetierDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Metier) {
        var vm = this;

        vm.metier = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.metier.id !== null) {
                Metier.update(vm.metier, onSaveSuccess, onSaveError);
            } else {
                Metier.save(vm.metier, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:metierUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MetierDetailController', MetierDetailController);

    MetierDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Metier'];

    function MetierDetailController($scope, $rootScope, $stateParams, previousState, entity, Metier) {
        var vm = this;

        vm.metier = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:metierUpdate', function(event, result) {
            vm.metier = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MetierDeleteController',MetierDeleteController);

    MetierDeleteController.$inject = ['$uibModalInstance', 'entity', 'Metier'];

    function MetierDeleteController($uibModalInstance, entity, Metier) {
        var vm = this;

        vm.metier = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Metier.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('metier', {
            parent: 'entity',
            url: '/metier?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.metier.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/metier/metiers.html',
                    controller: 'MetierController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metier');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('metier-detail', {
            parent: 'metier',
            url: '/metier/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.metier.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/metier/metier-detail.html',
                    controller: 'MetierDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metier');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Metier', function($stateParams, Metier) {
                    return Metier.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'metier',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('metier-detail.edit', {
            parent: 'metier-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/metier/metier-dialog.html',
                    controller: 'MetierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Metier', function(Metier) {
                            return Metier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('metier.new', {
            parent: 'metier',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/metier/metier-dialog.html',
                    controller: 'MetierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('metier', null, { reload: 'metier' });
                }, function() {
                    $state.go('metier');
                });
            }]
        })
        .state('metier.edit', {
            parent: 'metier',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/metier/metier-dialog.html',
                    controller: 'MetierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Metier', function(Metier) {
                            return Metier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('metier', null, { reload: 'metier' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('metier.delete', {
            parent: 'metier',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/metier/metier-delete-dialog.html',
                    controller: 'MetierDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Metier', function(Metier) {
                            return Metier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('metier', null, { reload: 'metier' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Metier', Metier);

    Metier.$inject = ['$resource'];

    function Metier ($resource) {
        var resourceUrl =  'api/metiers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MetierController', MetierController);

    MetierController.$inject = ['$scope', 'Metier', 'TableService'];

    function MetierController($scope, Metier, TableService) {

        var vm = this;

        var addItemData ={
            templateUrl: 'app/entities/metier/metier-dialog.html',
            controller: 'MetierDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'mg',
            resolve: {
                entity: function () {
                    return {
                        id: null,
                        libelle: null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/metier/metier-dialog.html',
            controller: 'MetierDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/entities/metier/metier-delete-dialog.html',
            controller: 'MetierDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

          var detailItemData = {
            templateUrl: 'app/entities/metier/metier-detail.html',
            controller: 'MetierDetailController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null, //valeur déterminé à l'appel de la boite
                 isViewing: true
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Metier,
            entitySearch: Metier,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();
(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembreServiceDialogController', MembreServiceDialogController);

    MembreServiceDialogController.$inject = ['UserExtraConnected','$timeout', '$scope', '$uibModalInstance', 'entity', 'MembreService', 'Association','States','CityByStateId','StatesByCountry'];

    function MembreServiceDialogController (UserExtraConnected,$timeout, $scope, $uibModalInstance, entity, MembreService, Association,States,CityByStateId,StatesByCountry) {
        var vm = this;

        vm.membreService = entity;
        vm.clear = clear;
        vm.save = save;
        vm.init =init;
        vm.user = UserExtraConnected.query();

        vm.associations = Association.query();

if(vm.membreService.id!=null)
{
    vm.membreService.date = new Date( vm.membreService.date);

}
function init()
{
    vm.membreService.consulat=null;
}



        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.membreService.id !== null) {
                MembreService.update(vm.membreService, onSaveSuccess, onSaveError);
            } else {
                MembreService.save(vm.membreService, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:countryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

          vm.etatColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadEtats", function () {
    
            });
    loadEtats();
            function loadEtats() {
                States.query({
                    size: 10000
                }, function (data) {
                    if (data != null) {
                        vm.etats = [];
                        vm.etats = data;
                    }
                });
    
                
               // vm.members.lieuNaissance = test.libele;
            }
    
    
            vm.statesVilleColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadStatesVille", function () {
    
            });


            $scope.$watch("vm.membreService.etatId", function () {
                loadEtats();
        if(vm.membreService.etatId!=null )
        {
                CityByStateId.query ({
                        id: vm.membreService.etatId
                    }, function (data) {
                        vm.villeAdresse = data;
                    })
                }
                
            });


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembreServiceDetailController', MembreServiceDetailController);

    MembreServiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MembreService', 'InfoService'];

    function MembreServiceDetailController($scope, $rootScope, $stateParams, previousState, entity, MembreService, InfoService) {
        var vm = this;

        vm.membreService = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:membreServiceUpdate', function(event, result) {
            vm.membreService = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembreServiceDeleteController',MembreServiceDeleteController);

    MembreServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'MembreService'];

    function MembreServiceDeleteController($uibModalInstance, entity, MembreService) {
        var vm = this;

        vm.membreService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MembreService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('membre-service', {
            parent: 'entity',
            url: '/membre-service?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'MembreServices'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/membre-service/membre-services.html',
                    controller: 'MembreServiceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('membreService');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('membre-service-detail', {
            parent: 'membre-service',
            url: '/membre-service/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'MembreService'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/membre-service/membre-service-detail.html',
                    controller: 'MembreServiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MembreService', function($stateParams, MembreService) {
                    return MembreService.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'membre-service',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('membre-service-detail.edit', {
            parent: 'membre-service-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membre-service/membre-service-dialog.html',
                    controller: 'MembreServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MembreService', function(MembreService) {
                            return MembreService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('membre-service.new', {
            parent: 'membre-service',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membre-service/membre-service-dialog.html',
                    controller: 'MembreServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numero: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('membre-service', null, { reload: 'membre-service' });
                }, function() {
                    $state.go('membre-service');
                });
            }]
        })
        .state('membre-service.edit', {
            parent: 'membre-service',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membre-service/membre-service-dialog.html',
                    controller: 'MembreServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MembreService', function(MembreService) {
                            return MembreService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('membre-service', null, { reload: 'membre-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('membre-service.delete', {
            parent: 'membre-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/membre-service/membre-service-delete-dialog.html',
                    controller: 'MembreServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MembreService', function(MembreService) {
                            return MembreService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('membre-service', null, { reload: 'membre-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('MembreServiceTop10', MembreServiceTop10)
        .factory('MembreServiceTop10Even', MembreServiceTop10Even)
        .factory('MembreService', MembreService);

    MembreServiceTop10.$inject = ['$resource'];
    MembreServiceTop10Even.$inject = ['$resource'];
    MembreService.$inject = ['$resource'];

    function MembreService ($resource) {
        var resourceUrl =  'api/membre-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function MembreServiceTop10 ($resource) {
        var resourceUrl =  'api/membre-services/findTop10';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function MembreServiceTop10Even ($resource) {
        var resourceUrl =  'api/membre-services/findTop10Even';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }









})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembreServiceController', MembreServiceController);

    MembreServiceController.$inject = ['$scope', 'MembreService', 'TableService','DataUtils','UserExtraConnected'];

    function MembreServiceController($scope, MembreService, TableService,DataUtils,UserExtraConnected) {

        var vm = this;
        vm.init = init;
        vm.datePickerOpenStatus = {};
        vm.openFile = DataUtils.openFile;
        vm.openCalendar = openCalendar;
        vm.user = UserExtraConnected.query();



        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        vm.itemSearch = {
            "dateDebut": null,
            "dateFin": null
        };


        vm.initFiltre = function () {
            vm.filtrer = !vm.filtrer;
            if (!vm.filtrer) {
                vm.itemSearch = {
                    "dateDebut": null,
                    "dateFin": null   
                };
                init();
            }
        }



          init();
        function init() {
          /*  if(vm.itemSearch.dateDebut!=null && vm.itemSearch.dateFin!=null )
            {
            vm.itemSearch.dateDebut = DateUtils.convertLocalDateToServer(vm.itemSearch.dateDebut);
            vm.itemSearch.dateFin = DateUtils.convertLocalDateToServer(vm.itemSearch.dateFin);

            }*/



            var addItemData ={
                templateUrl: 'app/entities/membre-service/membre-service-dialog.html',
                controller: 'MembreServiceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'mg',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            numero:null,
                            libelle: null
                        };
                    }
                }
            };
    
            /**
             *Modification d'un élément
             */
            var editItemData = {
                templateUrl: 'app/entities/membre-service/membre-service-dialog.html',
                controller: 'MembreServiceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: null
                }
            };
    
            /**
             * Suppresion d'un élément
             */
            var deleteItemData ={
                templateUrl: 'app/entities/membre-service/membre-service-delete-dialog.html',
                controller: 'MembreServiceDeleteController',
                controllerAs: 'vm',
                size: 'sm',
                resolve: {
                    entity: null
                }
            };
    
              var detailItemData = {
                templateUrl: 'app/entities/membre-service/membre-service-detail.html',
                controller: 'CountryDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: null, //valeur déterminé à l'appel de la boite
                     isViewing: true
                }
            };
    
            var dialogData = {
                addData: addItemData,
                editData: editItemData,
                deleteData: deleteItemData,
                detailData: detailItemData
            };
            var entitySearchParams = function() {
                return {
    
                };
            };
    
            var entityParams = function() {
                return {
                    "debut": vm.itemSearch.dateDebut,
                    "fin": vm.itemSearch.dateFin
                };
            };
    
            var datas = {
                scope: $scope,
                vm: vm,
                entity: MembreService,
                entitySearch: MembreService,
                dialogData: dialogData,
                entitySearchParams: entitySearchParams,
                entityParams: entityParams
            };
            TableService.init(datas);

        }

        var addItemData ={
            templateUrl: 'app/entities/membre-service/membre-service-dialog.html',
            controller: 'MembreServiceDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'mg',
            resolve: {
                entity: function () {
                    return {
                        id: null,
                        numero:null,
                        libelle: null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/membre-service/membre-service-dialog.html',
            controller: 'MembreServiceDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/entities/membre-service/membre-service-delete-dialog.html',
            controller: 'MembreServiceDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

          var detailItemData = {
            templateUrl: 'app/entities/membre-service/membre-service-detail.html',
            controller: 'CountryDetailController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null, //valeur déterminé à l'appel de la boite
                 isViewing: true
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: MembreService,
            entitySearch: MembreService,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();
(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembersVoteResultatController', MembersVoteResultatController);

        MembersVoteResultatController.$inject = ['$scope','$http','Zone'];

    function MembersVoteResultatController($scope,$http,Zone) {
        var vm = this;


        vm.zoneId = null;
        vm.init = init;
        vm.zones = [];
        vm.candidats = [];
        vm.zones = Zone.query();
        console.log(vm.zones);
        vm.etatCandidat = {};

            
        function init() {

            $http.get("api/statistiques/etatCandidats", {params: {zoneId: vm.zoneId }}).then(
                function(response) {
                    console.log(response.data);
                    vm.etatCandidat.labels = response.data.candidats;
                    vm.etatCandidat.data = response.data.data;
                }
            );
        }


        $scope.$watch("vm.zoneId", function () {
            if(vm.zoneId !=null)
            {
                vm.init();

            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembersStatsController', MembersStatsController);

        MembersStatsController.$inject = ['$scope','$http','$window','DateUtils','TableService',
            'MemberMultiParams','City','UserExtraConnected','DocumentLegal','Consulat','Notification','Zone','Position'];

    function MembersStatsController($scope,$http,$window,DateUtils,TableService,MemberMultiParams,City,
                                    UserExtraConnected,DocumentLegal,Consulat,Notification, Zone, Position) {
        var vm = this;

        vm.init = init;

        var fileURLPDF;
        vm.documents = DocumentLegal.query();
        vm.consulats = Consulat.query();
        vm.zones = Zone.query();
        vm.positions = Position.query();
        vm.user = UserExtraConnected.query();
        vm.etatCarte = etatCarte;


        function etatCarte(id) {
            $http.get('/api/members/cartePDF', {
                    responseType: 'arraybuffer',
                    params: {
                        idMembre:id,
                        changement:true

                    }
                })
                .success(function(response) {
                    var file = new Blob([(response)], {
                        type: 'application/pdf'
                    });
                    fileURLPDF = URL.createObjectURL(file);
                    $window.open(fileURLPDF, '_blank');
                })
                .error(function(data, status) {
                    if(status===400){
                        Notification.error("Vous ne pouvez pas generer une autre carte valide");
                    }
                });
           }

        vm.itemSearch = {
            "nom": null,
            "prenom": null,
            "numeroBf": null,
            "telephone": null,
            "dateArrivee": null,
            "mariage": null,
            "sexe": null,
            "metier": null,
            "occupation": null,
            "parentsUsa": null,
            "mumInUsa": null,
            "autorite": null,
            "villeResidence": null,
            "etatResidence": null,
            "consulatId": null,
            "candidate": null,
            "zoneId": null,
            "positionId": null

        };
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateDebut = false;
        vm.datePickerOpenStatus.dateFin = false;
        vm.filtrer=false;

        loadVilles();

        function loadVilles() {
            City.query({
                size: 10000
            }, function (data) {
                if (data != null) {
                    vm.villes = data;
                }
            });
           // vm.members.lieuNaissance = test.libele;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        vm.initFiltre = function () {
            vm.filtrer = !vm.filtrer;
            if (!vm.filtrer) {
                vm.itemSearch = {
                    "nom": null,
                    "prenom": null,
                    "numeroBf": null,
                    "telephone": null,
                    "dateArrivee": null,
                    "mariage": null,
                    "sexe": null,
                    "metier": null,
                    "occupation": null,
                    "parentsUsa": null,
                    "mumInUsa": null,
                    "autorite": null,
                    "villeResidence": null,
                    "etatResidence": null,
                    "consulatId": null,
                    "candidate": null,
                    "zoneId": null,
                    "positionId": null

                };
                init();
            }
        }

          init();
        function init() {
            if(vm.itemSearch.dateArrivee!=null)
            vm.date = null;
            vm.date = DateUtils.convertLocalDateFromServer(vm.itemSearch.dateArrivee);
            var addItemData = {};
            var editItemData = {};
            /**
             *Modification d'un élément
            */
       var editItemData = {
        templateUrl: 'app/entities/members/members-detail.html',
        controller: 'MembersDetailController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
            entity: null
        }
    };

            var detailItemData = {
                templateUrl: 'app/entities/members/members-dialog.html',
                controller: 'MembersDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    isViewing: function () {
                        return true;
                    },
                    entity: null //valeur déterminé à l'appel de la boite,
                }
            };

            var deleteItemData = {};
            var dialogData = {
                addData: addItemData,
                editData: editItemData,
                detailData: detailItemData
            };
            var entitySearchParams = function () {
                return {};
            };
            var entityParams = function () {
                return {
                    "nom": vm.itemSearch.nom,
                    "prenom": vm.itemSearch.prenom,
                    "numeroBf": vm.itemSearch.numeroBf,
                    "telephone": vm.itemSearch.telephone,
                    "dateArrivee": vm.date,
                    "mariage": vm.itemSearch.mariage,
                    "sexe": vm.itemSearch.sexe,
                    "metier": vm.itemSearch.metier,
                    "occupation": vm.itemSearch.occupation,
                    "parentsUsa": vm.itemSearch.parentsUsa,
                    "autorite": vm.itemSearch.autorite,
                    "villeResidence": vm.itemSearch.villeResidence,
                    "etatResidence": vm.itemSearch.etatResidence ,
                    "consulatId": vm.itemSearch.consulatId,
                    "candidate": vm.itemSearch.candidate,
                    "zoneId": vm.itemSearch.zoneId,
                    "positionId": vm.itemSearch.positionId
                    
                };
            };


            var datas = {
                scope: $scope,
                vm: vm,
                entity: MemberMultiParams,
                dialogData: dialogData,
                entitySearch: MemberMultiParams,
                entitySearchParams: entitySearchParams,
                entityParams: entityParams
            };
            TableService.init(datas);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembersStatController', MembersStatController);

        MembersStatController.$inject = ['$scope','$http','$window','TableService','UserExtraConnected',
        'CarteMultiParams'];

function MembersStatController($scope,$http,$window,TableService,UserExtraConnected,CarteMultiParams
                                ) {
    var vm = this;

    vm.init = init;

    var fileURLPDF;
    vm.etatCarte = etatCarte;

    vm.user = UserExtraConnected.query();

    function etatCarte(id) {
        $http.get('/api/cartes/cartePDF', {
                responseType: 'arraybuffer',
                params: {
                    idCarte:id
                }

            })
            .success(function(response) {
                var file = new Blob([(response)], {
                    type: 'application/pdf'
                });
                fileURLPDF = URL.createObjectURL(file);
                $window.open(fileURLPDF, '_blank');
            });
       }

    vm.itemSearch = {
        "nom": null,
        "prenom": null,
        "numero": null,
        "metier": null
    };
    vm.openCalendar = openCalendar;
    vm.datePickerOpenStatus = {};
    vm.datePickerOpenStatus.dateDebut = false;
    vm.datePickerOpenStatus.dateFin = false;
    vm.filtrer=false;



    function openCalendar(date) {
        vm.datePickerOpenStatus[date] = true;
    }


    vm.initFiltre = function () {
        vm.filtrer = !vm.filtrer;
        if (!vm.filtrer) {
            vm.itemSearch = {
                "nom": null,
                "prenom": null,
                "numero": null,
                "metier": null
            };
            init();
        }
    }

      init();
    function init() {
      /*   if(vm.itemSearch.dateArrivee!=null)
        vm.date = null;
        vm.date = DateUtils.convertLocalDateToServer(vm.itemSearch.dateArrivee); */
        var addItemData = {};
        var editItemData = {};
        /**
         *Modification d'un élément
        */
   var editItemData = {
    templateUrl: 'app/entities/carte/carte-detail.html',
    controller: 'CarteDetailController',
    controllerAs: 'vm',
    backdrop: 'static',
    size: 'lg',
    resolve: {
        entity: null
    }
};

        var detailItemData = {
            templateUrl: 'app/entities/carte/carte-dialog.html',
            controller: 'CarteDialogController',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
                isViewing: function () {
                    return true;
                },
                entity: null //valeur déterminé à l'appel de la boite,
            }
        };

        var deleteItemData = {};
        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function () {
            return {};
        };
        var entityParams = function () {
            return {
                "nom": vm.itemSearch.nom,
                "prenom": vm.itemSearch.prenom,
                "numero": vm.itemSearch.numero,
                "metier": vm.itemSearch.metier
            };
        };


        var datas = {
            scope: $scope,
            vm: vm,
            entity: CarteMultiParams,
            dialogData: dialogData,
            entitySearch: CarteMultiParams,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
}

})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembersDialogController', MembersDialogController);

    MembersDialogController.$inject = ['$http','DataUtils','AdressesByMember', 'InfoAssociationByMember', '$window', '$uibModalInstance', 'entity', 'Poste', 'UserExtra', 'CountryIdDoc', 'InfoPosteByMember', 'DocumentLegal'];

    function MembersDialogController ($http,DataUtils,AdressesByMember, InfoAssociationByMember, $window, $uibModalInstance, entity, Poste, UserExtra, CountryIdDoc, InfoPosteByMember, DocumentLegal) {
        var vm = this;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.documents = DocumentLegal.query();


        vm.postes = Poste.query();
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.members = entity;

        var fileURLPDF;

        vm.etatCarte=etatCarte;

        vm.members.dateDelivr = new Date(vm.members.dateDelivr);

        vm.init = init;

        InfoPosteByMember.query({id:vm.members.id},
            function (data) {
                vm.infoPostes=data;
            }
            );



        function init()
{InfoAssociationByMember.query({id:vm.members.id},
            function (data) {
                vm.members.associations=data;
            });


            AdressesByMember.query({id:vm.members.id},
                function (data) {
                    vm.members.adresseDTO=data;
                }
                );
        }

        vm.init();
        vm.clear = clear;
             /*****************************Gestionnaire des onglets**************************************/
        vm.steps = [
            'IDENTIFICATION',
            'CONTACTS AND ARRIVALS',
            'DOC IDENTIFICATION',
            'ASSOCIATION',
            'OCCUPATIONS HISTORY',

        ];


        vm.selection = vm.steps[0];
        vm.error = false;
        vm.showOnglet = showOnglet;
        vm.getCurrentStepIndex = function() {
            return vm.steps.indexOf(vm.selection);
        };

        function showOnglet(onglet) {
            return (vm.selection.toUpperCase() === onglet.toUpperCase());
        }

            // Go to a defined step index
        vm.goToStep = function(index, editForm) {
            vm.selection = vm.steps[index];
        };

        vm.hasNextStep = function() {
            var stepIndex = vm.getCurrentStepIndex();
            var nextStep = stepIndex + 1;
                // Return true if there is a next step, false if not
            return !angular.isUndefined(vm.steps[nextStep]);
        };

        vm.hasPreviousStep = function() {
            var stepIndex = vm.getCurrentStepIndex();
            var previousStep = stepIndex - 1;
                // Return true if there is a next step, false if not
            return !angular.isUndefined(vm.steps[previousStep]);
        };

        vm.incrementStep = function() {
            if (vm.hasNextStep()) {
                    //Vérification des champs du step précedent
                var stepIndex = vm.getCurrentStepIndex();
                var nextStep = stepIndex + 1;
                vm.selection = vm.steps[nextStep];
            }
        };


        vm.decrementStep = function() {
            if (vm.hasPreviousStep()) {
                var stepIndex = vm.getCurrentStepIndex();
                var previousStep = stepIndex - 1;
                vm.selection = vm.steps[previousStep];
            }
        };



        function etatCarte() {
            $http.get('/api/members/cartePDF', {
                responseType: 'arraybuffer',
                params: {
                    idMembre: vm.members.id,
                    changement:true

                }

            })
                    .success(function(response) {
                        var file = new Blob([(response)], {
                            type: 'application/pdf'
                        });
                        fileURLPDF = URL.createObjectURL(file);
                        $window.open(fileURLPDF, '_blank');



                    });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembersDetailController', MembersDetailController);

        MembersDetailController.$inject = ['$scope','$filter','$http','DataUtils','Members', 'InfoAssociationByMember', '$window', '$uibModalInstance', 'Country', 'entity', 'CityByStateId', 'Association', 'CityByCountryId', 'Poste', 'States', 'City', 'DocumentLegal', 'Adresses', 'InfoAssociation', 'InfoService', 'Consulat', 'Metier','Zone','Position'];

    function MembersDetailController ($scope,$filter,$http,DataUtils,Members, InfoAssociationByMember, $window, $uibModalInstance, Country, entity, CityByStateId, Association, CityByCountryId,Poste, States, City, DocumentLegal, Adresses, InfoAssociation, InfoService, Consulat,Metier,Zone,Position) {
        var vm = this;
        vm.members = entity;
        console.log("members",vm.members);
       // vm.members.dateNaissance = vm.members.dateNaissanceStr;

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save =save;
        vm.changerAdresse = changerAdresse;
        vm.countriesVille = [];
        vm.etats = [];
        vm.documents = DocumentLegal.query();
        vm.reset = reset;
        vm.mariage = mariage;
        vm.inusa = inusa;
        vm.inusae = inusae;
        vm.annulerCarte = annulerCarte();
        vm.members.annulerCarte = false;
        vm.members.dateAnnulation = null;
        vm.members.motifAnnulation = null;

        vm.reset();


        function changerAdresse(bol) {
              }

        function annulerCarte() {
           if(!vm.members.annulerCarte){
               vm.members.dateAnnulation = null;
               vm.members.motifAnnulation = null;
           }
        }

         $scope.$watch("vm.members.candidate", function () {
            if(!vm.members.candidate){
                vm.members.candidate = false;
                vm.members.zoneId = null;
                vm.members.zoneLibelle = null;
                vm.members.positionId = null;
                vm.members.positionLibelle = null;
            }


        });


        vm.setPhoto = function ($file, members) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        members.photo = base64Data;
                        members.photoContentType = $file.type;
                    });
                });
            }
        };

        vm.setSignature = function ($file, consulat) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        consulat.signature = base64Data;
                        consulat.signatureContentType = $file.type;
                    });
                });
            }
        };

        function reset () {
             if(vm.members.countryId==null)
            {

            vm.members.country = {
            autorite:null,
            cityId:null,
            dateDelivr:null,
            dateExpr:null,
            numero:null,
            etat:null,
            statesId:null,
            cityId:null
            };
        }

          if(vm.members.bfIdDocId==null)
        {
            vm.members.bfIdDoc = {
            autorite: null,
            cityId: null,
            dateDelivr: null,
            dateExpr: null,
            docId: '',
            numero: null,
            ville: null
            }

         }
        }

         function mariage () {
            if(vm.members.mariage==false)
            {
             vm.members.nomConjoint = null;
             vm.members.prenomConjoint = null;
             vm.members.memePaysConjoint = null;
             vm.members.noConjoint = null;
            }

         }

         function inusa () {
           if(vm.members.parentsUsa==false)
           {
            vm.members.infoParents.noPere = null;

           }

        }

        function inusae () {
            if(vm.members.mumInUsa==false)
            {
                vm.members.infoParents.noMere = null;

            }

         }



        function openCalendar (date) {
            vm.datePickerOpenStatus.date;

            vm.datePickerOpenStatus[date] = true;
         }

        if(vm.members.dateAnnulation!=null)
        {
            vm.members.dateAnnulation = new Date(vm.members.dateAnnulation);
        }

        if(vm.members.dateNaissance!=null)
        {
            vm.members.dateNaissance = new Date(vm.members.dateNaissance);
        }

        if(vm.members.dateNaissance!=null)
        {
            vm.members.dateNaissance = new Date(vm.members.dateNaissance);
        }

        if(vm.members.dateArrivee!=null)
        {
            vm.members.dateArrivee = new Date(vm.members.dateArrivee);
        }

        if(vm.members.bfIdDocId!=null)
        {
            vm.members.bfIdDoc.dateDelivr = new Date(vm.members.bfIdDoc.dateDelivr);
            vm.members.bfIdDoc.dateExpr = new Date(vm.members.bfIdDoc.dateExpr);

        }

        if(vm.members.countryId!=null)
        {
            vm.members.country.dateDelivr = new Date(vm.members.country.dateDelivr);
        }

        if(vm.members.countryId!=null)
        {
            vm.members.country.dateExpr = new Date(vm.members.country.dateExpr);
        }


if(vm.members.signature!=null)
{
        vm.members.signature="data:image/png;base64,"+vm.members.signature;
}


        var fileURLPDF;

        vm.etatCarte=etatCarte;

        vm.members.dateDelivr = new Date(vm.members.dateDelivr);

        vm.init = init;

        function init()
{
        InfoAssociationByMember.query({id:vm.members.id},
            function (data) {
               vm.members.associations=data;

              /*  angular.forEach(data, function (value, index) {
                var v = {};
                v = value;
                v.dateFonction = new Date(v.dateFonction);
                vm.members.associations.push(v);
            }); */



                }
            )


          /*  AdressesByMember.query({id:vm.members.id},
                function (data) {
                   vm.members.adresseDTO=data;
                    }
                )*/
}

vm.init();


        function save() {



          if(vm.members.bfIdDoc.docId=="")
             {
            vm.members.bfIdDoc.docId = null;

             }


        if(!vm.members.scanSignature)
            {
            if(vm.members.signature!=null)
            {
            var canvas = document.createElement("canvas");
        var dataURL = canvas.toDataURL( "image/png" );
        vm.members.signature =  vm.members.signature.substring( "data:image/png;base64,".length );

    }
    else
    {
        var canvas = document.createElement("canvas");
        var dataURL = canvas.toDataURL( "image/png" );
    }
}
else
{
    var canvas = document.createElement("canvas");
        var dataURL = canvas.toDataURL( "image/png" );

}
            vm.isSaving = true;
            if (vm.members.id !== null) {
                Members.update(vm.members, onSaveSuccess, onSaveError);
            } else {
                Members.save(vm.members, onSaveSuccess, onSaveError);
            }
           }

           function onSaveSuccess (resultat) {
            $scope.$emit('consulatApp:consulatUpdate', resultat);
            $uibModalInstance.close(resultat);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.clear = clear;
             /*****************************Gestionnaire des onglets**************************************/
             vm.steps = [
                'IDENTIFICATION',
                'ADRESS',
                'DOC IDENTIFICATION',
                'ASSOCIATION',
                 'ANNULATION CARTE',
                  'ELECTION'
            ];


            vm.selection = vm.steps[0];
            vm.error = false;
            vm.showOnglet = showOnglet;
            vm.getCurrentStepIndex = function() {
                return vm.steps.indexOf(vm.selection);
            };

                 function showOnglet(onglet) {
                var stepIndex = vm.getCurrentStepIndex();
                return (vm.selection.toUpperCase() === onglet.toUpperCase());
            }

          // Go to a defined step index
        vm.goToStep = function(index, editForm) {
            if (!editForm.$invalid || (vm.getCurrentStepIndex() > index) ) {
                if (!angular.isUndefined(vm.steps[index])) {
                    vm.selection = vm.steps[index];
                }
            }
        };
            vm.hasNextStep = function() {
                var stepIndex = vm.getCurrentStepIndex();
                var nextStep = stepIndex + 1;
                // Return true if there is a next step, false if not
                return !angular.isUndefined(vm.steps[nextStep]);
            };

            vm.hasPreviousStep = function() {
                var stepIndex = vm.getCurrentStepIndex();
                var previousStep = stepIndex - 1;
                // Return true if there is a next step, false if not
                return !angular.isUndefined(vm.steps[previousStep]);
            };

            vm.incrementStep = function() {
                if (vm.hasNextStep()) {
                    //Vérification des champs du step précedent
                    var stepIndex = vm.getCurrentStepIndex();
                    var nextStep = stepIndex + 1;
                    vm.selection = vm.steps[nextStep];
                }
            };


            vm.decrementStep = function() {
                if (vm.hasPreviousStep()) {
                    var stepIndex = vm.getCurrentStepIndex();
                    var previousStep = stepIndex - 1;
                    vm.selection = vm.steps[previousStep];
                }
            };



            function etatCarte() {
                $http.get('/api/members/cartePDF', {
                        responseType: 'arraybuffer',
                        params: {
                            idMembre: vm.members.id
                        }

                    })
                    .success(function(response) {
                        var file = new Blob([(response)], {
                            type: 'application/pdf'
                        });
                        fileURLPDF = URL.createObjectURL(file);
                        $window.open(fileURLPDF, '_blank');


                    });
               }





               vm.paysColumns = [{
                name: 'libele',
                title: 'Libelle'
            }];
            $scope.$on("onLoadPays", function () {

            });
            loadPays();

            function loadPays() {
                Country.query({
                    size: 10000
                }, function (data) {
                    if (data != null) {
                        vm.pays = [];
                        vm.pays = data;
                    }
                });


               // vm.members.lieuNaissance = test.libele;
            }

            $scope.$watch("vm.members.lieuNaissanceId", function () {
    if(vm.members.lieuNaissanceId!=null)
    {
                    Country.get ({
                        id: vm.members.lieuNaissanceId
                    }, function (data) {
                        vm.members.lieuNaissance = data.libele;
                    })
                }

            });





            vm.villeColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadVilles", function () {

            });
            loadVilles();

            function loadVilles() {
                City.query({
                    size: 10000
                }, function (data) {
                    if (data != null) {

                        vm.villes = data;
                    }
                });


            }


            vm.posteColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];

            loadPostes();

            function loadPostes() {
                vm.postes = Poste.query();

        }


            $scope.$on("onLoadVillesBF", function () {

            });
            loadVillesBF();

            function loadVillesBF() {
                CityByCountryId.query ({
                    id: 1001
                }, function (data) {
                    vm.countriesVille = data;
                })


               // vm.members.lieuNaissance = test.libele;
            }


            $scope.$on("onLoadVillesUSA", function () {

            });
            loadVillesUSA();

            function loadVillesUSA() {
                CityByCountryId.query ({
                    id: 1014
                }, function (data) {
                    vm.countriesVilleUSA = data;
                })


               // vm.members.lieuNaissance = test.libele;
            }

            $scope.$watch("vm.members.bfIdDoc.cityId", function () {
                loadVillesBF();
                if(vm.countriesVille.length > 0)
                vm.members.bfIdDoc.ville = $filter('filter')(vm.countriesVille, {id: vm.members.bfIdDoc.cityId}, true)[0].libelle;

            });


            $scope.$watch("vm.members.country.cityId", function () {

                if(vm.members.country.statesId!=null)
                {
                            CityByStateId.query ({
                                    id: vm.members.country.statesId
                                }, function (data) {
                                    vm.statesVille = data;

                                    if(vm.statesVille.length > 0)
                                    vm.members.country.ville = $filter('filter')(vm.statesVille, {id: vm.members.country.cityId}, true)[0].libelle;

                                })
                            }

                        });



            $scope.$watch("vm.members.villeArriveId", function () {


    if(vm.members.villeArriveId!=null)
    {
                    City.get ({
                        id: vm.members.villeArriveId
                    }, function (data) {
                        vm.members.villeArrivee = data.libelle;
                        vm.members.etatArrivee = data.statesLibelle;
                    })
                }

            });

            $scope.$watch("vm.members.villeId", function () {

                if(vm.members.villeId!=null)
                {

                    City.get ({
                        id: vm.members.villeId
                    }, function (data) {
                        vm.members.ville = data.libelle;
                    })
                }

            });


            vm.etatColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadEtats", function () {

            });
            loadEtats();

            function loadEtats() {
                States.query({
                    size: 10000
                }, function (data) {
                    if (data != null) {
                        vm.etats = [];
                        vm.etats = data;
                    }
                });


               // vm.members.lieuNaissance = test.libele;
            }

            vm.metierColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadMetier", function () {

            });
            loadMetier();

            function loadMetier() {
                vm.metiers = Metier.query({
                    size: 1000
                });

            }

            $scope.$watch("vm.members.metierId", function () {
                if (vm.members.metierId != null) {
                    Metier.get({
                        id: vm.members.metierId
                    }, function (data) {
                        vm.members.metier = data.libelle;
                    })
                }

            });



            vm.zoneColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadZone", function () {

            });
            loadZone();

            function loadZone() {
                vm.zones = Zone.query({
                    size: 1000
                });

            }

            $scope.$watch("vm.members.zoneId", function () {
                if (vm.members.zoneId != null) {
                    Zone.get({
                        id: vm.members.zoneId
                    }, function (data) {
                        vm.members.zoneLibelle = data.libelle;
                     //   vm.members.zoneId = data.id;
                    })
                }

            });



                vm.positionColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadPosition", function () {

            });
            loadPosition();

            function loadPosition() {
                vm.positions = Position.query({
                    size: 100
                });

            }

            $scope.$watch("vm.members.positionId", function () {
                if (vm.members.positionId != null) {
                    Position.get({
                        id: vm.members.positionId
                    }, function (data) {
                        vm.members.positionLibelle = data.libelle;
                     //   vm.members.zoneId = data.id;
                    })
                }

            });


            vm.statesVilleColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadStatesVille", function () {

            });


            $scope.$watch("vm.members.lieuNaissanceId", function () {
    if(vm.members.lieuNaissanceId!=null)
    {
                    Country.get ({
                        id: vm.members.lieuNaissanceId
                    }, function (data) {
                        vm.members.lieuNaissance = data.libele;
                    })
                }

            });


            $scope.$watch("vm.members.statesId", function () {
                if(vm.members.statesId!=null)
                {
                CityByStateId.query ({
                        id: vm.members.statesId
                    }, function (data) {
                        vm.countriesArrivee = data;
                    })

                    if(vm.etats.length > 0)
                    vm.members.etatArrivee = $filter('filter')(vm.etats, {id: vm.members.statesId}, true)[0].libelle;

                }

            });

            $scope.$watch("vm.associationId", function (ids) {

                Association.query ( function (data) {
                    vm.assocs = data;
                })

                if (angular.isDefined(ids)) {
                    vm.members.associations = [];
                    angular.forEach(ids, function (value, index) {
                        var auth = _.find(vm.assocs, { 'id': value });
                        vm.members.associations.push(auth);
                    });
                }
            });



            $scope.$watch("vm.members.country.statesId", function () {
                if(vm.members.country.statesId!=null)
                {
                CityByStateId.query ({
                        id: vm.members.country.statesId
                    }, function (data) {
                        vm.statesVille = data;
                    })

                    if(vm.etats.length > 0)
                    vm.members.country.etat = $filter('filter')(vm.etats, {id: vm.members.country.statesId}, true)[0].libelle;


                }

            });


            $scope.$watch("vm.members.adresseDTO.cityId", function () {
                if(vm.members.adresseDTO.etatId!=null)
                {
                CityByStateId.query ({
                        id: vm.members.adresseDTO.etatId
                    }, function (data) {
                        vm.villeAdresse = data;

                        if(vm.villeAdresse.length > 0)
                        vm.members.adresseDTO.city = $filter('filter')(vm.villeAdresse, {id: vm.members.adresseDTO.cityId}, true)[0].libelle;
                    })



                }

            });


           /* $scope.$watch("vm.members.adresseDTO.etatId", function () {

                CityByStateId.query ({
                        id: vm.members.adresseDTO.etatId
                    }, function (data) {
                        vm.villeAdresse = data;
                    })

            });*/

            $scope.$watch("vm.members.adresseDTO.etatId", function () {
                if(vm.members.adresseDTO.etatId!=null)
                {
                CityByStateId.query ({
                        id: vm.members.adresseDTO.etatId
                    }, function (data) {
                        vm.villeAdresse = data;
                    })

                    vm.members.adresseDTO.etat = $filter('filter')(vm.etats, {id: vm.members.adresseDTO.etatId}, true)[0].libelle;


                }

            });


            vm.colums = [{
                name: 'nom',
                title: 'Nom'
            }];


            $scope.$watch("vm.associationId", function (ids) {

                Association.query ( function (data) {
                    vm.assocs = data;
                })

                if (angular.isDefined(ids)) {
                    vm.members.associations = [];
                    angular.forEach(ids, function (value, index) {
                        var auth = _.find(vm.assocs, { 'id': value });
                        vm.members.associations.push(auth);
                    });
                }
            });

            function clear () {
                $uibModalInstance.dismiss('cancel');
            }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembersDeleteController',MembersDeleteController);

    MembersDeleteController.$inject = ['$uibModalInstance', 'entity', 'Members'];

    function MembersDeleteController($uibModalInstance, entity, Members) {
        var vm = this;

        vm.members = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Members.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembersCarteController', MembersCarteController);

        MembersCarteController.$inject = ['$scope','$http','$window','TableService','UserExtraConnected','CarteMultiParams','DateUtils'];

    function MembersCarteController($scope,$http,$window,TableService,UserExtraConnected,CarteMultiParams,DateUtils) {
        var vm = this;
        vm.init = init;
        vm.user = UserExtraConnected.query();
        vm.dateDebut = null;
        vm.dateFin = null;

        vm.itemSearch = {
            "dateDebut": null,
            "dateFin": null,
            "nom": null,
            "prenom": null,
            "numero": null,
            "metier": null,
            "statut":null,
            "sexe":null
        };

        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateDebut = false;
        vm.datePickerOpenStatus.dateFin = false;
        vm.filtrer=false;


        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dateFinEstAvantDateDebut = function () {
            var debut = new moment(vm.itemSearch.dateDebut);
            var fin = new moment(vm.itemSearch.dateFin);
            return fin.isBefore(debut);
        };


        vm.initFiltre = function () {
            vm.filtrer = !vm.filtrer;
            if (!vm.filtrer) {
                vm.itemSearch = {
                    "dateDebut": null,
                    "dateFin": null,
                    "nom": null,
                    "prenom": null,
                    "numero": null,
                    "metier": null,
                    "statut":null,
                    "sexe":null
                };
                init();
            }
        };

          init();
        function init() {
            if(vm.itemSearch.dateDebut!=null) vm.dateDebut = DateUtils.convertLocalDateToServer(vm.itemSearch.dateDebut);
            if(vm.itemSearch.dateFin!=null) vm.dateFin = DateUtils.convertLocalDateToServer(vm.itemSearch.dateFin);
            var addItemData = {};
            var editItemData = {};
            var detailItemData = {
                templateUrl: 'app/entities/carte/carte-dialog.html',
                controller: 'CarteDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    isViewing: function () {
                        return true;
                    },
                    entity: null //valeur déterminé à l'appel de la boite,
                }
            };            /**
             *Modification d'un élément
            */

            var deleteItemData = {};
            var dialogData = {
                addData: addItemData,
                editData: editItemData,
                detailData: detailItemData
            };
            var entitySearchParams = function () {
                return {};
            };
            var entityParams = function () {
                return {
                    "dateDebut": vm.dateDebut,
                    "dateFin": vm.dateFin,
                    "nom": vm.itemSearch.nom,
                    "prenom": vm.itemSearch.prenom,
                    "numero": vm.itemSearch.numero,
                    "metier": vm.itemSearch.metier,
                    "statut":vm.itemSearch.statut,
                    "sexe":vm.itemSearch.sexe
                };
            };


            var datas = {
                scope: $scope,
                vm: vm,
                entity: CarteMultiParams,
                dialogData: dialogData,
                entitySearch: CarteMultiParams,
                entitySearchParams: entitySearchParams,
                entityParams: entityParams
            };
            TableService.init(datas);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('members', {
            parent: 'entity',
            url: '/members?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Members'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/members/members.html',
                    controller: 'MembersController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('members');
                    $translatePartialLoader.addPart('bFIdDoc');
                    $translatePartialLoader.addPart('countryIdDoc');
                    $translatePartialLoader.addPart('adresses');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('association');
                    $translatePartialLoader.addPart('city');
                    return $translate.refresh();
                }]
            }
        })


        .state('carte-historique', {
            parent: 'entity',
            url: '/carte-historique?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.carte.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/members/members-cartes.html',
                    controller: 'MembersCarteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('carte');
                    $translatePartialLoader.addPart('members');
                    $translatePartialLoader.addPart('bFIdDoc');
                    $translatePartialLoader.addPart('countryIdDoc');
                    $translatePartialLoader.addPart('adresses');
                    $translatePartialLoader.addPart('association');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })

        .state('members-stats', {
            parent: 'entity',
            url: '/members-stats?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Members-stats'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/members/members-stats.html',
                    controller: 'MembersStatsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('members');
                    $translatePartialLoader.addPart('bFIdDoc');
                    $translatePartialLoader.addPart('countryIdDoc');
                    $translatePartialLoader.addPart('adresses');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('association');
                    return $translate.refresh();
                }]
            }
        })



        .state('members-resultat-vote', {
            parent: 'entity',
            url: '/members-resultat-vote?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Members-resultat-vote'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/members/members-vote-resultat.html',
                    controller: 'MembersVoteResultatController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('members');
                    $translatePartialLoader.addPart('bFIdDoc');
                    $translatePartialLoader.addPart('countryIdDoc');
                    $translatePartialLoader.addPart('adresses');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('association');
                    return $translate.refresh();
                }]
            }
        })



        .state('members-detail', {
            parent: 'members',
            url: '/members/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Members'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/members/members-detail.html',
                    controller: 'MembersDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Members', function($stateParams, Members) {
                    return Members.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'members',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('members-detail.edit', {
            parent: 'members-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/members/members-dialog.html',
                    controller: 'MembersDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Members', function(Members) {
                            return Members.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('members.new', {
            parent: 'members',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/members/members-dialog.html',
                    controller: 'MembersDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numero: null,
                                nom: null,
                                prenom: null,
                                dateNaissance: null,
                                lieuNaissance: null,
                                sexe: null,
                                mariage: null,
                                telephone: null,
                                dateArrivee: null,
                                villeArrivee: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('members', null, { reload: 'members' });
                }, function() {
                    $state.go('members');
                });
            }]
        })
        .state('members.edit', {
            parent: 'members',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/members/members-dialog.html',
                    controller: 'MembersDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Members', function(Members) {
                            return Members.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('members', null, { reload: 'members' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('members.delete', {
            parent: 'members',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/members/members-delete-dialog.html',
                    controller: 'MembersDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Members', function(Members) {
                            return Members.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('members', null, { reload: 'members' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Members', Members)
        .factory('MemberMultiParams', MemberMultiParams)
        .factory('MemberExisting', MemberExisting)
        .factory('MemberCandidats', MemberCandidats)
        .factory('MembersSaveVote', MembersSaveVote)
        .factory('CarteMultiParams', CarteMultiParams)
        .factory('MembersResultatVote', MembersResultatVote);

        
    Members.$inject = ['$resource', 'DateUtils'];
    MemberMultiParams.$inject = ['$resource', 'DateUtils'];
    MemberExisting.$inject = ['$resource', 'DateUtils'];
    MemberCandidats.$inject = ['$resource', 'DateUtils'];
    MembersSaveVote.$inject = ['$resource', 'DateUtils'];
    CarteMultiParams.$inject = ['$resource', 'DateUtils'];
    MembersResultatVote.$inject = ['$resource', 'DateUtils'];

    function CarteMultiParams ($resource, DateUtils) {
        var resourceUrl =  'api/cartes/findByParams';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                    }
                    return data;
                }
            }
        });
    }



    function MemberMultiParams ($resource, DateUtils) {
        var resourceUrl =  'api/members/findByParams';

        return $resource(resourceUrl, {}, {
                'query': {
                         method: 'GET',
                         isArray: true,
                    transformResponse: function (data) {
                         if (data) {
                                   data = angular.fromJson(data);
                                   console.log(data);
                                   data.forEach(function(item) {
                                      item.dateNaissance = DateUtils.convertLocalDateFromServer(item.dateNaissance);
                                     item.dateArrivee = DateUtils.convertLocalDateFromServer(item.dateArrivee);
                                    if (item.country && item.country !== null && item.country.dateDelivr) {
                                         item.country.dateDelivr = DateUtils.convertLocalDateFromServer(item.country.dateDelivr);
                                        }                         
                                        
                                    if (item.country && item.country !== null && item.country.dateExpr) {
                                        item.country.dateExpr = DateUtils.convertLocalDateFromServer(item.country.dateExpr);
                                        }        
                });
            }
            return data;
        }
    },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                        data.dateArrivee = DateUtils.convertLocalDateFromServer(data.dateArrivee);
                    }
                    return data;
                }
            }
        });
    }

    function MemberCandidats ($resource, DateUtils) {
        var resourceUrl =  'api/members/candidats';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                        data.dateArrivee = DateUtils.convertLocalDateFromServer(data.dateArrivee);
                    }
                    return data;
                }
            }
        });
    }

    function MemberExisting ($resource, DateUtils) {
        var resourceUrl =  'api/members/test';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);

                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);

                }
            },
            'sauvegarder': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);

                }
            }
        });
    }

    function MembersSaveVote ($resource, DateUtils) {
        var resourceUrl =  'api/members/saveVote';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                        data.dateArrivee = DateUtils.convertLocalDateFromServer(data.dateArrivee);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);
                    return angular.toJson(copy);
                }
            }
        });
    }


    function MembersResultatVote ($resource, DateUtils) {
        var resourceUrl =  'api/members/vote-resultat';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                        data.dateArrivee = DateUtils.convertLocalDateFromServer(data.dateArrivee);
                    }
                    return data;
                }
            },
        });
    }




    function Members ($resource, DateUtils) {
        var resourceUrl =  'api/members/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                        data.dateArrivee = DateUtils.convertLocalDateFromServer(data.dateArrivee);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('consulatApp')
        .controller('MembersController', MembersController);

    MembersController.$inject = ['$scope', '$filter', 'Poste', 'UserExtraConnected', '$rootScope', 'PopupService', '$http', '$window', 'Notification', '$state', 'DataUtils', 'Members', 'Association', 'Country', 'City', 'States', 'CityByStateId', 'CityByCountryId', 'DocumentLegal', 'Metier','MemberExisting','DateUtils'];

    function MembersController($scope, $filter, Poste, UserExtraConnected, $rootScope, PopupService, $http, $window, Notification, $state, DataUtils, Members, Association, Country, City, States, CityByStateId, CityByCountryId, DocumentLegal, Metier,MemberExisting,DateUtils) {

        var vm = this;
        vm.saveMembre = saveMembre;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.user = UserExtraConnected.query();
        vm.documents = DocumentLegal.query();
        var asArray = [];
        vm.essai = essai;

        vm.file = null;
        vm.croped = null;


        function essai() {
            // vm.setPhoto(vm.croped,vm.members);
            // vm.members.photo = vm.croped;
            // vm.members.photoContentType = vm.file.type;
            // console.log(vm.file);
            // console.log(vm.croped);
            // vm.setPhoto(vm.file,vm.members);
            // console.log("------------------------------------------------------------------------------------------------------------");
            // console.log(vm.members);


        }


        $scope.upload = function (dataUrl) {
            Upload.upload({
                //    url: 'https://angular-file-upload-cors-srv.appspot.com/upload',
                data: {
                    file: Upload.dataUrltoBlob(dataUrl)
                },
            }).then(function (response) {
                $timeout(function () {
                    $scope.result = response.data;
                });
            }, function (response) {
                if (response.status > 0) $scope.errorMsg = response.status
                    + ': ' + response.data;
            }, function (evt) {
                $scope.progress = parseInt(100.0 * evt.loaded / evt.total);
            });
        }


        var fileURLPDF;

        vm.etatCarte = etatCarte;

        vm.members = {
            id: null,
            numero: null,
            nom: null,
            prenom: null,
            nomConjoint: null,
            prenomConjoint: null,
            dateNaissance: null,
            lieuNaissance: null,
            sexe: null,
            mariage: null,
            signatureScan: null,
            dateArrivee: null,
            villeArrivee: null,
            etatArrivee: null,
            metier: null,
            occupation: null,
            memePaysConjoint: null,
            parentsUsa: null,
            mumInUsa: null,
            noConjoint: null,
            telephone: null,
            taille: null,
            country: {
                cityId: null,
                statesId: null,
                numero: null,
                autorite: null,
                dateDelivr: null,
                dateExpr: null
            },
            bfIdDoc: {
                type: null,
                numero: null,
                docId: null,
                cityId: null,
                dateDelivr: null,
                dateExpr: null,
            },
            infoParents: {
                nomPere: null,
                prenomPere: null,
                nomMere: null,
                prenomMere: null,
                noPere: null,
                noMere: null

            },
            adresseDTO: {
                rue: null,
                noPorte: null,
                telephone: null,
                mail: null,
                zipCode: null,
                autre: null,
                cityId: null,
                city: null,
                etatId: null,
                etat: null
            },
            associations: []
        };

        /*  if(entity.id!=null)
         {
         vm.members = entity;
         } */
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.mariage = mariage;
        vm.ville = ville;
        vm.etat = etat;
        vm.pereUsa = pereUsa;
        vm.mereUsa = mereUsa;
        vm.association = association;
        vm.villes = [];

        function saveMembre() {

            if (vm.croped != null) {
                vm.members.photo = vm.croped;
                vm.members.photoContentType = vm.file.type;
            }

            if (!vm.members.scanSignature) {
                if (vm.members.signature != null) {
                    var canvas = document.createElement("canvas");
                    var dataURL = canvas.toDataURL("image/png");
                    vm.members.signature = vm.members.signature.substring("data:image/png;base64,".length);
                    vm.members.photo = vm.members.photo.substring("data:image/png;base64,".length);

                } else {
                    var canvas = document.createElement("canvas");
                    var dataURL = canvas.toDataURL("image/png");
                    vm.members.photo = vm.members.photo.substring("data:image/png;base64,".length);
                }
            } else {
                var canvas = document.createElement("canvas");
                var dataURL = canvas.toDataURL("image/png");
                vm.members.photo = vm.members.photo.substring("data:image/png;base64,".length);

            }
            vm.isSaving = true;
            if (vm.members.id !== null) {
                Members.update(vm.members, onSaveSuccess, onSaveError);
            } else {
                Members.save(vm.members, onSaveSuccess, onSaveError);
            }
        }

        function etatCarte(resultat) {
            $http.get('/api/members/cartePDF', {
                responseType: 'arraybuffer',
                params: {
                    idMembre: resultat.id,
                    changement: false
                }

            })
                .then(function (response) {
                    var file = new Blob([(response)], {
                        type: 'application/pdf'
                    });
                    fileURLPDF = URL.createObjectURL(file);
                    $window.open(fileURLPDF, '_blank');
                },function (err) {
                });
        }

        function onSaveSuccess(resultat) {
            Notification.success("Le membre a été enregistré avec succès!");
            $state.reload();
            vm.isSaving = false;
            // vm.etatCarte(resultat);
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function mariage() {
            /* if(vm.members.mariage==false || vm.members.mariage==null)
             {
             vm.members.mariage = false;
             console.log("falsssss");

             }
             else
             {
                 vm.members.mariage = true;
                 console.log("trueeeee");

             }*/
        }

        function ville(bol) {
            //  vm.members.memePaysConjoint = bol;

        }

        function etat(bol) {
            //  vm.members.etatBol = bol;

        }

        function pereUsa(bol) {
            // vm.members.parentsUsa = bol;

        }

        function mereUsa(bol) {
            //    vm.members.mumInUsa = bol;

        }

        function association(bol) {
            vm.members.association = bol;
        }


        function openCalendar(date) {
            vm.datePickerOpenStatus.date;


            vm.datePickerOpenStatus[date] = true;
        }


        /*****************************Gestionnaire des onglets**************************************/
        vm.steps = [
            'IDENTIFICATION',
            'CONTACTS AND ARRIVALS',
            'IDENTIFICATION DOC',
            'ASSOCIATION'
        ];


        vm.selection = vm.steps[0];
        vm.error = false;
        vm.showOnglet = showOnglet;
        vm.getCurrentStepIndex = function () {
            return vm.steps.indexOf(vm.selection);
        };

        function showOnglet(onglet) {
            var stepIndex = vm.getCurrentStepIndex();
            return (vm.selection.toUpperCase() === onglet.toUpperCase());
        }

        // Go to a defined step index
        vm.goToStep = function (index, editForm) {

            if (vm.user.id != null) {
                if (!editForm.$invalid || (vm.getCurrentStepIndex() > index)) {
                    if (!angular.isUndefined(vm.steps[index])) {
                        vm.selection = vm.steps[index];
                    }
                }
            } else {
                Notification.error("L'administrateur principal ne peut enregistrer un membre'!")

            }
        };

        vm.hasNextStep = function () {
            var stepIndex = vm.getCurrentStepIndex();
            var nextStep = stepIndex + 1;
            // Return true if there is a next step, false if not
            return !angular.isUndefined(vm.steps[nextStep]);
        };

        vm.hasPreviousStep = function () {
            var stepIndex = vm.getCurrentStepIndex();
            var previousStep = stepIndex - 1;
            // Return true if there is a next step, false if not
            return !angular.isUndefined(vm.steps[previousStep]);
        };

        vm.incrementStep = function () {
            //vm.members.signature = null;

           // vm.members.dateNaissance = new Date(vm.members.dateNaissance );
            if(vm.getCurrentStepIndex()==0)
            {

           var url ='api/members/test';
           var copy = angular.copy(vm.members);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);
                    copy.signature = null;

            $http.post(url, copy)
            .then(
             function(response){
            //success callback
             if (vm.user.id != null) {
            if (vm.hasNextStep()) {
                //Vérification des champs du step précedent
                var stepIndex = vm.getCurrentStepIndex();
                var nextStep = stepIndex + 1;
                vm.selection = vm.steps[nextStep];
            }
        } else {
            Notification.error("L'administrateur principal ne peut enregistrer un membre'!")

        }
                 },
            function(response){
            //failure callback
               });

            }
            else
            {
                if (vm.hasNextStep()) {
                    //Vérification des champs du step précedent
                    var stepIndex = vm.getCurrentStepIndex();
                    var nextStep = stepIndex + 1;
                    vm.selection = vm.steps[nextStep];
                }

            }


        };


        vm.decrementStep = function () {
            if (vm.hasPreviousStep()) {
                var stepIndex = vm.getCurrentStepIndex();
                var previousStep = stepIndex - 1;
                vm.selection = vm.steps[previousStep];
            }
        };


        vm.paysColumns = [{
            name: 'libele',
            title: 'Libelle'
        }];
        $scope.$on("onLoadPays", function () {

        });
        loadPays();

        function loadPays() {
            Country.query({
                size: 10000
            }, function (data) {
                if (data != null) {
                    vm.pays = [];
                    vm.pays = data;
                }
            });
        }


        vm.posteColumns = [{
            name: 'libelle',
            title: 'Libelle'
        }];

        loadPostes();

        function loadPostes() {
            vm.postes = Poste.query();

        }

        $scope.$watch("vm.members.lieuNaissanceId", function () {
            if (vm.members.lieuNaissanceId != null) {

                Country.get({
                    id: vm.members.lieuNaissanceId
                }, function (data) {
                    vm.members.lieuNaissance = data.libele;
                })
            }

        });


        vm.villeColumns = [{
            name: 'libelle',
            title: 'Libelle'
        }];
        $scope.$on("onLoadVilles", function () {

        });

        $scope.$on("onLoadVillesBF", function () {

        });
        loadVillesBF();

        function loadVillesBF() {
            CityByCountryId.query({
                id: 1001
            }, function (data) {
                vm.countriesVille = data;
            })


            // vm.members.lieuNaissance = test.libele;
        }


        $scope.$on("onLoadVillesUSA", function () {

        });
        loadVillesUSA();

        function loadVillesUSA() {
            CityByCountryId.query({
                id: 1014
            }, function (data) {
                vm.countriesVilleUSA = data;
            })


            // vm.members.lieuNaissance = test.libele;
        }


        $scope.$watch("vm.members.villeArriveId", function () {
            if (vm.members.statesId != null) {
                CityByStateId.query({
                    id: vm.members.statesId
                }, function (data) {
                    vm.countriesVilleUSA = data;
                })
            }
            if (vm.members.villeArriveId != null) {
                City.get({
                    id: vm.members.villeArriveId
                }, function (data) {
                    vm.members.villeArrivee = data.libelle;
                    vm.members.etatArrivee = data.statesLibelle;
                })
            }

        });

        $scope.$watch("vm.members.villeId", function () {
            if (vm.members.villeId != null) {

                City.get({
                    id: vm.members.villeId
                }, function (data) {
                    vm.members.ville = data.libelle;
                })
            }

        });


        vm.etatColumns = [{
            name: 'libelle',
            title: 'Libelle'
        }];
        $scope.$on("onLoadEtats", function () {

        });
        loadEtats();

        function loadEtats() {
            States.query({
                size: 10000
            }, function (data) {
                if (data != null) {
                    vm.etats = [];
                    vm.etats = data;
                }
            });


            // vm.members.lieuNaissance = test.libele;
        }

        vm.metierColumns = [{
            name: 'libelle',
            title: 'Libelle'
        }];
        $scope.$on("onLoadMetier", function () {

        });
        loadMetier();

        function loadMetier() {
            vm.metiers = Metier.query({
                size: 1000
            });

        }

        $scope.$watch("vm.members.metierId", function () {
            if (vm.members.metierId != null) {
                Metier.get({
                    id: vm.members.metierId
                }, function (data) {
                    vm.members.metier = data.libelle;
                })
            }

        });


        vm.statesVilleColumns = [{
            name: 'libelle',
            title: 'Libelle'
        }];
        $scope.$on("onLoadStatesVille", function () {

        });


        $scope.$watch("vm.members.lieuNaissanceId", function () {
            if (vm.members.lieuNaissanceId != null) {
                Country.get({
                    id: vm.members.lieuNaissanceId
                }, function (data) {
                    vm.members.lieuNaissance = data.libele;
                })

            }

        });


        $scope.$watch("vm.members.country.statesId", function () {
            loadEtats();
            if (vm.members.country.statesId != null) {
                CityByStateId.query({
                    id: vm.members.country.statesId
                }, function (data) {
                    vm.statesVille = data;
                })


                vm.members.country.states = $filter('filter')(vm.etats, {id: vm.members.country.statesId}, true)[0].libelle;

            }

        });


        $scope.$watch("vm.members.country.cityId", function () {

            if (vm.members.country.statesId != null) {
                CityByStateId.query({
                    id: vm.members.country.statesId
                }, function (data) {
                    vm.statesVille = data;
                    vm.members.country.city = $filter('filter')(vm.statesVille, {id: vm.members.country.cityId}, true)[0].libelle;

                })
            }

        });


        $scope.$watch("vm.members.adresseDTO.etatId", function () {
            loadEtats();
            if (vm.members.adresseDTO.etatId != null) {
                CityByStateId.query({
                    id: vm.members.adresseDTO.etatId
                }, function (data) {
                    vm.villeAdresse = data;
                })
                vm.members.adresseDTO.etat = $filter('filter')(vm.etats, {id: vm.members.adresseDTO.etatId}, true)[0].libelle;
            }
        });


        $scope.$watch("vm.members.adresseDTO.cityId", function () {
            if (vm.members.adresseDTO.etatId != null) {
                CityByStateId.query({
                    id: vm.members.adresseDTO.etatId
                }, function (data) {
                    vm.villeAdresse = data;
                    vm.members.adresseDTO.city = $filter('filter')(vm.villeAdresse, {id: vm.members.adresseDTO.cityId}, true)[0].libelle;
                })
            }

        });


        $scope.$watch("vm.members.statesId", function () {
            loadEtats();
            if (vm.members.statesId != null) {
                CityByStateId.query({
                    id: vm.members.statesId
                }, function (data) {
                    vm.countriesVilleUSA = data;
                })

                vm.members.states = $filter('filter')(vm.etats, {id: vm.members.statesId}, true)[0].libelle;

            }

        });

        $scope.$watch("vm.members.bfIdDoc.cityId", function () {
            loadVillesBF();
            vm.members.bfIdDoc.city = $filter('filter')(vm.countriesVille, {id: vm.members.bfIdDoc.cityId}, true)[0].libelle;

        });


        vm.colums = [{
            name: 'nom',
            title: 'Nom'
        }];


        $scope.$watch("vm.associationId", function (ids) {

            Association.query(function (data) {
                vm.assocs = data;
            })


            if (angular.isDefined(ids)) {
                vm.members.associations = [];
                angular.forEach(ids, function (value, index) {
                    var auth = _.find(vm.assocs, {'id': value});
                    vm.members.associations.push(auth);
                });
            }
        });


        vm.setPhoto = function ($file, members) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        members.photo = base64Data;
                        members.photoContentType = $file.type;
                    });
                });
            }
        };

        vm.setSignature = function ($file, consulat) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        consulat.signature = base64Data;
                        consulat.signatureContentType = $file.type;
                    });
                });
            }
        };


        //  function addStates()
        //  {

        var addItemData = {
            templateUrl: 'app/entities/states/states-dialog.html',
            controller: 'StatesDialogController',
            service: 'States',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                isViewing: function () {
                    return false;
                },
                isHiding: function () {
                    return true;
                },
                entity: function () {
                    return {
                        /*Initialisation des valeurs par défauts de l'entité à créer*/
                        id: null,
                        libelle: null,
                        countryLibelle: null

                    };
                }
            }
        };

        var addItemDataSecond = {
            templateUrl: 'app/entities/city/city-dialog.html',
            controller: 'CityDialogController',
            service: 'City',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                isViewing: function () {
                    return false;
                },
                isHiding: function () {
                    return true;
                },
                entity: function () {
                    return {
                        /*Initialisation des valeurs par défauts de l'entité à créer*/
                        id: null,
                        libelle: null,
                        countriesLibelle: null,
                        statesLibelle: null

                    };
                }
            }
        };

        var dialogData = {
            addData: addItemData,
            addDataSecond: addItemDataSecond
        };


        var datasEmpty = [];


        var statesWindow = {
            vm: vm,
            datas: datasEmpty,
            dialogData: dialogData,
            scope: $scope
        };
        PopupService.open(statesWindow);

        $rootScope.$on('PopupService:resultData', function (event, result) {
            if (angular.isDefined(result.result.statesId) && result.result.statesId == vm.members.adresseDTO.etatId) {
                vm.villeAdresse.push(result.result);
            } else {
                vm.etats.push(result.result);
            }


        });


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoServiceDialogController', InfoServiceDialogController);

    InfoServiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InfoService', 'MembreService', 'Members'];

    function InfoServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InfoService, MembreService, Members) {
        var vm = this;

        vm.infoService = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.membreservices = MembreService.query();
        vm.members = Members.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.infoService.id !== null) {
                InfoService.update(vm.infoService, onSaveSuccess, onSaveError);
            } else {
                InfoService.save(vm.infoService, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:infoServiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateIntegration = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoServiceDetailController', InfoServiceDetailController);

    InfoServiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InfoService', 'MembreService', 'Members'];

    function InfoServiceDetailController($scope, $rootScope, $stateParams, previousState, entity, InfoService, MembreService, Members) {
        var vm = this;

        vm.infoService = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:infoServiceUpdate', function(event, result) {
            vm.infoService = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoServiceDeleteController',InfoServiceDeleteController);

    InfoServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'InfoService'];

    function InfoServiceDeleteController($uibModalInstance, entity, InfoService) {
        var vm = this;

        vm.infoService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InfoService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('info-service', {
            parent: 'entity',
            url: '/info-service?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfoServices'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/info-service/info-services.html',
                    controller: 'InfoServiceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('info-service');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('info-service-detail', {
            parent: 'info-service',
            url: '/info-service/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfoService'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/info-service/info-service-detail.html',
                    controller: 'InfoServiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InfoService', function($stateParams, InfoService) {
                    return InfoService.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'info-service',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('info-service-detail.edit', {
            parent: 'info-service-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-service/info-service-dialog.html',
                    controller: 'InfoServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfoService', function(InfoService) {
                            return InfoService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('info-service.new', {
            parent: 'info-service',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-service/info-service-dialog.html',
                    controller: 'InfoServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateIntegration: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('info-service', null, { reload: 'info-service' });
                }, function() {
                    $state.go('info-service');
                });
            }]
        })
        .state('info-service.edit', {
            parent: 'info-service',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-service/info-service-dialog.html',
                    controller: 'InfoServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfoService', function(InfoService) {
                            return InfoService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('info-service', null, { reload: 'info-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('info-service.delete', {
            parent: 'info-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-service/info-service-delete-dialog.html',
                    controller: 'InfoServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InfoService', function(InfoService) {
                            return InfoService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('info-service', null, { reload: 'info-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('InfoService', InfoService);

    InfoService.$inject = ['$resource', 'DateUtils'];

    function InfoService ($resource, DateUtils) {
        var resourceUrl =  'api/info-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateIntegration = DateUtils.convertLocalDateFromServer(data.dateIntegration);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateIntegration = DateUtils.convertLocalDateToServer(copy.dateIntegration);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateIntegration = DateUtils.convertLocalDateToServer(copy.dateIntegration);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoServiceController', InfoServiceController);

    InfoServiceController.$inject = ['$state', 'InfoService', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function InfoServiceController($state, InfoService, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            InfoService.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.infoServices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoPosteDialogController', InfoPosteDialogController);

    InfoPosteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InfoPoste', 'Members', 'Poste'];

    function InfoPosteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InfoPoste, Members, Poste) {
        var vm = this;

        vm.infoPoste = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.members = Members.query();
        vm.postes = Poste.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.infoPoste.id !== null) {
                InfoPoste.update(vm.infoPoste, onSaveSuccess, onSaveError);
            } else {
                InfoPoste.save(vm.infoPoste, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:infoPosteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateDebut = false;
        vm.datePickerOpenStatus.dateFin = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoPosteDetailController', InfoPosteDetailController);

    InfoPosteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InfoPoste', 'Members', 'Poste'];

    function InfoPosteDetailController($scope, $rootScope, $stateParams, previousState, entity, InfoPoste, Members, Poste) {
        var vm = this;

        vm.infoPoste = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:infoPosteUpdate', function(event, result) {
            vm.infoPoste = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoPosteDeleteController',InfoPosteDeleteController);

    InfoPosteDeleteController.$inject = ['$uibModalInstance', 'entity', 'InfoPoste'];

    function InfoPosteDeleteController($uibModalInstance, entity, InfoPoste) {
        var vm = this;

        vm.infoPoste = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InfoPoste.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('info-poste', {
            parent: 'entity',
            url: '/info-poste?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfoPostes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/info-poste/info-postes.html',
                    controller: 'InfoPosteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('info-poste');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('info-poste-detail', {
            parent: 'info-poste',
            url: '/info-poste/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfoPoste'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/info-poste/info-poste-detail.html',
                    controller: 'InfoPosteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InfoPoste', function($stateParams, InfoPoste) {
                    return InfoPoste.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'info-poste',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('info-poste-detail.edit', {
            parent: 'info-poste-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-poste/info-poste-dialog.html',
                    controller: 'InfoPosteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfoPoste', function(InfoPoste) {
                            return InfoPoste.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('info-poste.new', {
            parent: 'info-poste',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-poste/info-poste-dialog.html',
                    controller: 'InfoPosteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateDebut: null,
                                dateFin: null,
                                actuelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('info-poste', null, { reload: 'info-poste' });
                }, function() {
                    $state.go('info-poste');
                });
            }]
        })
        .state('info-poste.edit', {
            parent: 'info-poste',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-poste/info-poste-dialog.html',
                    controller: 'InfoPosteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfoPoste', function(InfoPoste) {
                            return InfoPoste.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('info-poste', null, { reload: 'info-poste' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('info-poste.delete', {
            parent: 'info-poste',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-poste/info-poste-delete-dialog.html',
                    controller: 'InfoPosteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InfoPoste', function(InfoPoste) {
                            return InfoPoste.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('info-poste', null, { reload: 'info-poste' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('InfoPoste', InfoPoste)
        .factory('InfoPosteByMember', InfoPosteByMember);

    InfoPoste.$inject = ['$resource', 'DateUtils'];
    InfoPosteByMember.$inject = ['$resource', 'DateUtils'];

    function InfoPosteByMember ($resource, DateUtils) {
        var resourceUrl =  'api/info-postes/ByMember/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateDebut = DateUtils.convertLocalDateFromServer(data.dateDebut);
                        data.dateFin = DateUtils.convertLocalDateFromServer(data.dateFin);
                    }
                    return data;
                }
            }
        });
    }

    function InfoPoste ($resource, DateUtils) {
        var resourceUrl =  'api/info-postes/:id';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateDebut = DateUtils.convertLocalDateFromServer(data.dateDebut);
                        data.dateFin = DateUtils.convertLocalDateFromServer(data.dateFin);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDebut = DateUtils.convertLocalDateToServer(copy.dateDebut);
                    copy.dateFin = DateUtils.convertLocalDateToServer(copy.dateFin);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDebut = DateUtils.convertLocalDateToServer(copy.dateDebut);
                    copy.dateFin = DateUtils.convertLocalDateToServer(copy.dateFin);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoPosteController', InfoPosteController);

    InfoPosteController.$inject = ['$state', 'InfoPoste', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function InfoPosteController($state, InfoPoste, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            InfoPoste.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.infoPostes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoParentsDialogController', InfoParentsDialogController);

    InfoParentsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InfoParents'];

    function InfoParentsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InfoParents) {
        var vm = this;

        vm.infoParents = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.infoParents.id !== null) {
                InfoParents.update(vm.infoParents, onSaveSuccess, onSaveError);
            } else {
                InfoParents.save(vm.infoParents, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:infoParentsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoParentsDetailController', InfoParentsDetailController);

    InfoParentsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InfoParents'];

    function InfoParentsDetailController($scope, $rootScope, $stateParams, previousState, entity, InfoParents) {
        var vm = this;

        vm.infoParents = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:infoParentsUpdate', function(event, result) {
            vm.infoParents = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoParentsDeleteController',InfoParentsDeleteController);

    InfoParentsDeleteController.$inject = ['$uibModalInstance', 'entity', 'InfoParents'];

    function InfoParentsDeleteController($uibModalInstance, entity, InfoParents) {
        var vm = this;

        vm.infoParents = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InfoParents.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('info-parents', {
            parent: 'entity',
            url: '/info-parents?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfoParents'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/info-parents/info-parents.html',
                    controller: 'InfoParentsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('info-parents');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('info-parents-detail', {
            parent: 'info-parents',
            url: '/info-parents/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfoParents'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/info-parents/info-parents-detail.html',
                    controller: 'InfoParentsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InfoParents', function($stateParams, InfoParents) {
                    return InfoParents.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'info-parents',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('info-parents-detail.edit', {
            parent: 'info-parents-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-parents/info-parents-dialog.html',
                    controller: 'InfoParentsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfoParents', function(InfoParents) {
                            return InfoParents.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('info-parents.new', {
            parent: 'info-parents',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-parents/info-parents-dialog.html',
                    controller: 'InfoParentsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numero: null,
                                nomPere: null,
                                prenomPere: null,
                                nomMere: null,
                                prenomMere: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('info-parents', null, { reload: 'info-parents' });
                }, function() {
                    $state.go('info-parents');
                });
            }]
        })
        .state('info-parents.edit', {
            parent: 'info-parents',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-parents/info-parents-dialog.html',
                    controller: 'InfoParentsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfoParents', function(InfoParents) {
                            return InfoParents.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('info-parents', null, { reload: 'info-parents' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('info-parents.delete', {
            parent: 'info-parents',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-parents/info-parents-delete-dialog.html',
                    controller: 'InfoParentsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InfoParents', function(InfoParents) {
                            return InfoParents.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('info-parents', null, { reload: 'info-parents' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('InfoParents', InfoParents);

    InfoParents.$inject = ['$resource'];

    function InfoParents ($resource) {
        var resourceUrl =  'api/info-parents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoParentsController', InfoParentsController);

    InfoParentsController.$inject = ['$state', 'InfoParents', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function InfoParentsController($state, InfoParents, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            InfoParents.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.infoParents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoAssociationDialogController', InfoAssociationDialogController);

    InfoAssociationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InfoAssociation'];

    function InfoAssociationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InfoAssociation) {
        var vm = this;

        vm.infoAssociation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.infoAssociation.id !== null) {
                InfoAssociation.update(vm.infoAssociation, onSaveSuccess, onSaveError);
            } else {
                InfoAssociation.save(vm.infoAssociation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:infoAssociationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateEntree = false;
        vm.datePickerOpenStatus.dateSortie = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoAssociationDetailController', InfoAssociationDetailController);

    InfoAssociationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InfoAssociation'];

    function InfoAssociationDetailController($scope, $rootScope, $stateParams, previousState, entity, InfoAssociation) {
        var vm = this;

        vm.infoAssociation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:infoAssociationUpdate', function(event, result) {
            vm.infoAssociation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoAssociationDeleteController',InfoAssociationDeleteController);

    InfoAssociationDeleteController.$inject = ['$uibModalInstance', 'entity', 'InfoAssociation'];

    function InfoAssociationDeleteController($uibModalInstance, entity, InfoAssociation) {
        var vm = this;

        vm.infoAssociation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InfoAssociation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('info-association', {
            parent: 'entity',
            url: '/info-association?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfoAssociations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/info-association/info-associations.html',
                    controller: 'InfoAssociationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('info-association');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('info-association-detail', {
            parent: 'info-association',
            url: '/info-association/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InfoAssociation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/info-association/info-association-detail.html',
                    controller: 'InfoAssociationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InfoAssociation', function($stateParams, InfoAssociation) {
                    return InfoAssociation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'info-association',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('info-association-detail.edit', {
            parent: 'info-association-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-association/info-association-dialog.html',
                    controller: 'InfoAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfoAssociation', function(InfoAssociation) {
                            return InfoAssociation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('info-association.new', {
            parent: 'info-association',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-association/info-association-dialog.html',
                    controller: 'InfoAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateEntree: null,
                                dateSortie: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('info-association', null, { reload: 'info-association' });
                }, function() {
                    $state.go('info-association');
                });
            }]
        })
        .state('info-association.edit', {
            parent: 'info-association',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-association/info-association-dialog.html',
                    controller: 'InfoAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfoAssociation', function(InfoAssociation) {
                            return InfoAssociation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('info-association', null, { reload: 'info-association' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('info-association.delete', {
            parent: 'info-association',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/info-association/info-association-delete-dialog.html',
                    controller: 'InfoAssociationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InfoAssociation', function(InfoAssociation) {
                            return InfoAssociation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('info-association', null, { reload: 'info-association' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('InfoAssociationByMember', InfoAssociationByMember)
        .factory('InfoAssociation', InfoAssociation);

    InfoAssociationByMember.$inject = ['$resource', 'DateUtils'];
    InfoAssociation.$inject = ['$resource', 'DateUtils'];


    function InfoAssociationByMember ($resource, DateUtils) {
        var resourceUrl =  'api/info-associations/association/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateEntree = DateUtils.convertLocalDateFromServer(data.dateEntree);
                        data.dateSortie = DateUtils.convertLocalDateFromServer(data.dateSortie);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateEntree = DateUtils.convertLocalDateToServer(copy.dateEntree);
                    copy.dateSortie = DateUtils.convertLocalDateToServer(copy.dateSortie);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateEntree = DateUtils.convertLocalDateToServer(copy.dateEntree);
                    copy.dateSortie = DateUtils.convertLocalDateToServer(copy.dateSortie);
                    return angular.toJson(copy);
                }
            }
        });
    }







    function InfoAssociation ($resource, DateUtils) {
        var resourceUrl =  'api/info-associations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateEntree = DateUtils.convertLocalDateFromServer(data.dateEntree);
                        data.dateSortie = DateUtils.convertLocalDateFromServer(data.dateSortie);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateEntree = DateUtils.convertLocalDateToServer(copy.dateEntree);
                    copy.dateSortie = DateUtils.convertLocalDateToServer(copy.dateSortie);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateEntree = DateUtils.convertLocalDateToServer(copy.dateEntree);
                    copy.dateSortie = DateUtils.convertLocalDateToServer(copy.dateSortie);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('InfoAssociationController', InfoAssociationController);

    InfoAssociationController.$inject = ['$state', 'InfoAssociation', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function InfoAssociationController($state, InfoAssociation, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            InfoAssociation.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.infoAssociations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('DocumentLegalDialogController', DocumentLegalDialogController);

    DocumentLegalDialogController.$inject = ['$timeout', '$scope', 'Country', '$uibModalInstance', 'entity', 'DocumentLegal'];

    function DocumentLegalDialogController ($timeout, $scope, Country, $uibModalInstance, entity, DocumentLegal) {
        var vm = this;

        vm.documentLegal = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.countryColumns = [{
            name: 'libele',
            title: 'Libelle'
        }];
        $scope.$on("onLoadCountries", function () {

        });
        loadCountries();

        function loadCountries() {
            Country.query({
                size: 10000
            }, function (data) {
                if (data != null) {
                    vm.countries = [];
                    vm.countries = data;
                }
            });


           // vm.members.lieuNaissance = test.libele;
        }


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documentLegal.id !== null) {
                DocumentLegal.update(vm.documentLegal, onSaveSuccess, onSaveError);
            } else {
                DocumentLegal.save(vm.documentLegal, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:documentLegalUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateExpr = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('DocumentLegalDetailController', DocumentLegalDetailController);

    DocumentLegalDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DocumentLegal'];

    function DocumentLegalDetailController($scope, $rootScope, $stateParams, previousState, entity, DocumentLegal) {
        var vm = this;

        vm.documentLegal = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:documentLegalUpdate', function(event, result) {
            vm.documentLegal = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('DocumentLegalDeleteController',DocumentLegalDeleteController);

    DocumentLegalDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentLegal'];

    function DocumentLegalDeleteController($uibModalInstance, entity, DocumentLegal) {
        var vm = this;

        vm.documentLegal = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentLegal.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-legal', {
            parent: 'entity',
            url: '/document-legal?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'DocumentLegals'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-legal/document-legals.html',
                    controller: 'DocumentLegalController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentLegal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-legal-detail', {
            parent: 'document-legal',
            url: '/document-legal/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'DocumentLegal'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-legal/document-legal-detail.html',
                    controller: 'DocumentLegalDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'DocumentLegal', function($stateParams, DocumentLegal) {
                    return DocumentLegal.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-legal',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-legal-detail.edit', {
            parent: 'document-legal-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-legal/document-legal-dialog.html',
                    controller: 'DocumentLegalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentLegal', function(DocumentLegal) {
                            return DocumentLegal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-legal.new', {
            parent: 'document-legal',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-legal/document-legal-dialog.html',
                    controller: 'DocumentLegalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numero: null,
                                dateExpr: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-legal', null, { reload: 'document-legal' });
                }, function() {
                    $state.go('document-legal');
                });
            }]
        })
        .state('document-legal.edit', {
            parent: 'document-legal',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-legal/document-legal-dialog.html',
                    controller: 'DocumentLegalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentLegal', function(DocumentLegal) {
                            return DocumentLegal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-legal', null, { reload: 'document-legal' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-legal.delete', {
            parent: 'document-legal',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-legal/document-legal-delete-dialog.html',
                    controller: 'DocumentLegalDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentLegal', function(DocumentLegal) {
                            return DocumentLegal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-legal', null, { reload: 'document-legal' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('DocumentLegal', DocumentLegal);

    DocumentLegal.$inject = ['$resource', 'DateUtils'];

    function DocumentLegal ($resource, DateUtils) {
        var resourceUrl =  'api/document-legals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateExpr = DateUtils.convertLocalDateFromServer(data.dateExpr);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateExpr = DateUtils.convertLocalDateToServer(copy.dateExpr);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateExpr = DateUtils.convertLocalDateToServer(copy.dateExpr);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('DocumentLegalController', DocumentLegalController);

    DocumentLegalController.$inject = ['$scope','DocumentLegal', 'TableService'];

    function DocumentLegalController($scope,DocumentLegal, TableService) {

        var vm = this;

        var addItemData ={
            templateUrl: 'app/entities/document-legal/document-legal-dialog.html',
            controller: 'DocumentLegalDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'mg',
            resolve: {
                entity: function () {
                    return {
                        id: null,
                        libelle: null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/document-legal/document-legal-dialog.html',
            controller: 'DocumentLegalDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/entities/document-legal/document-legal-delete-dialog.html',
            controller: 'DocumentLegalDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

          var detailItemData = {
            templateUrl: 'app/entities/document-legal/document-legal-detail.html',
            controller: 'DocumentLegalDetailController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null, //valeur déterminé à l'appel de la boite
                 isViewing: true
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: DocumentLegal,
            entitySearch: DocumentLegal,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CountryIdDocDialogController', CountryIdDocDialogController);

    CountryIdDocDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CountryIdDoc'];

    function CountryIdDocDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CountryIdDoc) {
        var vm = this;

        vm.countryIdDoc = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.countryIdDoc.id !== null) {
                CountryIdDoc.update(vm.countryIdDoc, onSaveSuccess, onSaveError);
            } else {
                CountryIdDoc.save(vm.countryIdDoc, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:countryIdDocUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateDelivr = false;
        vm.datePickerOpenStatus.dateExpr = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CountryIdDocDetailController', CountryIdDocDetailController);

    CountryIdDocDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CountryIdDoc'];

    function CountryIdDocDetailController($scope, $rootScope, $stateParams, previousState, entity, CountryIdDoc) {
        var vm = this;

        vm.countryIdDoc = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:countryIdDocUpdate', function(event, result) {
            vm.countryIdDoc = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CountryIdDocDeleteController',CountryIdDocDeleteController);

    CountryIdDocDeleteController.$inject = ['$uibModalInstance', 'entity', 'CountryIdDoc'];

    function CountryIdDocDeleteController($uibModalInstance, entity, CountryIdDoc) {
        var vm = this;

        vm.countryIdDoc = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CountryIdDoc.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country-id-doc', {
            parent: 'entity',
            url: '/country-id-doc?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CountryIdDocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country-id-doc/country-id-docs.html',
                    controller: 'CountryIdDocController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country-id-doc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-id-doc-detail', {
            parent: 'country-id-doc',
            url: '/country-id-doc/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CountryIdDoc'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country-id-doc/country-id-doc-detail.html',
                    controller: 'CountryIdDocDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CountryIdDoc', function($stateParams, CountryIdDoc) {
                    return CountryIdDoc.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'country-id-doc',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('country-id-doc-detail.edit', {
            parent: 'country-id-doc-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country-id-doc/country-id-doc-dialog.html',
                    controller: 'CountryIdDocDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CountryIdDoc', function(CountryIdDoc) {
                            return CountryIdDoc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country-id-doc.new', {
            parent: 'country-id-doc',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country-id-doc/country-id-doc-dialog.html',
                    controller: 'CountryIdDocDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numero: null,
                                autorite: null,
                                dateDelivr: null,
                                dateExpr: null,
                                etat: null,
                                ville: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country-id-doc', null, { reload: 'country-id-doc' });
                }, function() {
                    $state.go('country-id-doc');
                });
            }]
        })
        .state('country-id-doc.edit', {
            parent: 'country-id-doc',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country-id-doc/country-id-doc-dialog.html',
                    controller: 'CountryIdDocDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CountryIdDoc', function(CountryIdDoc) {
                            return CountryIdDoc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country-id-doc', null, { reload: 'country-id-doc' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country-id-doc.delete', {
            parent: 'country-id-doc',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country-id-doc/country-id-doc-delete-dialog.html',
                    controller: 'CountryIdDocDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CountryIdDoc', function(CountryIdDoc) {
                            return CountryIdDoc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country-id-doc', null, { reload: 'country-id-doc' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('CountryIdDoc', CountryIdDoc);

    CountryIdDoc.$inject = ['$resource', 'DateUtils'];

    function CountryIdDoc ($resource, DateUtils) {
        var resourceUrl =  'api/country-id-docs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateDelivr = DateUtils.convertLocalDateFromServer(data.dateDelivr);
                        data.dateExpr = DateUtils.convertLocalDateFromServer(data.dateExpr);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
               //     copy.dateDelivr = DateUtils.convertLocalDateToServer(copy.dateDelivr);
               //     copy.dateExpr = DateUtils.convertLocalDateToServer(copy.dateExpr);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                  //  copy.dateDelivr = DateUtils.convertLocalDateToServer(copy.dateDelivr);
                  //  copy.dateExpr = DateUtils.convertLocalDateToServer(copy.dateExpr);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CountryIdDocController', CountryIdDocController);

    CountryIdDocController.$inject = ['$state', 'CountryIdDoc', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CountryIdDocController($state, CountryIdDoc, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            CountryIdDoc.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.countryIdDocs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CountryDialogController', CountryDialogController);

    CountryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Country', 'States', 'City'];

    function CountryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Country, States, City) {
        var vm = this;

        vm.country = entity;

        vm.clear = clear;
        vm.save = save;
        vm.states = States.query();
        vm.cities = City.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.country.id !== null) {
                Country.update(vm.country, onSaveSuccess, onSaveError);
            } else {
                Country.save(vm.country, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:countryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CountryDetailController', CountryDetailController);

    CountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Country', 'States', 'City'];

    function CountryDetailController($scope, $rootScope, $stateParams, previousState, entity, Country, States, City) {
        var vm = this;

        vm.country = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:countryUpdate', function(event, result) {
            vm.country = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CountryDeleteController',CountryDeleteController);

    CountryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Country'];

    function CountryDeleteController($uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Country.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country', {
            parent: 'entity',
            url: '/country?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Countries'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/countries.html',
                    controller: 'CountryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-detail', {
            parent: 'country',
            url: '/country/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Country'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/country-detail.html',
                    controller: 'CountryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Country', function($stateParams, Country) {
                    return Country.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'country',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('country-detail.edit', {
            parent: 'country-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.new', {
            parent: 'country',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                libele: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('country');
                });
            }]
        })
        .state('country.edit', {
            parent: 'country',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.delete', {
            parent: 'country',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-delete-dialog.html',
                    controller: 'CountryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Country', Country);

    Country.$inject = ['$resource'];

    function Country ($resource) {
        var resourceUrl =  'api/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CountryController', CountryController);

    CountryController.$inject = ['$scope', 'Country', 'TableService'];

    function CountryController($scope, Country, TableService) {

        var vm = this;

        var addItemData ={
            templateUrl: 'app/entities/country/country-dialog.html',
            controller: 'CountryDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'mg',
            resolve: {
                entity: function () {
                    return {
                        id: null,
                        libele: null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/country/country-dialog.html',
            controller: 'CountryDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/entities/country/country-delete-dialog.html',
            controller: 'CountryDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

          var detailItemData = {
            templateUrl: 'app/entities/country/country-detail.html',
            controller: 'CountryDetailController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null, //valeur déterminé à l'appel de la boite
                 isViewing: true
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Country,
            entitySearch: Country,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ConsulatDialogController', ConsulatDialogController);

    ConsulatDialogController.$inject = ['$scope', 'States', '$uibModalInstance', 'CityByStateId', 'DataUtils', 'entity', 'Consulat', 'UserExtra', 'Adresses', 'City', 'Members'];

    function ConsulatDialogController ($scope, States, $uibModalInstance,CityByStateId, DataUtils, entity, Consulat, UserExtra, Adresses, City, Members) {
        var vm = this;
   
        vm.consulat = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        
if(vm.consulat.adressesId!=null)
{
        Adresses.get({id:vm.consulat.adressesId},
            function (data) {
               vm.consulat.adresseDTO=data;
               

               City.get({id:data.cityId},
                function (datas) {
                   vm.pays=datas;
                   vm.consulat.adresseDTO.etatId=datas.statesId;
                    }
                )
                }
            )
        }
      

        vm.clear = clear;
             /*****************************Gestionnaire des onglets**************************************/
             vm.steps = [
                'IDENTIFICATION',
                'ADRESSE'
            ];
    
    
            vm.selection = vm.steps[0];
            vm.error = false;
            vm.showOnglet = showOnglet;
            vm.getCurrentStepIndex = function() {
                return vm.steps.indexOf(vm.selection);
            };
        
                 function showOnglet(onglet) {
                var stepIndex = vm.getCurrentStepIndex();
                return (vm.selection.toUpperCase() === onglet.toUpperCase());
            }
    
            // Go to a defined step index
           
           vm.goToStep = function(index, editForm) {
            if (!editForm.$invalid || (vm.getCurrentStepIndex() > index) ) {
                if (!angular.isUndefined(vm.steps[index])) {
                    vm.selection = vm.steps[index];
                }
            }
        };
    
            vm.hasNextStep = function() {
                var stepIndex = vm.getCurrentStepIndex();
                var nextStep = stepIndex + 1;
                // Return true if there is a next step, false if not
                return !angular.isUndefined(vm.steps[nextStep]);
            };
    
            vm.hasPreviousStep = function() {
                var stepIndex = vm.getCurrentStepIndex();
                var previousStep = stepIndex - 1;
                // Return true if there is a next step, false if not
                return !angular.isUndefined(vm.steps[previousStep]);
            };
    
            vm.incrementStep = function() {
                if (vm.hasNextStep()) {
                    //Vérification des champs du step précedent
                    var stepIndex = vm.getCurrentStepIndex();
                    var nextStep = stepIndex + 1;
                    vm.selection = vm.steps[nextStep];
                }
            };
    
    
            vm.decrementStep = function() {
                if (vm.hasPreviousStep()) {
                    var stepIndex = vm.getCurrentStepIndex();
                    var previousStep = stepIndex - 1;
                    vm.selection = vm.steps[previousStep];
                }
            };
       

            vm.etatColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadEtats", function () {
    
            });
    loadEtats();
            function loadEtats() {
                States.query({
                    size: 10000
                }, function (data) {
                    if (data != null) {
                        vm.etats = [];
                        vm.etats = data;
                    }
                });
    
                
               // vm.members.lieuNaissance = test.libele;
            }
    
    
            vm.statesVilleColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadStatesVille", function () {
    
            });


            $scope.$watch("vm.consulat.adresseDTO.etatId", function () {
                loadEtats();
        if(vm.consulat.adresseDTO.etatId!=null )
        {
                CityByStateId.query ({
                        id: vm.consulat.adresseDTO.etatId
                    }, function (data) {
                        vm.villeAdresse = data;
                    })
                }
                
            });


            $scope.$watch("vm.consulat.adresseDTO.cityId", function () {
        if(vm.consulat.adresseDTO.etatId!=null )
        {
                CityByStateId.query ({
                        id: vm.consulat.adresseDTO.etatId
                    }, function (data) {
                        vm.villeAdresse = data;
                    })
                }
                
            });




        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.consulat.id !== null) {
                Consulat.update(vm.consulat, onSaveSuccess, onSaveError);
            } else {
                Consulat.save(vm.consulat, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:consulatUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setLogoBf = function ($file, consulat) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        consulat.logoBf = base64Data;
                        consulat.logoBfContentType = $file.type;
                    });
                });
            }
        };

        vm.setLogoUsa = function ($file, consulat) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        consulat.imageVerso = base64Data;
                        consulat.imageVersoContentType = $file.type;
                    });
                });
            }
        };

        vm.setArmoirie = function ($file, consulat) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        consulat.armoirie = base64Data;
                        consulat.armoirieContentType = $file.type;
                    });
                });
            }
        };



        vm.setSignature = function ($file, consulat) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        consulat.signature = base64Data;
                        consulat.signatureContentType = $file.type;
                    });
                });
            }
        };







    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ConsulatDetailController', ConsulatDetailController);

    ConsulatDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Consulat', 'UserExtra', 'Adresses', 'Country', 'Members'];

    function ConsulatDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Consulat, UserExtra, Adresses, Country, Members) {
        var vm = this;

        vm.consulat = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('consulatApp:consulatUpdate', function(event, result) {
            vm.consulat = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ConsulatDeleteController',ConsulatDeleteController);

    ConsulatDeleteController.$inject = ['$uibModalInstance', 'entity', 'Consulat'];

    function ConsulatDeleteController($uibModalInstance, entity, Consulat) {
        var vm = this;

        vm.consulat = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Consulat.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('consulat', {
            parent: 'entity',
            url: '/consulat?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Consulats'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/consulat/consulats.html',
                    controller: 'ConsulatController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('consulat');
                    $translatePartialLoader.addPart('adresses');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('city');
                    return $translate.refresh();
                }]
            }
        })
        .state('consulat-detail', {
            parent: 'consulat',
            url: '/consulat/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Consulat'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/consulat/consulat-detail.html',
                    controller: 'ConsulatDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Consulat', function($stateParams, Consulat) {
                    return Consulat.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'consulat',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('consulat-detail.edit', {
            parent: 'consulat-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/consulat/consulat-dialog.html',
                    controller: 'ConsulatDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Consulat', function(Consulat) {
                            return Consulat.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('consulat.new', {
            parent: 'consulat',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/consulat/consulat-dialog.html',
                    controller: 'ConsulatDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                nom: null,
                                description: null,
                                logoBf: null,
                                logoBfContentType: null,
                                logoUsa: null,
                                logoUsaContentType: null,
                                armoirie: null,
                                armoirieContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('consulat', null, { reload: 'consulat' });
                }, function() {
                    $state.go('consulat');
                });
            }]
        })
        .state('consulat.edit', {
            parent: 'consulat',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/consulat/consulat-dialog.html',
                    controller: 'ConsulatDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Consulat', function(Consulat) {
                            return Consulat.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('consulat', null, { reload: 'consulat' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('consulat.delete', {
            parent: 'consulat',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/consulat/consulat-delete-dialog.html',
                    controller: 'ConsulatDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Consulat', function(Consulat) {
                            return Consulat.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('consulat', null, { reload: 'consulat' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Consulat', Consulat)
        .factory('ConsulatTop1', ConsulatTop1);

    Consulat.$inject = ['$resource'];
    ConsulatTop1.$inject = ['$resource'];

    function Consulat ($resource) {
        var resourceUrl =  'api/consulats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function ConsulatTop1 ($resource) {
        var resourceUrl =  'api/consulats/consulatTop1';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ConsulatController', ConsulatController);

    ConsulatController.$inject = ['$scope', 'TableService', 'Consulat', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ConsulatController($scope, TableService, Consulat, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        var addItemData ={
           templateUrl: 'app/entities/consulat/consulat-dialog.html',
           controller: 'ConsulatDialogController',
           controllerAs: 'vm',
           backdrop: 'static',
           size: 'lg',
           resolve: {
               entity: function () {
                   return {
                       id: null,
                       code:null,
                       nom:null,
                       adressesId:null,
                            
        adresseDTO:{
            rue:null,
            noPorte:null,
            telephone:null,
            mail:null,
            zipCode:null,
            autre:null,
            cityId:null,
            etatId:null
        }
    
                       
                   };
               }
           }
       };
    
       /**
        *Modification d'un élément
        */
       var editItemData = {
           templateUrl: 'app/entities/consulat/consulat-dialog.html',
           controller: 'ConsulatDialogController',
           controllerAs: 'vm',
           backdrop: 'static',
           size: 'lg',
           resolve: {
               entity: null
           }
       };

       /**
        * Suppresion d'un élément
        */
       var deleteItemData ={
           templateUrl: 'app/entities/mariage/consulat-delete-dialog.html',
           controller: 'ConsulatDeleteController',
           controllerAs: 'vm',
           size: 'sm',
           resolve: {
               entity: null
           }
       };

         var detailItemData = {
           templateUrl: 'app/entities/consulat/consulat-detail.html',
           controller: 'ConsulatDetailController',
           controllerAs: 'vm',
           backdrop: 'static',
           size: 'md',
           resolve: {
               entity: null, //valeur déterminé à l'appel de la boite
                isViewing: true
           }
       };

       var dialogData = {
           addData: addItemData,
           editData: editItemData,
           deleteData: deleteItemData,
           detailData: detailItemData
       };
       var entitySearchParams = function() {
           return {

           };
       };

       var entityParams = function() {
           return {

           };
       };

       var datas = {
           scope: $scope,
           vm: vm,
           entity: Consulat,
           entitySearch: Consulat,
           dialogData: dialogData,
           entitySearchParams: entitySearchParams,
           entityParams: entityParams
       };

       TableService.init(datas);
   }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CityDialogController', CityDialogController);

    CityDialogController.$inject = ['$timeout', '$scope', 'StatesByCountry', '$uibModalInstance', 'entity', 'City', 'Country', 'States'];

    function CityDialogController ($timeout, $scope, StatesByCountry, $uibModalInstance, entity, City, Country, States) {
        var vm = this;

        vm.city = entity;
        vm.clear = clear;
        vm.save = save;

        vm.countryColumns = [{
            name: 'libele',
            title: 'Libelle'
        }];
        $scope.$on("onLoadCountries", function () {

        });
        loadCountries();

        function loadCountries() {
            Country.query({
                size: 10000
            }, function (data) {
                if (data != null) {
                    vm.countries = [];
                    vm.countries = data;
                }
            });

           // vm.members.lieuNaissance = test.libele;
        }
        vm.statesColumns = [{
            name: 'libelle',
            title: 'Libelle'
        }];

        $scope.$watch("vm.city.countriesId", function () {
  if(vm.city.countriesId!=null)
{
                StatesByCountry.query ({
                    id: vm.city.countriesId
                }, function (data) {
                    vm.states = data;
                })
            }

        });
  


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.city.id !== null) {
                City.update(vm.city, onSaveSuccess, onSaveError);
            } else {
                City.save(vm.city, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:cityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CityDetailController', CityDetailController);

    CityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'City', 'Country', 'States'];

    function CityDetailController($scope, $rootScope, $stateParams, previousState, entity, City, Country, States) {
        var vm = this;

        vm.city = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:cityUpdate', function(event, result) {
            vm.city = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CityDeleteController',CityDeleteController);

    CityDeleteController.$inject = ['$uibModalInstance', 'entity', 'City'];

    function CityDeleteController($uibModalInstance, entity, City) {
        var vm = this;

        vm.city = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            City.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('city', {
            parent: 'entity',
            url: '/city?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Cities'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/city/cities.html',
                    controller: 'CityController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('city');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('city-detail', {
            parent: 'city',
            url: '/city/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'City'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/city/city-detail.html',
                    controller: 'CityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'City', function($stateParams, City) {
                    return City.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'city',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('city-detail.edit', {
            parent: 'city-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('city.new', {
            parent: 'city',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                libelle: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: 'city' });
                }, function() {
                    $state.go('city');
                });
            }]
        })
        .state('city.edit', {
            parent: 'city',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-dialog.html',
                    controller: 'CityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: 'city' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('city.delete', {
            parent: 'city',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city/city-delete-dialog.html',
                    controller: 'CityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['City', function(City) {
                            return City.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('city', null, { reload: 'city' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('City', City)
        .factory('CityByStateId', CityByStateId)
        .factory('CityByCountryId', CityByCountryId);

    City.$inject = ['$resource'];
    CityByStateId.$inject = ['$resource'];
    CityByCountryId.$inject = ['$resource'];

    function CityByCountryId ($resource) {
        var resourceUrl =  'api/cities/countryId/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function CityByStateId ($resource) {
        var resourceUrl =  'api/cities/statesId/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

    function City ($resource) {
        var resourceUrl =  'api/cities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CityController', CityController);

    CityController.$inject = ['$scope', 'City','TableService'];

    function CityController($scope, City, TableService) {

        var vm = this;

        var addItemData ={
            templateUrl: 'app/entities/city/city-dialog.html',
            controller: 'CityDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'mg',
            resolve: {
                entity: function () {
                    return {
                        id: null,
                        libelle: null,
                        countriesLibelle: null,
                        statesLibelle: null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/city/city-dialog.html',
            controller: 'CityDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/entities/city/city-delete-dialog.html',
            controller: 'CityDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

          var detailItemData = {
            templateUrl: 'app/entities/city/city-detail.html',
            controller: 'CityDetailController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null, //valeur déterminé à l'appel de la boite
                 isViewing: true
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: City,
            entitySearch: City,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();
(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CarteDialogController', CarteDialogController);

    CarteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Carte', 'Members','isViewing','Adresses'];

    function CarteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Carte, Members,isViewing,Adresses) {
        var vm = this;

        vm.carte = entity;
        vm.isViewing = isViewing;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.adresse = {};
        vm.members = Members.query();

        if(vm.carte.adresseId){
            Adresses.get({
                id: vm.carte.adresseId
            }, function (data) {
                vm.adresse = data;
            }, function (error) {});
        }
        if(vm.carte.dateCreate!=null){
            vm.carte.dateCreate = new Date(vm.carte.dateCreate);
        }
        if(vm.carte.dateNaissance!=null){
            vm.carte.dateNaissance = new Date(vm.carte.dateNaissance);
        }
        if(vm.carte.dateExpr!=null){
            vm.carte.dateExpr = new Date(vm.carte.dateExpr);
        }
        if(vm.carte.dateAnnulation!=null){
            vm.carte.dateAnnulation = new Date(vm.carte.dateAnnulation);
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.carte.id !== null) {
                Carte.update(vm.carte, onSaveSuccess, onSaveError);
            } else {
                Carte.save(vm.carte, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:carteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateCreate = false;
        vm.datePickerOpenStatus.dateExpr = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CarteDetailController', CarteDetailController);

    CarteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Carte', 'Members'];

    function CarteDetailController($scope, $rootScope, $stateParams, previousState, entity, Carte, Members) {
        var vm = this;

        vm.carte = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:carteUpdate', function(event, result) {
            vm.carte = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CarteDeleteController',CarteDeleteController);

    CarteDeleteController.$inject = ['$uibModalInstance', 'entity', 'Carte'];

    function CarteDeleteController($uibModalInstance, entity, Carte) {
        var vm = this;

        vm.carte = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Carte.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('carte', {
            parent: 'entity',
            url: '/carte?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.carte.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/carte/cartes.html',
                    controller: 'CarteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('carte');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('carte-detail', {
            parent: 'carte',
            url: '/carte/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consulatApp.carte.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/carte/carte-detail.html',
                    controller: 'CarteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('carte');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Carte', function($stateParams, Carte) {
                    return Carte.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'carte',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('carte-detail.edit', {
            parent: 'carte-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/carte/carte-dialog.html',
                    controller: 'CarteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Carte', function(Carte) {
                            return Carte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('carte.new', {
            parent: 'carte',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/carte/carte-dialog.html',
                    controller: 'CarteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                prenom: null,
                                taille: null,
                                sexe: null,
                                metier: null,
                                lieuNaissance: null,
                                dateCreate: null,
                                dateExpr: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('carte', null, { reload: 'carte' });
                }, function() {
                    $state.go('carte');
                });
            }]
        })
        .state('carte.edit', {
            parent: 'carte',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/carte/carte-dialog.html',
                    controller: 'CarteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Carte', function(Carte) {
                            return Carte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('carte', null, { reload: 'carte' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('carte.delete', {
            parent: 'carte',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/carte/carte-delete-dialog.html',
                    controller: 'CarteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Carte', function(Carte) {
                            return Carte.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('carte', null, { reload: 'carte' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Carte', Carte)
        .factory('CarteMultiParams', CarteMultiParams);

    Carte.$inject = ['$resource', 'DateUtils'];
    CarteMultiParams.$inject = ['$resource', 'DateUtils'];



    function CarteMultiParams ($resource, DateUtils) {
        var resourceUrl =  'api/cartes/findByParams';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                    }
                    return data;
                }
            }
        });
    }


    function Carte ($resource, DateUtils) {
        var resourceUrl =  'api/cartes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateCreate = DateUtils.convertLocalDateFromServer(data.dateCreate);
                        data.dateExpr = DateUtils.convertLocalDateFromServer(data.dateExpr);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateCreate = DateUtils.convertLocalDateToServer(copy.dateCreate);
                    copy.dateExpr = DateUtils.convertLocalDateToServer(copy.dateExpr);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateCreate = DateUtils.convertLocalDateToServer(copy.dateCreate);
                    copy.dateExpr = DateUtils.convertLocalDateToServer(copy.dateExpr);
                    return angular.toJson(copy);
                }
            },

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('CarteController', CarteController);

        CarteController.$inject = ['$scope','$http','$window','DateUtils','TableService','UserExtraConnected',
            'CarteMultiParams'];

    function CarteController($scope,$http,$window,DateUtils,TableService,UserExtraConnected,CarteMultiParams
                                    ) {
        var vm = this;

        vm.init = init;

        var fileURLPDF;
        vm.etatCarte = etatCarte;

        vm.user = UserExtraConnected.query();

        function etatCarte(id) {
            $http.get('/api/cartes/cartePDF', {
                    responseType: 'arraybuffer',
                    params: {
                        idCarte:id
                    }

                })
                .success(function(response) {
                    var file = new Blob([(response)], {
                        type: 'application/pdf'
                    });
                    fileURLPDF = URL.createObjectURL(file);
                    $window.open(fileURLPDF, '_blank');
                });
           }

        vm.itemSearch = {
            "nom": null,
            "prenom": null,
            "numero": null,
            "metier": null
        };
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateDebut = false;
        vm.datePickerOpenStatus.dateFin = false;
        vm.filtrer=false;



        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        vm.initFiltre = function () {
            vm.filtrer = !vm.filtrer;
            if (!vm.filtrer) {
                vm.itemSearch = {
                    "nom": null,
                    "prenom": null,
                    "numero": null,
                    "metier": null
                };
                init();
            }
        }

          init();
        function init() {
          /*   if(vm.itemSearch.dateArrivee!=null)
            vm.date = null;
            vm.date = DateUtils.convertLocalDateToServer(vm.itemSearch.dateArrivee); */
            var addItemData = {};
            var editItemData = {};
            /**
             *Modification d'un élément
            */
       var editItemData = {
        templateUrl: 'app/entities/carte/carte-detail.html',
        controller: 'CarteDetailController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
            entity: null
        }
    };

            var detailItemData = {
                templateUrl: 'app/entities/carte/carte-dialog.html',
                controller: 'CarteDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    isViewing: function () {
                        return true;
                    },
                    entity: null //valeur déterminé à l'appel de la boite,
                }
            };

            var deleteItemData = {};
            var dialogData = {
                addData: addItemData,
                editData: editItemData,
                detailData: detailItemData
            };
            var entitySearchParams = function () {
                return {};
            };
            var entityParams = function () {
                return {
                    "nom": vm.itemSearch.nom,
                    "prenom": vm.itemSearch.prenom,
                    "numero": vm.itemSearch.numero,
                    "metier": vm.itemSearch.metier
                };
            };


            var datas = {
                scope: $scope,
                vm: vm,
                entity: CarteMultiParams,
                dialogData: dialogData,
                entitySearch: CarteMultiParams,
                entitySearchParams: entitySearchParams,
                entityParams: entityParams
            };
            TableService.init(datas);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('BfIdDocDialogController', BfIdDocDialogController);

    BfIdDocDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BfIdDoc'];

    function BfIdDocDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BfIdDoc) {
        var vm = this;

        vm.bfIdDoc = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.bfIdDoc.id !== null) {
                BfIdDoc.update(vm.bfIdDoc, onSaveSuccess, onSaveError);
            } else {
                BfIdDoc.save(vm.bfIdDoc, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:bfIdDocUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateDelivr = false;
        vm.datePickerOpenStatus.dateExpr = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('BfIdDocDetailController', BfIdDocDetailController);

    BfIdDocDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BfIdDoc'];

    function BfIdDocDetailController($scope, $rootScope, $stateParams, previousState, entity, BfIdDoc) {
        var vm = this;

        vm.bfIdDoc = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:bfIdDocUpdate', function(event, result) {
            vm.bfIdDoc = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('BfIdDocDeleteController',BfIdDocDeleteController);

    BfIdDocDeleteController.$inject = ['$uibModalInstance', 'entity', 'BfIdDoc'];

    function BfIdDocDeleteController($uibModalInstance, entity, BfIdDoc) {
        var vm = this;

        vm.bfIdDoc = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BfIdDoc.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bf-id-doc', {
            parent: 'entity',
            url: '/bf-id-doc?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'BfIdDocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bf-id-doc/bf-id-docs.html',
                    controller: 'BfIdDocController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('association');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('bf-id-doc-detail', {
            parent: 'bf-id-doc',
            url: '/bf-id-doc/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'BfIdDoc'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bf-id-doc/bf-id-doc-detail.html',
                    controller: 'BfIdDocDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'BfIdDoc', function($stateParams, BfIdDoc) {
                    return BfIdDoc.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'bf-id-doc',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('bf-id-doc-detail.edit', {
            parent: 'bf-id-doc-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bf-id-doc/bf-id-doc-dialog.html',
                    controller: 'BfIdDocDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BfIdDoc', function(BfIdDoc) {
                            return BfIdDoc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bf-id-doc.new', {
            parent: 'bf-id-doc',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bf-id-doc/bf-id-doc-dialog.html',
                    controller: 'BfIdDocDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numero: null,
                                autorite: null,
                                docId: null,
                                dateDelivr: null,
                                dateExpr: null,
                                ville: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('bf-id-doc', null, { reload: 'bf-id-doc' });
                }, function() {
                    $state.go('bf-id-doc');
                });
            }]
        })
        .state('bf-id-doc.edit', {
            parent: 'bf-id-doc',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bf-id-doc/bf-id-doc-dialog.html',
                    controller: 'BfIdDocDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BfIdDoc', function(BfIdDoc) {
                            return BfIdDoc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bf-id-doc', null, { reload: 'bf-id-doc' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bf-id-doc.delete', {
            parent: 'bf-id-doc',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bf-id-doc/bf-id-doc-delete-dialog.html',
                    controller: 'BfIdDocDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BfIdDoc', function(BfIdDoc) {
                            return BfIdDoc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bf-id-doc', null, { reload: 'bf-id-doc' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('BfIdDoc', BfIdDoc);

    BfIdDoc.$inject = ['$resource', 'DateUtils'];

    function BfIdDoc ($resource, DateUtils) {
        var resourceUrl =  'api/bf-id-docs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateDelivr = DateUtils.convertLocalDateFromServer(data.dateDelivr);
                        data.dateExpr = DateUtils.convertLocalDateFromServer(data.dateExpr);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDelivr = DateUtils.convertLocalDateToServer(copy.dateDelivr);
                    copy.dateExpr = DateUtils.convertLocalDateToServer(copy.dateExpr);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDelivr = DateUtils.convertLocalDateToServer(copy.dateDelivr);
                    copy.dateExpr = DateUtils.convertLocalDateToServer(copy.dateExpr);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('BfIdDocController', BfIdDocController);

    BfIdDocController.$inject = ['$state', 'BfIdDoc', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function BfIdDocController($state, BfIdDoc, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            BfIdDoc.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bfIdDocs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('TypeAssociationDialogController', TypeAssociationDialogController);

    TypeAssociationDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'TypeAssociation'];

    function TypeAssociationDialogController ($timeout, $scope, $uibModalInstance, entity, TypeAssociation) {
        var vm = this;
        vm.typeAssociation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeAssociation.id !== null) {
                TypeAssociation.update(vm.typeAssociation, onSaveSuccess, onSaveError);
            } else {
                TypeAssociation.save(vm.typeAssociation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:typeAssociationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('TypeAssociationController', TypeAssociationController);

        TypeAssociationController.$inject = ['$scope', 'TypeAssociation', 'TableService'];

    function TypeAssociationController($scope, TypeAssociation, TableService) {

        var vm = this;

        var addItemData ={
            templateUrl: 'app/entities/association/type-associations-dialog.html',
            controller: 'TypeAssociationDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'mg',
            resolve: {
                entity: function () {
                    return {
                        id: null,
                        libelle: null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/association/type-associations-dialog.html',
            controller: 'TypeAssociationDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/entities/association/type-associations-delete-dialog.html',
            controller: 'TypeAssociationDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: TypeAssociation,
            entitySearch: TypeAssociation,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();
(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('AssociationDialogController', AssociationDialogController);

    AssociationDialogController.$inject = ['City', '$scope', 'DataUtils', '$uibModalInstance', 'entity', 'Association', 'States','CityByStateId','Adresses','TypeAssociation'];

    function AssociationDialogController (City, $scope,DataUtils, $uibModalInstance, entity, Association, States,CityByStateId,Adresses,TypeAssociation) {
        var vm = this;
   
        vm.association = entity;
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.datePickerOpenStatus = {};
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.types = TypeAssociation.query();
        vm.association.dateCreation = new Date(vm.association.dateCreation);

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        
if(vm.association.adressesId!=null)
{
        Adresses.get({id:vm.association.adressesId},
            function (data) {
               vm.association.adresseDTO=data;
               

               City.get({id:data.cityId},
                function (datas) {
                   vm.pays=datas;
                   vm.association.adresseDTO.etatId=datas.statesId;
                    }
                )
                }
            )
        }
      

        vm.clear = clear;
             /*****************************Gestionnaire des onglets**************************************/
             vm.steps = [
                'IDENTIFICATION',
                'ADRESSE'
            ];
    
    
            vm.selection = vm.steps[0];
            vm.error = false;
            vm.showOnglet = showOnglet;
            vm.getCurrentStepIndex = function() {
                return vm.steps.indexOf(vm.selection);
            };
        
                 function showOnglet(onglet) {
                var stepIndex = vm.getCurrentStepIndex();
                return (vm.selection.toUpperCase() === onglet.toUpperCase());
            }
    
            // Go to a defined step index
            vm.goToStep = function(index, editForm) {
                if (!editForm.$invalid || (vm.getCurrentStepIndex() > index) ) {
                    if (!angular.isUndefined(vm.steps[index])) {
                        vm.selection = vm.steps[index];
                    }
                }
            };
    
            vm.hasNextStep = function() {
                var stepIndex = vm.getCurrentStepIndex();
                var nextStep = stepIndex + 1;
                // Return true if there is a next step, false if not
                return !angular.isUndefined(vm.steps[nextStep]);
            };
    
            vm.hasPreviousStep = function() {
                var stepIndex = vm.getCurrentStepIndex();
                var previousStep = stepIndex - 1;
                // Return true if there is a next step, false if not
                return !angular.isUndefined(vm.steps[previousStep]);
            };
    
            vm.incrementStep = function() {
                if (vm.hasNextStep()) {
                    //Vérification des champs du step précedent
                    var stepIndex = vm.getCurrentStepIndex();
                    var nextStep = stepIndex + 1;
                    vm.selection = vm.steps[nextStep];
                }
            };
    
    
            vm.decrementStep = function() {
                if (vm.hasPreviousStep()) {
                    var stepIndex = vm.getCurrentStepIndex();
                    var previousStep = stepIndex - 1;
                    vm.selection = vm.steps[previousStep];
                }
            };
       

            vm.etatColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadEtats", function () {
    
            });
    loadEtats();
            function loadEtats() {
                States.query({
                    size: 10000
                }, function (data) {
                    if (data != null) {
                        vm.etats = [];
                        vm.etats = data;
                    }
                });
    
                
               // vm.members.lieuNaissance = test.libele;
            }
    
    
            vm.statesVilleColumns = [{
                name: 'libelle',
                title: 'Libelle'
            }];
            $scope.$on("onLoadStatesVille", function () {
    
            });


            $scope.$watch("vm.association.adresseDTO.etatId", function () {
                loadEtats();
        if(vm.association.adresseDTO.etatId!=null )
        {
                CityByStateId.query ({
                        id: vm.association.adresseDTO.etatId
                    }, function (data) {
                        vm.villeAdresse = data;
                    })
                }
                
            });

            $scope.$watch("vm.association.adresseDTO.cityId", function () {
        if(vm.association.adresseDTO.etatId!=null )
        {
                CityByStateId.query ({
                        id: vm.association.adresseDTO.etatId
                    }, function (data) {
                        vm.villeAdresse = data;
                    })
                }
                
            });




        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.association.id !== null) {
                Association.update(vm.association, onSaveSuccess, onSaveError);
            } else {
                Association.save(vm.association, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('associationApp:associationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('AssociationDetailController', AssociationDetailController);

    AssociationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Association', 'InfoAssociation'];

    function AssociationDetailController($scope, $rootScope, $stateParams, previousState, entity, Association, InfoAssociation) {
        var vm = this;

        vm.association = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:associationUpdate', function(event, result) {
            vm.association = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('AssociationDeleteController',AssociationDeleteController);

    AssociationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Association'];

    function AssociationDeleteController($uibModalInstance, entity, Association) {
        var vm = this;

        vm.association = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Association.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('association', {
            parent: 'entity',
            url: '/association?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Associations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/association/associations.html',
                    controller: 'AssociationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('association');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })


        .state('type-associations', {
            parent: 'entity',
            url: '/type-associations?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Type-associations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/association/type-associations.html',
                    controller: 'TypeAssociationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('association');
                    $translatePartialLoader.addPart('typeAssociation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })



        .state('type-associations.new', {
            parent: 'type-associations',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/association/type-associations-dialog.html',
                    controller: 'TypeAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null

                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-associations', null, { reload: 'type-associations' });
                }, function() {
                    $state.go('type-associations');
                });
            }]
        })

    /*   .state('type-association.edit', {
            parent: 'type-asociation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/association/type-asociations-dialog.html',
                    controller: 'TypeAssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Association', function(Association) {
                            return Association.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('association', null, { reload: 'association' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/

       /* .state('type-association.delete', {
            parent: 'type-asociation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/association/type-asociation-delete-dialog.html',
                    controller: 'TypeAssociationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeAssociation', function(TypeAssociation) {
                            return TypeAssociation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-association', null, { reload: 'type-association' });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/









        .state('association-detail', {
            parent: 'association',
            url: '/association/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Association'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/association/association-detail.html',
                    controller: 'AssociationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Association', function($stateParams, Association) {
                    return Association.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'association',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('association-detail.edit', {
            parent: 'association-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/association/association-dialog.html',
                    controller: 'AssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Association', function(Association) {
                            return Association.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('association.new', {
            parent: 'association',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/association/association-dialog.html',
                    controller: 'AssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                numero: null,
                                nom: null,
                                poste: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('association', null, { reload: 'association' });
                }, function() {
                    $state.go('association');
                });
            }]
        })
        .state('association.edit', {
            parent: 'association',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/association/association-dialog.html',
                    controller: 'AssociationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Association', function(Association) {
                            return Association.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('association', null, { reload: 'association' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('association.delete', {
            parent: 'association',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/association/association-delete-dialog.html',
                    controller: 'AssociationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Association', function(Association) {
                            return Association.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('association', null, { reload: 'association' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('AssociationFiltre', AssociationFiltre)
        .factory('TypeAssociation', TypeAssociation)
        .factory('Association', Association);



    Association.$inject = ['$resource'];
    TypeAssociation.$inject = ['$resource'];
    AssociationFiltre.$inject = ['$resource'];



    function AssociationFiltre ($resource, DateUtils) {
        var resourceUrl =  'api/associations/findByParams';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateCreation = DateUtils.convertLocalDateFromServer(data.dateCreation);
                    }
                    return data;
                }
            }
        });
    }


    function TypeAssociation ($resource) {
        var resourceUrl =  'api/type-associations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }





    function Association ($resource) {
        var resourceUrl =  'api/associations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('AssociationController', AssociationController);

    AssociationController.$inject = ['$scope','DataUtils','DateUtils', 'Association', 'TableService','AssociationFiltre'];

    function AssociationController($scope,DataUtils,DateUtils, Association, TableService,AssociationFiltre) {

        var vm = this;
        vm.init = init;
        vm.datePickerOpenStatus = {};
        vm.openFile = DataUtils.openFile;
        vm.openCalendar = openCalendar;


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        vm.itemSearch = {
            "nom": null,
            "type": null,
            "adresse": null,
            "dateCreation": null
        };


        vm.initFiltre = function () {
            vm.filtrer = !vm.filtrer;
            if (!vm.filtrer) {
                vm.itemSearch = {
                    "nom": null,
                    "type": null,
                    "dateCreation": null,
                    "adresse": null
                     
                };
                init();
            }
        }



          init();
        function init() {
            if(vm.itemSearch.dateCreation!=null)
            vm.itemSearch.dateCreation = DateUtils.convertLocalDateToServer(vm.itemSearch.dateCreation);


            var addItemData = {};

            var editItemData = {};

            var addItemData ={
                templateUrl: 'app/entities/association/association-dialog.html',
                controller: 'AssociationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            numero:null,
                            nom:null,
                            type:null,
                            siege:null,
                            adresseId:null,
                                 
             adresseDTO:{
                 rue:null,
                 noPorte:null,
                 telephone:null,
                 mail:null,
                 zipCode:null,
                 autre:null,
                 cityId:null,
                 etatId:null
             }
         
                            
                        };
                    }
                }
            };
         
            /**
             *Modification d'un élément
             */
            var editItemData = {
                templateUrl: 'app/entities/association/association-dialog.html',
                controller: 'AssociationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: null
                }
            };
     
            /**
             * Suppresion d'un élément
             */
            var deleteItemData ={
                templateUrl: 'app/entities/association/association-delete-dialog.html',
                controller: 'AssociationDeleteController',
                controllerAs: 'vm',
                size: 'sm',
                resolve: {
                    entity: null
                }
            };
     
              var detailItemData = {
                templateUrl: 'app/entities/association/association-detail.html',
                controller: 'AssociationDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: null, //valeur déterminé à l'appel de la boite
                     isViewing: true
                }
            };

            var dialogData = {
                addData: addItemData,
                editData: editItemData,
                detailData: detailItemData
            };
            var entitySearchParams = function () {
                return {};
            };
            var entityParams = function () {
                return {
                    "nom": vm.itemSearch.nom,
                    "type": vm.itemSearch.type,
                    "dateCreation": vm.itemSearch.dateCreation,
                    "adresse": vm.itemSearch.adresse
                    
                    
                };
            };


            var datas = {
                scope: $scope,
                vm: vm,
                entity: AssociationFiltre,
                dialogData: dialogData,
                entitySearch: AssociationFiltre,
                entitySearchParams: entitySearchParams,
                entityParams: entityParams
            };
            TableService.init(datas);
        }

















        var addItemData ={
           templateUrl: 'app/entities/association/association-dialog.html',
           controller: 'AssociationDialogController',
           controllerAs: 'vm',
           backdrop: 'static',
           size: 'lg',
           resolve: {
               entity: function () {
                   return {
                       id: null,
                       numero:null,
                       nom:null,
                       type:null,
                       siege:null,
                       adresseId:null,
                            
        adresseDTO:{
            rue:null,
            noPorte:null,
            telephone:null,
            mail:null,
            zipCode:null,
            autre:null,
            cityId:null,
            etatId:null
        }
    
                       
                   };
               }
           }
       };
    
       /**
        *Modification d'un élément
        */
       var editItemData = {
           templateUrl: 'app/entities/association/association-dialog.html',
           controller: 'AssociationDialogController',
           controllerAs: 'vm',
           backdrop: 'static',
           size: 'lg',
           resolve: {
               entity: null
           }
       };

       /**
        * Suppresion d'un élément
        */
       var deleteItemData ={
           templateUrl: 'app/entities/association/association-delete-dialog.html',
           controller: 'AssociationDeleteController',
           controllerAs: 'vm',
           size: 'sm',
           resolve: {
               entity: null
           }
       };

         var detailItemData = {
           templateUrl: 'app/entities/association/association-detail.html',
           controller: 'AssociationDetailController',
           controllerAs: 'vm',
           backdrop: 'static',
           size: 'md',
           resolve: {
               entity: null, //valeur déterminé à l'appel de la boite
                isViewing: true
           }
       };

       var dialogData = {
           addData: addItemData,
           editData: editItemData,
           deleteData: deleteItemData,
           detailData: detailItemData
       };
       var entitySearchParams = function() {
           return {

           };
       };

       var entityParams = function() {
           return {

           };
       };

       var datas = {
           scope: $scope,
           vm: vm,
           entity: Association,
           entitySearch: Association,
           dialogData: dialogData,
           entitySearchParams: entitySearchParams,
           entityParams: entityParams
       };

       TableService.init(datas);
   }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('AdressesDialogController', AdressesDialogController);

    AdressesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Adresses', 'Members'];

    function AdressesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Adresses, Members) {
        var vm = this;

        vm.adresses = entity;
        vm.clear = clear;
        vm.save = save;
        vm.members = Members.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.adresses.id !== null) {
                Adresses.update(vm.adresses, onSaveSuccess, onSaveError);
            } else {
                Adresses.save(vm.adresses, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consulatApp:adressesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('AdressesDetailController', AdressesDetailController);

    AdressesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Adresses', 'Members'];

    function AdressesDetailController($scope, $rootScope, $stateParams, previousState, entity, Adresses, Members) {
        var vm = this;

        vm.adresses = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('consulatApp:adressesUpdate', function(event, result) {
            vm.adresses = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('AdressesDeleteController',AdressesDeleteController);

    AdressesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Adresses'];

    function AdressesDeleteController($uibModalInstance, entity, Adresses) {
        var vm = this;

        vm.adresses = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Adresses.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('adresses', {
            parent: 'entity',
            url: '/adresses?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Adresses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/adresses/adresses.html',
                    controller: 'AdressesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('adresses');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('adresses-detail', {
            parent: 'adresses',
            url: '/adresses/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Adresses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/adresses/adresses-detail.html',
                    controller: 'AdressesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Adresses', function($stateParams, Adresses) {
                    return Adresses.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'adresses',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('adresses-detail.edit', {
            parent: 'adresses-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/adresses/adresses-dialog.html',
                    controller: 'AdressesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Adresses', function(Adresses) {
                            return Adresses.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('adresses.new', {
            parent: 'adresses',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/adresses/adresses-dialog.html',
                    controller: 'AdressesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                rue: null,
                                noPorte: null,
                                mail: null,
                                telephone: null,
                                zipCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('adresses', null, { reload: 'adresses' });
                }, function() {
                    $state.go('adresses');
                });
            }]
        })
        .state('adresses.edit', {
            parent: 'adresses',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/adresses/adresses-dialog.html',
                    controller: 'AdressesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Adresses', function(Adresses) {
                            return Adresses.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('adresses', null, { reload: 'adresses' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('adresses.delete', {
            parent: 'adresses',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/adresses/adresses-delete-dialog.html',
                    controller: 'AdressesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Adresses', function(Adresses) {
                            return Adresses.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('adresses', null, { reload: 'adresses' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('AdressesByMember', AdressesByMember)
        .factory('AdressesParams', AdressesParams)
        .factory('Adresses', Adresses);

    AdressesByMember.$inject = ['$resource'];
    AdressesParams.$inject = ['$resource'];
    Adresses.$inject = ['$resource'];


    function AdressesParams ($resource) {
        var resourceUrl =  'api/adresses/findByParams';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }




    function AdressesByMember ($resource) {
        var resourceUrl =  'api/adresses/member/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }


    function Adresses ($resource) {
        var resourceUrl =  'api/adresses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('AdressesController', AdressesController);

    AdressesController.$inject = ['$scope', 'AdressesParams', 'TableService'];

    function AdressesController($scope, AdressesParams, TableService) {

        var vm = this;
        vm.init = init;
      
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        vm.itemSearch = {
            "rue": null,
            "telephone": null,
            "zipCode": null,
            "membreNom": null
        };


        vm.initFiltre = function () {
            vm.filtrer = !vm.filtrer;
            if (!vm.filtrer) {
                vm.itemSearch = {
                    "rue": null,
                    "telephone": null,
                    "zipCode": null,
                    "membreNom": null
                     
                };
                init();
            }
        }



          init();
        function init() {

            var addItemData = {};

            var editItemData = {};

            var addItemData ={
                templateUrl: 'app/entities/adresses/adresses-dialog.html',
                controller: 'AdresseDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                          
                 rue:null,
                 noPorte:null,
                 telephone:null,
                 mail:null,
                 zipCode:null,
                 autre:null,
                 cityId:null,
                 etatId:null
             
                            
                        };
                    }
                }
            };
         
            /**
             *Modification d'un élément
             */
            var editItemData = {
                templateUrl: 'app/entities/adresses/adresses-dialog.html',
                controller: 'AdresseDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: null
                }
            };
     
            /**
             * Suppresion d'un élément
             */
            var deleteItemData ={
                templateUrl: 'app/entities/adresses/adresses-delete-dialog.html',
                controller: 'AdresseDeleteController',
                controllerAs: 'vm',
                size: 'sm',
                resolve: {
                    entity: null
                }
            };
     
              var detailItemData = {
                templateUrl: 'app/entities/adresses/adresses-detail.html',
                controller: 'AdresseDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: null, //valeur déterminé à l'appel de la boite
                     isViewing: true
                }
            };

            var dialogData = {
                addData: addItemData,
                editData: editItemData,
                detailData: detailItemData
            };
            var entitySearchParams = function () {
                return {};
            };
            var entityParams = function () {
                return {
                    "nom": vm.itemSearch.nom,
                    "prenom": vm.itemSearch.prenom
                 
                    
                };
            };


            var datas = {
                scope: $scope,
                vm: vm,
                entity: AdressesParams,
                dialogData: dialogData,
                entitySearch: AdressesParams,
                entitySearchParams: entitySearchParams,
                entityParams: entityParams
            };
            TableService.init(datas);
        }



     
   }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    "use strict";
    angular.module('consulatApp').service('TableService', ['$uibModal', '_', 'ParseLinks', 'Notification', 'paginationConstants', service]);

    function service($uibModal, _, ParseLinks, Notification, paginationConstants) {
        var self = this;
        self.init = init;
        self.initSimpleTable = initSimpleTable;
        self.initParentInDropdown = initParentInDropdown;


        function init(data) {
            var tableScope = data.scope,
                vm = data.vm,
                Entity = data.entity,
                EntitySearch = data.entitySearch,
                dialogData = data.dialogData,
                dialogTest = data.dialogTest,
                entityParams = data.entityParams,
                loadCallBack = data.loadCallBack,
                entitySearchParams = data.entitySearchParams;
                vm.predicate = 'id';
                    console.log(dialogTest);

            /*True = ASC et False = DESC*/
            vm.reverse = false;
           // vm.itemsPerPage = paginationConstants.itemsPerPage;
            if(angular.isDefined(data.itemsPerPage)){
                vm.itemsPerPage = data.itemsPerPage;
            }else{
                vm.itemsPerPage = 20;                    
            }
            vm.clear = clear;
            vm.search = search;
            vm.loadAll = loadAll;
            vm.setItemsPerPage = setItemsPerPage;
            vm.sortBy = sortBy;
            vm.isCurrentColumn = isCurrentColumn;
            /*Page courante*/
            vm.page = 1;
            /*Nombre d'élements*/
            vm.totalItems = null;
            vm.searchQuery = null;
            vm.currentSearch = null;

            /*Méthode d'ajout, de suppression et de modification*/
            vm.editItem = editItem;
            vm.addItem = addItem;
            vm.deleteItem = deleteItem;
            vm.detailItem = detailItem;
            /*Fonction permettant de n'afficher la pagination que si besoin*/
            vm.canShowPagination = canShowPagination;
            /*Id de la ligne courante sélectionnée*/
            vm.idSelectedCode = null;

            vm.datas = [];
            vm.test=dialogTest;

            vm.forward = function(idCode) {
                /*Initialisation du code selectionné*/
                vm.idSelectedCode = idCode;
                console.log("***forward : id =>" + idCode);
                console.log("***vm.totalItems =>" + vm.totalItems);
                /*Scroll automatique jusqu'au details*/
                //smoothScroll.scrollTo('mf-details');
            };

            function canShowPagination() {
                return vm.totalItems > 0 && (vm.totalItems > vm.itemsPerPage);
            }

            /*Observe le changement de la valeur du numéro de page*/
            tableScope.$watch(angular.bind(vm, function() {
                return vm.page;
            }), function(newPage) {
                if (!waitForParent()) {
                    loadAll();
                }
            });

            function setItemsPerPage(value) {
                vm.itemsPerPage = value;
                changePageAndLoadAll();
            }
            /**
             *Utilisée au cas où les éléments de l'entité sont listés en fonction de l'id du parent.
             *Dans ce cas, on verifie que l'entité est bien associée à un parent et que ce parent
             *est à l'instant T connu.
             */
            function waitForParent() {
                /*var b  = false ;*/
                if (angular.isFunction(vm.getParentId)) {
                    var id = vm.getParentId();
                    if (angular.isUndefined(id) || id === null) {
                        return true;
                    }
                    console.log("***waitForParent : " + vm.getParentId());
                }

                return false;
            }

            function changePageAndLoadAll() {
                if (vm.page == 1) {
                    loadAll();
                } else {
                    /*Le changement de la page rechargement directement les données du à un watcher sur cet attribut*/
                    vm.page = 1;
                }
            }

            function loadAll() {
                console.log("***Loading items");
                if (vm.currentSearch !== null) {
                    var d = _.merge({ /*Paramètres initials*/
                        query: vm.currentSearch,
                        page: vm.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, entitySearchParams());
                    EntitySearch.query(d, onSuccess, onError);
                } else {
                    var d = _.merge({
                        page: vm.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, entityParams());
                    Entity.query(d, onSuccess, onError);
                }

                function sort() {
                    var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                    if (vm.predicate !== 'id') {
                        result.push('id');
                    }
                    return result;
                }

                function onSuccess(data, headers) {
                    /**
                     *Cette condition est testée pour pouvoir prendre en compte le faite que
                     *toutes les tables ne prennent pas en compte la pagination.
                     */
                    if (headers('link') !== null && headers('link') !== undefined) {
                        vm.links = ParseLinks.parse(headers('link'));
                        vm.totalItems = headers('X-Total-Count');
                        vm.queryCount = vm.totalItems;
                    } else {
                        vm.queryCount = data.length;
                    }
                    vm.datas = data;
                    if (angular.isFunction(loadCallBack)) {
                        loadCallBack();
                    }

                }

                function onError(error) {
                    if(error.data.message!="Not Found")
                    Notification.error(error.data.message);
                }
            }

            function search(searchQuery) {
                if (!searchQuery) {
                    return vm.clear();
                }
                vm.links = null;
                vm.predicate = 'id';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
                vm.idSelectedCode = null;
                changePageAndLoadAll();
            }

            function clear() {
                vm.links = null;
                vm.predicate = 'id';
                vm.reverse = true;
                vm.currentSearch = null;
                vm.searchQuery = null;
                vm.idSelectedCode = null;
                changePageAndLoadAll();
            }

            /*##############################################################################*/
            /*##########################Gestion du trie par colonne#########################*/
            function sortBy(column) {
                if (column === vm.predicate) { //S'il s'agit de la même column, on inverse l'ordre du trie
                    reverse();
                } else { // Sinon, on remet l'ordre à ascendant ou croissant
                    vm.reverse = true;
                }
                vm.predicate = column;
                loadAll();
            }

            /*Inverse l'ordre de trie*/
            function reverse() {
                vm.reverse = !vm.reverse;
            }

            function isCurrentColumn(column) {
                return vm.predicate === column;
            }

            /**
             *Ajout d'un élément
             */
            function addItem() {
                $uibModal.open(dialogData.addData).result.then(function(result) {
                    Notification.success('Enregistrement reussit !');
                    /*Ajout de l'élément ajouté dans le tableau, en le triant avec les paramètres courants*/
                    if (vm.datas !== null) {
                        vm.totalItems = vm.totalItems + 1;
                        if (vm.itemsPerPage > vm.totalItems) {
                            vm.datas.push(result);
                            vm.datas = _.sortBy(vm.datas, vm.predicate, !vm.reverse);
                            loadAll();
                        } else {
                            loadAll();
                        }
                    } else {
                        console.error("***vm.datas is null");
                    }
                }, function(datas) {
                    if( angular.isDefined(datas) && datas==true )
                    {
                    loadAll();
                    console.log(datas);
                    }
                    
                });
            }

            function detailItem($event, item) {
                $event.stopPropagation();
                dialogData.detailData.resolve.entity = angular.copy(item);
                console.log("***detailItem for " + item.id);
                $uibModal.open(dialogData.detailData).result.then(function(datas) {

                    if (datas.isEdit) {
                        angular.forEach(item, function(value, key) {
                            item[key] = datas.result[key];
                        });
                    //    Notification.success('Modification reussit !');
                    }
                    loadAll();
                }, function() {

                    console.info("***Closing detail dialog");
                    loadAll();
                });
            }

            /**
             *Modification d'un élément
             */
            function editItem($event, item) {
                $event.stopPropagation();
                dialogData.editData.resolve.entity = angular.copy(item);
                $uibModal.open(dialogData.editData).result.then(function(result) {
                    Notification.success('Modification reussit !');
                    /*Les valeurs dans result écrase celle d'item */
                    angular.forEach(item, function(value, key) {
                        item[key] = result[key];
                    });
                    loadAll();
                }, function() {

                });
            }

            /**
             *Suppression d'un élément
             **/
            function deleteItem($event, item) {
                $event.stopPropagation();
                dialogData.deleteData.resolve.entity = item;
                $uibModal.open(dialogData.deleteData).result.then(function(result) {
                    loadAll();
                    Notification.success('Suppression effectué !');
                }, function() {

                });
            }
            return vm;
        }

        function initParentInDropdown(data) {
            var vm = data.vm,
                scope = data.scope,
                ParentEntity = data.ParentEntity,
                filter = data.filter,
                orderBy = data.orderBy,
                dialogData = data.dialogData;

            vm.parents = loadParents();
            vm.addParent = addParent;
            vm.editParent = editParent;
            vm.deleteParent = deleteParent;
            vm.getParentId = getParentId;
            vm.currentParent = {};
            vm.setCurrentParent = setCurrentParent;
            vm.hasParents = hasParents;

            /*Observe le changement de la catégorie*/
            scope.$watch(angular.bind(vm, function() {
                if (angular.isDefined(vm.currentParent)) {
                    return vm.currentParent.id;
                }
            }), function(newValue) {
                //console.log('***New value for currentParent id = ' + newValue);
                if (angular.isDefined(newValue)) {
                    //Obtention de l'objet à partir de son id
                    var item = _.find(vm.parents, function(p) {
                        p.id === newValue;
                    });
                    vm.setCurrentParent(item, false);
                    /*Chargement des critères si la catégorie sélectionnée change!*/
                    if (angular.isFunction(vm.loadAll)) {
                        vm.loadAll();
                    }
                }
            });

            function hasParents() {
                if (angular.isDefined(vm.parents)) {
                    return vm.parents.length > 0;
                }
                return false;
            }

            function getParentId() {
                if (angular.isDefined(vm.currentParent)) {
                    return vm.currentParent.id;
                } else {
                    console.error("***Parent not selected.");
                    return null;
                }
            }

            function setCurrentParent(item, eraseId) {
                console.log('***Changing current parent.With eraseId = ' + eraseId);
                angular.forEach(item, function(value, key) {
                    if (eraseId || key != "id") {
                        //console.log("***Copy of key = " + key);
                        //console.log("***Old value = " + vm.currentParent[key]);
                        vm.currentParent[key] = item[key];
                        //console.log("***New value = " + vm.currentParent[key]);
                    }
                });
            }

            function loadParents() {
                //console.log("***Loading all parents");
                return ParentEntity.query(function() {
                    if (angular.isDefined(vm.parents) && vm.parents.length > 0) {
                        vm.parents = filter('orderBy')(vm.parents, orderBy);
                        vm.setCurrentParent(vm.parents[0], true);
                    }
                }, function() {
                    console.error("Impossible de charger la liste des parents.");
                });
            }

            function addParent() {
                console.log('***Add a parent');
                $uibModal.open(dialogData.addParent).result.then(function(result) {
                    if (vm.parents !== null) {
                        vm.parents.push(result);
                        vm.parents = filter('orderBy')(vm.parents, orderBy);
                        vm.setCurrentParent(vm.parents[0], true);
                    } else {
                        console.log("***vm.parents is NULL");
                    }
                }, function() {});
            }

            function editParent() {
                console.log('***Editing parent with id : ' + vm.currentParent.id);
                //var editedItem = angular.copy(vm.currentParent, {});
                dialogData.editParent.resolve.entity = angular.copy(vm.currentParent);
                //console.log(editedItem);

                $uibModal.open(dialogData.editParent).result.then(function(item) {
                    vm.parents = _.reject(vm.parents, ['id', item.id]);
                    vm.parents.push(item);
                    vm.parents = filter('orderBy')(vm.parents, orderBy);
                    vm.setCurrentParent(item, false);
                });
            }

            function deleteParent() {
                console.log('***Delete parent with id : ' + vm.currentParent.id);
                dialogData.deleteParent.resolve.entity = vm.currentParent;
                $uibModal.open(dialogData.deleteParent).result.then(function() {
                    console.log('***Item deleted.');
                    vm.parents = _.reject(vm.parents, ['id', vm.currentParent.id]);
                    vm.parents = filter('orderBy')(vm.parents, orderBy);
                    vm.setCurrentParent(vm.parents[0], true);
                });
            }
            return vm;
        }
        /**Initialise les tableaux simples qui n'ont ni de pagination,ni de trie, ni de barre de recherche.
         *Uniquement l'affichage, la modification et la suppression d'un élément.
         */
        function initSimpleTable(data) {

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function() {
    "use strict";
    angular.module("consulatApp").directive('mfRequired', [function() {
        return {
            restrict: 'A',
            link: function(scope, iElement, iAttrs) {
                angular.element(iElement).ready(function() {
                    iElement.append("<span class='text-danger'><b> *</b></span>");
                    iElement.addClass("pr2");
                });
            }
        };
    }]);
})();
(function () {
    "use strict";
    angular.module('consulatApp').factory('PopupService', ['Notification', '_', '$uibModal', PopupService]);
    function PopupService(Notification, _, $uibModal) {
        console.log('***Création du service popup');
        var service = {
            open: open,
            choisir: choisir
        };
        return service;
        function open(data) {
            console.log("4444444444444444");
            var vm = data.vm,
                dialogData = data.dialogData,
                datas = data.datas,
                scope = data.scope;
            vm.addItem = addItem;
            vm.addItemSecond = addItemSecond;
            vm.editItem = editItem;
            vm.deleteItem = deleteItem;
            if (angular.isUndefined(vm.datas)) {
                vm.datas = [];
            }
            // vm.deleteItem=deleteItem;isUndefined


            /**
             * Ajout d'un élément
             *
             */

            function addItem() {
                $uibModal.open(dialogData.addData).result.then(function (result) {
                    Notification.success('Enregistrement reussit !');
                    /*Ajout de l'élément ajouté dans le tableau, en le triant avec les paramètres courants*/
                    if (datas !== null) {
                        vm.datas.push(result);
                        scope.$emit('PopupService:resultData', { 'result': result });
                        console.log(result + 'result');
                        console.log(datas + 'datas');
                        //datas = _.sortBy(vm.datas, vm.predicate, !vm.reverse);
                    } else {
                        console.error("***vm.datas is null");
                    }
                }, function () { });
            }

            function addItemSecond() {
                $uibModal.open(dialogData.addDataSecond).result.then(function (result) {
                    Notification.success('Enregistrement reussit !');
                    /*Ajout de l'élément ajouté dans le tableau, en le triant avec les paramètres courants*/
                    if (datas !== null) {
                        vm.datas.push(result);
                        scope.$emit('PopupService:resultData', { 'result': result });
                        console.log(result + 'result');
                        console.log(datas + 'datas');
                        //datas = _.sortBy(vm.datas, vm.predicate, !vm.reverse);
                    } else {
                        console.error("***vm.datas is null");
                    }
                }, function () { });
            }


            /**
             *Modification d'un élément
             */
            function editItem($event, item) {
                $event.stopPropagation();
                dialogData.editData.resolve.entity = angular.copy(item);
                $uibModal.open(dialogData.editData).result.then(function (result) {
                    Notification.success('Modification reussit !');
                    /*Les valeurs dans result écrase celle d'item */
                    angular.forEach(item, function (value, key) {
                        item[key] = result[key];
                    });
                }, function () {

                });
            }

            function deleteItem(index) {
                vm.datas.splice(index, 1);
                Notification.success('Supression reussit !');
            }

        }

        function choisir(datas) {
            var Entity = datas.entity;
            var scope = datas.scope;
            var data = datas.popupDatas;
            var vm = data.vm,
                datas = data.datas
            console.log("choisir agent popup");
            $uibModal.open(data).result.then(function (data) {
                console.log(data);
                //   var id_entity=data.value[0];
                scope.$emit('imanetApp:valueChoisi', { 'result': true, 'data': data.value, 'entity': Entity });
                /* if(id_entity!=null){
                   console.log("result of popup service");
                      Entity.get({id:id_entity}, function(data) {
                          console.log(data); 
                      scope.$emit('microfinApp:valueChoisi', {'result':true,'data':data,'entity':Entity});                
                     });
                 }*/
            }, function () {
                console.log("erreur serveur");
            });
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('consulatApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('consulatApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('consulatApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('consulatApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    "use strict";
    angular.module('consulatApp').directive('jSelectDialog', select);
    select.$inject = ['$uibModal', "$rootScope","PopupService"];

    function select($uibModal, $rootScope,PopupService) {
        var modalInstance;
        console.log("111111111111111111");
        return {
            restrict: 'AE',
            scope: {
                datas: '=jList',
                model: '=jModel',
                states:'=jStates',
                multiple: '=jMultiple',
                columns: '=jColumns',
                eventName: '@jEventName',
                onFilter: '&jOnSearch'
            },
            link: function(scope, iElement, iAttrs, iCtrl,$scope) {
                var d = {
                    templateUrl: 'app/components/select/select-dialog.html',
                    controller: function() {
                        console.log(scope);
                        var vm = this;

                        var ctrl = this;
                      //  ctrl.test = test;
                        ctrl.query = "";
                        ctrl.cancel = cancel;
                        ctrl.confirm = confirm;
                        ctrl.isChecked = isChecked;
                        ctrl.toggle = toggle;
                        ctrl.datas = scope.datas;
                        ctrl.columns = scope.columns;
                        ctrl.onFilter = scope.onFilter;
                        ctrl.check = check;
                        ctrl.checkMultiples = checkMultiples;
                        ctrl.uncheck = uncheck;
                        ctrl.multiple = scope.multiple;
                        ctrl.states = scope.states;
                        ctrl.toggleAll = toggleAll;
                        ctrl.getColumnTitle = getColumnTitle;
                        ctrl.getColumnName = getColumnName;

                        scope.$watch(angular.bind(scope, function() {
                            return scope.datas;
                        }), function(items) {
                            ctrl.datas = items;
                        });

//function test()
//{
    console.log("55555555555555");
                        var addItemData = {
                            templateUrl: 'app/entities/states/states-dialog.html',
                            controller: 'StatesDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                isViewing:function(){
                                    return false;
                                },
                                isHiding:function(){
                                    return true;
                                },
                                entity: function() {
                                    return {
                                        /*Initialisation des valeurs par défauts de l'entité à créer*/
                                        id: null,
                                        libelle: null,
                                        countryLibelle: null
                
                                    };
                                }
                            }
                        };
    
    
    
    
                        var dialogData = {
                            addData: addItemData
                        };
                
                
                        var datasEmpty=[];
                
               
                        var statesWindow = {
                            vm: ctrl,
                            datas: datasEmpty,
                            dialogData: dialogData,
                            scope: $scope
                        };
                         
                        PopupService.open(statesWindow);
                
                        console.log("eeeeeeeeeeeeeeeee");
                        $rootScope.$on('PopupService:resultData', function(event, result) {
                            console.log(result.result);
                          
                            ctrl.datas.push(result.result);
                        

                         });





                        /**A SUIVRE : L'appel de la fonction ctrl.onFilter ne fonctionne pas ! Le
                         * newValue passé est toujours vide !
                         */
                        scope.$watch(angular.bind(ctrl, function() {
                            return ctrl.query;
                        }), function(newValue) {
                            scope.filterText = newValue;
                        });

                        ctrl.model = angular.copy(scope.model);
                        if (angular.isUndefined(ctrl.model)) {
                            if (ctrl.multiple) {
                                ctrl.model = [];
                            } else {
                                ctrl.model = '';
                            }
                        }

                        function getColumnTitle(column) {
                            if (angular.isDefined(column) && column !== null) {
                                if (column.indexOf(',') !== -1) {
                                    var items = column.split(',');
                                    if (items.length !== 2) {
                                        console.error("***Column " + column + " is incorrect");
                                    }
                                    return items[1].trim();
                                } else {
                                    return column.trim();
                                }
                            }
                            return "";
                        }

                        function getColumnName(column) {
                            if (angular.isDefined(column) && column !== null) {
                                if (column.indexOf(',') !== -1) {
                                    var items = column.split(',');
                                    if (items.length !== 2) {
                                        console.error("***Column " + column + " is incorrect");
                                    }
                                    return items[0];
                                } else {
                                    return column;
                                }
                            } else {
                                console.error("***Column name can't be null");
                                return "";
                            }
                        }

                        function cancel() {
                            console.log("111111111111111111");

                            modalInstance.dismiss('cancel');
                        }

                        function confirm() {

                            modalInstance.close(ctrl.model);
                        }

                        
                      

                        function isChecked(item) {
                            if (ctrl.multiple) {
                               // modalInstance.close(ctrl.model);
                                return _.includes(ctrl.model, item.id);
                            } else {
                              //  modalInstance.close(ctrl.model);
                                return ctrl.model === item.id;

                            }
                        }

                        function toggle(item) {
                            if (ctrl.isChecked(item)) {
                                ctrl.uncheck(item);
                            } else {
                                ctrl.check(item);
                            }
                        }

                        function toggleAll() {
                            if (ctrl.allSelected) {
                                angular.forEach(ctrl.datas, function(val, key) {
                                    ctrl.checkMultiples(val);
                                });
                            } else {
                                angular.forEach(ctrl.datas, function(val, key) {
                                    ctrl.uncheck(val);
                                });
                            }
                        }


                        function checkMultiples(item) {
                            if (ctrl.multiple) {
                                ctrl.model.push(item.id);
                            } else {
                                ctrl.model = item.id;
                            }
                        }



                        function check(item) {
                            if (ctrl.multiple) {
                                ctrl.model.push(item.id);
                                this.confirm();
                            } else {
                                ctrl.model = item.id;
                                this.confirm();
                            }
                        }

                        function uncheck(item) {
                            if (ctrl.multiple) {
                                var index=ctrl.model.indexOf(item.id);
                               ctrl.model.splice(index, 1);
                            } else {
                                ctrl.model = '';
                            }
                        }
                    },
                    controllerAs: 'ctrl',
                    size: 'md',
                    backdrop: 'static'


                };

                iElement.on("click", function(event) {
                    if (angular.isDefined(scope.eventName)) {
                        $rootScope.$broadcast(scope.eventName);
                    }
                    modalInstance = $uibModal.open(d);
                    modalInstance.result.then(
                        function(res) {
                            scope.model = res;
                        },
                        function() {

                        });
                });
            }
        };
    }
})();

(function() {
    "use strict";
    angular.module('consulatApp').directive('jSelect2Dialog', select);
    select.$inject = ['$uibModal', "$rootScope","PopupService"];

    function select($uibModal, $rootScope,PopupService) {
        var modalInstance;
        console.log("111111111111111111");
        return {
            restrict: 'AE',
            scope: {
                datas: '=jList',
                model: '=jModel',
                states:'=jStates',
                multiple: '=jMultiple',
                columns: '=jColumns',
                eventName: '@jEventName',
                onFilter: '&jOnSearch'
            },
            link: function(scope, iElement, iAttrs, iCtrl,$scope) {
                var d = {
                    templateUrl: 'app/components/select/select-dialog.html',
                    controller: function() {
                        console.log(scope);
                        var vm = this;

                        var ctrl = this;
                      //  ctrl.test = test;
                        ctrl.query = "";
                        ctrl.cancel2 = cancel2;
                        ctrl.confirm2 = confirm2;
                        ctrl.isChecked = isChecked;
                        ctrl.toggle = toggle;
                        ctrl.datas = scope.datas;
                        ctrl.columns = scope.columns;
                        ctrl.onFilter = scope.onFilter;
                        ctrl.check = check;
                        ctrl.uncheck = uncheck;
                        ctrl.multiple = scope.multiple;
                        ctrl.states = scope.states;
                        ctrl.toggleAll = toggleAll;
                        ctrl.getColumnTitle = getColumnTitle;
                        ctrl.getColumnName = getColumnName;

                        scope.$watch(angular.bind(scope, function() {
                            return scope.datas;
                        }), function(items) {
                            ctrl.datas = items;
                        });

//function test()
//{
    console.log("55555555555555");
                        var addItemData = {
                            templateUrl: 'app/entities/states/states-dialog.html',
                            controller: 'StatesDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                isViewing:function(){
                                    return false;
                                },
                                isHiding:function(){
                                    return true;
                                },
                                entity: function() {
                                    return {
                                        /*Initialisation des valeurs par défauts de l'entité à créer*/
                                        id: null,
                                        libelle: null,
                                        countryLibelle: null
                
                                    };
                                }
                            }
                        };


                        var addItemDataSecond = {
                            templateUrl: 'app/entities/city/city-dialog.html',
                            controller: 'CityDialogController',
                            service: 'City',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            resolve: {
                                isViewing:function(){
                                    return false;
                                },
                                isHiding:function(){
                                    return true;
                                },
                                entity: function() {
                                    return {
                                        /*Initialisation des valeurs par défauts de l'entité à créer*/
                                            id: null,
                                            libelle: null,
                                            countriesLibelle: null,
                                            statesLibelle: null
                    
                                    };
                                }
                            }
                        };
    
    
    
    
                        var dialogData = {
                            addData: addItemData,
                            addDataSecond:addItemDataSecond
                        };
                
                
                        var datasEmpty=[];
                
               
                        var statesWindow = {
                            vm: ctrl,
                            datas: datasEmpty,
                            dialogData: dialogData,
                            scope: $scope
                        };
                         
                        PopupService.open(statesWindow);
                
                        console.log("eeeeeeeeeeeeeeeee");
                        $rootScope.$on('PopupService:resultData', function(event, result) {
                            console.log(result.result);
                          
                            ctrl.datas.push(result.result);
                        

                         });





                        /**A SUIVRE : L'appel de la fonction ctrl.onFilter ne fonctionne pas ! Le
                         * newValue passé est toujours vide !
                         */
                        scope.$watch(angular.bind(ctrl, function() {
                            return ctrl.query;
                        }), function(newValue) {
                            scope.filterText = newValue;
                        });

                        ctrl.model = angular.copy(scope.model);
                        if (angular.isUndefined(ctrl.model)) {
                            if (ctrl.multiple) {
                                ctrl.model = [];
                            } else {
                                ctrl.model = '';
                            }
                        }

                        function getColumnTitle(column) {
                            if (angular.isDefined(column) && column !== null) {
                                if (column.indexOf(',') !== -1) {
                                    var items = column.split(',');
                                    if (items.length !== 2) {
                                        console.error("***Column " + column + " is incorrect");
                                    }
                                    return items[1].trim();
                                } else {
                                    return column.trim();
                                }
                            }
                            return "";
                        }

                        function getColumnName(column) {
                            if (angular.isDefined(column) && column !== null) {
                                if (column.indexOf(',') !== -1) {
                                    var items = column.split(',');
                                    if (items.length !== 2) {
                                        console.error("***Column " + column + " is incorrect");
                                    }
                                    return items[0];
                                } else {
                                    return column;
                                }
                            } else {
                                console.error("***Column name can't be null");
                                return "";
                            }
                        }
                        
                        function cancel2() {
                            modalInstance.dismiss('cancel');

                        }

                        function confirm2() {
                            modalInstance.close(ctrl.model);
                        }

                        function isChecked(item) {
                            if (ctrl.multiple) {
                                return _.includes(ctrl.model, item.id);
                            } else {
                                return ctrl.model === item.id;
                            }
                        }

                        function toggle(item) {
                            if (ctrl.isChecked(item)) {
                                ctrl.uncheck(item);
                            } else {
                                ctrl.check(item);
                            }
                        }

                        function toggleAll() {
                            if (ctrl.allSelected) {
                                angular.forEach(ctrl.datas, function(val, key) {
                                    ctrl.check(val);
                                });
                            } else {
                                angular.forEach(ctrl.datas, function(val, key) {
                                    ctrl.uncheck(val);
                                });
                            }
                        }

                        function check(item) {
                            if (ctrl.multiple) {
                                ctrl.model.push(item.id);
                                this.confirm2();
                            } else {
                                ctrl.model = item.id;
                                this.confirm2();
                            }
                        }

                        function uncheck(item) {
                            if (ctrl.multiple) {
                                var index=ctrl.model.indexOf(item.id);
                               ctrl.model.splice(index, 1);
                            } else {
                                ctrl.model = '';
                            }
                        }
                    },
                    controllerAs: 'ctrl',
                    size: 'md',
                    backdrop: 'static'


                };

                iElement.on("click", function(event) {
                    if (angular.isDefined(scope.eventName)) {
                        $rootScope.$broadcast(scope.eventName);
                    }
                    modalInstance = $uibModal.open(d);
                    modalInstance.result.then(
                        function(res) {
                            scope.model = res;
                        },
                        function() {

                        });
                });
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                size: 'md',
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('consulatApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'en': { name: 'English' },
        'fr': { name: 'Français' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
        console.log("--------"+languageKey);
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('consulatApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'fr',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('ConfirmService', ConfirmService);

    ConfirmService.$inject = ['$uibModal'];

    function ConfirmService ($uibModal) {
        return {
            open: open
        };

        function open(text, onOk) {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/components/confirmDialog/confirm-dialog.html',
            controller: 'ModalConfirmCtrl',
            resolve: {
                text: function () {
                    return text;
                }
            }
        });
        modalInstance.result.then(function (selectedItem) {
            onOk();
        }, function () {
        });
    }
    }
})();

(function() {
    'use strict';

    angular.module('consulatApp').directive('confirm',ConfirmDirect);
    ConfirmDirect.$inject = ['ConfirmService'];

    function ConfirmDirect (ConfirmService) {
        return {
            restrict: 'A',
            scope: {
                eventHandler: '&ngClick'
            },
            link: function(scope, element, attrs){
                element.unbind("click");
                element.bind("click", function(e) {
                    ConfirmService.open(attrs.confirm, scope.eventHandler);
                });
            }
        }
        }
    })();


(function() {
    'use strict';
angular.module('consulatApp').controller('ModalConfirmCtrl',ModalConfirmCtrl);

    ModalConfirmCtrl.$inject = ['$scope','$uibModalInstance','text'];

    function ModalConfirmCtrl($scope, $uibModalInstance, text) {

    $scope.text = text;

    $scope.ok = function () {
        $uibModalInstance.close(true);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('consulatApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('consulatApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('consulatApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('consulatApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            if (!config || !config.url || /^http/.test(config.url)) return config;

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state'];

    function translationHandler($rootScope, $window, $state) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
             function test (title) {
                $window.document.title = title;
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'consulatApp' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('consulatApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "fr"');
                $cookies.putObject(name, 'fr');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('fr');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
           resolve: {
                           authorize: ['Auth',
                               function (Auth) {
                                   return Auth.authorize();
                               }
                           ],
                           translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                               $translatePartialLoader.addPart('global');
                           }]
                       }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('consulatApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1756498031463)
;
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'User','isViewing','isEdit'];

    function UserManagementDialogController ($scope, $uibModalInstance, entity, User,isViewing,isEdit) {
        var vm = this;

        vm.clear = clear;
        vm.isViewing = isViewing;
        vm.isEdit = isEdit;
        vm.languages = null;
        vm.profils = null;
        vm.uniteOrganisations = null;
        vm.save = save;
        vm.user = entity;
        vm.authorities = [];
        vm.personnes = [];
        vm.modifPassword = false;
        vm.loadProgressBar = loadProgressBar;


        vm.profilsColums = [{
            name: 'nom',
            title: 'Nom'
        }, {
            name: 'organisationNom',
            title: 'Organisation'
        }];

        $scope.$on("onLoadProfil", function() {
            if (vm.user.uniteOrganisationId != null) {
                if (vm.user.uniteOrganisationId != "") {
                    loadProfils();
                }
            }
        });


        function loadProfils() {
            RequestUtils.GetProfilsCreatedByUserConnectedAndOrganisation.query({
                id: vm.user.uniteOrganisationId
            }, function(datas) {
                console.log("profils");
                console.log(datas);
                if (datas != null) {
                    vm.profils = datas;
                    console.log(vm.profils);
                    console.log(vm.user.profilId);
                }
            });
        }

        function loadConsulats() {
            vm.personnes = PersonneTotalName.query();
            console.log(vm.personnes);
        }

        vm.consulatColums = [{
            name: 'nom',
            title: 'Nom'
        }, {
            name: 'dateNaissance',
            title: 'date de naissance'
        }];

        $scope.$on("onLoadConsulats", function() {
            loadPersonnes();
        });


        if(!vm.isViewing && !vm.isEdit){
            vm.modifPassword = true;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save() {
            vm.user.langKey = "fr";
            vm.isSaving = true;
            console.log(vm.user);
            if (vm.user.id !== null) {
                if(vm.modifPassword && (vm.confirmPassword !== vm.user.password) ){
                    Notification.error("Le mot de passe et sa confirmation ne sont pas égaux !");
                    onSaveError();
                }else{
                    console.log("mise à jour");
                    User.update(vm.user, onSaveSuccess, onSaveError);
                }
            } else {
                if (vm.confirmPassword == vm.user.password) {
                    User.save(vm.user, onSaveSuccess, onSaveError);
                } else {
                    Notification.error("Le mot de passe et sa confirmation ne sont pas égaux !");
                    onSaveError();
                }
            }
        }

        if (vm.user.id != null) {
            console.log("Toutes les informations-----------------------------------------");
            console.log(vm.user.uniteOrganisationId);
            loadOrganisations();
            loadProfils();
            loadPersonnes();

        }



        function changePasswordProgressBar(ev) {
            // less than 8 characters
            var wrost = 7,
                // minimum 8 characters
                bad = /(?=.{8,}).*/,
                //Alpha Numeric plus minimum 8
                good = /^(?=\S*?[a-z])(?=\S*?[0-9])\S{8,}$/,
                //Must contain at least one upper case letter, one lower case letter and (one number OR one special char).
                better = /^(?=\S*?[A-Z])(?=\S*?[a-z])((?=\S*?[0-9])|(?=\S*?[^\w\*]))\S{8,}$/,
                //Must contain at least one upper case letter, one lower case letter and (one number AND one special char).
                best = /^(?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9])(?=\S*?[^\w\*])\S{8,}$/,
                password = $(ev.target).val(),
                strength = '0',
                progressClass = 'progress-bar progress-bar-',
                ariaMsg = '0% Complete (danger)',
                $progressBarElement = $('#password-progress-bar');

            if (best.test(password) === true) {
                strength = '100%';
                progressClass += 'success';
                ariaMsg = '100% Complete (success)';
            } else if (better.test(password) === true) {
                strength = '80%';
                progressClass += 'info';
                ariaMsg = '80% Complete (info)';
            } else if (good.test(password) === true) {
                strength = '50%';
                progressClass += 'warning';
                ariaMsg = '50% Complete (warning)';
            } else if (bad.test(password) === true) {
                strength = '30%';
                progressClass += 'warning';
                ariaMsg = '30% Complete (warning)';
            } else if (password.length >= 1 && password.length <= wrost) {
                strength = '10%';
                progressClass += 'danger';
                ariaMsg = '10% Complete (danger)';
            } else if (password.length < 1) {
                strength = '0';
                progressClass += 'danger';
                ariaMsg = '0% Complete (danger)';
            }

            $progressBarElement.removeClass().addClass(progressClass);
            $progressBarElement.attr('aria-valuenow', strength);
            $progressBarElement.css('width', strength);
            $progressBarElement.find('span.sr-only').text(ariaMsg);
        }

        function loadProgressBar() {
            $(document).ready(function () {
                $(".pwd").first().on('keyup', changePasswordProgressBar);
            });
        }

        loadProgressBar();

    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'consulatApp'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User','$scope', 'TableService'];

    function UserManagementController(Principal, User, $scope, TableService) {
        var vm = this;

        vm.currentAccount = null;
        vm.setActive = setActive;


        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        var addItemData ={
            templateUrl: 'app/admin/user-management/user-management-dialog.html',
            controller: 'UserManagementDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                isViewing:function(){
                    return false;
                },
                isEdit:function(){
                    return false;
                },
                entity: function () {
                    return {
                        login: null,
                        email: null,
                        id: null
                    };
                }
            }
        };

        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/admin/user-management/user-management-dialog.html',
            controller: 'UserManagementDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                isViewing:function(){
                    return false;
                },
                isEdit:function(){
                    return true;
                },
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData ={
            templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
            controller: 'UserManagementDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        var detailItemData = {
            templateUrl: 'app/admin/user-management/user-management-dialog.html',
            controller: 'UserManagementDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'md',
            resolve: {
                isViewing:function(){
                    return true;
                },
                isEdit:function(){
                    return false;
                },
                entity: null //valeur déterminé à l'appel de la boite
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData,
            detailData: detailItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: User,
            entitySearch: User,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };

        TableService.init(datas);

        vm.setItemsPerPage(10);
    
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('consulatApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants'];

    function RequestResetController ($timeout, Auth, errorConstants) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService', 'errorConstants'];

    function RegisterController ($timeout, Auth, LoginService, errorConstants) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('consulatApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.loadProgressBar = loadProgressBar;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }


        function changePasswordProgressBar(ev) {
            // less than 8 characters
            var wrost = 7,
                // minimum 8 characters
                bad = /(?=.{8,}).*/,
                //Alpha Numeric plus minimum 8
                good = /^(?=\S*?[a-z])(?=\S*?[0-9])\S{8,}$/,
                //Must contain at least one upper case letter, one lower case letter and (one number OR one special char).
                better = /^(?=\S*?[A-Z])(?=\S*?[a-z])((?=\S*?[0-9])|(?=\S*?[^\w\*]))\S{8,}$/,
                //Must contain at least one upper case letter, one lower case letter and (one number AND one special char).
                best = /^(?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9])(?=\S*?[^\w\*])\S{8,}$/,
                password = $(ev.target).val(),
                strength = '0',
                progressClass = 'progress-bar progress-bar-',
                ariaMsg = '0% Complete (danger)',
                $progressBarElement = $('#password-progress-bar');

            if (best.test(password) === true) {
                strength = '100%';
                progressClass += 'success';
                ariaMsg = '100% Complete (success)';
            } else if (better.test(password) === true) {
                strength = '80%';
                progressClass += 'info';
                ariaMsg = '80% Complete (info)';
            } else if (good.test(password) === true) {
                strength = '50%';
                progressClass += 'warning';
                ariaMsg = '50% Complete (warning)';
            } else if (bad.test(password) === true) {
                strength = '30%';
                progressClass += 'warning';
                ariaMsg = '30% Complete (warning)';
            } else if (password.length >= 1 && password.length <= wrost) {
                strength = '10%';
                progressClass += 'danger';
                ariaMsg = '10% Complete (danger)';
            } else if (password.length < 1) {
                strength = '0';
                progressClass += 'danger';
                ariaMsg = '0% Complete (danger)';
            }

            $progressBarElement.removeClass().addClass(progressClass);
            $progressBarElement.attr('aria-valuenow', strength);
            $progressBarElement.css('width', strength);
            $progressBarElement.find('span.sr-only').text(ariaMsg);
        }

        function loadProgressBar() {
            $(document).ready(function () {
                $(".pwd").first().on('keyup', changePasswordProgressBar);
            });
        }

        loadProgressBar();








    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
             resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('activate');
                                return $translate.refresh();
                            }]
                        }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app',

            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
(function(){angular.module('consulatApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<head><script defer="defer">window.VerifaliaWidgetConfig = {\n      appKey: \'048e195278a540bba8758accb811a8b7\'\n    };</script><script defer="defer" src="https://unpkg.com/verifalia-widget@1.2.0/dist/verifalia-widget.js" integrity="sha512-KNWaWGZz1V4Hm+9e4pdMB0rJ/wOY3ifDIYdfnHyoRnAXtpTxvxU+beMZ6nO//qqPYWcm9uFlIA1eye6/BAnbjQ==" crossorigin="anonymous"></script></head><div ng-cloak><div class="row shadow" style="height: 425px; background: aliceblue" ng-if="!vm.isAuthenticated()"><div class="col-sm-7"><div class="card mb-3" style="max-width: 500px"><div class="row no-gutters"><div class="col-md-4"><img class="bd-placeholder-img" width="150" height="150" src="../../content/images/armoirie.png" alt=""></div><div class="col-md-8"><!--                 <h4 class="card-title" data-translate="global.menu.entities.upHome">Embassade du Burkina Faso <br/> aux Usa</h4>\n --><!--             <div class="card-body">\n                  <h4 ng-if="vm.consulat.nom!=null"><p class="card-text">{{vm.consulat.nom}}</p></h4>\n                  <h4 ng-if="vm.consulat.adresseConsulat!=null"><p class="card-text">{{vm.consulat.adresseConsulat}}</p></h4>\n                </div> --></div></div></div><br><br><h2 class="text-center" data-translate="global.menu.entities.titleHome">Bienvenue au syst\xE8me de gestion des consulats</h2><br><h2 class="text-center" data-translate="global.menu.entities.titleHome2">Portail des services consulaires de l\'Ambasade du<br>Burkina Faso aux Etats-Unis</h2></div><div class="col-sm-2"><!-- <div class="container-login100"> --><div class="wrap-login100"><div class="login100-form-title" style="background-image: url(../../content/images/bg-01.jpg)"><span class="login100-form-title-1">Sign In</span></div><form class="login100-form validate-form"><div class="text-center"><span class="text-danger m5" ng-show="vm.authenticationError"><strong>Utilisateur ou mot de passe non valide</strong></span></div><div class="wrap-input100 validate-input m-b-26" data-validate="Username is required"><span data-translate="global.menu.account.username" class="label-input100">Username</span> <input class="input100" type="text" name="username" placeholder="username" ng-model="vm.username"> <span class="focus-input100"></span></div><div class="wrap-input100 validate-input m-b-18" data-validate="Password is required"><span data-translate="global.menu.account.password" class="label-input100">Password</span> <input class="input100" type="password" name="pass" placeholder="password" ng-model="vm.password"> <span class="focus-input100"></span></div><div class="flex-sb-m w-full p-b-30"><div class="flex-sb-m w-full p-b-30"><div><a ui-sref="requestReset" class="txt1" data-translate="global.menu.account.forgotPassword">Forgot Password?</a></div></div><div class="container-login100-form-btn"><button class="login100-form-btn" ng-click="vm.login($event)" data-translate="global.menu.account.login">Login</button></div></div></form></div><!-- </div> --></div></div></div><!-- Content Row --><div><div class="col-sm-6" style="margin-top: 20px"><div class="text-center" ng-if="!vm.isAuthenticated()"><h2 class="section-heading text-uppercase">LISTE DES SERVICES</h2></div><div ng-repeat="info in vm.list track by info.id"><div class="container" ng-if="!vm.isAuthenticated()"><br><br><div class="mb-5" ng-if="info!=null"><div class="card h-100"><div class="card-body"><h4 class="text-danger">{{info.date | date:\'mediumDate\'}}-{{info.consulat}}</h4><h4 class="card-title">{{info.libelle}}</h4><p class="card-text">{{info.description}}</p></div><div class="card-footer"><a href="#" class="btn btn-primary btn-sm">More Info</a></div></div></div></div></div></div><div class="col-sm-6"><section class="page-section" id="about" ng-if="!vm.isAuthenticated()"><div class="container"><div class="row"><div class="col-lg-12 text-center"><h2 data-translate="global.menu.entities.event" class="section-heading text-uppercase" style="margin-top: 20px">EVENEMENTS</h2></div></div><div class="row"><div class="col-lg-12"><ul class="timeline" ng-repeat="even in vm.listEven track by even.id"><li ng-if="vm.listEven!=null" style="margin-top: -10px"><div class="timeline-image" style="width:100px;height:100px"><img class="rounded-circle img-fluid" style="width:100px;height:100px" src="../../img/about/3.jpg" alt=""></div><div class="timeline-panel"><div class="timeline-heading"><h4 class="text-danger">{{even.date | date:\'mediumDate\'}}-{{even.consulat}}</h4><h4 class="subheading">{{even.libelle}}</h4></div><div class="timeline-body"><p class="text-muted">{{even.description}}</p></div><div><a href="#" class="btn btn-primary btn-sm">S\'inscrire</a></div></div></li></ul></div></div></div></section></div></div><div class="col-md-7"></div><div class="col-sm-10 col-sm-offset-1" ng-if="vm.isAuthenticated()"><div class="row mb25"><div class="text-center"><h4 class="row-title before-blue"><strong><u data-translate="global.menu.stats.infos">INFORMATIONS GENERALES</u> </strong><u ng-if="vm.consulat.nom != null"><strong></strong>( {{vm.account.login}} : {{vm.consulat.nom}} )</u></h4></div><div class="col-sm-6"><br><div class="panel"><div class="panel-heading border text-center" title="Le nombre de ressortissants par sexe"><u><b data-translate="global.menu.stats.sexe">Le nombre de ressortissants par sexe</b></u></div><div class="panel-body"><div class="canvas-holder"><canvas id="MembreSexe-pie" class="chart chart-pie" chart-data="vm.membreSexe.data" chart-labels="vm.membreSexe.labels" chart-options="vm.membreSexe.options"></canvas></div></div></div></div><div class="col-sm-6"><br><div class="panel"><div class="panel-heading border text-center" title="Le nombre de ressortissants par sexe"><u><b data-translate="global.menu.stats.states">Le nombre de ressortissants par Etat</b></u></div><div class="panel-body"><div class="canvas-holder"><canvas id="MembreEtat-bar" class="chart chart-bar" chart-data="vm.etatMembre.data" chart-labels="vm.etatMembre.labels" chart-options="vm.etatMembre.options"></canvas></div></div></div></div></div><div class="row mb25" ng-if="vm.isAuthenticated()"><div class="col-md-6"><div class="panel"><div class="panel-heading border text-center" title="membres par association"><u><b data-translate="global.menu.stats.assoc">Membres par association</b></u></div><div class="panel-body"><div class="canvas-holder"><br><br><canvas id="membre-par-assoc-pie" class="chart chart-doughnut" chart-data="vm.membreAssoc.data" chart-labels="vm.membreAssoc.labels" chart-options="vm.membreAssoc.options"></canvas></div></div></div></div><div class="col-md-6"><div class="panel"><div class="panel-heading border text-center" title="Le nombre de ressortissants par date d\'arrivee"><u data-translate="global.menu.stats.arrival"><b>Le nombre de ressortissants par date d\'arriv\xE9e</b></u></div><div class="panel-body"><div class="canvas-holder"><div class="col-sm-3"><input show-button-bar="false" placeholder="Start date arrival" is-open="vm.datePickerOpenStatus.periodeDebut" uib-datepicker-popup="dd MMMM yyyy" ng-focus="vm.openCalendar(\'periodeDebut\')" class="form-control" ng-model="vm.periodeDebut" name="periodeDebut"> <input show-button-bar="false" ng-disabled="vm.periodeDebut==null" placeholder="End date arrival" is-open="vm.datePickerOpenStatus.periodeFin" uib-datepicker-popup="dd MMMM yyyy" ng-focus="vm.openCalendar(\'periodeFin\')" class="form-control" ng-model="vm.periodeFin" name="periodeFin"><div ng-show="vm.dateFinEstAvantDateDebut() "><p class="alert alert-danger" data-translate="global.menu.stats.controlDate">La date de fin doit \xEAtre sup\xE9rieure \xE0 la date de Debut.</p></div></div><canvas id="MembreArrivee-pie" class="chart chart-pie" chart-data="vm.membreArrivee.data" chart-labels="vm.membreArrivee.labels" chart-options="vm.membreArrivee.options"></canvas></div></div></div></div></div><div class="row mb25" ng-if="vm.isAuthenticated()"><div class="panel"><div class="panel-heading border text-center" title="Le nombre de ressortissants par trance d\'age"><u><b data-translate="global.menu.stats.age">Le nombre de ressortissants par tranche d\'age</b></u></div><div class="panel-body"><div class="canvas-holder"><canvas id="MembreAge-pie" class="chart chart-bar" chart-data="vm.trancheAge.data" chart-labels="vm.trancheAge.labels" chart-options="vm.trancheAge.options"></canvas></div></div></div></div></div>');
$templateCache.put('app/layouts/layout.tpl.html','<!-- HEADER --><div data-smart-include="app/layout/partials/header.tpl.html" class="placeholder-header"></div><!-- END HEADER --><!-- Left panel : Navigation area --><!-- Note: This width of the aside area can be adjusted through LESS variables --><div data-smart-include="app/layout/partials/navigation.tpl.html" class="placeholder-left-panel"></div><!-- END NAVIGATION --><!-- MAIN PANEL --><div id="main" role="main"><demo-states></demo-states><!-- RIBBON --><div id="ribbon"><span class="ribbon-button-alignment"><span id="refresh" class="btn btn-ribbon" reset-widgets tooltip-placement="bottom" smart-tooltip-html="<i class=\'text-warning fa fa-warning\'></i> Warning! This will reset all your widget settings."><i class="fa fa-refresh"></i> </span></span><!-- breadcrumb --><state-breadcrumbs></state-breadcrumbs><!-- end breadcrumb --></div><!-- END RIBBON --><div data-smart-router-animation-wrap="content content@app" data-wrap-for="#content"><div data-ui-view="content" data-autoscroll="false"></div></div></div><!-- END MAIN PANEL --><!-- PAGE FOOTER --><div data-smart-include="app/layout/partials/footer.tpl.html"></div><div data-smart-include="app/layout/shortcut/shortcut.tpl.html"></div><!-- END PAGE FOOTER -->');
$templateCache.put('app/home-election/home-election.html','<head><script defer="defer">window.VerifaliaWidgetConfig = {\n      appKey: \'048e195278a540bba8758accb811a8b7\'\n    };</script><script defer="defer" src="https://unpkg.com/verifalia-widget@1.2.0/dist/verifalia-widget.js" integrity="sha512-KNWaWGZz1V4Hm+9e4pdMB0rJ/wOY3ifDIYdfnHyoRnAXtpTxvxU+beMZ6nO//qqPYWcm9uFlIA1eye6/BAnbjQ==" crossorigin="anonymous"></script><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=1"><meta http-equiv="X-UA-Compatible" content="ie=edge"><meta name="msapplication-TileColor" content="#0E0E0E"><meta name="template-color" content="#0E0E0E"><meta name="description" content="Phone email login template 1"><meta name="keywords" content="free SMS,OTP,phone email,free sms otp service"><meta name="author" content=""><title>Phone Email Login Template - 1</title><style>.phem-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin: 50px 0;\n    }\n\n    .phem-input {\n      padding: 12px 20px;\n      display: inline-block;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      box-sizing: border-box;\n      margin-bottom: 20px;\n    }\n\n    .phem-card {\n      color: #024430 !important;\n      text-align: center;\n      background-color: #ced4da;\n      ;\n      padding: 30px;\n      border-radius: 0.5rem;\n      box-shadow: 0 1px 3px rgba(17, 24, 39, .09);\n      width: 100%;\n      max-width: 420px;\n      margin: 0 auto;\n      font-family: sans-serif, serif, system-ui, -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, Oxygen, Ubuntu, Cantarell, \'Open Sans\', \'Helvetica Neue\', sans-serif;\n      line-height: 28px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .pe_signin_button button {\n      width: 400px;\n    }\n\n    .pe_signin_button button {\n      width: 320px;\n    }</style></head><div ng-cloak><div class="row shadow" style="background: aliceblue" ng-if="!vm.isAuthenticated()"><div class="col-sm-7"><div class="card mb-3" style="max-width: 500px"><div class="row no-gutters"><div class="col-md-4"><img class="bd-placeholder-img" width="150" height="150" src="../../content/images/armoirie.png" alt=""></div></div></div><br><br><br><br><br><br><div><h2 class="text-right">\xC9lection des d\xE9l\xE9gu\xE9s du HCBE <img class="bd-placeholder-img" width="150" height="150" src="../../content/images/urne2.jpg" alt=""></h2></div><br><br><br><br><br><div class="card mb-3" style="max-width: 500px"><div class="row no-gutters"><div class="col-md-4"><img class="bd-placeholder-img" width="150" height="150" src="../../content/images/bf-usa.png" alt=""></div></div></div></div><div class="phem-container"><div class="phem-card"><h1 style="margin:10px">Vote</h1><p class="">Connectez-vous avec votre num\xE9ro de t\xE9l\xE9phone pour acc\xE9der \xE0 la page des \xE9lections</p><!-- <img class="phe-login-img" width="250px" src="https://resource.phone.email/images/wm_login-animation.gif"\n          alt="phone email login demo"> --><div class="form-group has-feedback" ng-if="vm.otp==null"><label class="control-label col-sm-3" mf-required for="field_numero"><b>Phone</b></label><div class="col-sm-7"><input disabled="disabled" type="number" class="form-control" name="libelle" id="field_numero" ng-model="vm.phoneNumber" ng-disabled="vm.isViewing" required></div></div><br><div class="contape_signin_buttoniner-login100-form-btn" ng-if="vm.otp==null"><button class="login100-form-btn" ng-click="vm.getOtp()" ng-disabled="vm.phoneNumber==null">Login</button></div><div class="form-group has-feedback" ng-if="vm.otp!=null"><label class="control-label col-sm-3" mf-required for="field_otp"><b>Code Otp</b></label><div class="col-sm-6"><input type="text" class="form-control" name="libelle" id="field_otp" ng-model="vm.codeOtp" ng-disabled="vm.isViewing" maxlength="6" required></div></div><div class="contape_signin_buttoniner-login100-form-btn" ng-if="vm.otp!=null"><button class="login100-form-btn" ng-click="vm.login($event)">V\xE9rifier</button></div></div></div></div></div>');
$templateCache.put('app/vote/vote.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="mb5"></div></div><div class="col-sm-10 col-sm-offset-1 mb5" ng-if="!vm.vote"><div class="no-padding-left"><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div><div style="text-align: center; font-weight: bold; margin-top: 6px; margin-bottom: 3px; text-decoration: underline"><h3><span>Liste des Candidats</span> : {{vm.totalItems}}</h3></div><br><br></div></div><div class="row mt-3 bg-white" ng-if="!vm.vote"><div class="col-sm-10 col-sm-offset-1"><div class="grid-container"><div ng-repeat="member in vm.datas track by member.id"><div class="card mb-3" style="width: 250px"><div class="row no-gutters"><div class="col-md-5"><img ng-if="member.photo" data-ng-src="{{\'data:\' + member.photoContentType + \';base64,\' + member.photo}}" style="max-height: 100px" alt="member image"> <svg ng-if="!member.photo" class="bd-placeholder-img" width="100" height="100" xmlns="http://www.w3.org/2000/svg" aria-label="Placeholder: Image" preserveAspectRatio="xMidYMid slice" role="img"><title>Placeholder</title><rect width="100%" height="100%" fill="#868e96"/><text x="50%" y="50%" fill="#dee2e6" dy=".3em">Image</text></svg></div><div class="col-md-7"><div class="card-body"><h5 class="card-title">{{member.nom }} {{member.prenom | characters:30}}</h5><p class="card-text">{{member.villeResidence | characters:30}}, {{member.etatResidence}}</p><p class="card-text"></p><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="voter" ng-click="vm.voter(member.id)" confirm="Etes-vous sure de vouloir voter ce candidat" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-book">Voter</span></button></div><p></p></div></div></div></div><br></div></div></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div><div class="center" ng-cloak ng-if="vm.vote"><div class="row"><br><br><div class="alert alert-success text-center"><h1 class="">Merci pour votre vote!!!</h1></div><div style="margin-top: 120px;text-align:center"><img class="bd-placeholder-img" width="300" height="300" src="../../../content/images/armoirie.png" alt=""></div></div></div></div><footer class="navbar-fixed-bottom text-center"></footer>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div><br><div class="alert alert-dismissable alert-info"><!--                 <button type="button" class="close"  class="btn btn-danger" data-dismiss="alert" aria-hidden="true">&times;</button>\n     --><marquee scrollamount="2" direction="up" height="100" class="text-center"><span>Votre mots de passe devrait \xEAtre d\'une longueur de 8 \xE0 50 caract\xE8res et contenir:</span><br><span class="text-center">- au moins une lettre minuscule</span><br><span class="text-center">- au moins une lettre majuscule</span><br><span class="text-center">- au moins un chiffre</span><br><span class="text-center">- au moins un de ces caract\xE8res sp\xE9ciaux: $ @ % * + - _ !</span><br><span class="text-center">- aucun autre caract\xE8re possible: pas de & ni de { par exemple)</span></marquee><!--                 <p><button id="myButton" type="button" class="btn btn-primary">Fermer</button></p>\n     --></div><!-- Fin du bandeau d\'alerte --><script>$(\'#myButton\').click(function(){ /* Apr\xE8s le clic sur l\'\xE9l\xE9ment dont l\'id est "myButton" (le bouton dans notre cas) "*/\n                        $(\'.alert\').alert(\'close\'); /* Faire disparaitre le bandeau d\'alerte*/\n                    });</script></div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control pwd" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="8" ng-maxlength="50" ng-pattern="/^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[-+!*$@%_])([-+!*$@%_\\w]{8,50})$/" required><div class="progress"><div class="progress-bar progress-bar-danger" id="password-progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0"><span class="sr-only">0% Complete (danger)</span> <span id="progress-bar-text" style="color:#000"></span></div></div><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.pattern">invalid password</p><p class="help-block" ng-show="form.password.$error.minlength">minimum required of 8 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">maximum required of 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Your email" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Registration</h1><div class="alert alert-success" ng-show="vm.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="Your username" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Your email" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Register</button></form><p></p><div class="alert alert-warning">If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span>Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated">Activated</span></dd><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserExtraLabel">Cr\xE9er ou \xE9diter un utilisateur</h4></div><div class="modal-body"><div class="form-group" ng-if="!vm.isVue() && vm.esDefini==null"><label mf-required class="control-label col-sm-4" for="field_profil">Profil</label><div class="col-sm-6"><select disabled="disabled" required class="form-control" id="field_profil" name="profil" ng-model="vm.user.profilId" ng-options="profil.id as profil.nom for profil in vm.profils"><option value=""></option></select></div><i title="S\xE9lectionnez le profil" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.user.profilId" j-list="vm.profils" j-columns="vm.profilsColums" j-event-name="onLoadProfil">Choisir...</i></div><div class="form-group"><label class="control-label col-sm-4">Consulat</label><div class="col-sm-6"><select disabled="disabled" required class="form-control" id="field_personne" name="personne" ng-model="vm.user.personneId" ng-options="consulat.id as personne.nom for personne in vm.consulats"><option value=""></option></select></div><i title="S\xE9lectionnez la personne" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.consulat.personneId" j-list="vm.consulats" j-columns="vm.consulatColums" j-event-name="onLoadConsulats">Choisir...</i></div><div class="form-group" ng-if="vm.isVue() && vm.esDefini!=null"><label mf-required class="control-label col-sm-4" for="field_profil">Profil</label><div class="col-sm-6"><input type="text" ng-disabled="vm.isVue()" class="form-control" name="lastName" ng-model="vm.user.profilNom" required></div></div><fieldset class="p10 mf-fieldset"><legend>Informations de l\'utilisateur</legend><div class="form-group"><label mf-required class="control-label col-sm-4" data-translate="userManagement.lastName">Last Name</label><div class="col-sm-6"><input type="text" ng-disabled="vm.isVue()" class="form-control" name="lastName" ng-model="vm.user.lastName" required></div></div><div class="form-group"><label mf-required class="control-label col-sm-4" data-translate="userManagement.firstName">First Name</label><div class="col-sm-6"><input type="text" ng-disabled="vm.isVue()" class="form-control" name="firstName" ng-model="vm.user.firstName" required></div></div><div class="form-group"><label mf-required class="control-label col-sm-4">Login455</label><div class="col-sm-6"><input ng-disabled="vm.isVue()" type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$dirty && editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">Your username is required.</p><p class="help-block" ng-show="editForm.login.$error.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.login.$error.pattern">Your username can only contain lower-case letters and digits.</p></div></div></div><div class="form-group"><label mf-required class="control-label col-sm-4" data-translate="userManagement.email">Email</label><div class="col-sm-6"><input type="email" ng-disabled="vm.isVue()" type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$dirty && editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="editForm.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="control-label col-sm-4" for="field_telephone">Telephone</label><div class="col-sm-6"><input type="text" ng-disabled="vm.isVue()" class="form-control" name="telephone" id="field_telephone" ng-model="vm.user.phoneNumber" ng-minlength="8" ng-maxlength="13"></div></div><div class="checkbox text-center" ng-if="!vm.isViewing && vm.user.id!=null"><label><input type="checkbox" ng-change="vm.loadProgressBar()" class="checkbox-slider colored-blue checkbox-lg" ng-model="vm.modifPassword"> <span class="text">Modifier Mot de Passe?</span></label></div><div class="form-group" ng-if="vm.modifPassword"><label mf-required class="control-label col-sm-4" for="password">Mot de passe</label><div class="col-sm-6"><input type="password" class="form-control pwd" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[-+!*$@%_])([-+!*$@%_\\w]{8,50})$" ng-model="vm.user.password" ng-minlength="4" ng-maxlength="50" required><div class="progress"><div class="progress-bar progress-bar-danger" id="password-progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0"><span class="sr-only">0% Complete (danger)</span> <span id="progress-bar-text" style="color:#000"></span></div></div></div></div><div class="form-group" ng-if="vm.modifPassword"><label mf-required class="control-label col-sm-4" for="confirmPassword">Confirmation du mot de passe</label><div class="col-sm-6"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required></div></div></fieldset></div><div class="modal-footer"><button ng-if="!vm.isVue()" type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="entity.action.cancel">Cancel</span></button> <button ng-if="!vm.isVue()" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp; <span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="vm.isVue()" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Fermer</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="row"><div class="well with-header" style="margin-top:10px"><div class="header bg-blue"><div class="col-xs-10"><h4>Liste des utilisateurs</h4></div><div class="no-padding-left col-xs-2"><button ng-if="vm.actions.add || vm.actions.add==null" class="btn btn-default btn-circle btn-xs" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle btn-xs" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)">15</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)">20</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)">30</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)">40</a></li></ul></div></div></div><table class="table table-hover"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'login\') "><span>Login</span> <span ng-if="vm.isCurrentColumn(\'login\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'email\') "><span>Email</span> <span ng-if="vm.isCurrentColumn(\'email\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'activated\') "><span>Statut</span> <span ng-if="vm.isCurrentColumn(\'activated\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><!-- <th ng-click="vm.sortBy(\'authorities\') ">\n                         <span>Droit</span>\n                         <span ng-if="vm.isCurrentColumn(\'authoroties\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span>\n                     </th>--><th ng-click="vm.sortBy(\'createdDate\') "><span>Cr\xE9\xE9 le</span> <span ng-if="vm.isCurrentColumn(\'createdDate\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'lastModifiedBy\') "><span>Modifi\xE9 par</span> <span ng-if="vm.isCurrentColumn(\'lastModifiedBy\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'lastModifiedDate\') "><span>Modifi\xE9 le</span> <span ng-if="vm.isCurrentColumn(\'lastModifiedDate\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.datas track by user.id"><td>{{user.login}}</td><td title="{{user.email}}">{{user.email | characters:30}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><!-- <td>\n                         <div ng-repeat="authority in user.authorities">\n                             <span title="{{authority}}" class="label label-info">{{ authority }}</span>\n                         </div>\n                     </td>--><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button title="Consulter" type="submit" ng-click="vm.detailItem($event,user)" class="btn btn-info btn-xs btn-round"><span class="glyphicon glyphicon-eye-open"></span></button> <button title="Modifier" type="submit" ng-click="vm.editItem($event,user)" class="btn btn-warning btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button title="Reinitialiser le mot de passe" type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-check"></span></button></div></td></tr></tbody></table></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div>');
$templateCache.put('app/entities/adresses/adresses-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.adresses.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Adresses?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/adresses/adresses-detail.html','<div><h2><span>Adresses</span> {{vm.adresses.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Rue</span></dt><dd><span>{{vm.adresses.rue}}</span></dd><dt><span>No Porte</span></dt><dd><span>{{vm.adresses.noPorte}}</span></dd><dt><span>Mail</span></dt><dd><span>{{vm.adresses.mail}}</span></dd><dt><span>Telephone</span></dt><dd><span>{{vm.adresses.telephone}}</span></dd><dt><span>Zip Code</span></dt><dd><span>{{vm.adresses.zipCode}}</span></dd><dt><span>Members</span></dt><dd><a ui-sref="members-detail({id:vm.adresses.membersId})">{{vm.adresses.membersId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="adresses-detail.edit({id:vm.adresses.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/adresses/adresses-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAdressesLabel">Create or edit a Adresses</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.adresses.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.adresses.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_rue">Rue</label><input type="text" class="form-control" name="rue" id="field_rue" ng-model="vm.adresses.rue"></div><div class="form-group"><label class="control-label" for="field_noPorte">No Porte</label><input type="text" class="form-control" name="noPorte" id="field_noPorte" ng-model="vm.adresses.noPorte"></div><div class="form-group"><label class="control-label" for="field_mail">Mail</label><input type="text" class="form-control" name="mail" id="field_mail" ng-model="vm.adresses.mail"></div><div class="form-group"><label class="control-label" for="field_telephone">Telephone</label><input type="text" class="form-control" name="telephone" id="field_telephone" ng-model="vm.adresses.telephone"></div><div class="form-group"><label class="control-label" for="field_zipCode">Zip Code</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" ng-model="vm.adresses.zipCode"></div><div class="form-group"><label for="field_members">Members</label><select class="form-control" id="field_members" name="members" ng-model="vm.adresses.membersId" ng-options="members.id as members.id for members in vm.members"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/adresses/adresses.html','<div class="container"><div class="row mb5"><div class="no-padding-left"><div class="form-group" ng-if="!vm.filtrer"><div class="pull-right"><button class="btn btn-info btn-md" ng-click="vm.filtrer=true"><span class="glyphicon glyphicon-search">Filtrer</span></button></div></div><!--  <button class="btn btn-primary btn-outline" ng-click="vm.addItem()">\n           <span class="glyphicon glyphicon-plus"></span>\n           <span class="hidden-xs-down">\n               Nouveau\n           </span>\n           </button> --><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} \xE9l\xE9ments par page <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="row" ng-if="vm.filtrer"><div class="form-group col-sm-2"><input type="text" placeholder="Nom" required class="form-control" id="field_nom" ng-model="vm.itemSearch.nom" name="nom"> <input type="text" placeholder="Prenom" required class="form-control" id="field_prenom" ng-model="vm.itemSearch.prenom" name="prenom"></div><div class="form-group col-sm-4"><div class="col-sm-4"><button class="btn btn-warnig btn-md" ng-click="vm.initFiltre()"><span class="glyphicon glyphicon-search">Annuler</span></button></div><div class="col-sm-4"><button class="btn btn-info btn-md" ng-click="vm.init()"><span class="glyphicon glyphicon-search">Filtrer</span></button></div></div></div><div class="text-center"><span class="h4"><u>Historique des r\xE9sidences</u></span></div></div><div class="row"><div class="col-sm-12"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'rue\') "><span>Adresse</span> <span ng-if="vm.isCurrentColumn(\'rue\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'mail\') "><span>Mail</span> <span ng-if="vm.isCurrentColumn(\'mail\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'telephone\') "><span>Telephone</span> <span ng-if="vm.isCurrentColumn(\'telephone\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'siege\') "><span>ZipCode</span> <span ng-if="vm.isCurrentColumn(\'siege\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'dateCreation\') "><span>Membre</span> <span ng-if="vm.isCurrentColumn(\'dateCreation\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th></th></tr></thead><tbody><tr ng-repeat="adresse in vm.datas track by adresse.id"><td>{{adresse.rue}}</td><td>{{adresse.mail}}</td><td>{{adresse.telephone}}</td><td>{{adresse.zipCode}}</td><td>{{adresse.membersNom}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><!--   <button type="submit"\n                            ng-click="vm.detailItem($event,consulat)"\n                            class="btn btn-primary btn-xs btn-round">\n                            <span class="glyphicon glyphicon-eye-open"></span>\n                            </button> --><!--              <button type="submit"\n                            ng-click="vm.editItem($event,adresse)"\n                            class="btn btn-success btn-xs btn-round">\n                            <span class="glyphicon glyphicon-pencil"></span>\n                            </button> --></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/bf-id-doc/bf-id-doc-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.bfIdDoc.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Bf Id Doc?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/bf-id-doc/bf-id-doc-detail.html','<div><h2><span>Bf Id Doc</span> {{vm.bfIdDoc.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Numero</span></dt><dd><span>{{vm.bfIdDoc.numero}}</span></dd><dt><span>Autorite</span></dt><dd><span>{{vm.bfIdDoc.autorite}}</span></dd><dt><span>Doc Id</span></dt><dd><span>{{vm.bfIdDoc.docId}}</span></dd><dt><span>Date de d\xE9livrance</span></dt><dd><span>{{vm.bfIdDoc.dateDelivr | date:\'mediumDate\'}}</span></dd><dt><span>Date d\'expiration</span></dt><dd><span>{{vm.bfIdDoc.dateExpr | date:\'mediumDate\'}}</span></dd><dt><span>Ville</span></dt><dd><span>{{vm.bfIdDoc.ville}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="bf-id-doc-detail.edit({id:vm.bfIdDoc.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/bf-id-doc/bf-id-doc-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBfIdDocLabel">Create or edit a Bf Id Doc</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.bfIdDoc.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.bfIdDoc.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_numero">Numero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-model="vm.bfIdDoc.numero" required><div ng-show="editForm.numero.$invalid"><p class="help-block" ng-show="editForm.numero.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_autorite">Autorite</label><input type="text" class="form-control" name="autorite" id="field_autorite" ng-model="vm.bfIdDoc.autorite"></div><div class="form-group"><label class="control-label" for="field_docId">Doc Id</label><select class="form-control" name="docId" ng-model="vm.bfIdDoc.docId" id="field_docId"><option value="CNIB">CNIB</option><option value="PASSPORT">PASSPORT</option></select></div><div class="form-group"><label class="control-label" for="field_dateDelivr">Date Delivr</label><div class="input-group"><input id="field_dateDelivr" type="text" class="form-control" name="dateDelivr" uib-datepicker-popup="{{dateformat}}" ng-model="vm.bfIdDoc.dateDelivr" is-open="vm.datePickerOpenStatus.dateDelivr"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateDelivr\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_dateExpr">Date Expr</label><div class="input-group"><input id="field_dateExpr" type="text" class="form-control" name="dateExpr" uib-datepicker-popup="{{dateformat}}" ng-model="vm.bfIdDoc.dateExpr" is-open="vm.datePickerOpenStatus.dateExpr"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateExpr\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_ville">Ville</label><input type="text" class="form-control" name="ville" id="field_ville" ng-model="vm.bfIdDoc.ville"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/bf-id-doc/bf-id-docs.html','<div><h2>Bf Id Docs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="bf-id-doc.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Bf Id Doc</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="numero"><span>Numero</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="autorite"><span>Autorite</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="docId"><span>Doc Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateDelivr"><span>Date Delivr</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateExpr"><span>Date Expr</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ville"><span>Ville</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="bfIdDoc in vm.bfIdDocs track by bfIdDoc.id"><td><a ui-sref="bf-id-doc-detail({id:bfIdDoc.id})">{{bfIdDoc.id}}</a></td><td>{{bfIdDoc.numero}}</td><td>{{bfIdDoc.autorite}}</td><td>{{bfIdDoc.docId}}</td><td>{{bfIdDoc.dateDelivr | date:\'mediumDate\'}}</td><td>{{bfIdDoc.dateExpr | date:\'mediumDate\'}}</td><td>{{bfIdDoc.ville}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="bf-id-doc-detail({id:bfIdDoc.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="bf-id-doc.edit({id:bfIdDoc.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="bf-id-doc.delete({id:bfIdDoc.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/association/adresse.html','<fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend>Contacts association</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" data-translate="consulatApp.association.adresse">Adresse</label><div class="col-sm-6"><input type="text" placeholder="ex: 100, Red Fox Avenue" class="form-control" name="nom" id="field_nom" ng-model="vm.association.adresseDTO.rue"></div></div><br><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="etat" data-translate="consulatApp.association.states">Etat</label><div class="col-sm-6"><select disabled="disabled" required class="form-control" id="field_etat" name="etat" ng-model="vm.association.adresseDTO.etatId" ng-options="etat.id as etat.libelle for etat in vm.etats"><option value=""></option></select></div><i title="Select the states" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="true" j-model="vm.association.adresseDTO.etatId" j-list="vm.etats" j-columns="vm.etatColumns" j-event-name="onLoadEtats">Choose...</i></div><br><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="ville" data-translate="consulatApp.association.city">Ville</label><div class="col-sm-6"><select disabled="disabled" placeholder="City" required class="form-control" id="field_ville" name="ville" ng-model="vm.association.adresseDTO.cityId" ng-options="ville.id as ville.libelle for ville in vm.villeAdresse"><option value=""></option></select></div><i title="Select the city" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="false" j-model="vm.association.adresseDTO.cityId" j-list="vm.villeAdresse" j-columns="vm.statesVilleColumns" j-event-name="onLoadStatesVille">Choose...</i></div><br></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_telephone" mf-required data-translate="consulatApp.association.phone">Telephone</label><div class="col-sm-6"><input required type="text" placeholder="phone number" class="form-control" name="telephone" id="field_telephone" ng-model="vm.association.adresseDTO.telephone"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_zipCode">Zip Code</label><div class="col-sm-6"><input type="text" class="form-control" placeholder="zip code" name="telephone" id="field_zipCode" ng-model="vm.association.adresseDTO.zipCode"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_mail">Mail</label><div class="col-sm-6"><input type="email" placeholder="mail adress" class="form-control" name="email" id="field_mail" ng-model="vm.association.adresseDTO.mail" ng-maxlength="100" ng-minlength="5"><div ng-show="editForm.email.$dirty && editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="editForm.email.$error.minlength">Minimum required is 5 characters.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div></div></div></fieldset>');
$templateCache.put('app/entities/association/association-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.association.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Association?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/association/association-detail.html','<div><h2><span>Association</span> {{vm.association.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Numero</span></dt><dd><span>{{vm.association.numero}}</span></dd><dt><span>Nom</span></dt><dd><span>{{vm.association.nom}}</span></dd><dt><span>Poste</span></dt><dd><span>{{vm.association.poste}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="association-detail.edit({id:vm.association.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/association/association-dialog.html','<form name="editForm" role="form" novalidate class="container-fluid form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="consulat" data-translate="consulatApp.association.home.createLabel">Ajouter une association</h4></div><div class="modal-body"><div class="box-tab justified" id="rootwizard"><ul class="nav nav-tabs"><li ng-repeat="step in vm.steps" ng-class="{active: $index==vm.getCurrentStepIndex()}"><a href="javascript:void(0)" ng-click="vm.goToStep($index,editForm)">{{step}}</a></li></ul><!-- D\xE9mandeur de la carte grise--><div class="tab-pane" ng-if="vm.showOnglet(\'IDENTIFICATION\',0)"><div ng-include="\'app/entities/association/identification.html\'" scope="" onload=""></div></div><!--Informations de la carte grise--><div class="tab-pane" ng-if="vm.showOnglet(\'ADRESSE\',1)"><div ng-include="\'app/entities/association/adresse.html\'" scope="" onload=""></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span ng-hide="vm.isViewing" data-translate="entity.action.cancel">Cancel</span> <span ng-show="vm.isViewing">Fermer</span></button> <button class="btn btn-primary" ng-show="vm.hasPreviousStep()" ng-click="vm.decrementStep()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; <span>Pr\xE9cedent</span></button> <button class="btn btn-primary" ng-show="vm.hasNextStep()" ng-disabled="editForm.$invalid " ng-click="vm.incrementStep()"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp; <span data-translate="global.menu.entities.next">Suivant</span></button> <button type="submit" class="btn btn-success" ng-show="!vm.hasNextStep()" ng-disabled="editForm.$invalid || vm.isSaving" data-dismiss="modal" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp; <span data-translate="entity.action.save">Sauvegarder</span></button></div></form>');
$templateCache.put('app/entities/association/associations.html','<div class="container"><div class="row mb5"><div class="no-padding-left"><div class="form-group" ng-if="!vm.filtrer"><div class="pull-right"><button class="btn btn-info btn-md" ng-click="vm.filtrer=true"><span class="glyphicon glyphicon-search" data-translate="global.menu.entities.filtrer">Filtrer</span></button></div></div><button class="btn btn-primary btn-outline" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="row" ng-if="vm.filtrer"><div class="form-group col-sm-2"><input type="text" placeholder="Nom" required class="form-control" id="field_nom" ng-model="vm.itemSearch.nom" name="nom"></div><div class="form-group col-sm-2"><input type="text" placeholder="Type" required class="form-control" id="field_type" ng-model="vm.itemSearch.type" name="type"></div><div class="form-group col-sm-2"><input type="text" placeholder="adresse" required class="form-control" id="field_adresse" ng-model="vm.itemSearch.adresse" name="adresse"></div><div class="form-group col-sm-2"><input show-button-bar="false" id="field_dateCreation" placeholder="Date de cr\xE9ation" type="text" class="form-control" name="dateCreation" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="vm.itemSearch.dateCreation" is-open="vm.datePickerOpenStatus.dateCreation" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateCreation\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div class="form-group col-sm-4"><div class="col-sm-4"><button class="btn btn-warnig btn-md" ng-click="vm.initFiltre()"><span class="glyphicon glyphicon-search">Annuler</span></button></div><div class="col-sm-4"><button class="btn btn-info btn-md" ng-click="vm.init()"><span class="glyphicon glyphicon-search" data-translate="global.menu.entities.filtrer">Filtrer</span></button></div></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.association.home.title">Liste des associations</u></span></div></div><div class="row"><div class="col-sm-12"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'numero\') "><span data-translate="consulatApp.association.numero">Numero</span> <span ng-if="vm.isCurrentColumn(\'numero\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'nom\') "><span data-translate="consulatApp.association.nom">Nom</span> <span ng-if="vm.isCurrentColumn(\'nom\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'type\') "><span>Type</span> <span ng-if="vm.isCurrentColumn(\'type\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'siege\') "><span data-translate="consulatApp.association.siege">Si\xE8ge</span> <span ng-if="vm.isCurrentColumn(\'siege\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'dateCreation\') "><span>Creation</span> <span ng-if="vm.isCurrentColumn(\'dateCreation\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th></th></tr></thead><tbody><tr ng-repeat="association in vm.datas track by association.id"><td>{{association.numero}}</td><td>{{association.nom}}</td><td>{{association.type}}</td><td>{{association.siege}}</td><td>{{association.dateCreation}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><!--   <button type="submit"\n                            ng-click="vm.detailItem($event,consulat)"\n                            class="btn btn-primary btn-xs btn-round">\n                            <span class="glyphicon glyphicon-eye-open"></span>\n                            </button> --> <button type="submit" ng-click="vm.editItem($event,association)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/association/identification.html','<fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.association.infoAssociation">informations sur l\'association</legend><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.association.nom">Nom</label><div class="col-sm-6"><input required type="text" placeholder="association name" class="form-control" name="nom" id="field_nom" ng-model="vm.association.nom"></div></div><br><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="document">Type</label><div class="col-sm-6"><select placeholder="document" required class="form-control" id="field_ville" name="ville" ng-model="vm.association.type" ng-options="type.libelle as type.libelle for type in vm.types"><option value=""></option></select></div></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateCreation" mf-required data-translate="consulatApp.association.dateCreation">Date de Cr\xE9ation</label><div class="col-sm-6"><input show-button-bar="false" placeholder="creation date" id="field_dateCreation" type="text" class="form-control" name="dateCreation" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.association.dateCreation" is-open="vm.datePickerOpenStatus.dateCreation" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateCreation\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></fieldset>');
$templateCache.put('app/entities/association/type-associations-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCityLabel" data-translate="consulatApp.typeAssociation.home.createLabel">Ajouter un type</h4></div><div class="modal-body"><!--   <div class="form-group has-feedback">\n            <label class="control-label col-sm-3" mf-required  for="field_numero">Code</label>\n            <div class="col-sm-6">\n                <input type="text" class="form-control" name="numero" id="field_numero"\n                    ng-model="vm.poste.numero" ng-disabled="vm.isViewing"\n                    required/>\n            </div>\n        </div> --><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_numero" data-translate="consulatApp.typeAssociation.libelle">Libelle</label><div class="col-sm-6"><input type="text" class="form-control" name="libelle" id="field_numero" ng-model="vm.typeAssociation.libelle" ng-disabled="vm.isViewing" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/association/type-associations.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" title="Ajouter" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.typeAssociation.home.title">Liste des types d\'associations</u></span></div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'libelle\') " class="col-lg-3"><span data-translate="consulatApp.typeAssociation.libelle">Libelle</span> <span ng-if="vm.isCurrentColumn(\'libelle\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right"><span>Actions</span></th><th></th></tr></thead><tbody><tr ng-repeat="typeAssociation in vm.datas track by typeAssociation.id"><td title="{{typeAssociation.libelle}}">{{typeAssociation.libelle | characters:45}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,typeAssociation)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button><!--  <button type="submit" title="Supprimer"\n                                ng-click="vm.deleteItem($event,typeAssociation)"\n                                class="btn btn-danger btn-xs btn-round">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                </button> --></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/carte/carte-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.carte.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="consulatApp.carte.delete.question" translate-values="{id: \'{{vm.carte.id}}\'}">Are you sure you want to delete this Carte?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/carte/carte-detail.html','<div><h2><span data-translate="consulatApp.carte.detail.title">Carte</span> {{vm.carte.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="consulatApp.carte.nom">Nom</span></dt><dd><span>{{vm.carte.nom}}</span></dd><dt><span data-translate="consulatApp.carte.prenom">Prenom</span></dt><dd><span>{{vm.carte.prenom}}</span></dd><dt><span data-translate="consulatApp.carte.taille">Taille</span></dt><dd><span>{{vm.carte.taille}}</span></dd><dt><span data-translate="consulatApp.carte.sexe">Sexe</span></dt><dd><span>{{vm.carte.sexe}}</span></dd><dt><span data-translate="consulatApp.carte.metier">Metier</span></dt><dd><span>{{vm.carte.metier}}</span></dd><dt><span data-translate="consulatApp.carte.lieuNaissance">Lieu Naissance</span></dt><dd><span>{{vm.carte.lieuNaissance}}</span></dd><dt><span data-translate="consulatApp.carte.dateCreate">Date Create</span></dt><dd><span>{{vm.carte.dateCreate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="consulatApp.carte.dateExpr">Date Expr</span></dt><dd><span>{{vm.carte.dateExpr | date:\'mediumDate\'}}</span></dd><dt><span data-translate="consulatApp.carte.members">Members</span></dt><dd><a ui-sref="members-detail({id:vm.carte.membersId})">{{vm.carte.membersId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="carte-detail.edit({id:vm.carte.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/carte/carte-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCarteLabel" data-translate="consulatApp.carte.home.createOrEditLabel">Create or edit a Carte</h4></div><div class="modal-body"><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.carte.home.createOrEditLabel">Create or edit a Carte</legend><div class="row col-sm-12"></div><div class="row col-sm-4"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.carte.nom">Nom</label><div class="col-sm-6"><input required type="text" placeholder="nom de la personne" class="form-control" name="nom" id="field_nom" ng-model="vm.carte.nom"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_prenom" mf-required data-translate="consulatApp.carte.prenom">Prenom</label><div class="col-sm-6"><input required type="text" placeholder="prenom de la personne" class="form-control" name="prenom" id="field_prenom" ng-model="vm.carte.prenom"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_taille" mf-required data-translate="consulatApp.carte.taille">Taille</label><div class="col-sm-6"><input required type="text" placeholder="taille en cm" class="form-control" name="taille" id="field_prenom" ng-model="vm.carte.taille"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_libelle" mf-required data-translate="consulatApp.carte.sexe">Sexe</label><div class="col-sm-6"><select required placeholder="sexe" class="form-control" name="libelle" ng-model="vm.carte.sexe" id="field_libelle"><option value="MALE">HOMME</option><option value="FEMALE">FEMME</option></select></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" data-translate="consulatApp.carte.metier" for="field_metier">Metier</label><div class="col-sm-6"><input type="text" class="form-control" name="metier" id="field_metier" ng-disabled="vm.isViewing" ng-model="vm.carte.metier"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" data-translate="consulatApp.carte.lieuNaissance" for="field_lieuNaissance">Lieu Naissance</label><div class="col-sm-6"><input type="text" class="form-control" name="lieuNaissance" id="field_lieuNaissance" ng-disabled="vm.isViewing" ng-model="vm.carte.lieuNaissance"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" data-translate="consulatApp.carte.dateNaissance" for="field_dateNaissance">Date Naissance</label><div class="input-group col-sm-6"><input ng-disabled="vm.isViewing" id="field_dateNaissance" type="text" class="form-control" name="dateNaissance" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.carte.dateNaissance" is-open="vm.datePickerOpenStatus.dateNaissance"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateNaissance\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><br><div class="form-group" ngf-drop ngf-change="vm.setPhoto($file, vm.carte" ngf-pattern="\'image/*\'"><label class="control-label col-sm-3 ft16" for="field_photo" data-translate="consulatApp.carte.photo">Photo</label><div class="col-sm-6"><div><img data-ng-src="{{\'data:\' + vm.carte.photoContentType + \';base64,\' + vm.carte.photo}}" style="max-height: 100px" ng-if="vm.carte.photo" alt="carte image"><div ng-if="vm.carte.photo" class="help-block clearfix"><span class="pull-left">{{vm.carte.photoContentType}}, {{vm.byteSize(vm.carte.photo)}}</span></div><button ng-if="!vm.isViewing" type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPhoto($file, vm.carte)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="photo" id="field_photo" ng-model="vm.carte.photo"> <input type="hidden" class="form-control" name="photoContentType" id="field_photoContentType" ng-model="vm.carte.photoContentType"></div></div></div><div class="row col-sm-4"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_numero" mf-required data-translate="consulatApp.carte.numero">Nom</label><div class="col-sm-6"><input required type="text" class="form-control" name="numero" id="field_numero" ng-model="vm.carte.numero"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" data-translate="consulatApp.carte.statut" for="field_statut">Statut</label><div class="col-sm-6"><select required class="form-control" name="statut" ng-model="vm.carte.statut" id="field_statut" ng-disabled="vm.isViewing"><option value="">Statut</option><option value="ACTIVE">ACTIVE</option><option value="ANNULEE">ANNULEE</option><option value="EXPIREE">EXPIREE</option></select></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" data-translate="consulatApp.carte.dateCreate" for="field_dateCreate">Date Create</label><div class="input-group col-sm-6"><input ng-disabled="vm.isViewing" id="field_dateCreate" type="text" class="form-control" name="dateCreate" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.carte.dateCreate" is-open="vm.datePickerOpenStatus.dateCreate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateCreate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" data-translate="consulatApp.carte.dateExpr" for="field_dateExpr">Date Expr</label><div class="input-group col-sm-6"><input ng-disabled="vm.isViewing" id="field_dateExpr" type="text" class="form-control" name="dateExpr" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.carte.dateExpr" is-open="vm.datePickerOpenStatus.dateExpr"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateExpr\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" data-translate="consulatApp.carte.dateAnnulation" for="field_dateAnnulation">Date Expr</label><div class="input-group col-sm-6"><input ng-disabled="vm.isViewing" id="field_dateAnnulation" type="text" class="form-control" name="dateAnnulation" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.carte.dateAnnulation" is-open="vm.datePickerOpenStatus.dateAnnulation"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateAnnulation\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" data-translate="consulatApp.carte.motifAnnulation" for="field_motifAnnulation">motifAnnulation</label><div class="col-sm-6"><input type="text" class="form-control" name="motifAnnulation" id="field_motifAnnulation" ng-disabled="vm.isViewing" ng-model="vm.carte.motifAnnulation"></div></div></div><div class="row col-sm-4"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_telephone" data-translate="consulatApp.adresses.telephone">Telephone</label><div class="col-sm-6"><input disabled="disabled" required type="text" class="form-control" name="telephone" id="field_telephone" ng-model="vm.adresse.telephone"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_zipecode">Zip Code</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="zipcode" id="field_zipecode" ng-model="vm.adresse.zipCode"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_mail">Mail</label><div class="col-sm-6"><input disabled="disabled" type="email" class="form-control" name="mail" id="field_mail" ng-model="vm.adresse.mail"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" data-translate="consulatApp.members.adresses">Adresse</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.adresse.rue"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_etat" data-translate="consulatApp.adresses.states">Etat</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_etat" ng-model="vm.adresse.etat"></div></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_ville" data-translate="consulatApp.adresses.city">Ville</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_ville" ng-model="vm.adresse.ville"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_ice">Personne a prevenir:</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="ice" id="field_ice" ng-model="vm.carte.ice"></div></div><br><div class="form-group" ngf-drop ngf-change="vm.setPhoto($file, vm.carte" ngf-pattern="\'image/*\'"><label class="control-label col-sm-3 ft16" for="field_photo" data-translate="consulatApp.carte.signature">Signature</label><div class="col-sm-6"><div><img data-ng-src="{{\'data:\' + \'image/jpg\' + \';base64,\' + vm.carte.signature}}" style="max-height: 100px" ng-if="vm.carte.signature" alt="carte signature"><div ng-if="vm.carte.signature" class="help-block clearfix"><span class="pull-left">{{vm.byteSize(vm.carte.signature)}}</span></div><button ng-if="!vm.isViewing" type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPhoto($file, vm.carte)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="photo" id="field_signature" ng-model="vm.carte.signature"></div></div></div></fieldset></div><div class="modal-footer"><div ng-if="vm.isViewing"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div ng-if="!vm.isViewing"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/carte/cartes.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="row" ng-if="vm.filtrer"><div class="form-group col-sm-2"><input type="text" placeholder="Nom" required class="form-control" id="field_nom" ng-model="vm.itemSearch.nom" name="nom"> <input type="text" placeholder="Prenom" required class="form-control" id="field_prenom" ng-model="vm.itemSearch.prenom" name="prenom"></div><div class="form-group col-sm-2"><input type="text" placeholder="Numero de la carte" required class="form-control" id="field_numero" ng-model="vm.itemSearch.numero" name="numero"> <input type="text" placeholder="Metier" required class="form-control" id="field_metier" ng-model="vm.itemSearch.metier" name="metier"></div><div class="form-group col-sm-4"><div class="col-sm-4"><button class="btn btn-warnig btn-md" ng-click="vm.initFiltre()"><span class="glyphicon glyphicon-search" data-translate="entity.action.cancel">Annuler</span></button></div><div class="col-sm-4"><button class="btn btn-info btn-md" ng-disabled="vm.dateFinEstAvantDateDebut()" ng-click="vm.init()"><span class="glyphicon glyphicon-search" data-translate="global.menu.entities.filtrer">Filtrer</span></button></div></div></div><div class="mb5"></div></div><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><div class="form-group" ng-if="!vm.filtrer"><div class="pull-right"><button class="btn btn-info btn-md" ng-click="vm.filtrer=true"><span class="glyphicon glyphicon-search" data-translate="global.menu.entities.filtrer">Filtrer</span></button></div></div><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div><!--   <div style="text-align: center; font-weight: bold; margin-top: 6px; margin-bottom: 3px; text-decoration: underline;">\n                <h3>\n                   <span data-translate="consulatApp.members.registers">Nombre d\'inscrits</span> : {{vm.totalItems}}\n                </h3>\n            </div> --></div></div><div class="row mt-3 bg-white"><div class="col-sm-10 col-sm-offset-1"><div class="grid-container"><div ng-repeat="member in vm.datas track by member.id"><div class="card mb-3" style="width: 250px"><div class="row no-gutters"><div class="col-md-5"><img ng-if="member.photo" data-ng-src="{{\'data:\' + member.photoContentType + \';base64,\' + member.photo}}" style="max-height: 100px" alt="member image"> <svg ng-if="!member.photo" class="bd-placeholder-img" width="100" height="100" xmlns="http://www.w3.org/2000/svg" aria-label="Placeholder: Image" preserveAspectRatio="xMidYMid slice" role="img"><title>Placeholder</title><rect width="100%" height="100%" fill="#868e96"/><text x="50%" y="50%" fill="#dee2e6" dy=".3em">Image</text></svg></div><div class="col-md-7"><div class="card-body"><h5 class="card-title"><span style="font-weight: bold; margin-bottom: 2px">ID: {{member.numero}}</span></h5><h5 class="card-title">{{member.nom }} {{member.prenom | characters:30}}</h5><p class="card-text">{{member.villeResidence | characters:30}}, {{member.etatResidence}}</p><p class="card-text"></p><div class="btn-group flex-btn-group-container mt5"><!--     <button type="submit" title="View"\n                                           ng-click="vm.detailItem($event,member)"\n                                           class="btn btn-primary btn-xs btn-round">\n                                           <span class="glyphicon glyphicon-eye-open"></span>\n                                           </button>\n                                           <button ng-if=\'vm.user.profilId!=null\' type="submit" title="modify"\n                                           ng-click="vm.editItem($event,member)"\n                                           class="btn btn-sucess btn-xs btn-round">\n                                           <span class="glyphicon glyphicon-pencil"></span>\n                                           </button> --> <button ng-if="vm.user.profilId!=null" type="submit" title="print card" ng-click="vm.etatCarte(member.id)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-book"></span></button></div><p></p></div></div></div></div><br></div></div></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div><footer class="navbar-fixed-bottom text-center"></footer>');
$templateCache.put('app/entities/city/cities.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" title="Ajouter" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15) " data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.city.home.title">Liste des villes</u></span></div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'code\') " class="col-lg-3"><span>Code</span> <span ng-if="vm.isCurrentColumn(\'code\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'intitule\') " class="col-lg-3"><span data-translate="consulatApp.city.libelle">Intitule</span> <span ng-if="vm.isCurrentColumn(\'libelle\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'statesLibelle\') " class="col-lg-3"><span data-translate="consulatApp.city.states">States</span> <span ng-if="vm.isCurrentColumn(\'statesLibelle\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'countriesLibelle\') " class="col-lg-3"><span data-translate="consulatApp.city.countries">Countries</span> <span ng-if="vm.isCurrentColumn(\'countriesLibelle\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right"><span>Actions</span></th><th></th></tr></thead><tbody><tr ng-repeat="city in vm.datas track by city.id"><td title="{{city.code}}">{{city.code | characters:45}}</td><td title="{{city.intitule}}">{{city.libelle | characters:45}}</td><td title="{{city.statesLibelle}}">{{city.statesLibelle | characters:45}}</td><td title="{{city.countriesLibelle}}">{{city.countriesLibelle | characters:45}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,city)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" title="Supprimer" ng-click="vm.deleteItem($event,city)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/city/city-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.city.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this City?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/city/city-detail.html','<div><h2><span>City</span> {{vm.city.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Code</span></dt><dd><span>{{vm.city.code}}</span></dd><dt><span>Libelle</span></dt><dd><span>{{vm.city.libelle}}</span></dd><dt><span>Countries</span></dt><dd><a ui-sref="country-detail({id:vm.city.countriesId})">{{vm.city.countriesLibelle}}</a></dd><dt><span>States</span></dt><dd><a ui-sref="states-detail({id:vm.city.statesId})">{{vm.city.statesLibelle}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="city-detail.edit({id:vm.city.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/city/city-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCityLabel" data-translate="consulatApp.city.home.createLabel">Ajouter une ville</h4></div><div class="modal-body"><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_numero">Code</label><div class="col-sm-6"><input type="text" class="form-control" name="numero" id="field_numero" ng-model="vm.city.code" ng-disabled="vm.isViewing" required></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_intitule" data-translate="consulatApp.city.libelle">Libelle</label><div class="col-sm-6"><input type="text" class="form-control" name="intitule" id="field_intitule" ng-model="vm.city.libelle" ng-disabled="vm.isViewing" required></div></div><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="pays" data-translate="consulatApp.city.countries">Pays</label><div class="col-sm-6"><select disabled="disabled" placeholder="pays" required class="form-control" id="field_etat" name="etat" ng-model="vm.city.countriesId" ng-options="country.id as country.libele for country in vm.countries"><option value=""></option></select></div><i title="S\xE9lectionnez la ville" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.city.countriesId" j-list="vm.countries" j-columns="vm.countryColumns" j-event-name="onLoadCountries">Choisir...</i></div><div class="form-group has-feedback" ng-if="vm.states.length > 0"><label mf-required class="control-label col-sm-3 ft16" for="pays" data-translate="consulatApp.city.states">States</label><div class="col-sm-6"><select disabled="disabled" placeholder="states" required class="form-control" id="field_states" name="etat" ng-model="vm.city.statesId" ng-options="states.id as states.libelle for states in vm.states"><option value=""></option></select></div><i title="S\xE9lectionnez un Etat" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.city.statesId" j-list="vm.states" j-columns="vm.statesColumns" j-event-name="onLoadStates">Choisir...</i></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/consulat/adresse.html','<fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend mf-required data-translate="consulatApp.adresses.home.title">Contacts Consulat</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label mf-required class="control-label col-sm-3 ft16" for="field_address">Adresse</label><div class="col-sm-6"><input required type="text" placeholder="ex: 100, Red Fox Avenue" class="form-control" name="adresse" id="field_address" ng-model="vm.consulat.adresseDTO.rue"><div ng-show="editForm.adresse.$dirty && editForm.adresse.$invalid"><p class="help-block" ng-show="editForm.adresse.$error.required">consulat name is required.</p></div></div></div><br><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="field_etat" data-translate="consulatApp.adresses.states">Etat</label><div class="col-sm-6"><select disabled="disabled" placeholder="Etat" required class="form-control" id="field_etat" name="etat" ng-model="vm.consulat.adresseDTO.etatId" ng-options="etat.id as etat.libelle for etat in vm.etats"><option value=""></option></select></div><i title="S\xE9lectionnez la ville" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="true" j-model="vm.consulat.adresseDTO.etatId" j-list="vm.etats" j-columns="vm.etatColumns" j-event-name="onLoadEtats">Choisir...</i></div><br><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="field_ville" data-translate="consulatApp.adresses.city">Ville</label><div class="col-sm-6"><select disabled="disabled" placeholder="Ville" required class="form-control" id="field_ville" name="ville" ng-model="vm.consulat.adresseDTO.cityId" ng-options="ville.id as ville.libelle for ville in vm.villeAdresse"><option value=""></option></select></div><i title="S\xE9lectionnez la ville" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="false" j-model="vm.consulat.adresseDTO.cityId" j-list="vm.villeAdresse" j-columns="vm.statesVilleColumns" j-event-name="onLoadStatesVille">Choisir...</i></div><br></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_telephone" mf-required data-translate="consulatApp.adresses.telephone">Telephone</label><div class="col-sm-6"><input required type="text" placeholder="phone number" class="form-control" name="telephone" id="field_telephone" ng-model="vm.consulat.adresseDTO.telephone"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_zipCode">Zip Code</label><div class="col-sm-6"><input type="text" class="form-control" placeholder="zip code" name="zipCode" id="field_zipCode" ng-model="vm.consulat.adresseDTO.zipCode"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_mail">Mail</label><div class="col-sm-6"><input type="email" placeholder="adresse mail" class="form-control" id="field_mail" name="mail" ng-model="vm.consulat.adresseDTO.mail" ng-minlength="5" ng-maxlength="100"><div ng-show="editForm.mail.$dirty && editForm.mail.$invalid"><p class="help-block text-danger font-bold" ng-show="editForm.mail.$error.email">Your email is invalid.</p><p class="help-block text-danger font-bold" ng-show="editForm.mail.$error.minlength">minimum required of 5 characters.</p><p class="help-block text-danger font-bold" ng-show="editForm.mail.$error.maxlength">maximum required of 100 characters.</p></div></div></div></div></fieldset>');
$templateCache.put('app/entities/consulat/consulat-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.consulat.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Consulat?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/consulat/consulat-detail.html','<div><h2><span>Consulat</span> {{vm.consulat.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Code</span></dt><dd><span>{{vm.consulat.code}}</span></dd><dt><span>Nom</span></dt><dd><span>{{vm.consulat.nom}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.consulat.description}}</span></dd><dt><span>Logo Bf</span></dt><dd><div ng-if="vm.consulat.logoBf"><a ng-click="vm.openFile(vm.consulat.logoBfContentType, vm.consulat.logoBf)"><img data-ng-src="{{\'data:\' + vm.consulat.logoBfContentType + \';base64,\' + vm.consulat.logoBf}}" style="max-width: 100%" alt="consulat image"> </a>{{vm.consulat.logoBfContentType}}, {{vm.byteSize(vm.consulat.logoBf)}}</div></dd><dt><span>Logo Usa</span></dt><dd><div ng-if="vm.consulat.logoUsa"><a ng-click="vm.openFile(vm.consulat.logoUsaContentType, vm.consulat.logoUsa)"><img data-ng-src="{{\'data:\' + vm.consulat.logoUsaContentType + \';base64,\' + vm.consulat.logoUsa}}" style="max-width: 100%" alt="consulat image"> </a>{{vm.consulat.logoUsaContentType}}, {{vm.byteSize(vm.consulat.logoUsa)}}</div></dd><dt><span>Armoirie</span></dt><dd><div ng-if="vm.consulat.armoirie"><a ng-click="vm.openFile(vm.consulat.armoirieContentType, vm.consulat.armoirie)"><img data-ng-src="{{\'data:\' + vm.consulat.armoirieContentType + \';base64,\' + vm.consulat.armoirie}}" style="max-width: 100%" alt="consulat image"> </a>{{vm.consulat.armoirieContentType}}, {{vm.byteSize(vm.consulat.armoirie)}}</div></dd><dt><span>User Extra</span></dt><dd><a ui-sref="user-extra-detail({id:vm.consulat.userExtraId})">{{vm.consulat.userExtraId}}</a></dd><dt><span>Adresses</span></dt><dd><a ui-sref="adresses-detail({id:vm.consulat.adressesId})">{{vm.consulat.adressesId}}</a></dd><dt><span>Country</span></dt><dd><a ui-sref="country-detail({id:vm.consulat.countryId})">{{vm.consulat.countryId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="consulat-detail.edit({id:vm.consulat.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/consulat/consulat-dialog.html','<form name="editForm" role="form" novalidate class="container-fluid form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="consulat" data-translate="consulatApp.consulat.home.createLabel">Ajouter un consulat</h4></div><div class="modal-body"><div class="box-tab justified" id="rootwizard"><ul class="nav nav-tabs"><li ng-repeat="step in vm.steps" ng-class="{active: $index==vm.getCurrentStepIndex()}"><a href="javascript:void(0)" ng-click="vm.goToStep($index,editForm)">{{step}}</a></li></ul><div class="tab-pane" ng-if="vm.showOnglet(\'IDENTIFICATION\',0)"><div ng-include="\'app/entities/consulat/identification.html\'" scope="" onload=""></div></div><div class="tab-pane" ng-if="vm.showOnglet(\'ADRESSE\',1)"><div ng-include="\'app/entities/consulat/adresse.html\'" scope="" onload=""></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span ng-hide="vm.isViewing" data-translate="entity.action.cancel">Cancel</span> <span ng-show="vm.isViewing">Fermer</span></button> <button class="btn btn-primary" ng-show="vm.hasPreviousStep()" ng-click="vm.decrementStep()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; <span>Pr\xE9cedent</span></button> <button class="btn btn-primary" ng-show="vm.hasNextStep()" ng-disabled="editForm.$invalid " ng-click="vm.incrementStep()"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp; <span>Suivant</span></button> <button type="submit" class="btn btn-success" ng-show="!vm.hasNextStep()" ng-disabled="editForm.$invalid || vm.isSaving" data-dismiss="modal" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp; <span>Sauvegarder</span></button></div></form>');
$templateCache.put('app/entities/consulat/consulats.html','<div class="container"><div class="row mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.consulat.home.title">Liste des consulats</u></span></div></div><div class="row"><div class="col-sm-12"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'code\') "><span>Code</span> <span ng-if="vm.isCurrentColumn(\'code\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'nom\') "><span data-translate="consulatApp.consulat.nom">Nom</span> <span ng-if="vm.isCurrentColumn(\'nom\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'logoBf\') "><span data-translate="consulatApp.consulat.logoBf">Image droit</span> <span ng-if="vm.isCurrentColumn(\'logoBf\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'armoirie\') "><span data-translate="consulatApp.consulat.armoirie">Image bas</span> <span ng-if="vm.isCurrentColumn(\'armoirie\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th></th></tr></thead><tbody><tr ng-repeat="consulat in vm.datas track by consulat.id"><td>{{consulat.code}}</td><td>{{consulat.nom}}</td><td><a ng-if="consulat.logoBf" ng-click="vm.openFile(consulat.logoBfContentType, consulat.logoBf)"><img data-ng-src="{{\'data:\' + consulat.logoBfContentType + \';base64,\' + consulat.logoBf}}" style="max-height: 30px" alt="consulat image"> </a><span ng-if="consulat.logoBf">{{consulat.logoBfContentType}}, {{vm.byteSize(consulat.logoBf)}}</span></td><td><a ng-if="consulat.armoirie" ng-click="vm.openFile(consulat.armoirieContentType, consulat.armoirie)"><img data-ng-src="{{\'data:\' + consulat.armoirieContentType + \';base64,\' + consulat.armoirie}}" style="max-height: 30px" alt="consulat image"> </a><span ng-if="consulat.armoirie">{{consulat.armoirieContentType}}, {{vm.byteSize(consulat.armoirie)}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><!--   <button type="submit"\n                            ng-click="vm.detailItem($event,consulat)"\n                            class="btn btn-primary btn-xs btn-round">\n                            <span class="glyphicon glyphicon-eye-open"></span>\n                            </button> --> <button type="submit" ng-click="vm.editItem($event,consulat)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/consulat/identification.html','<fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.consulat.home.infoConsulat">informations sur le consulat et de la carte</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.consulat.nom">Nom</label><div class="col-sm-6"><input required type="text" placeholder="consulate name" class="form-control" name="nom" id="field_nom" ng-model="vm.consulat.nom"><div ng-show="editForm.nom.$dirty && editForm.nom.$invalid"><p class="help-block" ng-show="editForm.nom.$error.required">consulat name is required.</p></div></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_description">Description</label><div class="col-sm-6"><textarea type="text" placeholder="description" class="form-control" name="description" id="field_description" ng-model="vm.consulat.description" ng-maxlength="1000"></textarea></div></div><br><div class="form-group" ngf-drop ngf-change="vm.setLogoBf($file, vm.consulat" ngf-pattern="\'image/*\'"><label class="control-label col-sm-3 ft16" for="field_logoBf" data-translate="consulatApp.consulat.logoBf">Image en haut \xE0 droite recto</label><div class="col-sm-6"><div><img data-ng-src="{{\'data:\' + vm.consulat.logoContentType + \';base64,\' + vm.consulat.logoBf}}" style="max-height: 100px" ng-if="vm.consulat.logoBf" alt="consulat image"><div ng-if="vm.consulat.logoBf" class="help-block clearfix"><span class="pull-left">{{vm.consulat.logoBfContentType}}, {{vm.byteSize(vm.consulat.logoBf)}}</span> <button type="button" ng-click="vm.consulat.logoBf=null;vm.consulat.logoBfContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setLogoBf($file, vm.consulat)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="logoBf" id="field_logoBf" ng-model="vm.consulat.logoBf"> <input type="hidden" class="form-control" name="logoBfContentType" id="field_logoBfContentType" ng-model="vm.consulat.logoBfContentType"></div></div><br><div class="form-group" ngf-drop ngf-change="vm.setArmoirie($file, vm.consulat" ngf-pattern="\'image/*\'"><label class="control-label col-sm-3 ft16" for="field_armoirie" data-translate="consulatApp.consulat.armoirie">Image en bas recto</label><div class="col-sm-6"><div><img data-ng-src="{{\'data:\' + vm.consulat.armoirieContentType + \';base64,\' + vm.consulat.armoirie}}" style="max-height: 100px" ng-if="vm.consulat.armoirie" alt="consulat image"><div ng-if="vm.consulat.armoirie" class="help-block clearfix"><span class="pull-left">{{vm.consulat.armoirieContentType}}, {{vm.byteSize(vm.consulat.armoirie)}}</span> <button type="button" ng-click="vm.consulat.armoirie=null;vm.consulat.armoirieContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setArmoirie($file, vm.consulat)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="armoirie" id="field_armoirie" ng-model="vm.consulat.armoirie"> <input type="hidden" class="form-control" name="armoirieContentType" id="field_armoirieContentType" ng-model="vm.consulat.armoirieContentType"></div></div><br><div class="form-group" ngf-drop ngf-change="vm.setLogoUsa($file, vm.consulat" ngf-pattern="\'image/*\'"><label class="control-label col-sm-3 ft16" for="field_imageVerso" data-translate="consulatApp.consulat.imageVerso">Image au Verso</label><div class="col-sm-6"><div><img data-ng-src="{{\'data:\' + vm.consulat.imageVersoContentType + \';base64,\' + vm.consulat.imageVerso}}" style="max-height: 100px" ng-if="vm.consulat.imageVerso" alt="consulat image"><div ng-if="vm.consulat.imageVerso" class="help-block clearfix"><span class="pull-left">{{vm.consulat.imageVersoContentType}}, {{vm.byteSize(vm.consulat.imageVerso)}}</span> <button type="button" ng-click="vm.consulat.imageVerso=null;vm.consulat.imageVersoContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setLogoUsa($file, vm.consulat)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="imageVerso" id="field_imageVerso" ng-model="vm.consulat.imageVerso"> <input type="hidden" class="form-control" name="imageVersoContentType" id="field_imageVersoContentType" ng-model="vm.consulat.imageVersoContentType"></div></div><br><div class="form-group" ngf-drop ngf-change="vm.setSignature($file, vm.consulat" ngf-pattern="\'image/*\'"><label class="control-label col-sm-3 ft16" for="field_armoirie" data-translate="consulatApp.consulat.signature">Signature de l\'autorit\xE9</label><div class="col-sm-6"><div><img data-ng-src="{{\'data:\' + vm.consulat.signatureContentType + \';base64,\' + vm.consulat.signature}}" style="max-height: 100px" ng-if="vm.consulat.signature" alt="consulat image"><div ng-if="vm.consulat.signature" class="help-block clearfix"><span class="pull-left">{{vm.consulat.signatureContentType}}, {{vm.byteSize(vm.consulat.signature)}}</span> <button type="button" ng-click="vm.consulat.signature=null;vm.consulat.signatureContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setSignature($file, vm.consulat)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="signature" id="field_signature" ng-model="vm.consulat.signature"> <input type="hidden" class="form-control" name="signatureContentType" id="field_signatureContentType" ng-model="vm.consulat.signatureContentType"></div></div></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_entete" mf-required data-translate="consulatApp.consulat.enTete">En_t\xEAte carte</label><div class="col-sm-6"><input required type="text" class="form-control" name="entete" id="field_entete" ng-model="vm.consulat.enTete" maxlength="50"><div ng-show="editForm.entete.$dirty && editForm.entete.$invalid"><p class="help-block" ng-show="editForm.entete.$error.required">header is required.</p></div></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_titre" mf-required data-translate="consulatApp.consulat.titre">Nom de la carte</label><div class="col-sm-6"><input required type="text" class="form-control" name="cardName" id="field_titre" ng-model="vm.consulat.titre" maxlength="70"><div ng-show="editForm.cardName.$dirty && editForm.cardName.$invalid"><p class="help-block" ng-show="editForm.cardName.$error.required">card name is required.</p></div></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_libelleAdresse" mf-required data-translate="consulatApp.consulat.libelleAdresse">Libelle Adresse</label><div class="col-sm-6"><input required type="text" class="form-control" name="libelleAdresse" id="field_libelleAdresse" ng-model="vm.consulat.libelleAdresse" maxlength="10"><div ng-show="editForm.libelleAdresse.$dirty && editForm.libelleAdresse.$invalid"><p class="help-block" ng-show="editForm.libelleAdresse.$error.required">adress name is required.</p></div></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_codeCarte" mf-required data-translate="consulatApp.consulat.codificationCarte">Pr\xE9fixe des no</label><div class="col-sm-6"><input required type="text" class="form-control" name="codeCarte" id="field_codeCarte" ng-model="vm.consulat.codificationCarte" maxlength="50"><div ng-show="editForm.codeCarte.$dirty && editForm.codeCarte.$invalid"><p class="help-block" ng-show="editForm.codeCarte.$error.required">prefix no is required.</p></div></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_texteVerso" data-translate="consulatApp.consulat.texteVerso">Text au verso</label><div class="col-sm-6"><textarea type="text" class="form-control" name="texteVerso" id="field_texteVerso" ng-model="vm.consulat.texteVerso" ng-maxlength="1000"></textarea></div></div><br><div class="form-group"><label mf-required class="control-label col-sm-3 ft16" for="field_codificationCarte" data-translate="consulatApp.consulat.validite">Validite de la carte</label><div class="col-sm-6"><input required type="number" class="form-control" name="validite" id="field_validite" ng-model="vm.consulat.validideCarte"><div ng-show="editForm.validideCarte.$dirty && editForm.validideCarte.$invalid"><p class="help-block" ng-show="editForm.validideCarte.$error.required">prefix no is required.</p></div></div></div><br><!--   <div class="form-group">\n        <label mf-required class="control-label col-sm-3 ft16" for="field_validite" data-translate="consulatApp.consulat.codificationCarte">codification de la carte</label>\n        <div class="col-sm-6">\n            <input required  type="text" class="form-control" name="codificationCarte" id="field_codificationCarte" ng-model="vm.consulat.codificationCarte" />\n            <div ng-show="editForm.codificationCarte.$dirty && editForm.codificationCarte.$invalid">\n                <p class="help-block"\n                       ng-show="editForm.codificationCarte.$error.required">\n                    prefix no is required.\n                </p>\n            </div>\n        </div>\n\n    </div> --></div></fieldset>');
$templateCache.put('app/entities/country/countries.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" title="Ajouter" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.country.home.title">Liste des Pays</u></span></div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'code\') " class="col-lg-3"><span>Code</span> <span ng-if="vm.isCurrentColumn(\'code\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'libele\') " class="col-lg-3"><span data-translate="consulatApp.country.libele">Libelle</span> <span ng-if="vm.isCurrentColumn(\'libell\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right"><span>Actions</span></th><th></th></tr></thead><tbody><tr ng-repeat="country in vm.datas track by country.id"><td title="{{country.code}}">{{country.code | characters:45}}</td><td title="{{country.libele}}">{{country.libele | characters:45}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,country)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" title="Supprimer" ng-click="vm.deleteItem($event,country)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/country/country-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.country.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Country?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/country/country-detail.html','<div><h2><span>Country</span> {{vm.country.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Code</span></dt><dd><span>{{vm.country.code}}</span></dd><dt><span>Libele</span></dt><dd><span>{{vm.country.libele}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="country-detail.edit({id:vm.country.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/country/country-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Ajouter un pays</h4></div><div class="modal-body"><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_intitule" data-translate="consulatApp.country.libele">Libelle</label><div class="col-sm-6"><input type="text" class="form-control" name="intitule" id="field_intitule" ng-model="vm.country.libele" ng-disabled="vm.isViewing" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/country-id-doc/country-id-doc-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.countryIdDoc.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Country Id Doc?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/country-id-doc/country-id-doc-detail.html','<div><h2><span>Country Id Doc</span> {{vm.countryIdDoc.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Numero</span></dt><dd><span>{{vm.countryIdDoc.numero}}</span></dd><dt><span>Autorite</span></dt><dd><span>{{vm.countryIdDoc.autorite}}</span></dd><dt><span>Date Delivr</span></dt><dd><span>{{vm.countryIdDoc.dateDelivr | date:\'mediumDate\'}}</span></dd><dt><span>Date Expr</span></dt><dd><span>{{vm.countryIdDoc.dateExpr | date:\'mediumDate\'}}</span></dd><dt><span>Etat</span></dt><dd><span>{{vm.countryIdDoc.etat}}</span></dd><dt><span>Ville</span></dt><dd><span>{{vm.countryIdDoc.ville}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="country-id-doc-detail.edit({id:vm.countryIdDoc.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/country-id-doc/country-id-doc-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCountryIdDocLabel">Create or edit a Country Id Doc</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.countryIdDoc.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.countryIdDoc.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_numero">Numero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-model="vm.countryIdDoc.numero" required><div ng-show="editForm.numero.$invalid"><p class="help-block" ng-show="editForm.numero.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_autorite">Autorite</label><input type="text" class="form-control" name="autorite" id="field_autorite" ng-model="vm.countryIdDoc.autorite"></div><div class="form-group"><label class="control-label" for="field_dateDelivr">Date de d\xE9livrance</label><div class="input-group"><input id="field_dateDelivr" type="text" class="form-control" name="dateDelivr" uib-datepicker-popup="{{dateformat}}" ng-model="vm.countryIdDoc.dateDelivr" is-open="vm.datePickerOpenStatus.dateDelivr"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateDelivr\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_dateExpr">Date d\'expiration</label><div class="input-group"><input id="field_dateExpr" type="text" class="form-control" name="dateExpr" uib-datepicker-popup="{{dateformat}}" ng-model="vm.countryIdDoc.dateExpr" is-open="vm.datePickerOpenStatus.dateExpr"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateExpr\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_etat">Etat</label><input type="text" class="form-control" name="etat" id="field_etat" ng-model="vm.countryIdDoc.etat"></div><div class="form-group"><label class="control-label" for="field_ville">Ville</label><input type="text" class="form-control" name="ville" id="field_ville" ng-model="vm.countryIdDoc.ville"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/country-id-doc/country-id-docs.html','<div><h2>Country Id Docs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="country-id-doc.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Country Id Doc</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="numero"><span>Numero</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="autorite"><span>Autorite</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateDelivr"><span>Date Delivr</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateExpr"><span>Date Expr</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="etat"><span>Etat</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ville"><span>Ville</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="countryIdDoc in vm.countryIdDocs track by countryIdDoc.id"><td><a ui-sref="country-id-doc-detail({id:countryIdDoc.id})">{{countryIdDoc.id}}</a></td><td>{{countryIdDoc.numero}}</td><td>{{countryIdDoc.autorite}}</td><td>{{countryIdDoc.dateDelivr | date:\'mediumDate\'}}</td><td>{{countryIdDoc.dateExpr | date:\'mediumDate\'}}</td><td>{{countryIdDoc.etat}}</td><td>{{countryIdDoc.ville}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="country-id-doc-detail({id:countryIdDoc.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="country-id-doc.edit({id:countryIdDoc.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="country-id-doc.delete({id:countryIdDoc.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/document-legal/document-legal-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.documentLegal.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Document Legal?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/document-legal/document-legal-detail.html','<div><h2><span>Document Legal</span> {{vm.documentLegal.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Numero</span></dt><dd><span>{{vm.documentLegal.numero}}</span></dd><dt><span>Date Expr</span></dt><dd><span>{{vm.documentLegal.dateExpr | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="document-legal-detail.edit({id:vm.documentLegal.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/document-legal/document-legal-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCityLabel" data-translate="consulatApp.documentLegal.home.createLabel">Ajouter un type document</h4></div><div class="modal-body"><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="pays" data-translate="consulatApp.documentLegal.country">Pays</label><div class="col-sm-6"><select disabled="disabled" placeholder="pays" required class="form-control" id="field_etat" name="etat" ng-model="vm.documentLegal.countryId" ng-options="country.id as country.libele for country in vm.countries"><option value=""></option></select></div><i title="S\xE9lectionnez la ville" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.documentLegal.countryId" j-list="vm.countries" j-columns="vm.countryColumns" j-event-name="onLoadCountriess">Choisir...</i></div><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_numero" data-translate="consulatApp.documentLegal.libelle">Libelle</label><div class="col-sm-6"><input type="text" class="form-control" name="libelle" id="field_numero" ng-model="vm.documentLegal.libelle" ng-disabled="vm.isViewing" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/document-legal/document-legals.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" title="Ajouter" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} \xE9l\xE9ments par page <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.documentLegal.home.title">Liste des types de documents</u></span></div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'numero\') " class="col-lg-3"><span>Code</span> <span ng-if="vm.isCurrentColumn(\'numero\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'libelle\') " class="col-lg-3"><span data-translate="consulatApp.documentLegal.libelle">Libelle</span> <span ng-if="vm.isCurrentColumn(\'libelle\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'country\') " class="col-lg-3"><span data-translate="consulatApp.documentLegal.country">Pays</span> <span ng-if="vm.isCurrentColumn(\'country\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right"><span>Actions</span></th><th></th></tr></thead><tbody><tr ng-repeat="documentLegal in vm.datas track by documentLegal.id"><td title="{{documentLegal.numero}}">{{documentLegal.numero | characters:45}}</td><td title="{{documentLegal.libelle}}">{{documentLegal.libelle | characters:45}}</td><td title="{{documentLegal.countryNom}}">{{documentLegal.countryNom | characters:45}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,documentLegal)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" title="Supprimer" ng-click="vm.deleteItem($event,documentLegal)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/info-association/info-association-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.infoAssociation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Info Association?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/info-association/info-association-detail.html','<div><h2><span>Info Association</span> {{vm.infoAssociation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Date Entree</span></dt><dd><span>{{vm.infoAssociation.dateEntree | date:\'mediumDate\'}}</span></dd><dt><span>Date Sortie</span></dt><dd><span>{{vm.infoAssociation.dateSortie | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="info-association-detail.edit({id:vm.infoAssociation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/info-association/info-association-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInfoAssociationLabel">Create or edit a Info Association</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.infoAssociation.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.infoAssociation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_dateEntree">Date Entree</label><div class="input-group"><input id="field_dateEntree" type="text" class="form-control" name="dateEntree" uib-datepicker-popup="{{dateformat}}" ng-model="vm.infoAssociation.dateEntree" is-open="vm.datePickerOpenStatus.dateEntree"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateEntree\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_dateSortie">Date Sortie</label><div class="input-group"><input id="field_dateSortie" type="text" class="form-control" name="dateSortie" uib-datepicker-popup="{{dateformat}}" ng-model="vm.infoAssociation.dateSortie" is-open="vm.datePickerOpenStatus.dateSortie"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateSortie\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/info-association/info-associations.html','<div><h2>Info Associations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="info-association.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Info Association</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateEntree"><span>Date Entree</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateSortie"><span>Date Sortie</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="infoAssociation in vm.infoAssociations track by infoAssociation.id"><td><a ui-sref="info-association-detail({id:infoAssociation.id})">{{infoAssociation.id}}</a></td><td>{{infoAssociation.dateEntree | date:\'mediumDate\'}}</td><td>{{infoAssociation.dateSortie | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="info-association-detail({id:infoAssociation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="info-association.edit({id:infoAssociation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="info-association.delete({id:infoAssociation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/info-parents/info-parents-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.infoParents.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Info Parents?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/info-parents/info-parents-detail.html','<div><h2><span>Info Parents</span> {{vm.infoParents.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Numero</span></dt><dd><span>{{vm.infoParents.numero}}</span></dd><dt><span>Nom Pere</span></dt><dd><span>{{vm.infoParents.nomPere}}</span></dd><dt><span>Prenom Pere</span></dt><dd><span>{{vm.infoParents.prenomPere}}</span></dd><dt><span>Nom Mere</span></dt><dd><span>{{vm.infoParents.nomMere}}</span></dd><dt><span>Prenom Mere</span></dt><dd><span>{{vm.infoParents.prenomMere}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="info-parents-detail.edit({id:vm.infoParents.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/info-parents/info-parents-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInfoParentsLabel">Create or edit a Info Parents</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.infoParents.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.infoParents.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_numero">Numero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-model="vm.infoParents.numero" required><div ng-show="editForm.numero.$invalid"><p class="help-block" ng-show="editForm.numero.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_nomPere">Nom Pere</label><input type="text" class="form-control" name="nomPere" id="field_nomPere" ng-model="vm.infoParents.nomPere"></div><div class="form-group"><label class="control-label" for="field_prenomPere">Prenom Pere</label><input type="text" class="form-control" name="prenomPere" id="field_prenomPere" ng-model="vm.infoParents.prenomPere"></div><div class="form-group"><label class="control-label" for="field_nomMere">Nom Mere</label><input type="text" class="form-control" name="nomMere" id="field_nomMere" ng-model="vm.infoParents.nomMere"></div><div class="form-group"><label class="control-label" for="field_prenomMere">Prenom Mere</label><input type="text" class="form-control" name="prenomMere" id="field_prenomMere" ng-model="vm.infoParents.prenomMere"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/info-parents/info-parents.html','<div><h2>Info Parents</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="info-parents.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Info Parents</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="numero"><span>Numero</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomPere"><span>Nom Pere</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="prenomPere"><span>Prenom Pere</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nomMere"><span>Nom Mere</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="prenomMere"><span>Prenom Mere</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="infoParents in vm.infoParents track by infoParents.id"><td><a ui-sref="info-parents-detail({id:infoParents.id})">{{infoParents.id}}</a></td><td>{{infoParents.numero}}</td><td>{{infoParents.nomPere}}</td><td>{{infoParents.prenomPere}}</td><td>{{infoParents.nomMere}}</td><td>{{infoParents.prenomMere}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="info-parents-detail({id:infoParents.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="info-parents.edit({id:infoParents.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="info-parents.delete({id:infoParents.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/info-poste/info-poste-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.infoPoste.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Info Poste?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/info-poste/info-poste-detail.html','<div><h2><span>Info Poste</span> {{vm.infoPoste.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Date Debut</span></dt><dd><span>{{vm.infoPoste.dateDebut | date:\'mediumDate\'}}</span></dd><dt><span>Date Fin</span></dt><dd><span>{{vm.infoPoste.dateFin | date:\'mediumDate\'}}</span></dd><dt><span>Actuelle</span></dt><dd><span>{{vm.infoPoste.actuelle}}</span></dd><dt><span>Members</span></dt><dd><a ui-sref="members-detail({id:vm.infoPoste.membersId})">{{vm.infoPoste.membersNom}}</a></dd><dt><span>Poste</span></dt><dd><a ui-sref="poste-detail({id:vm.infoPoste.posteId})">{{vm.infoPoste.posteLibelle}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="info-poste-detail.edit({id:vm.infoPoste.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/info-poste/info-poste-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInfoPosteLabel">Create or edit a Info Poste</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.infoPoste.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.infoPoste.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_dateDebut">Date Debut</label><div class="input-group"><input id="field_dateDebut" type="text" class="form-control" name="dateDebut" uib-datepicker-popup="{{dateformat}}" ng-model="vm.infoPoste.dateDebut" is-open="vm.datePickerOpenStatus.dateDebut"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateDebut\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_dateFin">Date Fin</label><div class="input-group"><input id="field_dateFin" type="text" class="form-control" name="dateFin" uib-datepicker-popup="{{dateformat}}" ng-model="vm.infoPoste.dateFin" is-open="vm.datePickerOpenStatus.dateFin"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateFin\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_actuelle">Actuelle</label><input type="checkbox" name="actuelle" id="field_actuelle" ng-model="vm.infoPoste.actuelle"></div><div class="form-group"><label for="field_members">Members</label><select class="form-control" id="field_members" name="members" ng-model="vm.infoPoste.membersId" ng-options="members.id as members.nom for members in vm.members"><option value=""></option></select></div><div class="form-group"><label for="field_poste">Poste</label><select class="form-control" id="field_poste" name="poste" ng-model="vm.infoPoste.posteId" ng-options="poste.id as poste.libelle for poste in vm.postes"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/info-poste/info-postes.html','<div><h2>Info Postes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="info-poste.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Info Poste</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateDebut"><span>Date Debut</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateFin"><span>Date Fin</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="actuelle"><span>Actuelle</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="membersNom"><span>Members</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="posteLibelle"><span>Poste</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="infoPoste in vm.infoPostes track by infoPoste.id"><td><a ui-sref="info-poste-detail({id:infoPoste.id})">{{infoPoste.id}}</a></td><td>{{infoPoste.dateDebut | date:\'mediumDate\'}}</td><td>{{infoPoste.dateFin | date:\'mediumDate\'}}</td><td>{{infoPoste.actuelle}}</td><td><a ui-sref="members-detail({id:infoPoste.membersId})">{{infoPoste.membersNom}}</a></td><td><a ui-sref="poste-detail({id:infoPoste.posteId})">{{infoPoste.posteLibelle}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="info-poste-detail({id:infoPoste.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="info-poste.edit({id:infoPoste.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="info-poste.delete({id:infoPoste.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/info-service/info-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.infoService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Info Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/info-service/info-service-detail.html','<div><h2><span>Info Service</span> {{vm.infoService.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Date Integration</span></dt><dd><span>{{vm.infoService.dateIntegration | date:\'mediumDate\'}}</span></dd><dt><span>Membre Service</span></dt><dd><a ui-sref="membre-service-detail({id:vm.infoService.membreServiceId})">{{vm.infoService.membreServiceId}}</a></dd><dt><span>Members</span></dt><dd><a ui-sref="members-detail({id:vm.infoService.membersId})">{{vm.infoService.membersNom}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="info-service-detail.edit({id:vm.infoService.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/info-service/info-service-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInfoServiceLabel">Create or edit a Info Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.infoService.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.infoService.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_dateIntegration">Date Integration</label><div class="input-group"><input id="field_dateIntegration" type="text" class="form-control" name="dateIntegration" uib-datepicker-popup="{{dateformat}}" ng-model="vm.infoService.dateIntegration" is-open="vm.datePickerOpenStatus.dateIntegration"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateIntegration\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_membreService">Membre Service</label><select class="form-control" id="field_membreService" name="membreService" ng-model="vm.infoService.membreServiceId" ng-options="membreService.id as membreService.id for membreService in vm.membreservices"><option value=""></option></select></div><div class="form-group"><label for="field_members">Members</label><select class="form-control" id="field_members" name="members" ng-model="vm.infoService.membersId" ng-options="members.id as members.nom for members in vm.members"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/info-service/info-services.html','<div><h2>Info Services</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="info-service.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Info Service</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateIntegration"><span>Date Integration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="membreServiceId"><span>Membre Service</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="membersNom"><span>Members</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="infoService in vm.infoServices track by infoService.id"><td><a ui-sref="info-service-detail({id:infoService.id})">{{infoService.id}}</a></td><td>{{infoService.dateIntegration | date:\'mediumDate\'}}</td><td><a ui-sref="membre-service-detail({id:infoService.membreServiceId})">{{infoService.membreServiceId}}</a></td><td><a ui-sref="members-detail({id:infoService.membersId})">{{infoService.membersNom}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="info-service-detail({id:infoService.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="info-service.edit({id:infoService.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="info-service.delete({id:infoService.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/membre-service/membre-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.membreService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Membre Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/membre-service/membre-service-detail.html','<div><h2><span>Membre Service</span> {{vm.membreService.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Numero</span></dt><dd><span>{{vm.membreService.numero}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.membreService.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="membre-service-detail.edit({id:vm.membreService.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/membre-service/membre-service-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="consulatApp.membreService.home.createLabel">Ajouter une information ou un \xE9v\xE8nement</h4></div><div class="modal-body"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_libelle" mf-required>Type</label><div class="col-sm-6"><select required placeholder="type" class="form-control" name="libelle" ng-model="vm.membreService.type" id="field_libelle"><option value="EVENEMENT">EVENT</option><option value="INFORMATION">INFORMATION</option></select></div></div><div><div class="form-group has-feedback" ng-if="vm.user.profilId==2"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.membreService.association">Choose an association</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.membreService.association" ng-click="vm.init()"> <span><i class="handle"></i></span></label></div></div><div class="form-group has-feedback" ng-if="vm.user.profilId!=2 || vm.membreService.association "><br><label mf-required class="control-label col-sm-3 ft16" for="associations">Association</label><div class="col-sm-6"><select placeholder="associations" required class="form-control" id="field_association" name="associations" ng-model="vm.membreService.consulat" ng-options="assoc.nom as assoc.nom for assoc in vm.associations"><option value=""></option></select></div></div><div class="form-group has-feedback"><br><label class="control-label col-sm-3 ft16" for="field_libelle" data-translate="consulatApp.membreService.title">Titre</label><div class="col-sm-6"><input required type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.membreService.libelle"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_heureFin">Date</label><div class="d-flex col-sm-6"><input id="field_heureFin" type="datetime-local" class="form-control" name="heureFin" ng-model="vm.membreService.date" placeholder="YYYY-MM-DD HH:mm"></div></div><br><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="etat" data-translate="consulatApp.membreService.state">Etat</label><div class="col-sm-6"><select disabled="disabled" placeholder="Etat" required class="form-control" id="field_etat" name="etat" ng-model="vm.membreService.etatId" ng-options="etat.id as etat.libelle for etat in vm.etats"><option value=""></option></select></div><i title="S\xE9lectionnez la ville" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="true" j-model="vm.membreService.etatId" j-list="vm.etats" j-columns="vm.etatColumns" j-event-name="onLoadEtats">Choisir...</i></div><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="ville" data-translate="consulatApp.membreService.city">Ville</label><div class="col-sm-6"><select disabled="disabled" placeholder="Ville" required class="form-control" id="field_ville" name="ville" ng-model="vm.membreService.cityId" ng-options="ville.id as ville.libelle for ville in vm.villeAdresse"><option value=""></option></select></div><i title="S\xE9lectionnez la ville" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="false" j-model="vm.membreService.cityId" j-list="vm.villeAdresse" j-columns="vm.statesVilleColumns" j-event-name="onLoadStatesVille">Choisir...</i></div><div class="form-group has-feedback"><br><label mf-required class="control-label col-sm-3 ft16" for="field_libelle" data-translate="consulatApp.membreService.lieu">lieu</label><div class="col-sm-6"><input required type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.membreService.lieu"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_description">Description</label><div class="col-sm-9"><textarea type="text" placeholder="description" class="form-control" name="description" id="field_description" ng-model="vm.membreService.description" ng-maxlength="6000"></textarea></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/membre-service/membre-services.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><div class="form-group" ng-if="!vm.filtrer"><div class="pull-right"><button class="btn btn-info btn-md" ng-click="vm.filtrer=true"><span class="glyphicon glyphicon-search" data-translate="global.menu.entities.filtrer">Filtrer</span></button></div></div><button class="btn btn-primary btn-outline" title="Ajouter" ng-if="vm.user.id!=null" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="row" ng-if="vm.filtrer"><br><div class="form-group col-sm-3"><input show-button-bar="false" id="field_dateDebut" placeholder="Date d\xE9but" type="text" class="form-control" name="dateDebut" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="vm.itemSearch.dateDebut" is-open="vm.datePickerOpenStatus.dateDebut" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateDebut\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div class="form-group col-sm-3"><input show-button-bar="false" id="field_dateDateFin" placeholder="Date fin" type="text" class="form-control" name="dateDateFin" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="vm.itemSearch.dateFin" is-open="vm.datePickerOpenStatus.dateFin" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateFin\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div class="form-group col-sm-4"><div class="col-sm-4"><button class="btn btn-warnig btn-md" ng-click="vm.initFiltre()"><span class="glyphicon glyphicon-search" data-translate="entity.action.cancel">Annuler</span></button></div><div class="col-sm-4"><button class="btn btn-info btn-md" ng-click="vm.init()"><span class="glyphicon glyphicon-search" data-translate="global.menu.entities.filtrer">Filtrer</span></button></div></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.membreService.home.title">Liste des Services</u></span></div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'numero\') " class="col-lg-3"><span>Code</span> <span ng-if="vm.isCurrentColumn(\'numero\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'date\') " class="col-lg-3"><span>Date</span> <span ng-if="vm.isCurrentColumn(\'date\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'type\') " class="col-lg-2"><span>Type</span> <span ng-if="vm.isCurrentColumn(\'type\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'libele\') " class="col-lg-2"><span data-translate="consulatApp.membreService.libelle">Libelle</span> <span ng-if="vm.isCurrentColumn(\'libelle\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'consulat\') " class="col-lg-2"><span data-translate="consulatApp.membreService.consulat">Consulat</span> <span ng-if="vm.isCurrentColumn(\'consulat\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right"><span>Actions</span></th><th></th></tr></thead><tbody><tr ng-repeat="membreService in vm.datas track by membreService.id"><td title="{{membreService.numero}}">{{membreService.numero | characters:45}}</td><td title="{{membreService.date}}">{{membreService.date | date:\'medium\'}}</td><td title="{{membreService.type}}">{{membreService.type | characters:45}}</td><td title="{{membreService.libelle}}">{{membreService.libelle | characters:45}}</td><td title="{{membreService.consulat}}">{{membreService.consulat | characters:45}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,membreService)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" title="Supprimer" ng-click="vm.deleteItem($event,membreService)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/metier/metier-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.metier.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="consulatApp.metier.delete.question" translate-values="{id: \'{{vm.metier.id}}\'}">Are you sure you want to delete this Metier?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/metier/metier-detail.html','<div><h2><span data-translate="consulatApp.metier.detail.title">Metier</span> {{vm.metier.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="consulatApp.metier.libelle">Libelle</span></dt><dd><span>{{vm.metier.libelle}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="metier-detail.edit({id:vm.metier.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/metier/metier-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCityLabel" data-translate="consulatApp.metier.home.createLabel">Ajouter un m\xE9tier</h4></div><div class="modal-body"><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_libelle" data-translate="consulatApp.metier.libelle">Libelle</label><div class="col-sm-6"><input type="text" class="form-control" name="libelle" id="field_leibelle" ng-model="vm.metier.libelle" ng-disabled="vm.isViewing" required></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/metier/metiers.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" title="Ajouter" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.metier.home.title">Liste des M\xE9tiers</u></span></div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'libelle\') " class="col-lg-3"><span data-translate="consulatApp.metier.libelle">Libelle</span> <span ng-if="vm.isCurrentColumn(\'libelle\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right"><span>Actions</span></th><th></th></tr></thead><tbody><tr ng-repeat="metier in vm.datas track by metier.id"><td title="{{metier.libelle}}">{{metier.libelle | characters:45}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,metier)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" title="Supprimer" ng-click="vm.deleteItem($event,metier)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/poste/poste-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.poste.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Poste?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/poste/poste-detail.html','<div><h2><span>Poste</span> {{vm.poste.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Numero</span></dt><dd><span>{{vm.poste.numero}}</span></dd><dt><span>Libelle</span></dt><dd><span>{{vm.poste.libelle}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.poste.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="poste-detail.edit({id:vm.poste.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/poste/poste-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCityLabel" data-translate="consulatApp.poste.home.createLabel">Ajouter un Poste</h4></div><div class="modal-body"><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_numero" data-translate="consulatApp.poste.libelle">Libelle</label><div class="col-sm-6"><input type="text" class="form-control" name="libelle" id="field_numero" ng-model="vm.poste.libelle" ng-disabled="vm.isViewing" required></div></div><div class="form-group has-feedbackp"><label class="control-label col-sm-3" for="field_description">Description</label><div class="col-sm-6"><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.poste.description" ng-maxlength="1000"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/poste/postes.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" title="Ajouter" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.poste.home.title">Liste des Poste</u></span></div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'numero\') " class="col-lg-3"><span>Code</span> <span ng-if="vm.isCurrentColumn(\'numero\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'libelle\') " class="col-lg-3"><span data-translate="consulatApp.poste.libelle">Libelle</span> <span ng-if="vm.isCurrentColumn(\'libelle\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'description\') " class="col-lg-3"><span>Description</span> <span ng-if="vm.isCurrentColumn(\'description\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right"><span>Actions</span></th><th></th></tr></thead><tbody><tr ng-repeat="poste in vm.datas track by poste.id"><td title="{{poste.numero}}">{{poste.numero | characters:45}}</td><td title="{{poste.libelle}}">{{poste.libelle | characters:45}}</td><td title="{{poste.description}}">{{poste.description | characters:45}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,poste)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" title="Supprimer" ng-click="vm.deleteItem($event,poste)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/members/adresse-consultation.html','<fieldset class="mf-fieldset p10"><legend>Contacts</legend><div class="row"><div class="col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" data-translate="consulatApp.members.adresses">Adresse</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.members.adresseDTO.rue"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_etat" data-translate="consulatApp.adresses.states">Etat</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_etat" ng-model="vm.members.adresseDTO.etat"></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_ville" data-translate="consulatApp.adresses.city">Ville</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_ville" ng-model="vm.members.adresseDTO.ville"></div></div></div><div class="col-sm-6"><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_telephone" data-translate="consulatApp.adresses.telephone">Telephone</label><div class="col-sm-6"><input disabled="disabled" required type="text" class="form-control" name="telephone" id="field_telephone" ng-model="vm.members.adresseDTO.telephone"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_zipecode">Zip Code</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="zipcode" id="field_zipecode" ng-model="vm.members.adresseDTO.zipCode"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_mail">Mail</label><div class="col-sm-6"><input disabled="disabled" type="email" class="form-control" name="mail" id="field_mail" ng-model="vm.members.adresseDTO.mail"></div></div></div></div></div></fieldset><br><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.adresses.arrivee">Arriv\xE9e</legend><div class="row col-sm-6"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dt_arrivee" data-translate="consulatApp.members.dateArrivee">Date d\'arriv\xE9e</label><div class="col-sm-6"><input disabled="disabled" show-button-bar="false" id="field_dt_arrivee" type="text" class="form-control" name="dateArrrive" ng-model="vm.members.dateArrivee"></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_etat_arrive" data-translate="consulatApp.adresses.states">Etat</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="etat" id="field_etat_arrive" ng-model="vm.members.etatArrivee" required></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_ville_arrivee" data-translate="consulatApp.members.villeArrivee">Lieu d\'arriv\xE9e</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="ville" id="field_ville_arrivee" ng-model="vm.members.villeArrivee" required></div></div></div></fieldset><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.adresses.history">Historique des adresses</legend><ol class="list-group"><li ng-repeat="hst in vm.members.historique track by hst.id" class="list-group-item"><div>{{hst.etat}} - {{hst.ville}} - {{hst.rue}} - {{hst.zipCode}}</div></li></ol></fieldset>');
$templateCache.put('app/entities/members/adresse-modification.html','<fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.adresses">Contacts Personnel</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.changeAdresse">Voulez vous changez d\'adresse compl\xE8tement ?</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.changerAdresse" ng-click="vm.changerAdresse()"> <span><i class="handle"></i></span></label></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" data-translate="consulatApp.members.adresses">Adresse</label><div class="col-sm-6"><input type="text" placeholder="ex: 100, Red Fox Avenue" class="form-control" name="nom" id="field_nom" ng-model="vm.members.adresseDTO.rue"></div></div><br><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="field_etat" data-translate="consulatApp.adresses.states">Etat</label><div class="col-sm-6"><input disabled="disabled" class="form-control" id="field_etat" name="etat" ng-model="vm.members.adresseDTO.etat" required></div><i title="S\xE9lectionnez l\'etat" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.adresseDTO.etatId" j-list="vm.etats" j-columns="vm.etatColumns" j-event-name="onLoadEtats">Choose...</i></div><br><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="field_ville" data-translate="consulatApp.adresses.city">Ville</label><div class="col-sm-6"><input disabled="disabled" class="form-control" id="field_ville" name="ville" ng-model="vm.members.adresseDTO.city" required></div><i title="S\xE9lectionnez la ville" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.adresseDTO.cityId" j-list="vm.villeAdresse" j-columns="vm.villeColumns">Choose...</i></div></div><br><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_telephone" mf-required data-translate="consulatApp.adresses.telephone">Telephone</label><div class="col-sm-6"><input required type="text" placeholder="phone number ex: 4156541010" class="form-control" name="telephone" id="field_telephone" maxlength="10" ng-model="vm.members.adresseDTO.telephone"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_zipcode">Zip Code</label><div class="col-sm-6"><input type="text" class="form-control" maxlength="50" placeholder="zip code" name="telephone" id="field_zipcode" ng-model="vm.members.adresseDTO.zipCode"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_email">Mail</label><div class="col-sm-6"><input type="email" placeholder="adresse mail" class="form-control" name="email" id="field_email" ng-model="vm.members.adresseDTO.mail" ng-maxlength="100" ng-minlength="5"><div ng-show="editForm.email.$dirty && editForm.email.$invalid"><p class="help-block text-danger" ng-show="editForm.email.$error.email">Your email is invalid.</p><p class="help-block text-danger" ng-show="editForm.email.$error.minlength">Minimum required is 5 characters.</p><p class="help-block text-danger" ng-show="editForm.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_ice" data-translate="consulatApp.members.ice">ice</label><div class="col-sm-6"><input type="text" placeholder="ice" maxlength="50" class="form-control" name="ice" id="field_ice" ng-model="vm.members.ice"></div></div></div></fieldset><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.adress2">Informations sur l\'arriv\xE9e</legend><div class="row col-sm-6"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_date_arrivee" data-translate="consulatApp.members.dateArrivee">Date d\'arriv\xE9e</label><div class="col-sm-6"><input show-button-bar="false" placeholder="date of arrival" id="field_date_arrivee" type="text" class="form-control" name="dateArrivee" ng-model="vm.members.dateArrivee" uib-datepicker-popup="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.dateArrivee"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateArrivee\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_etat_arrivee" data-translate="consulatApp.members.etatArrivee">Etat Arriv\xE9e</label><div class="col-sm-6"><input disabled="disabled" placeholder="arrival state" class="form-control" id="field_etat_arrivee" name="etat" ng-model="vm.members.etatArrivee"></div><i title="S\xE9lectionnez l\'etat" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.statesId" j-list="vm.etats" j-columns="vm.etatColumns" j-event-name="onLoadEtats">Choose...</i></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_ville_arrivee" data-translate="consulatApp.members.villeArrivee">Lieu d\'arriv\xE9e</label><div class="col-sm-6"><input disabled="disabled" type="text" placeholder="lieu d\'arriv\xE9e aux usa" class="form-control" name="ville" id="field_ville_arrivee" ng-model="vm.members.villeArrivee"></div><i title="S\xE9lectionnez la ville" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.villeArriveId" j-list="vm.countriesArrivee" j-columns="vm.villeColumns">Choose...</i></div></div></fieldset>');
$templateCache.put('app/entities/members/adresse.html','<div class="col-sm-11 col-sm-offset-1"><div class="row"><div class="col-sm-6"><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.adresses">Adresse</legend><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.adresses.rue">Rue</label><div class="col-sm-6"><input required type="text" placeholder="ex: 100, Red Fox Avenue" class="form-control" name="nom" id="field_nom" ng-model="vm.members.adresseDTO.rue"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_zipCode">Zip Code</label><div class="col-sm-6"><input type="text" class="form-control" placeholder="zip code" maxlength="50" name="zipCode" id="field_zipCode" ng-model="vm.members.adresseDTO.zipCode"></div></div><br></div><div class="row col-sm-6"><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="field_etat" data-translate="consulatApp.adresses.states">Etat</label><div class="col-sm-6"><input disabled="disabled" class="form-control" id="field_etat" name="etat" ng-model="vm.members.adresseDTO.etat" required></div><i title="Select the state" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-model="vm.members.adresseDTO.etatId" j-list="vm.etats" j-states="true" j-columns="vm.etatColumns" j-event-name="onLoadEtats">Choose...</i></div><br><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="field_ville" data-translate="consulatApp.adresses.city">Ville</label><div class="col-sm-6"><input disabled="disabled" class="form-control" id="field_ville" name="ville" ng-model="vm.members.adresseDTO.city" required></div><i title="Select the city" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-model="vm.members.adresseDTO.cityId" j-states="false" j-list="vm.villeAdresse" j-columns="vm.statesVilleColumns" j-event-name="onLoadStatesVille">Choose...</i></div></div></fieldset></div><div class="col-sm-6"><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.adress1">Autres contacts</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-4 ft16" for="field_telephone" mf-required data-translate="consulatApp.adresses.telephone">Telephone</label><div class="col-sm-6"><input required type="text" placeholder="ex: 4156541010" class="form-control" name="telephone" id="field_telephone" maxlength="10" ng-model="vm.members.adresseDTO.telephone"></div></div><br><div class="form-group"><label class="control-label col-sm-4 ft16" for="field_email">Mail</label><div class="col-sm-6"><input type="email" placeholder="mail adress" class="form-control" name="email" id="field_email" ng-model="vm.members.adresseDTO.mail" ng-maxlength="100" ng-minlength="5"><div ng-show="editForm.email.$dirty && editForm.email.$invalid" class="text-danger"><p class="help-block text-danger font-bold" ng-show="editForm.email.$error.email">Your email is invalid.</p><p class="help-block text-danger font-bold" ng-show="editForm.email.$error.minlength">Minimum required is 5 characters.</p><p class="help-block text-danger font-bold" ng-show="editForm.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div></div><br><div class="form-group"><label class="control-label col-sm-4 ft16" for="field_ice" data-translate="consulatApp.members.ice">ice</label><div class="col-sm-6"><input type="text" placeholder="ice" maxlength="20" class="form-control" name="ice" id="field_ice" ng-model="vm.members.ice"></div></div></div></fieldset></div></div><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.adress2">Informations sur l\'arriv\xE9e</legend><div class="row col-sm-6"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_date_arrivee" data-translate="consulatApp.members.dateArrivee">Date d\'arriv\xE9e</label><div class="col-sm-6"><input show-button-bar="false" placeholder="date of arrival" id="field_date_arrivee" type="text" class="form-control" name="dateArrrive" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.members.dateArrivee" is-open="vm.datePickerOpenStatus.dateArrivee"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateArrivee\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group has-feedback"></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_etat_arrive" data-translate="consulatApp.members.etatArrivee">Etat d\'arriv\xE9e</label><div class="col-sm-6"><input disabled="disabled" placeholder="arrival state" class="form-control" id="field_etat_arrive" name="etat" ng-model="vm.members.states"></div><i title="Select the state" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="true" j-model="vm.members.statesId" j-list="vm.etats" j-columns="vm.etatColumns" j-event-name="onLoadEtats">Choose...</i></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_ville_arrivvee" data-translate="consulatApp.members.villeArrivee">Ville d\'arriv\xE9e</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" placeholder="place of arrival" name="telephone" id="field_ville_arrivvee" ng-model="vm.members.villeArrivee"></div><i title="Select the city" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="false" j-model="vm.members.villeArriveId" j-list="vm.countriesVilleUSA" j-columns="vm.villeColumns">Choose...</i></div></div></fieldset></div>');
$templateCache.put('app/entities/members/annulation-carte.html','<div class="col-sm-10 col-sm-offset-1"><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.annulCarte">Voulez vous annuler la carte active du membre?</legend><div><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.annulCarte">Voulez-vous annuler la carte active?</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.annulerCarte" ng-click="vm.annulerCarte()"> <span><i class="handle"></i></span></label></div></div><br><br><div class="col-sm-offset-2 col-sm-8" ng-if="vm.members.annulerCarte"><div class="form-group"><label class="control-label col-sm-4" for="field_dateAnnulation" mf-required>Date Annulation</label><div class="col-sm-7"><input show-button-bar="false" id="field_dateAnnulation" type="text" class="form-control" name="dateAnnulation" ng-model="vm.members.dateAnnulation" uib-datepicker-popup="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.dateAnnulation" required></div><span class="input-group-btn col-sm-1 pull-left"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateAnnulation\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div class="form-group"><label class="control-label col-sm-4" for="field_motifAnnulation" mf-required>Motif Annulation</label><div class="col-sm-7"><input required type="text" class="form-control" name="motifAnnulation" id="field_motifAnnulation" ng-model="vm.members.motifAnnulation"></div></div><br><br></div></fieldset></div>');
$templateCache.put('app/entities/members/association-consultation.html','<fieldset class="mf-fieldset p10" ng-if="vm.members.associations.length!=0"><legend data-translate="consulatApp.association.assocMembre">Associations dont il est membre</legend><ol class="list-group"><li ng-repeat="ass in vm.members.associations track by ass.id" class="list-group-item">Association {{ass.nom}}</li></ol></fieldset>');
$templateCache.put('app/entities/members/association-modification.html','<fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.assoc1">Faites vous partie d\'une ou plusieurs associations ?</legend><div class="form-group"><label class="control-label col-sm-4" for="field_role" data-translate="consulatApp.members.assoc2">Selectionner les associations</label><div class="col-sm-6"><select class="form-control" style="height:200px" multiple="multiple" name="authority" id="field_role" ng-model="vm.members.associations.nom" ng-options="association.nom for association in vm.members.associations"></select></div><i title="Select the associations" class="btn btn-primary btn-xs" j-select-dialog j-multiple="true" j-model="vm.associationId" j-list="vm.assocs" j-columns="vm.colums" j-event-name="onLoadRoles">Choose...</i></div><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10" ng-if="vm.members.associations.length>0"><legend data-translate="consulatApp.members.assoc3">Choisissez les postes occup\xE9s dans ces association</legend><div ng-repeat="assoc in vm.members.associations track by assoc.id"><div class="form-group has-feedback"><label mf-required class="control-label col-sm-4 ft16" for="etat">{{assoc.nom}}</label><div class="col-sm-6"><select disabled="disabled" placeholder="Etat" required class="form-control" id="field_etat" name="etat" ng-model="assoc.posteId" ng-options="poste.id as poste.libelle for poste in vm.postes"><option value=""></option></select></div><i title="Select the occupations" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="assoc.posteId" j-list="vm.postes" j-columns="vm.posteColumns">Choose...</i></div><div class="form-group has-feedback"><label class="control-label col-sm-4 ft16" for="field_dateDebut" mf-required data-translate="consulatApp.association.dateFonction">Date prise fonction</label><div class="col-sm-3"><input show-button-bar="false" placeholder="ex: 2020-04-28" id="assoc.nom" type="text" class="form-control" name="assoc.nom" ng-model="assoc.dateFonction" required><!--  <span class="input-group-btn">\n                <button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(assoc.nom)"><i class="glyphicon glyphicon-calendar"></i></button>\n            </span> --></div></div></div></fieldset></fieldset>');
$templateCache.put('app/entities/members/association.html','<div class="col-sm-10 col-sm-offset-1"><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.assoc1">Faites vous partie d\'une ou plusieurs associations ?</legend><div><div class="col-sm-6 form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.yes">OUI</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.association" ng-click="vm.association(true)"> <span><i class="handle"></i></span></label></div><div class="col-sm-6 form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.no">NON</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-click="vm.association(false)"> <span><i class="handle"></i></span></label></div></div><br><br><br><br><div class="form-group" ng-if="vm.members.association"><label class="control-label col-sm-4" for="field_role" data-translate="consulatApp.members.assoc2">Selectionner les associations</label><div class="col-sm-6"><select class="form-control" style="height:200px" multiple="multiple" name="authority" id="field_role" ng-click="vm.test()" ng-model="vm.members.associations.nom" ng-options="association.nom for association in vm.members.associations"></select></div><i title="Select associations" class="btn btn-primary btn-xs" j-select-dialog j-multiple="true" j-model="vm.associationId" j-list="vm.assocs" j-columns="vm.colums" j-event-name="onLoadRoles">Choose...</i></div></fieldset><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10" ng-if="vm.members.associations.length>0"><legend data-translate="consulatApp.members.assoc3">Choisissez les postes occup\xE9s dans ces association</legend><div ng-repeat="assoc in vm.members.associations track by assoc.id"><div class="form-group has-feedback"><label mf-required class="control-label col-sm-4 ft16" for="field_etat">{{assoc.nom}}</label><div class="col-sm-3"><select disabled="disabled" placeholder="Etat" required class="form-control" id="field_etat" name="etat" ng-model="assoc.posteId" ng-options="poste.id as poste.libelle for poste in vm.postes"><option value=""></option></select></div><i title="Select the occupation" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="assoc.posteId" j-list="vm.postes" j-columns="vm.posteColumns">Choose...</i></div><div class="form-group has-feedback"><label class="control-label col-sm-4 ft16" for="assoc_nom" mf-required data-translate="consulatApp.association.dateFonction">Date prise fonction</label><div class="col-sm-3"><input show-button-bar="false" placeholder="ex: 12/04/2020" id="assoc_nom" name="assoc.nom" type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="assoc.dateFonction" required><!--  <span class="input-group-btn">\n                <button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(assoc.nom)"><i class="glyphicon glyphicon-calendar"></i></button>\n            </span> --></div></div><br></div></fieldset></div>');
$templateCache.put('app/entities/members/doc-identification-consultation.html','<fieldset class="mf-fieldset p10"><legend data-translate="consulatApp.members.docId1">Document d\'identification Burkinab\xE8</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_docId" data-translate="consulatApp.bFIdDoc.type">Type de document</label><div class="col-sm-6"><input disabled="disabled" class="form-control" name="docId" id="field_docId" ng-model="vm.members.bfIdDoc.docId"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_numero" data-translate="consulatApp.bFIdDoc.numero">Numero Id</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="numero" id="field_numero" ng-model="vm.members.bfIdDoc.numero"></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="ville" data-translate="consulatApp.bFIdDoc.city">Lieu</label><div class="col-sm-6"><input disabled="disabled" required class="form-control" id="field_ville" name="ville" ng-model="vm.members.bfIdDoc.ville"></div></div></div><div class="row col-sm-6"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateDelivr" mf-required data-translate="consulatApp.bFIdDoc.dateDelivr">Date de delivrance</label><div class="col-sm-6"><input disabled="disabled" show-button-bar="false" id="field_dateDelivr" type="text" class="form-control" name="dateDelivr" ng-model="vm.members.bfIdDoc.dateDelivr"></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateExpr" data-translate="consulatApp.bFIdDoc.dateExpr">Date d\'expiration</label><div class="col-sm-6"><input disabled="disabled" show-button-bar="false" id="field_dateExpr" type="text" class="form-control" name="dateExpr" ng-model="vm.members.bfIdDoc.dateExpr"></div></div></div></fieldset><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10" ng-if="vm.members.country.autorite!=null"><legend data-translate="consulatApp.members.docId2">Document l\xE9gal USA</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_autorite" data-translate="consulatApp.countryIdDoc.type">Type de Document</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="autorite" id="field_autorite" ng-model="vm.members.country.autorite"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_numero" data-translate="consulatApp.countryIdDoc.numero">Numero Id</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="numero" id="field_numero" ng-model="vm.members.country.numero"></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="etat" data-translate="consulatApp.countryIdDoc.states">Etat de delivrance</label><div class="col-sm-6"><input disabled="disabled" class="form-control" id="field_etat" name="etat" ng-model="vm.members.etatResidence"></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="ville" data-translate="consulatApp.countryIdDoc.city">Ville de delivrance</label><div class="col-sm-6"><input disabled="disabled" class="form-control" id="field_ville" name="ville" ng-model="vm.members.villeResidence"></div></div></div><div class="row col-sm-6"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateDelivr2" data-translate="consulatApp.countryIdDoc.dateDelivr">Date de delivrance</label><div class="col-sm-6"><input disabled="disabled" show-button-bar="false" id="field_dateDelivr2" type="text" class="form-control" name="dateDelivr2" ng-model="vm.members.country.dateDelivr"></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateExpr2" data-translate="consulatApp.countryIdDoc.dateExpr">Date d\'expiration</label><div class="col-sm-6"><input show-button-bar="false" id="field_dateExpr2" type="text" class="form-control" name="dateExpr2" ng-model="vm.members.country.dateExpr" disabled="disabled"></div></div></div></fieldset>');
$templateCache.put('app/entities/members/doc-identification-modification.html','<fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.docId1">BF ID DOC</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_docId" data-translate="consulatApp.bFIdDoc.type">Type de document</label><div class="col-sm-6"><select class="form-control" name="docId" ng-model="vm.members.bfIdDoc.docId" id="field_docId"><option value="">choisir le type de document</option><option value="CNIB">CNIB</option><option value="PASSPORT">PASSPORT</option></select></div></div><br><div class="form-group" ng-if="vm.members.bfIdDoc.docId!=\'\'"><label class="control-label col-sm-3 ft16" for="field_numero" mf-required data-translate="consulatApp.bFIdDoc.numero">Numero Id</label><div class="col-sm-6"><input required type="text" class="form-control" name="numero" id="field_numero" ng-model="vm.members.bfIdDoc.numero"></div></div><br><div class="form-group has-feedback" ng-if="vm.members.bfIdDoc.docId!=\'\'"><label mf-required class="control-label col-sm-3 ft16" for="ville" data-translate="consulatApp.bFIdDoc.city">Lieu d\'\xE9tablissement</label><div class="col-sm-6"><input disabled="disabled" required class="form-control" id="field_ville" name="ville" ng-model="vm.members.bfIdDoc.ville"></div><i title="Select the city" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.bfIdDoc.cityId" j-list="vm.countriesVille" j-columns="vm.villeColumns" j-event-name="onLoadVilles">Choose...</i></div></div><div class="row col-sm-6" ng-if="vm.members.bfIdDoc.docId!=\'\'"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateDelivr" mf-required data-translate="consulatApp.bFIdDoc.dateDelivr">Date de delivrance</label><div class="col-sm-6"><input show-button-bar="false" id="field_dateDelivr" type="text" class="form-control" name="dateDelivr" ng-model="vm.members.bfIdDoc.dateDelivr" uib-datepicker-popup="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.dateDelivr" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateDelivr\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateExpr" mf-required data-translate="consulatApp.bFIdDoc.dateExpr">Date d\'expiration</label><div class="col-sm-6"><input show-button-bar="false" id="field_dateExpr" type="text" class="form-control" name="dateExpr" ng-model="vm.members.bfIdDoc.dateExpr" is-open="vm.datePickerOpenStatus.dateExpr" uib-datepicker-popup="dd/MM/yyyy" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateExpr\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></fieldset><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.docId2">Pays ID DOC</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="document" data-translate="consulatApp.countryIdDoc.type">Type de Document</label><div class="col-sm-6"><select placeholder="document" class="form-control" id="field_ville" name="ville" ng-model="vm.members.country.autorite" ng-options="doc.libelle as doc.libelle for doc in vm.documents"><option value="">choisir le type de document</option></select></div></div><br><div class="form-group" ng-if="vm.members.country.autorite!=null"><label class="control-label col-sm-3 ft16" for="field_numero" mf-required data-translate="consulatApp.countryIdDoc.numero">Numero Id</label><div class="col-sm-6"><input required type="text" class="form-control" name="numero" id="field_numero" ng-model="vm.members.country.numero"></div></div><br><br><br><br><div class="form-group has-feedback" ng-if="vm.members.country.autorite!=null"><label mf-required class="control-label col-sm-3 ft16" for="etat" data-translate="consulatApp.countryIdDoc.states">Etat de delivrance</label><div class="col-sm-6"><input disabled="disabled" required class="form-control" id="field_etat" name="etat" ng-model="vm.members.country.etat" placeholder="state of issue"></div><i title="Select the state" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.country.statesId" j-list="vm.etats" j-columns="vm.etatColumns" j-event-name="onLoadEtats">Choose...</i></div><br><div class="form-group has-feedback" ng-if="vm.members.country.autorite!=null"><label mf-required class="control-label col-sm-3 ft16" for="ville" data-translate="consulatApp.countryIdDoc.city">Ville de delivrance</label><div class="col-sm-6"><input disabled="disabled" required class="form-control" id="field_ville" name="ville" ng-model="vm.members.country.ville" placeholder="city of issue"></div><i title="Select the city" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.country.cityId" j-list="vm.statesVille" j-columns="vm.statesVilleColumns" j-event-name="onLoadStatesVille">Choose...</i></div></div><div class="row col-sm-6" ng-if="vm.members.country.autorite!=null"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateDelivr2" mf-required data-translate="consulatApp.countryIdDoc.dateDelivr">Date de delivrance</label><div class="col-sm-6"><input show-button-bar="false" id="field_dateDelivr2" type="text" class="form-control" name="dateDelivr2" ng-model="vm.members.country.dateDelivr" is-open="vm.datePickerOpenStatus.dateDelivr2" uib-datepicker-popup="dd/MM/yyyy" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateDelivr2\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateExpr2" mf-required data-translate="consulatApp.countryIdDoc.dateExpr">Date d\'expiration</label><div class="col-sm-6"><input show-button-bar="false" id="field_dateExpr2" type="text" class="form-control" name="dateExpr2" ng-model="vm.members.country.dateExpr" is-open="vm.datePickerOpenStatus.dateExpr2" uib-datepicker-popup="dd/MM/yyyy" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateExpr2\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></fieldset>');
$templateCache.put('app/entities/members/doc-identification.html','<div class="col-sm-10 col-sm-offset-1 well"><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.docId1">Document d\'identification Burkinab\xE8</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_docId" data-translate="consulatApp.bFIdDoc.type">Type de pi\xE8ce d\'identit\xE9</label><div class="col-sm-6"><select class="form-control" name="docId" ng-model="vm.members.bfIdDoc.docId" id="field_docId"><option value="">choisir le type de document</option><option value="CNIB">CNIB</option><option value="PASSPORT">PASSPORT</option></select></div></div><br><div class="form-group" ng-if="vm.members.bfIdDoc.docId!=null"><label class="control-label col-sm-3 ft16" for="field_numero" mf-required data-translate="consulatApp.bFIdDoc.numero">Num\xE9ro de la pi\xE8ce d\'identit\xE9</label><div class="col-sm-6"><input required type="text" placeholder="number of CNIB or PASSPORT" class="form-control" name="numero" id="field_numero" ng-model="vm.members.bfIdDoc.numero"></div></div><br><div class="form-group has-feedback" ng-if="vm.members.bfIdDoc.docId!=null"><label mf-required class="control-label col-sm-3 ft16" for="ville" data-translate="consulatApp.bFIdDoc.city">Lieu d\'\xE9tablissement</label><div class="col-sm-6"><input disabled="disabled" required class="form-control" id="field_ville" name="ville" ng-model="vm.members.bfIdDoc.city"></div><i title="Select  the place" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="false" j-model="vm.members.bfIdDoc.cityId" j-list="vm.countriesVille" j-columns="vm.villeColumns" j-event-name="onLoadVilles">Choose...</i></div></div><div class="row col-sm-6" ng-if="vm.members.bfIdDoc.docId!=null"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateDelivr" mf-required data-translate="consulatApp.bFIdDoc.dateDelivr">Date de delivrance</label><div class="col-sm-6"><input show-button-bar="false" placeholder="date of issue" id="field_dateDelivr" type="text" class="form-control" name="dateDelivr" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.members.bfIdDoc.dateDelivr" is-open="vm.datePickerOpenStatus.dateDelivr" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateDelivr\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateExpr" mf-required data-translate="consulatApp.bFIdDoc.dateExpr">Date d\'expiration</label><div class="col-sm-6"><input show-button-bar="false" placeholder="expiry date" id="field_dateExpr" type="text" class="form-control" name="dateExpr" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.members.bfIdDoc.dateExpr" is-open="vm.datePickerOpenStatus.dateExpr" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateExpr\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></fieldset><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.docId2">Document d\'identification USA</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="document" data-translate="consulatApp.countryIdDoc.type">Type de Document</label><div class="col-sm-6"><select placeholder="type of document" class="form-control" id="field_ville" name="ville" ng-model="vm.members.country.autorite" ng-options="doc.libelle as doc.libelle for doc in vm.documents"><option value="">choisir le type de document</option></select></div></div><br><div class="form-group" ng-if="vm.members.country.autorite!=null"><label class="control-label col-sm-3 ft16" for="field_numero" mf-required data-translate="consulatApp.countryIdDoc.numero">Num\xE9ro du document</label><div class="col-sm-6"><input required type="text" placeholder="identification number" class="form-control" name="numero" id="field_numero" ng-model="vm.members.country.numero"></div></div><br><br><br><br><div class="form-group has-feedback" ng-if="vm.members.country.autorite!=null"><label mf-required class="control-label col-sm-3 ft16" for="etat" data-translate="consulatApp.countryIdDoc.states">Etat de delivrance</label><div class="col-sm-6"><input disabled="disabled" required class="form-control" id="field_etat" name="etat" ng-model="vm.members.country.states" placeholder="state of issue"></div><i title="Select the  state" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="true" j-model="vm.members.country.statesId" j-list="vm.etats" j-columns="vm.etatColumns" j-event-name="onLoadEtats">Choose...</i></div><br><div class="form-group has-feedback" ng-if="vm.members.country.autorite!=null"><label mf-required class="control-label col-sm-3 ft16" for="ville" data-translate="consulatApp.countryIdDoc.city">Ville de delivrance</label><div class="col-sm-6"><input disabled="disabled" required class="form-control" id="field_ville" name="ville" ng-model="vm.members.country.city" placeholder="city of issue"></div><i title="Select the city" class="btn btn-primary btn-xs" j-select-2-dialog j-multiple="false" j-states="false" j-model="vm.members.country.cityId" j-list="vm.statesVille" j-columns="vm.statesVilleColumns" j-event-name="onLoadStatesVille">Choose...</i></div></div><div class="row col-sm-6"><div class="form-group has-feedback" ng-if="vm.members.country.autorite!=null"><label class="control-label col-sm-3 ft16" for="field_dateDelivr2" mf-required data-translate="consulatApp.countryIdDoc.dateDelivr">Date de delivrance</label><div class="col-sm-6"><input show-button-bar="false" id="field_dateDelivr2" placeholder="date of issue" type="text" class="form-control" name="dateDelivr2" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.members.country.dateDelivr" is-open="vm.datePickerOpenStatus.dateDelivr2" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateDelivr2\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group has-feedback" ng-if="vm.members.country.autorite!=null"><label class="control-label col-sm-3 ft16" for="field_dateExpr2" mf-required data-translate="consulatApp.countryIdDoc.dateExpr">Date d\'expiration</label><div class="col-sm-6"><input show-button-bar="false" placeholder="expiry date" id="field_dateExpr2" type="text" class="form-control" name="dateExpr2" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.members.country.dateExpr" is-open="vm.datePickerOpenStatus.dateExpr2" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateExpr2\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></fieldset></div>');
$templateCache.put('app/entities/members/election.html','<div class="col-sm-10 col-sm-offset-1"><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10"><legend>Candidature pour les \xE9lections</legend><div><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong>Voulez-vous enr\xE9gistr\xE9 la candidature du membre ?</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.candidate"> <span><i class="handle"></i></span></label></div></div><br><br><div class="col-sm-offset-2 col-sm-8" ng-if="vm.members.candidate"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_zone">Zone de candidature</label><div class="col-sm-6"><input disabled="disabled" required type="text" placeholder="zone" class="form-control" name="zone" id="field_zone" ng-model="vm.members.zoneLibelle" disabled="disabled"></div><i title="Select a brand" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.zoneId" j-list="vm.zones" j-columns="vm.zoneColumns" j-event-name="onLoadZone">Choose...</i></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_position">Poste du candidat</label><div class="col-sm-6"><input disabled="disabled" required type="text" placeholder="position" class="form-control" name="position" id="field_position" ng-model="vm.members.positionLibelle" disabled="disabled"></div><i title="Select a brand" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.positionId" j-list="vm.positions" j-columns="vm.positionColumns" j-event-name="onLoadPosition">Choose...</i></div><br></div></fieldset></div>');
$templateCache.put('app/entities/members/historiques-consultation.html','<fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10" ng-if="vm.infoPostes.length!=0"><legend data-translate="consulatApp.association.posteOccupe">Postes occup\xE9s dans des associations</legend><ol class="list-group"><li ng-repeat="poste in vm.infoPostes track by poste.id" class="list-group-item"><div ng-if="poste.dateFin">Association {{poste.associationNom}} : {{poste.posteLibelle}} du {{poste.dateDebut}} au {{poste.dateFin}}</div><div ng-if="!poste.dateFin">Association {{poste.associationNom}} : {{poste.posteLibelle}} du {{poste.dateDebut}} \xE0 maintenant</div></li></ol></fieldset>');
$templateCache.put('app/entities/members/identification-consultation.html','<fieldset class="mf-fieldset p10"><legend data-translate="consulatApp.members.ident1">Identification</legend><span style="font-weight: bolder; font-size: 14pt;margin-bottom: 4px">ID: {{vm.members.numero}}</span><div class="row"><div class="col-sm-1"><img data-ng-src="{{\'data:\' + vm.members.photoContentType + \';base64,\' + vm.members.photo}}" style="max-height: 100px" ng-if="vm.members.photo" alt="Sa photo"> <img data-ng-src="{{\'data:\' + vm.members.signatureContentType + \';base64,\' + vm.members.signature}}" style="max-height: 100px" ng-if="vm.members.signature" alt="Signature du ressortissant"></div><div class="col-sm-5"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" data-translate="consulatApp.members.nom">Nom</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.members.nom"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_prenom" data-translate="consulatApp.members.prenom">Prenom</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="prenom" id="field_prenom" ng-model="vm.members.prenom"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_taille" data-translate="consulatApp.members.taille">Taille</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="taille" id="field_taille" ng-model="vm.members.taille"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_libelle" data-translate="consulatApp.members.sexe">Sexe</label><div class="col-sm-6"><select disabled="disabled" class="form-control" name="libelle" ng-model="vm.members.sexe" id="field_libelle"><option value="MALE">MALE</option><option value="FEMALE">FEMALE</option></select></div></div></div><div class="col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_telephone" data-translate="consulatApp.members.metier">Metier</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="telephone" id="field_telephone" ng-model="vm.members.metier"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_telephone" data-translate="consulatApp.members.occupation">Poste</label><div class="col-sm-6"><input disabled="disabled" type="text" required class="form-control" name="telephone" id="field_telephone" ng-model="vm.members.occupation"></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateDebut" data-translate="consulatApp.members.dateNaissance">Date de Naissance</label><div class="col-sm-6"><input disabled="disabled" show-button-bar="false" id="field_dateNaissance" type="text" class="form-control" name="dateNaissance" ng-model="vm.members.dateNaissance"></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_marque_vehicule" data-translate="consulatApp.members.lieuNaissance">Lieu de Naissance</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="lieuNaissance" id="field_lieuNaissance" ng-model="vm.members.lieuNaissance"></div></div></div></div></fieldset><br><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.matrimoniale">Situation matrimoniale</legend><div ng-if="vm.members.mariage"><label class="h5 text-left"><i><strong data-translate="consulatApp.members.marie">Mari\xE9(e)</strong></i></label><div class="row"><div class="col-sm-6"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_nom" data-translate="consulatApp.members.nomConjoint">Nom Conjoint(e)</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.members.nomConjoint"></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_prenom" data-translate="consulatApp.members.prenomConjoint">Prenom Conjoint(e)</label><div class="col-sm-6"><input disabled="disabled" required type="text" class="form-control" name="prenom" id="field_prenom" ng-model="vm.members.prenomConjoint"></div></div></div><div class="col-sm-6" ng-if="vm.members.memePaysConjoint"><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.habiteUsa">Habite aux USA.</strong></i></label></div><br><div class="form-group"><label class="control-label col-sm-6 ft16" for="field_nom" data-translate="consulatApp.members.noConjoint">No identification conjoint(te)</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.members.noConjoint"></div></div></div><div class="col-sm-6" ng-if="!vm.members.memePaysConjoint"><label class="h5 text-left"><i><strong data-translate="consulatApp.members.habitePasUsa">N\'habite pas aux USA</strong></i></label></div></div></div><div ng-if="!vm.members.mariage"><label class="h5 text-left"><i><strong data-translate="consulatApp.members.celibataire">C\xE9libataire</strong></i></label></div></fieldset><br><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10"><legend>Parents</legend><div class="row"><div class="col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" data-translate="consulatApp.members.nomPere">Nom du p\xE8re</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.members.infoParents.nomPere"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_prenom" data-translate="consulatApp.members.prenomPere">Prenom du p\xE8re</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="prenom" id="field_prenom" ng-model="vm.members.infoParents.prenomPere"></div></div><div ng-if="vm.members.parentsUsa"><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.habiteUsa">Il habite aux USA.</strong></i></label></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_idPere" data-translate="consulatApp.members.noPere">No ID du P\xE8re</label><div class="col-sm-6"><input disabled="disabled" required type="text" class="form-control" name="idPere" id="field_idPere" ng-model="vm.members.infoParents.noPere"></div></div></div><div ng-if="!vm.members.parentsUsa" class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.habitePasUsa">Il n\'habite pas aux USA.</strong></i></label></div></div><div class="col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" data-translate="consulatApp.members.nomMere">Nom de la m\xE8re</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.members.infoParents.nomMere"></div></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_prenom" data-translate="consulatApp.members.prenomMere">Prenom de la m\xE8re</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="prenom" id="field_prenom" ng-model="vm.members.infoParents.prenomMere"></div></div><div class="form-group" ng-if="vm.members.mumInUsa"><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.habiteUsa">Elle habite aux USA</strong></i></label></div><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_noIdMere" data-translate="consulatApp.members.noMere">No ID de la M\xE8re</label><div class="col-sm-6"><input disabled="disabled" required type="text" class="form-control" name="noIdMere" id="field_noIdMere" ng-model="vm.members.infoParents.noMere"></div></div></div><div ng-if="!vm.members.mumInUsa" class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.habitePasUsa">Elle n\'habite pas aux USA.</strong></i></label></div></div></div></fieldset>');
$templateCache.put('app/entities/members/identification-modification.html','<fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.ident1">Identit\xE9 de la personne</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.members.nom">Nom</label><div class="col-sm-6"><input required type="text" placeholder="nom de la personne" class="form-control" name="nom" id="field_nom" ng-model="vm.members.nom"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_prenom" mf-required data-translate="consulatApp.members.prenom">Prenom</label><div class="col-sm-6"><input required type="text" placeholder="prenom de la personne" class="form-control" name="prenom" id="field_prenom" ng-model="vm.members.prenom"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_taille" mf-required data-translate="consulatApp.members.taille">Taille</label><div class="col-sm-6"><input required type="text" placeholder="taille en cm" class="form-control" name="taille" id="field_prenom" ng-model="vm.members.taille"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_libelle" mf-required data-translate="consulatApp.members.sexe">Sexe</label><div class="col-sm-6"><select required placeholder="sexe" class="form-control" name="libelle" ng-model="vm.members.sexe" id="field_libelle"><option value="MALE">HOMME</option><option value="FEMALE">FEMME</option></select></div></div><br><div class="form-group" ngf-drop ngf-change="vm.setPhoto($file, vm.members" ngf-pattern="\'image/*\'"><label class="control-label col-sm-3 ft16" for="field_photo" data-translate="consulatApp.members.photo">Photo</label><div class="col-sm-6"><div><img data-ng-src="{{\'data:\' + vm.members.photoContentType + \';base64,\' + vm.members.photo}}" style="max-height: 100px" ng-if="vm.members.photo" alt="members image"><div ng-if="vm.members.photo" class="help-block clearfix"><span class="pull-left">{{vm.members.photoContentType}}, {{vm.byteSize(vm.members.photo)}}</span></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPhoto($file, vm.members)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="photo" id="field_photo" ng-model="vm.members.photo"> <input type="hidden" class="form-control" name="photoContentType" id="field_photoContentType" ng-model="vm.members.photoContentType"></div></div></div><div class="row col-sm-6"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_metier" data-translate="consulatApp.members.metier">M\xE9tier</label><div class="col-sm-6"><input type="text" placeholder="metier" class="form-control" name="metier" id="field_metier" ng-model="vm.members.metier" disabled="disabled"></div><i title="Select a brand" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.metierId" j-list="vm.metiers" j-columns="vm.metierColumns" j-event-name="onLoadMetier">Choose...</i></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_telephone" data-translate="consulatApp.members.occupation">Poste</label><div class="col-sm-6"><input type="text" placeholder="poste occup\xE9" class="form-control" name="telephone" id="field_telephone" ng-model="vm.members.occupation"></div></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateNaissance" mf-required data-translate="consulatApp.members.dateNaissance">Date de Naissance</label><div class="col-sm-6"><input show-button-bar="false" placeholder="date de naissance" id="field_dateNaissance" type="text" class="form-control" name="dateNaissance" ng-model="vm.members.dateNaissance" uib-datepicker-popup="dd/MM/yyyy" is-open="vm.datePickerOpenStatus.dateNaissance" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateNaissance\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="field_marque_vehicule" data-translate="consulatApp.members.lieuNaissance">Lieu de Naissance</label><div class="col-sm-6"><input required type="text" placeholder="lieu de naissance" class="form-control" name="telephone" id="field_telephone" ng-model="vm.members.lieuNaissance"></div><i title="S\xE9lectionnez la marque" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.lieuNaissanceId" j-list="vm.pays" j-columns="vm.paysColumns" j-event-name="onLoadPays">Choose...</i></div><br><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.scanSignature">utiliser un scan pour la signature ?</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.scanSignature"> <span><i class="handle"></i></span></label></div><br><div ng-if="vm.members.scanSignature" class="form-group" ngf-drop ngf-change="vm.setSignature($file, vm.members" ngf-pattern="\'image/*\'"><label class="control-label col-sm-3 ft16" for="field_armoirie">Signature</label><div class="col-sm-6"><div><img data-ng-src="{{\'data:\' + vm.members.signatureContentType + \';base64,\' + vm.members.signature}}" style="max-height: 100px" ng-if="vm.members.signature" alt="members image"><div ng-if="vm.members.signature" class="help-block clearfix"><span class="pull-left">{{vm.members.signatureContentType}}, {{vm.byteSize(vm.members.signature)}}</span> <button type="button" ng-click="vm.members.signature=null;vm.members.signatureContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setSignature($file, vm.members)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="signature" id="field_signature" ng-model="vm.members.signature"> <input type="hidden" class="form-control" name="signatureContentType" id="field_signatureContentType" ng-model="vm.members.signatureContentType"></div></div><div class="signate" ng-if="!vm.members.scanSignature"><signature-pad accept="accept" clear="clear" height="100" width="200" dataurl="vm.members.signature"></signature-pad><div class="buttons"><button ng-click="clear()">Clear</button></div></div></div></fieldset><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.ident2">Informations sur le conjoint</legend><div class="row col-sm-6"><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.maried">Je suis mari\xE9(e)</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.mariage" ng-click="vm.mariage()"> <span><i class="handle"></i></span></label></div><br><br><div class="form-group" ng-if="vm.members.mariage"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.members.nomConjoint">Nom Conjoint(e)</label><div class="col-sm-5"><input required type="text" placeholder="spouse\'s last name" class="form-control" name="nom" id="field_nom" ng-model="vm.members.nomConjoint"></div></div><br><div class="form-group" ng-if="vm.members.mariage"><label class="control-label col-sm-3 ft16" for="field_prenom" mf-required data-translate="consulatApp.members.prenomConjoint">Prenom Conjoint(e)</label><div class="col-sm-5"><input required type="text" class="form-control" placeholder="spouse\'s firt name" name="prenom" id="field_prenom" ng-model="vm.members.prenomConjoint"></div></div><br><br><div><div class="form-group" ng-if="vm.members.mariage"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.partUSa">L\'\xE9poux(se) habite aux USA</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.memePaysConjoint" ng-click="vm.ville()"> <span><i class="handle"></i></span></label></div></div><br><br><div class="form-group" ng-if="vm.members.memePaysConjoint && vm.members.mariage"><label class="control-label col-sm-3 ft16" for="field_nom" data-translate="consulatApp.members.noConjoint" mf-required>No identification conjoint(te)</label><div class="col-sm-5"><input required type="text" placeholder="id number" class="form-control" name="nom" id="field_nom" ng-model="vm.members.noConjoint"></div></div></div></fieldset><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.ident3">Informations sur les parents ?</legend><br><br><br><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.members.nomPere">Nom du p\xE8re</label><div class="col-sm-6"><input required type="text" class="form-control" placeholder="father\'s last name" name="nom" id="field_nom" ng-model="vm.members.infoParents.nomPere"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_prenom" mf-required data-translate="consulatApp.members.prenomPere">Prenom du p\xE8re</label><div class="col-sm-6"><input required type="text" class="form-control" placeholder="father\'s first name" name="prenom" id="field_prenom" ng-model="vm.members.infoParents.prenomPere"></div></div><br><br><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.fatherUsa">Il habite aux USA</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.parentsUsa" ng-click="vm.inusa()"> <span><i class="handle"></i></span></label></div><br><br><br><div class="form-group" ng-if="vm.members.parentsUsa"><label mf-required class="control-label col-sm-3 ft16" for="field_idPere" data-translate="consulatApp.members.noPere">NO Id P\xE8re</label><div class="col-sm-6"><input required type="text" class="form-control" placeholder=" id number" name="idPere" id="field_idPere" ng-model="vm.members.infoParents.noPere"></div></div></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.members.nomMere">Nom de la m\xE8re</label><div class="col-sm-6"><input required type="text" class="form-control" placeholder="mother\'s last name" name="nom" id="field_nom" ng-model="vm.members.infoParents.nomMere"></div></div><br><div class="form-group"><label mf-required class="control-label col-sm-3 ft16" for="field_prenom" data-translate="consulatApp.members.prenomMere">Prenom de la m\xE8re</label><div class="col-sm-6"><input required type="text" class="form-control" placeholder="mother\'s first name" name="prenom" id="field_prenom" ng-model="vm.members.infoParents.prenomMere"></div></div><br><br><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.motherUsa">Elle habite aux USA</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.mumInUsa" ng-click="vm.inusae()"> <span><i class="handle"></i></span></label></div><br><br><br><div class="form-group" ng-if="vm.members.mumInUsa"><label class="control-label col-sm-3 ft16" for="field_noIdMere" data-translate="consulatApp.members.noMere">No Id M\xE8re</label><div class="col-sm-6"><input type="text" class="form-control" placeholder="id number" name="noIdMere" id="field_noIdMere" ng-model="vm.members.infoParents.noMere"></div></div></div></fieldset>');
$templateCache.put('app/entities/members/identification.html','<head><style>.cropArea {\n  background: #E4E4E4;\n  overflow: hidden;\n  width: 200px;\n  height: 200px;\n}\n\n       form .progress {\n  line-height: 15px;\n}\n\n.progress {\n  display: inline-block;\n  width: 10px;\n  border: 3px groove #CCC;\n}\n\n.progress div {\n  font-size: smaller;\n  background: orange;\n  width: 0;\n}</style></head><div class="col-sm-10 col-sm-offset-1 well"><fieldset ng-disabled="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.ident1">Identit\xE9 de la personne</legend><div class="row col-sm-12"></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.members.nom">Nom</label><div class="col-sm-6"><input required type="text" placeholder="lastName" class="form-control" name="nom" id="field_nom" ng-model="vm.members.nom"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_prenom" mf-required data-translate="consulatApp.members.prenom">Prenom</label><div class="col-sm-6"><input required type="text" placeholder="firstName" class="form-control" name="prenom" id="field_prenom" ng-model="vm.members.prenom"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_taille" mf-required data-translate="consulatApp.members.taille">Taille</label><div class="col-sm-6"><input required type="text" min="0" max="300" placeholder="height cm" class="form-control" name="taille" id="field_prenom" ng-model="vm.members.taille"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_libelle" mf-required data-translate="consulatApp.members.sexe">Sexe</label><div class="col-sm-6"><select required placeholder="sexe" class="form-control" name="libelle" ng-model="vm.members.sexe" id="field_libelle"><option value="MALE">MALE</option><option value="FEMALE">FEMALE</option></select></div></div><br><!--\n  <div class="form-group" ngf-drop ngf-change="vm.setPhoto($file, vm.members" ngf-pattern="\'image/*\'">\n    <label class="control-label col-sm-3 ft16" for="field_photo" data-translate="consulatApp.members.photo">Photo</label>\n    <div class="col-sm-6">\n        <div>\n            <img data-ng-src="{{\'data:\' + vm.members.photoContentType + \';base64,\' + vm.members.photo}}"\n                style="max-height: 100px;" ng-if="vm.members.photo" alt="members image" />\n            <div ng-if="vm.members.photo" class="help-block clearfix">\n                <span class="pull-left">{{vm.members.photoContentType}},\n                    {{vm.byteSize(vm.members.photo)}}</span>\n                <button type="button" ng-click="vm.members.photo=null;vm.personne.photoContentType=null;"\n                    class="btn btn-default btn-xs pull-right">\n                    <span class="glyphicon glyphicon-remove"></span>\n                </button>\n            </div>\n            <button type="button" ngf-select class="btn btn-default btn-block"\n                ngf-change="vm.setPhoto($file, vm.members)" accept="image/*">\n                Add image\n            </button>\n        </div>\n\n\n\n        <input type="hidden" class="form-control" name="photo" id="field_photo"\n            ng-model="vm.members.photo" />\n        <input type="hidden" class="form-control" name="photoContentType" id="field_photoContentType"\n            ng-model="vm.members.photoContentType" />\n    </div>\n</div>\n --><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_photo" data-translate="consulatApp.members.photo">Photo</label><div class="col-sm-6"><button class="btn btn-primary btn-xs col-sm-offset-7" ngf-select ng-model="vm.file" accept="image/*">Select Picture</button><div class="col-sm-offset-5"><div required ngf-drop ng-model="vm.file" ngf-pattern="image/*" class="cropArea"><img-crop image="vm.file  | ngfDataUrl" result-image="vm.croped" ng-init="croppedDataUrl=\'\'" area-type="square" area-min-size="200" change-on-fly="true"></img-crop></div></div><div class="col-sm-offset-5"><img ng-src="{{vm.croped}}"></div></div></div></div><div class="row col-sm-6"><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_metier" data-translate="consulatApp.members.metier">M\xE9tier</label><div class="col-sm-6"><input type="text" placeholder="metier" class="form-control" name="metier" id="field_metier" ng-model="vm.members.metier" disabled="disabled"></div><i title="Select a brand" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.metierId" j-list="vm.metiers" j-columns="vm.metierColumns" j-event-name="onLoadMetier">Choose...</i></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_telephone" data-translate="consulatApp.members.occupation">Poste</label><div class="col-sm-6"><input type="text" placeholder="occupation" class="form-control" name="telephone" id="field_telephone" ng-model="vm.members.occupation"></div></div><br><div class="form-group has-feedback"><label class="control-label col-sm-3 ft16" for="field_dateDebut" mf-required data-translate="consulatApp.members.dateNaissance">Date de Naissance</label><div class="col-sm-6"><input show-button-bar="false" placeholder="date of birth" id="field_dateNaissance" type="text" class="form-control" name="dateNaissance" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.members.dateNaissance" is-open="vm.datePickerOpenStatus.dateNaissance" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateNaissance\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="field_marque_vehicule" data-translate="consulatApp.members.lieuNaissance">Lieu de Naissance</label><div class="col-sm-6"><input required type="text" placeholder="place of birth" class="form-control" name="telephone" id="field_telephone" ng-model="vm.members.lieuNaissance"></div><i title="choose" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.members.lieuNaissanceId" j-list="vm.pays" j-columns="vm.paysColumns" j-event-name="onLoadPays">Choose...</i></div><br><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.scanSignature">utiliser un scan pour la signature ?</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.scanSignature"> <span><i class="handle"></i></span></label></div><br><div ng-if="vm.members.scanSignature" class="form-group" ngf-drop ngf-change="vm.setSignature($file, vm.members" ngf-pattern="\'image/*\'"><label class="control-label col-sm-3 ft16" for="field_armoirie">Signature</label><div class="col-sm-6"><div><img data-ng-src="{{\'data:\' + vm.members.signatureContentType + \';base64,\' + vm.members.signature}}" style="max-height: 100px" ng-if="vm.members.signature" alt="members image"><div ng-if="vm.members.signature" class="help-block clearfix"><span class="pull-left">{{vm.members.signatureContentType}}, {{vm.byteSize(vm.members.signature)}}</span> <button type="button" ng-click="vm.members.signature=null;vm.members.signatureContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setSignature($file, vm.members)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="signature" id="field_signature" ng-model="vm.members.signature"> <input type="hidden" class="form-control" name="signatureContentType" id="field_signatureContentType" ng-model="vm.members.signatureContentType"></div></div><div ng-if="!vm.members.scanSignature" class="signate"><label mf-required class="control-label col-sm-3 ft16" for="field_signature">Signature</label><signature-pad accept="accept" clear="clear" height="100" width="200" dataurl="vm.members.signature"></signature-pad><div class="buttons"><button ng-click="clear()">Clear</button></div></div></div></fieldset><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.ident2">Informations sur le conjoint</legend><div class="row col-sm-6"><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.maried">Etes vous mari\xE9s(e) ?</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.mariage" ng-click="vm.mariage()"> <span><i class="handle"></i></span></label></div><br><br><div class="form-group" ng-if="vm.members.mariage"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.members.nomConjoint">Nom Conjoint(e)</label><div class="col-sm-5"><input required type="text" placeholder="spouse\'s last name" class="form-control" name="nom" id="field_nom" ng-model="vm.members.nomConjoint"></div></div><br><div class="form-group" ng-if="vm.members.mariage"><label class="control-label col-sm-3 ft16" for="field_prenom" mf-required data-translate="consulatApp.members.prenomConjoint">Prenom Conjoint(e)</label><div class="col-sm-5"><input required type="text" class="form-control" placeholder="spouse\'s firts name" name="prenom" id="field_prenom" ng-model="vm.members.prenomConjoint"></div></div><br><br><div><div class="form-group" ng-if="vm.members.mariage"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.partUSa">L\'\xE9poux(se) habite t\'il (elle) aux USA</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.memePaysConjoint" ng-click="vm.ville()"> <span><i class="handle"></i></span></label></div></div><br><br><div class="form-group" ng-if="vm.members.memePaysConjoint && vm.members.mariage"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.members.noConjoint">No identification conjoint(te)</label><div class="col-sm-5"><input required type="text" placeholder=" no d\'identification des usa" class="form-control" name="nom" id="field_nom" ng-model="vm.members.noConjoint"></div></div></div></fieldset><fieldset ng-hide="vm.isViewing" class="mf-fieldset p10"><legend data-translate="consulatApp.members.ident3">Informations sur les parents ?</legend><br><br><br><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required no identification conjoint(te) data-translate="consulatApp.members.nomPere">Nom du p\xE8re</label><div class="col-sm-6"><input required type="text" class="form-control" placeholder="father\'s last name" name="nom" id="field_nom" ng-model="vm.members.infoParents.nomPere"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_prenom" mf-required data-translate="consulatApp.members.prenomPere">Prenom du p\xE8re</label><div class="col-sm-6"><input required type="text" placeholder="father\'s first name" class="form-control" name="prenom" id="field_prenom" ng-model="vm.members.infoParents.prenomPere"></div></div><br><br><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.fatherUsa">Habite t\'il aux USA ?</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.parentsUsa" ng-click="vm.pereUsa()"> <span><i class="handle"></i></span></label></div><br><br><br><div class="form-group" ng-if="vm.members.parentsUsa"><label class="control-label col-sm-3 ft16" for="field_idPere" mf-required data-translate="consulatApp.members.noPere">NO Id P\xE8re</label><div class="col-sm-6"><input required type="text" class="form-control" placeholder=" identification number" name="idPere" id="field_idPere" ng-model="vm.members.infoParents.noPere"></div></div></div><div class="row col-sm-6"><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_nom" mf-required data-translate="consulatApp.members.nomMere">Nom de la m\xE8re</label><div class="col-sm-6"><input required type="text" placeholder="mother\'s last name" class="form-control" name="nom" id="field_nom" ng-model="vm.members.infoParents.nomMere"></div></div><br><div class="form-group"><label class="control-label col-sm-3 ft16" for="field_prenom" data-translate="consulatApp.members.prenomMere">Prenom de la m\xE8re</label><div class="col-sm-6"><input type="text" placeholder="mother\'s first name" class="form-control" name="prenom" id="field_prenom" ng-model="vm.members.infoParents.prenomMere"></div></div><br><br><div class="form-group"><label class="control-label h5 col-sm-8 text-center"><i><strong data-translate="consulatApp.members.motherUsa">Habite t\'elle aux USA ?</strong></i></label><label class="switch switch-sm"><input type="checkbox" ng-model="vm.members.mumInUsa"> <span><i class="handle"></i></span></label></div><br><br><br><div class="form-group" ng-if="vm.members.mumInUsa"><label class="control-label col-sm-3 ft16" for="field_noIdMere" data-translate="consulatApp.members.noMere">No Id M\xE8re</label><div class="col-sm-6"><input type="text" class="form-control" placeholder="identification number" name="noIdMere" id="field_noIdMere" ng-model="vm.members.infoParents.noMere"></div></div></div></fieldset></div>');
$templateCache.put('app/entities/members/members-cartes.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="row" ng-if="vm.filtrer"><div class="form-group col-sm-2"><input type="text" placeholder="Nom" required class="form-control" id="field_nom" ng-model="vm.itemSearch.nom" name="nom"> <input type="text" placeholder="Prenom" required class="form-control" id="field_prenom" ng-model="vm.itemSearch.prenom" name="prenom"></div><div class="form-group col-sm-2"><input type="text" placeholder="Numero de la carte" required class="form-control" id="field_numero" ng-model="vm.itemSearch.numero" name="numero"> <input type="text" placeholder="Metier" required class="form-control" id="field_metier" ng-model="vm.itemSearch.metier" name="metier"></div><div class="form-group col-sm-2"><input show-button-bar="false" placeholder=" Date debut" is-open="vm.datePickerOpenStatus.dateDebut" uib-datepicker-popup="dd/MM/yyyy" ng-focus="vm.openCalendar(\'dateDebut\')" class="form-control" ng-model="vm.itemSearch.dateDebut" name="dateDebut"><select required class="form-control" name="statut" ng-model="vm.itemSearch.statut" id="field_statut"><option value="">Statut</option><option value="ACTIVE">ACTIVE</option><option value="ANNULEE">ANNULEE</option><option value="EXPIREE">EXPIREE</option></select></div><div class="form-group col-sm-2"><input show-button-bar="false" ng-disabled="!vm.itemSearch.dateDebut" placeholder=" Date fin" is-open="vm.datePickerOpenStatus.dateFin" uib-datepicker-popup="dd/MM/yyyy" ng-focus="vm.openCalendar(\'dateFin\')" class="form-control" ng-model="vm.itemSearch.dateFin" name="dateFin"><div ng-show="vm.dateFinEstAvantDateDebut() "><p class="alert alert-danger">La date de fin doit \xEAtre sup\xE9rieure \xE0 la date de Debut.</p></div><select required class="form-control" name="sexe" ng-model="vm.itemSearch.sexe" id="field_sexe"><option value="">Sexe</option><option value="MALE">MALE</option><option value="FEMALE">FEMALE</option></select></div><div class="form-group col-sm-4"><div class="col-sm-4"><button class="btn btn-warnig btn-md" ng-click="vm.initFiltre()"><span class="glyphicon glyphicon-search" data-translate="entity.action.cancel">Annuler</span></button></div><div class="col-sm-4"><button class="btn btn-info btn-md" ng-disabled="vm.dateFinEstAvantDateDebut()" ng-click="vm.init()"><span class="glyphicon glyphicon-search" data-translate="global.menu.entities.filtrer">Filtrer</span></button></div></div></div><div class="mb5"></div></div><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><div class="form-group" ng-if="!vm.filtrer"><div class="pull-right"><button class="btn btn-info btn-md" ng-click="vm.filtrer=true"><span class="glyphicon glyphicon-search" data-translate="global.menu.entities.filtrer">Filtrer</span></button></div></div><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div><div style="text-align: center; font-weight: bold; margin-top: 6px; margin-bottom: 3px; text-decoration: underline"><h3><span data-translate="consulatApp.members.cartes">Nombre d\'inscrits</span> : {{vm.totalItems}}</h3></div></div></div><div class="row mt-3 bg-white"><div class="col-sm-10 col-sm-offset-1"><div class="grid-container"><div ng-repeat="carte in vm.datas track by carte.id"><div class="card mb-3" style="width: 250px"><div class="row no-gutters"><div class="col-md-5"><img ng-if="carte.photo" data-ng-src="{{\'data:\' + carte.photoContentType + \';base64,\' + carte.photo}}" style="max-height: 100px" alt="member image"> <svg ng-if="!carte.photo" class="bd-placeholder-img" width="100" height="100" xmlns="http://www.w3.org/2000/svg" aria-label="Placeholder: Image" preserveAspectRatio="xMidYMid slice" role="img"><title>Placeholder</title><rect width="100%" height="100%" fill="#868e96"/><text x="50%" y="50%" fill="#dee2e6" dy=".3em">Image</text></svg></div><div class="col-md-7"><div class="card-body"><h5 class="card-title"><stong style="font-weight: bold; margin-bottom: 2px">ID: {{carte.numero}}</stong></h5><h5 class="card-title">{{carte.nom }} {{carte.prenom | characters:30}}</h5><h6 class="card-text">{{carte.villeResidence | characters:30}}, {{carte.etatResidence}}</h6><br><h6 style="font-weight: bold; margin-bottom: 2px"><span ng-if="carte.statut==\'ACTIVE\'" class="alert alert-success">{{carte.statut}}</span> <span ng-if="carte.statut==\'ANNULEE\'" class="alert alert-danger">{{carte.statut}}</span> <span ng-if="carte.statut==\'EXPIREE\'" class="alert alert-warning">{{carte.statut}}</span></h6><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="View" ng-click="vm.detailItem($event,carte)" class="btn btn-primary btn-xs btn-round"><span class="glyphicon glyphicon-eye-open"></span></button></div></div></div></div></div><br></div></div></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div><footer class="navbar-fixed-bottom text-center"></footer>');
$templateCache.put('app/entities/members/members-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.members.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Members?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/members/members-detail.html','<form name="editForm" role="form" novalidate class="container-fluid form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQuitanceLabel">informations du membre</h4></div><div class="modal-body"><div class="box-tab justified" id="rootwizard"><ul class="nav nav-tabs"><li ng-repeat="step in vm.steps" ng-class="{active: $index==vm.getCurrentStepIndex()}"><a href="javascript:void(0)" ng-click="vm.goToStep($index,editForm)">{{step}}</a></li></ul><!-- Information de l\'identification--><div class="tab-pane" ng-if="vm.showOnglet(\'IDENTIFICATION\',0)"><div ng-include="\'app/entities/members/identification-modification.html\'" scope="" onload=""></div></div><!--Informations de la carte grise--><div class="tab-pane" ng-if="vm.showOnglet(\'ADRESS\',1)"><div ng-include="\'app/entities/members/adresse-modification.html\'" scope="" onload=""></div></div><!--Informations de la quitance--><div class="tab-pane" ng-if="vm.showOnglet(\'DOC IDENTIFICATION\',2)"><div ng-include="\'app/entities/members/doc-identification-modification.html\'" scope="" onload=""></div></div><!--Informations de la quitance--><div class="tab-pane" ng-if="vm.showOnglet(\'ASSOCIATION\',3)"><div ng-include="\'app/entities/members/association-modification.html\'" scope="" onload=""></div></div><!--Informations de l\'annulation de la carte--><div class="tab-pane" ng-if="vm.showOnglet(\'ANNULATION CARTE\',4)"><div ng-include="\'app/entities/members/annulation-carte.html\'" scope="" onload=""></div></div><div class="tab-pane" ng-if="vm.showOnglet(\'ELECTION\',5)"><div ng-include="\'app/entities/members/election.html\'" scope="" onload=""></div></div></div></div><div class="col-sm-4 col-sm-offset-10"><button type="button" ng-click="vm.decrementStep()" ng-show="vm.hasPreviousStep()" type="button" class="btn btn-warning btn-sm" data-dismiss="modal"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span>Precedent</span></button> <button type="button" ng-show="vm.hasNextStep()" ng-click=" vm.incrementStep()" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-click="vm.next()"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp; <span>Suivant</span></button> <button ng-show="!vm.hasNextStep()" ng-disabled="editForm.$invalid || vm.isSaving" ng-click="vm.save()" confirm="Etes-vous sure de vouloir modifier ce membre?" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/members/members-dialog.html','<form name="editForm" role="form" novalidate class="container-fluid form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQuitanceLabel"></h4></div><div class="modal-body"><div ng-include="\'app/entities/members/identification-consultation.html\'"></div><br><div ng-include="\'app/entities/members/adresse-consultation.html\'"></div><br><div ng-include="\'app/entities/members/doc-identification-consultation.html\'"></div><br><div ng-include="\'app/entities/members/association-consultation.html\'"></div><br><div ng-include="\'app/entities/members/historiques-consultation.html\'"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span ng-hide="vm.isViewing" data-translate="entity.action.cancel">Fermer</span> <span ng-show="vm.isViewing">Fermer</span></button><!--        <button type="button"  class="btn btn-success" data-dismiss="modal" ng-click="vm.etatCarte()">--><!--            <span class="glyphicon glyphicon-print"></span>&nbsp;--><!--            <span data-translate="consulatApp.members.print" >Imprimer carte</span>--><!--        </button>--></div></form>');
$templateCache.put('app/entities/members/members-stats.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="row" ng-if="vm.filtrer"><div class="form-group col-sm-2"><input type="text" placeholder="Nom" required class="form-control" id="field_nom" ng-model="vm.itemSearch.nom" name="nom"> <input type="text" placeholder="Prenom" required class="form-control" id="field_prenom" ng-model="vm.itemSearch.prenom" name="prenom"></div><div class="form-group col-sm-2"><input type="text" placeholder="ville de r\xE9sidence" required class="form-control" id="field_villeResidence" ng-model="vm.itemSearch.villeResidence" name="villeResidence"> <input type="text" placeholder="Etat de residence" required class="form-control" id="field_etatResidence" ng-model="vm.itemSearch.etatResidence" name="etatResidence"></div><div class="form-group col-sm-2"><input type="text" placeholder="Telephone USA" required class="form-control" id="field_telephone" ng-model="vm.itemSearch.telephone" name="telephone"> <input type="text" placeholder="Telephone BF" required class="form-control" id="field_numeroBf" ng-model="vm.itemSearch.numeroBf" name="numeroBf"></div><div class="form-group col-sm-2"><input type="text" placeholder="Metier" required class="form-control" id="field_metier" ng-model="vm.itemSearch.metier" name="metier"> <input type="text" placeholder="Poste" required class="form-control" id="field_poste" ng-model="vm.itemSearch.occupation" name="poste"></div><div class="form-group col-sm-2"><select required class="form-control" name="mariage" ng-model="vm.itemSearch.mariage" id="field_mariage"><option value="">Mari\xE9(e)?</option><option value="TRUE">YES</option><option value="FALSE">FALSE</option></select><select required class="form-control" name="sexe" ng-model="vm.itemSearch.sexe" id="field_sexe"><option value="">Sexe</option><option value="MALE">MALE</option><option value="FEMALE">FEMALE</option></select></div><div class="form-group col-sm-2"><select required class="form-control" name="sexe" ng-model="vm.itemSearch.parentsUsa" id="field_usa"><option value="">Parents aux USA</option><option value="TRUE">YES</option><option value="FALSE">FALSE</option></select><select required class="form-control" id="field_doc" name="doc" ng-model="vm.itemSearch.autorite" ng-options="doc.libelle as doc.libelle for doc in vm.documents"><option value="">Type de Document</option></select></div><div class="form-group col-sm-2"><select required class="form-control" name="candidate" ng-model="vm.itemSearch.candidate" id="candidate"><option value="">Candidat(e) ?</option><option value="TRUE">YES</option><option value="FALSE">FALSE</option></select><select required class="form-control" id="field_zone" name="doc" ng-model="vm.itemSearch.zoneId" ng-options="zone.id as zone.libelle for zone in vm.zones"><option value="">Zone</option></select></div><!--   <div class="form-group col-sm-2">\n                <input show-button-bar="false" id="field_dateArrivee" placeholder="La date d\'arriv\xE9e" type="text"\n                    class="form-control" name="dateArrivee" uib-datepicker-popup="dd/MM/yyyy"\n                    ng-model="vm.itemSearch.dateArrivee" is-open="vm.datePickerOpenStatus.dateArrivee" required />\n                <span class="input-group-btn">\n                    <button type="button" class="btn btn-default btn-xs" ng-click="vm.openCalendar(\'dateArrivee\')"><i\n                            class="glyphicon glyphicon-calendar"></i></button>\n                </span>\n            </div> --><div class="form-group col-sm-2"><select required class="form-control" id="field_consulat" name="doc" ng-model="vm.itemSearch.consulatId" ng-options="consulat.id as consulat.nom for consulat in vm.consulats"><option value="">Consulate</option></select><select required class="form-control" id="field_position" name="doc" ng-model="vm.itemSearch.positionId" ng-options="position.id as position.libelle for position in vm.positions"><option value="">Position</option></select></div><div class="form-group col-sm-4"><div class="col-sm-4"><button class="btn btn-warnig btn-md" ng-click="vm.initFiltre()"><span class="glyphicon glyphicon-search" data-translate="entity.action.cancel">Annuler</span></button></div><div class="col-sm-4"><button class="btn btn-info btn-md" ng-disabled="vm.dateFinEstAvantDateDebut()" ng-click="vm.init()"><span class="glyphicon glyphicon-search" data-translate="global.menu.entities.filtrer">Filtrer</span></button></div></div></div><div class="mb5"></div></div><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><div class="form-group" ng-if="!vm.filtrer"><div class="pull-right"><button class="btn btn-info btn-md" ng-click="vm.filtrer=true"><span class="glyphicon glyphicon-search" data-translate="global.menu.entities.filtrer">Filtrer</span></button></div></div><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div><div style="text-align: center; font-weight: bold; margin-top: 6px; margin-bottom: 3px; text-decoration: underline"><h3><span data-translate="consulatApp.members.registers">Nombre d\'inscrits</span> : {{vm.totalItems}}</h3></div></div></div><div class="row mt-3 bg-white"><div class="col-sm-10 col-sm-offset-1"><div class="grid-container"><div ng-repeat="member in vm.datas track by member.id"><div class="card mb-3" style="width: 250px"><div class="row no-gutters"><div class="col-md-5"><img ng-if="member.photo" data-ng-src="{{\'data:\' + member.photoContentType + \';base64,\' + member.photo}}" style="max-height: 100px" alt="member image"> <svg ng-if="!member.photo" class="bd-placeholder-img" width="100" height="100" xmlns="http://www.w3.org/2000/svg" aria-label="Placeholder: Image" preserveAspectRatio="xMidYMid slice" role="img"><title>Placeholder</title><rect width="100%" height="100%" fill="#868e96"/><text x="50%" y="50%" fill="#dee2e6" dy=".3em">Image</text></svg></div><div class="col-md-7"><div class="card-body"><h5 class="card-title"><span style="font-weight: bold; margin-bottom: 2px">ID: {{member.numero}}</span></h5><h5 class="card-title">{{member.nom }} {{member.prenom | characters:30}}</h5><p class="card-text">{{member.villeResidence | characters:30}}, {{member.etatResidence}}</p><p class="card-text"></p><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="View" ng-click="vm.detailItem($event,member)" class="btn btn-primary btn-xs btn-round"><span class="glyphicon glyphicon-eye-open"></span></button> <button ng-if="vm.user.profilId!=null" type="submit" title="modify" ng-click="vm.editItem($event,member)" class="btn btn-sucess btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-if="vm.user.profilId!=null" type="submit" title="print card" ng-click="vm.etatCarte(member.id)" confirm="Etes-vous sure de vouloir g\xE9n\xE9rer la carte?" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-book"></span></button></div><p></p></div></div></div></div><br></div></div></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div><footer class="navbar-fixed-bottom text-center"></footer>');
$templateCache.put('app/entities/members/members-vote-resultat.html','<div class="container-fluid"><br><br><div class="text-center"><span class="h4"><u>R\xE9sultats des votes par Zone \xC9lectorale</u></span></div><br><br><div class="col-sm-10 col-sm-offset-1 mb5"><div class="form-group col-sm-2"><select required class="form-control" id="field_zone" name="doc" ng-model="vm.zoneId" ng-options="zone.id as zone.libelle for zone in vm.zones"><option value="">Zone</option></select></div><div class="mb5"></div></div><div class="panel-body"><div class="canvas-holder"><canvas id="EtatCandidat-bar" class="chart chart-bar" chart-data="vm.etatCandidat.data" chart-labels="vm.etatCandidat.labels" chart-options="vm.etatCandidat.options"></canvas></div></div></div><footer class="navbar-fixed-bottom text-center"></footer>');
$templateCache.put('app/entities/members/members.html','<form name="editForm" role="form" novalidate class="form-horizontal" ng-if="vm.user.id!=null"><div class="row mt10" style="margin-top:10px; margin-bottom:5px"><div class="box-tab justified" id="rootwizard"><ul class="nav nav-tabs"><li ng-repeat="step in vm.steps" ng-class="{active: $index==vm.getCurrentStepIndex()}"><a href="javascript:void(0)" ng-click="vm.goToStep($index,editForm)">{{step}}</a></li></ul><div><div class="tab-pane" ng-if="vm.showOnglet(\'IDENTIFICATION\')"><div ng-include="\'app/entities/members/identification.html\'" scope="" onload=""></div></div><div class="tab-pane" ng-if="vm.showOnglet(\'CONTACTS AND ARRIVALS\')"><div ng-include="\'app/entities/members/adresse.html\'" scope="" onload=""></div></div><div class="tab-pane" ng-if="vm.showOnglet(\'IDENTIFICATION DOC\')"><div ng-include="\'app/entities/members/doc-identification.html\'" scope="" onload=""></div></div><div class="tab-pane" ng-if="vm.showOnglet(\'ASSOCIATION\')"><div ng-include="\'app/entities/members/association.html\'" scope="" onload=""></div></div></div></div></div><div class="col-sm-4 col-sm-offset-10"><button type="button" ng-click="vm.decrementStep()" ng-show="vm.hasPreviousStep()" type="button" class="btn btn-warning btn-sm" data-dismiss="modal"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span>Precedent</span></button> <button type="button" ng-show="vm.hasNextStep()" ng-click=" vm.incrementStep()" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-click="vm.next()"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp; <span>Suivant</span></button> <button type="button" ng-show="!vm.hasNextStep()" ng-disabled="editForm.$invalid || vm.isSaving" confirm="Etes-vous sure de vouloir enregistrer ce membre?" ng-click="vm.saveMembre()" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form><div ng-cloak ng-if="vm.user.id==null"><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="text-danger text-center" style="margin-top: 40px"><h1 class="">Administrator can\'t access to this service!!!</h1></div><div class="col-md-7 col-sm-offset-5" style="margin-top: 120px"><img class="bd-placeholder-img" width="300" height="300" src="../../../content/images/armoirie.png" alt=""></div></div></div>');
$templateCache.put('app/entities/profil/profil-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.profil.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Profil?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/profil/profil-detail.html','<div><h2><span>Profil</span> {{vm.profil.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Nom</span></dt><dd><span>{{vm.profil.nom}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.profil.description}}</span></dd><dt><span>Authority</span></dt><dd><span ng-repeat="authority in vm.profil.authorities"><a ui-sref="authority-detail({id: authority.id})">{{authority.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span>User</span></dt><dd>{{vm.profil.userLogin}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="profil-detail.edit({id:vm.profil.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/profil/profil-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProfilLabel" data-translate="consulatApp.profil.home.createLabel">Create or edit a Profil</h4></div><div class="modal-body"><div class="form-group"><label mf-required class="control-label col-sm-4" for="field_nom" data-translate="consulatApp.profil.nom">Nom</label><div class="col-sm-6"><input disabled="disabled" type="text" class="form-control" name="nom" id="field_nom" ng-model="vm.profil.nom" required></div></div><div class="form-group"><label class="control-label col-sm-4" for="field_description">Description</label><div class="col-sm-6"><textarea disabled="disabled" type="text" class="form-control" name="description" id="field_description" ng-model="vm.profil.description" ng-maxlength="1000"></textarea></div></div><div class="form-group"><label mf-required class="control-label col-sm-4" data-translate="consulatApp.profil.rules">Role</label><div class="col-sm-6"><select disabled="disabled" required style="height: 120px" class="form-control" multiple="multiple" name="authority" ng-model="vm.profil.authorities" ng-options="authority for authority in vm.authorities"></select></div><!-- i  title="choose the rules" class="btn btn-primary btn-xs"\n                j-select-dialog\n                j-multiple="true"\n                j-model="vm.authIds"\n                j-list="vm.auth"\n                j-columns="vm.roleColums"\n                j-event-name="onLoadRoles"\n            >Choisir...</i> --></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Fermer</span></button><!-- <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>\n        </button>--></div></form>');
$templateCache.put('app/entities/profil/profils.html','<div class="container-fluid col-sm-10 col-sm-offset-1"><div class="row mb5"><div class="no-padding-left"><!-- <button class="btn btn-primary btn-outline"  title="Ajouter" ng-click="vm.addItem()">\n                <span class="glyphicon glyphicon-plus"></span>\n                <span class="hidden-xs-down">\n                    Nouveau\n                </span>\n            </button> --><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div><!--<div class="btn-group col-sm-3 mr15 pull-right" uib-dropdown>--><!--<select class="form-control" id="field_organisation" ng-change="vm.initInfo()" name="organisation" ng-model="vm.organisationId"--><!--ng-options="organisation.id as organisation.nom for organisation in vm.organisations" ng-disabled="vm.isViewing">--><!--<option value="">--><!--<i>Toutes les organisations</i>--><!--</option>--><!--</select>--><!--</div>--></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.profil.home.title">Liste des profils</u></span></div></div><div class="row"><div><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'nom\') " class="col-lg-3"><span data-translate="consulatApp.profil.nom">Nom</span> <span ng-if="vm.isCurrentColumn(\'code\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'description\') " class="col-lg-5"><span>Description</span> <span ng-if="vm.isCurrentColumn(\'code\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="col-lg-1">Actions</th></tr></thead><tbody><tr ng-repeat="profil in vm.datas track by profil.id"><td title="{{profil.nom}}">{{profil.nom | characters:30}}</td><td title="{{profil.description}}">{{profil.description | characters:45}}</td><td class="col-lg-1"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,profil)" class="btn btn-info btn-xs btn-round"><span class="glyphicon glyphicon-eye-open"></span></button><!-- <button type="submit" title="Supprimer"  ng-click="vm.deleteItem($event,profil)" class="btn btn-danger btn-xs btn-round">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                            </button> --></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/states/states-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.states.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this States?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/states/states-detail.html','<div><h2><span>States</span> {{vm.states.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Code</span></dt><dd><span>{{vm.states.code}}</span></dd><dt><span>Libelle</span></dt><dd><span>{{vm.states.libelle}}</span></dd><dt><span>Country</span></dt><dd><a ui-sref="country-detail({id:vm.states.countryId})">{{vm.states.countryLibelle}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="states-detail.edit({id:vm.states.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/states/states-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCityLabel" data-translate="consulatApp.states.home.createLabel">Ajouter un Etat</h4></div><div class="modal-body"><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_intitule" data-translate="consulatApp.states.libelle">Libelle</label><div class="col-sm-6"><input type="text" class="form-control" name="intitule" id="field_intitule" ng-model="vm.states.libelle" ng-disabled="vm.isViewing" required></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_numero">Code</label><div class="col-sm-6"><input type="text" class="form-control" name="numero" id="field_numero" ng-model="vm.states.code" ng-disabled="vm.isViewing" required></div></div><div class="form-group has-feedback"><label mf-required class="control-label col-sm-3 ft16" for="pays" data-translate="consulatApp.states.country">Pays</label><div class="col-sm-6"><select disabled="disabled" placeholder="pays" required class="form-control" id="field_etat" name="etat" ng-model="vm.states.countryId" ng-options="country.id as country.libele for country in vm.countries"><option value=""></option></select></div><i title="S\xE9lectionnez la ville" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.states.countryId" j-list="vm.countries" j-columns="vm.countryColumns" j-event-name="onLoadCountriess">Choisir...</i></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/states/states.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" title="Ajouter" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.states.home.title">Liste des Etats</u></span></div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'code\') " class="col-lg-3"><span>Code</span> <span ng-if="vm.isCurrentColumn(\'code\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'libelle\') " class="col-lg-3"><span data-translate="consulatApp.states.libelle">Libelle</span> <span ng-if="vm.isCurrentColumn(\'libelle\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'countryLibele\') " class="col-lg-3"><span data-translate="consulatApp.states.country">Pays</span> <span ng-if="vm.isCurrentColumn(\'countryLibele\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right"><span>Actions</span></th><th></th></tr></thead><tbody><tr ng-repeat="states in vm.datas track by states.id"><td title="{{states.code}}">{{states.code | characters:45}}</td><td title="{{states.intitule}}">{{states.libelle | characters:45}}</td><td title="{{states.countryLibele}}">{{states.countryLibele | characters:45}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,states)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" title="Supprimer" ng-click="vm.deleteItem($event,states)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/position/position-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.position.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Position?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/position/position-detail.html','<div><h2><span>Position</span> {{vm.position.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Numero</span></dt><dd><span>{{vm.position.numero}}</span></dd><dt><span>Libelle</span></dt><dd><span>{{vm.position.libelle}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.position.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="position-detail.edit({id:vm.position.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/position/position-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCityLabel">Ajouter un position</h4></div><div class="modal-body"><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_position">Code</label><div class="col-sm-6"><input type="text" class="form-control" name="position" id="field_zposition" ng-model="vm.position.code" ng-disabled="vm.isViewing" required></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_numero">Libelle</label><div class="col-sm-6"><input type="text" class="form-control" name="libelle" id="field_numero" ng-model="vm.position.libelle" ng-disabled="vm.isViewing" required></div></div><div class="form-group has-feedbackp"><label class="control-label col-sm-3" for="field_description">Description</label><div class="col-sm-6"><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.position.description" ng-maxlength="1000"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/position/position.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" title="Ajouter" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="text-center"><span class="h4"><u>Liste des position</u></span></div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'numero\') " class="col-lg-3"><span>Code</span> <span ng-if="vm.isCurrentColumn(\'numero\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'libelle\') " class="col-lg-3"><span>Libelle</span> <span ng-if="vm.isCurrentColumn(\'libelle\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'description\') " class="col-lg-3"><span>Description</span> <span ng-if="vm.isCurrentColumn(\'description\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right"><span>Actions</span></th><th></th></tr></thead><tbody><tr ng-repeat="position in vm.datas track by position.id"><td title="{{position.code}}">{{position.code | characters:45}}</td><td title="{{position.libelle}}">{{position.libelle | characters:45}}</td><td title="{{position.description}}">{{position.description | characters:45}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,position)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" title="Supprimer" ng-click="vm.deleteItem($event,position)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/entities/type-association/type-association-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.typeAssociation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="consulatApp.typeAssociation.delete.question" translate-values="{id: \'{{vm.typeAssociation.id}}\'}">Are you sure you want to delete this Type Association?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/type-association/type-association-detail.html','<div><h2><span data-translate="consulatApp.typeAssociation.detail.title">Type Association</span> {{vm.typeAssociation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="consulatApp.typeAssociation.libelle">Libelle</span></dt><dd><span>{{vm.typeAssociation.libelle}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="type-association-detail.edit({id:vm.typeAssociation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/type-association/type-association-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTypeAssociationLabel" data-translate="consulatApp.typeAssociation.home.createOrEditLabel">Create or edit a Type Association</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typeAssociation.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.typeAssociation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="consulatApp.typeAssociation.libelle" for="field_libelle">Libelle</label><input type="text" class="form-control" name="libelle" id="field_libelle" ng-model="vm.typeAssociation.libelle"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/type-association/type-associations.html','<div><h2 data-translate="consulatApp.typeAssociation.home.title">Type Associations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="type-association.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="consulatApp.typeAssociation.home.createLabel">Create new Type Association</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="libelle"><span data-translate="consulatApp.typeAssociation.libelle">Libelle</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="typeAssociation in vm.typeAssociations track by typeAssociation.id"><td><a ui-sref="type-association-detail({id:typeAssociation.id})">{{typeAssociation.id}}</a></td><td>{{typeAssociation.libelle}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="type-association-detail({id:typeAssociation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="type-association.edit({id:typeAssociation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="type-association.delete({id:typeAssociation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/user-extra/user-extra-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.userExtra.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User Extra?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/user-extra/user-extra-detail.html','<div><h2><span>User Extra</span> {{vm.userExtra.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Code</span></dt><dd><span>{{vm.userExtra.code}}</span></dd><dt><span>Telephone</span></dt><dd><span>{{vm.userExtra.telephone}}</span></dd><dt><span>Photo</span></dt><dd><div ng-if="vm.userExtra.photo"><a ng-click="vm.openFile(vm.userExtra.photoContentType, vm.userExtra.photo)">open</a> {{vm.userExtra.photoContentType}}, {{vm.byteSize(vm.userExtra.photo)}}</div></dd><dt><span>User</span></dt><dd>{{vm.userExtra.userId}}</dd><dt><span>Consulat</span></dt><dd><a ui-sref="consulat-detail({id:vm.userExtra.consulatId})">{{vm.userExtra.consulatId}}</a></dd><dt><span>Profil</span></dt><dd><a ui-sref="profil-detail({id:vm.userExtra.profilId})">{{vm.userExtra.profilId}}</a></dd><dt><span>Members</span></dt><dd><a ui-sref="members-detail({id:vm.userExtra.membersId})">{{vm.userExtra.membersId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="user-extra-detail.edit({id:vm.userExtra.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/user-extra/user-extra-dialog.html','<!-- <head>\n    <script defer>\n        window.VerifaliaWidgetConfig = {\n          appKey: \'b56d9ef3d9b84c14aa408cb8ecab57fd\'\n        };\n      </script>\n      <script defer\n        src="https://unpkg.com/verifalia-widget@1.2.0/dist/verifalia-widget.js"\n        integrity="sha512-KNWaWGZz1V4Hm+9e4pdMB0rJ/wOY3ifDIYdfnHyoRnAXtpTxvxU+beMZ6nO//qqPYWcm9uFlIA1eye6/BAnbjQ=="\n        crossorigin="anonymous"></script>\n\n\n</head> --><body><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserExtraLabel" data-translate="consulatApp.userExtra.home.createLabel">Cr\xE9er ou \xE9diter un utilisateur</h4></div><div class="modal-body"><div class="form-group" ng-if="!vm.isVue() && vm.esDefini==null"><label mf-required class="control-label col-sm-4" data-translate="consulatApp.userExtra.consulat">Consulat</label><div class="col-sm-6"><select disabled="disabled" required class="form-control" id="field_consulat" name="consulat" ng-model="vm.user.consulatId" ng-options="consulat.id as consulat.nom for consulat in vm.consulats"><option value=""></option></select></div><i title="select organisation" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.user.consulatId" j-list="vm.consulats" j-columns="vm.consulatColums" j-event-name="onLoadConsulat">choose...</i></div><div class="form-group" ng-if="!vm.isVue() && vm.esDefini==null  && vm.utilisateur.id!=null"><label mf-required class="control-label col-sm-4" for="field_profil" data-translate="consulatApp.userExtra.profil">Profil</label><div class="col-sm-6"><select disabled="disabled" required class="form-control" id="field_profil" name="profil" ng-model="vm.user.profilId" ng-options="profil.id as profil.nom for profil in vm.profils"><option value=""></option></select></div><i title="select profil" class="btn btn-primary btn-xs" j-select-dialog j-multiple="false" j-model="vm.user.profilId" j-list="vm.profils" j-columns="vm.profilsColums" j-event-name="onLoadProfil">choose...</i></div><div class="form-group" ng-if="vm.isVue() && vm.esDefini!=null"><label mf-required class="control-label col-sm-4" for="field_consulat" data-translate="consulatApp.userExtra.consulat">Consulat</label><div class="col-sm-6"><input type="text" ng-disabled="vm.isVue()" class="form-control" name="consulat" ng-model="vm.user.consulatNom" required></div></div><div class="form-group" ng-if="vm.isVue() && vm.esDefini!=null"><label mf-required class="control-label col-sm-4" for="field_profil" data-translate="consulatApp.userExtra.profil">Profil</label><div class="col-sm-6"><input type="text" ng-disabled="vm.isVue()" class="form-control" name="lastName" ng-model="vm.user.profilNom" required></div></div><fieldset class="p10 mf-fieldset"><legend data-translate="consulatApp.userExtra.userInfo">Informations de l\'utilisateur</legend><div><br><div class="alert alert-dismissable alert-info"><!--                 <button type="button" class="close"  class="btn btn-danger" data-dismiss="alert" aria-hidden="true">&times;</button>\n --><marquee scrollamount="2" direction="up" height="100" class="text-center"><span>Votre mots de passe devrait \xEAtre d\'une longueur de 8 \xE0 50 caract\xE8res et contenir:</span><br><span class="text-center">- au moins une lettre minuscule</span><br><span class="text-center">- au moins une lettre majuscule</span><br><span class="text-center">- au moins un chiffre</span><br><span class="text-center">- au moins un de ces caract\xE8res sp\xE9ciaux: $ @ % * + - _ !</span><br><span class="text-center">- aucun autre caract\xE8re possible: pas de & ni de { par exemple)</span></marquee><!--                 <p><button id="myButton" type="button" class="btn btn-primary">Fermer</button></p>\n --></div><!-- Fin du bandeau d\'alerte --><script>$(\'#myButton\').click(function(){ /* Apr\xE8s le clic sur l\'\xE9l\xE9ment dont l\'id est "myButton" (le bouton dans notre cas) "*/\n                    $(\'.alert\').alert(\'close\'); /* Faire disparaitre le bandeau d\'alerte*/\n                });</script></div><div class="form-group"><label mf-required class="control-label col-sm-4" data-translate="consulatApp.userExtra.lastName">Last Name</label><div class="col-sm-6"><input type="text" ng-disabled="vm.isVue()" class="form-control" name="lastName" ng-model="vm.user.lastName" required></div></div><div class="form-group"><label mf-required class="control-label col-sm-4" data-translate="consulatApp.userExtra.firstName">First Name</label><div class="col-sm-6"><input type="text" ng-disabled="vm.isVue()" class="form-control" name="firstName" ng-model="vm.user.firstName" required></div></div><div class="form-group"><label mf-required class="control-label col-sm-4">Login</label><div class="col-sm-6"><input ng-disabled="vm.isVue()" type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"></div></div><div class="form-group"><label mf-required class="control-label col-sm-4">Email</label><div class="col-sm-6"><input type="email" ng-disabled="vm.isVue()" type="email" class="form-control" name="mail" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.mail.$dirty && editForm.mail.$invalid"><p class="help-block" ng-show="editForm.mail.$error.email">Your email is invalid.</p><p class="help-block" ng-show="editForm.mail.$error.minlength">minimum required of 5 characters.</p><p class="help-block" ng-show="editForm.mail.$error.maxlength">maximum required of 100 characters.</p></div></div></div><div class="form-group"><label class="control-label col-sm-4" for="field_telephone" data-translate="consulatApp.userExtra.phone">Telephone</label><div class="col-sm-6"><input type="text" ng-disabled="vm.isVue()" class="form-control" name="telephone" id="field_telephone" ng-model="vm.user.telephone" ng-maxlength="20"></div></div><div class="checkbox text-center" ng-if="!vm.isViewing && vm.user.id!=null"><label><input type="checkbox" ng-change="vm.loadProgressBar()" class="checkbox-slider colored-blue checkbox-lg" ng-model="vm.modifPassword"> <span class="text">Modifier Mot de Passe?</span></label></div><div class="form-group" ng-if="vm.modifPassword"><label mf-required class="control-label col-sm-4" for="password" data-translate="consulatApp.userExtra.password">Mot de passe</label><div class="col-sm-6"><input type="password" class="form-control pwd" id="password" name="password" placeholder="Nouveau mot de passe" ng-pattern="/^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[-+!*$@%_])([-+!*$@%_\\w]{8,50})$/" ng-model="vm.user.password" ng-minlength="8" ng-maxlength="50" required><div ng-show="editForm.password.$dirty && editForm.password.$invalid"><p class="help-block" ng-show="editForm.password.$error.pattern">invalid password</p><p class="help-block" ng-show="editForm.password.$error.minlength">minimum required of 8 characters.</p><p class="help-block" ng-show="editForm.password.$error.maxlength">maximum required of 50 characters.</p></div><div class="progress"><div class="progress-bar progress-bar-danger" id="password-progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0"><span class="sr-only">0% Complete (danger)</span> <span id="progress-bar-text" style="color:#000"></span></div></div><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.pattern"></p></div></div></div><div class="form-group" ng-if="vm.modifPassword"><label mf-required class="control-label col-sm-4" for="confirmPassword" data-translate="consulatApp.userExtra.confirmPassword">Confirmation du mot de passe</label><div class="col-sm-6"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirmation du mot de passe" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required></div></div></fieldset></div><div class="modal-footer"><button ng-if="!vm.isVue()" type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="entity.action.cancel">Cancel</span></button> <button ng-if="!vm.isVue()" type="submit" ng-disabled="editForm.$invalid || vm.isSaving || verifalia-classification" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp; <span data-translate="entity.action.save">Save</span></button> <button type="button" ng-if="vm.isVue()" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Fermer</span></button><!-- <button type="button"  class="btn btn-default" data-dismiss="modal" ng-click="vm.test()">\n                <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;\n                <span>tester</span>\n            </button> --></div></form></body>');
$templateCache.put('app/entities/user-extra/user-extra-forgot-pass.html','<head><script defer="defer">window.VerifaliaWidgetConfig = {\n          appKey: \'b56d9ef3d9b84c14aa408cb8ecab57fd\'\n        };</script><script defer="defer" src="https://unpkg.com/verifalia-widget@1.2.0/dist/verifalia-widget.js" integrity="sha512-KNWaWGZz1V4Hm+9e4pdMB0rJ/wOY3ifDIYdfnHyoRnAXtpTxvxU+beMZ6nO//qqPYWcm9uFlIA1eye6/BAnbjQ==" crossorigin="anonymous"></script></head><body data-verifalia-appkey="b56d9ef3d9b84c14aa408cb8ecab57fd"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="form-horizontal"><div class="modal-header"><h4 class="modal-title" id="myUserExtraLabel">Mot de passe oubli\xE9</h4></div><div class="modal-body"><div class="row col-sm-6"><fieldset class="mf-fieldset p10"><legend>Informations de l\'utilisateur</legend><div class="form-group"><label mf-required class="control-label col-sm-4">adresse Email</label><div class="col-sm-4"><input type="email" ng-disabled="vm.isVue()" type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"></div><button title="G\xE9n\xE9rer la cl\xE9 de r\xE9initialisation" class="btn btn-success btn-xs">G\xE9n\xE9rer la cl\xE9...</button></div><div class="form-group"><label mf-required class="control-label col-sm-4">confirmation adresse Email</label><div class="col-sm-4"><input type="email" ng-disabled="vm.isVue()" type="email" class="form-control verifalia-field" name="email" ng-model="vm.user.email" required ng-maxlength="100"></div><button title="G\xE9n\xE9rer la cl\xE9 de r\xE9initialisation" class="btn btn-success btn-xs">G\xE9n\xE9rer la cl\xE9...</button></div></fieldset></div></div></form></body>');
$templateCache.put('app/entities/user-extra/user-extras.html','<div class="container-fluid"><div class="row mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" title="Ajouter" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div><div class="btn-group mr15 col-sm-3 pull-right" uib-dropdown><select class="form-control" id="field_organisation" ng-change="vm.initInfo()" name="organisation" ng-model="vm.organisationId" ng-options="organisation.id as organisation.nom for organisation in vm.organisations" ng-disabled="vm.isViewing"><option value="" data-translate="consulatApp.userExtra.home.consulat"><i>Tous les consulats</i></option></select></div></div><div class="text-center"><span class="h4"><u data-translate="consulatApp.userExtra.home.title">Liste des utilisateurs</u></span></div></div><div class="row"><div><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th>Login</th><th data-translate="consulatApp.userExtra.lastName">Nom</th><th data-translate="consulatApp.userExtra.firstName">Prenom</th><th data-translate="consulatApp.userExtra.consulat">Consulat</th><th data-translate="consulatApp.userExtra.profil">Profil</th><th data-translate="consulatApp.userExtra.etat">Etat</th><th data-translate="consulatApp.userExtra.createBy">Cr\xE9e Par</th><th class="text-right"><span>Actions</span></th></tr></thead><tbody><tr ng-repeat="userExtra in vm.datas "><td title="{{userExtra.userDTO.login}}">{{userExtra.userDTO.login | characters:20}}</td><td title="{{userExtra.userDTO.firstName}}">{{userExtra.userDTO.lastName | characters:20}}</td><td title="{{userExtra.userDTO.lastName}}">{{userExtra.userDTO.firstName | characters:20}}</td><td title="{{userExtra.userExtraDTO.consulatNom}}">{{userExtra.consulatNom | characters:20}}</td><td {{userextra.userextradto.profilnom}}>{{userExtra.profilNom | characters:25}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(userExtra, true)" ng-show="!userExtra.userDTO.activated" data-translate="consulatApp.userExtra.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(userExtra, false)" ng-show="userExtra.userDTO.activated" ng-disabled="vm.currentAccount.login === userExtra.userDTO.login" data-translate="consulatApp.userExtra.activated">Activated</button></td><td title="{{userExtra.userDTO.createdBy}}">{{userExtra.userDTO.createdBy | characters:20}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Consulter" ng-click="vm.detailItem($event,userExtra)" class="btn btn-primary btn-xs btn-round"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" title="Modifier" ng-click="vm.editItem($event,userExtra)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div><div ng-if="vm.currentAccount.login==\'admin\'" class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div><footer ng-if="vm.currentAccount.login==\'admin\'" class="navbar-fixed-bottom text-center h4"><label class="label label-warning text-left h1">Quantit\xE9 Totale :</label><label>: {{vm.totalItems}}</label></footer>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div class="alert alert-danger">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/language/language-selector.tpl.html','<ul class="header-dropdown-list hidden-xs ng-cloak" ng-controller="LanguagesCtrl"><li class="dropdown" dropdown><a class="dropdown-toggle" data-toggle="dropdown" href><img src="styles/img/blank.gif" class="flag flag-{{currentLanguage.key}}" alt="{{currentLanguage.alt}}"> <span>{{currentLanguage.title}} </span><i class="fa fa-angle-down"></i></a><ul class="dropdown-menu pull-right"><li ng-class="{active: language==currentLanguage}" ng-repeat="language in languages"><a ng-click="selectLanguage(language)"><img src="styles/img/blank.gif" class="flag flag-{{language.key}}" alt="{{language.alt}}"> {{language.title}}</a></li></ul></li></ul>');
$templateCache.put('app/entities/zone/zone-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.zone.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this zone?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/zone/zone-detail.html','<div><h2><span>zone</span> {{vm.zone.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Code</span></dt><dd><span>{{vm.zone.code}}</span></dd><dt><span>Libele</span></dt><dd><span>{{vm.zone.libele}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="zone-detail.edit({id:vm.zone.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/zone/zone-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="container-fluid form-horizontal" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Ajouter une Zone</h4></div><div class="modal-body"><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_zone">Code</label><div class="col-sm-6"><input type="text" class="form-control" name="zone" id="field_zone" ng-model="vm.zone.code" ng-disabled="vm.isViewing" required></div></div><div class="form-group has-feedback"><label class="control-label col-sm-3" mf-required for="field_intitule">Libelle</label><div class="col-sm-6"><input type="text" class="form-control" name="intitule" id="field_intitule" ng-model="vm.zone.libelle" ng-disabled="vm.isViewing" required></div></div><div class="form-group"><label class="control-label col-sm-3" for="field_role">Selectionner les \xE9tats associ\xE9s</label><div class="col-sm-6"><select class="form-control" style="height:200px" multiple="multiple" name="authority" id="field_role" ng-click="vm.test()" ng-model="vm.zone.etats.libelle" ng-options="etat.libelle for etat in vm.zone.etats"></select></div><i title="Select states" class="btn btn-primary btn-xs" j-select-dialog j-multiple="true" j-model="vm.etatId" j-list="vm.etats" j-columns="vm.colums" j-event-name="onLoadRoles">Choose...</i></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/zone/zone.html','<div class="container-fluid"><div class="col-sm-10 col-sm-offset-1 mb5"><div class="no-padding-left"><button class="btn btn-primary btn-outline" title="Ajouter" ng-click="vm.addItem()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="entity.action.new">Nouveau</span></button><div class="btn-group mr15" uib-dropdown><button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>{{vm.itemsPerPage}} <span data-translate="global.menu.entities.items">\xE9l\xE9ments par page</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a href="javascript:;" ng-click="vm.setItemsPerPage(15)" data-translate="global.menu.entities.items15">15 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(20)" data-translate="global.menu.entities.items20">20 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(30)" data-translate="global.menu.entities.items30">30 \xE9l\xE9ments par page</a></li><li><a href="javascript:;" ng-click="vm.setItemsPerPage(40)" data-translate="global.menu.entities.items40">40 \xE9l\xE9ments par page</a></li></ul></div></div><div class="text-center"><span class="h4"><u>Zones</u></span></div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><table class="table-responsive table table-hover"><thead><tr class="mf-table-header"><th ng-click="vm.sortBy(\'code\') " class="col-lg-3"><span>Code</span> <span ng-if="vm.isCurrentColumn(\'code\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th ng-click="vm.sortBy(\'libele\') " class="col-lg-3"><span>Libelle</span> <span ng-if="vm.isCurrentColumn(\'libell\')" ng-class="{\'fa fa-sort-amount-asc\':vm.reverse, \'fa fa-sort-amount-desc\': !vm.reverse}"></span></th><th class="text-right"><span>Actions</span></th><th></th></tr></thead><tbody><tr ng-repeat="zone in vm.datas track by zone.id"><td title="{{zone.code}}">{{zone.code | characters:45}}</td><td title="{{zone.libelle}}">{{zone.libelle | characters:45}}</td><td class="text-right"><div class="btn-group flex-btn-group-container mt5"><button type="submit" title="Modifier" ng-click="vm.editItem($event,zone)" class="btn btn-success btn-xs btn-round"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" title="Supprimer" ng-click="vm.deleteItem($event,zone)" class="btn btn-danger btn-xs btn-round"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="center-block text-center" ng-show="vm.canShowPagination()"><uib-pagination total-items="vm.totalItems" ng-model="vm.page" items-per-page="vm.itemsPerPage"></uib-pagination></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="nav navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button><!-- <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()">--><!-- <img class="logo-img" src="content/images/LogoSTH.png" alt="logo"/> --><!-- <span data-translate="global.title">Imanet</span> <span class="navbar-version">v{{VERSION}}</span>  --><!-- </a>--></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><div class="nav navbar-nav navbar-left"></div><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active" has-any-authority="ROLE_USER"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer" has-any-authority="ROLE_USER"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true" has-any-authority="ROLE_USER"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/layouts/navbar/sidebar.html','<!-- sidebar panel --><div class="sidebar-panel" ng-show="vs.isAuthenticated()&&vs.passwordChanged" has-any-authority="ROLE_USER" ng-cloak><div class="brand"><!-- logo --><div class="brand-logo h2 faa-parent animated-hover faa-pulse"><b>MENU</b></div><!-- /logo --><!-- toggle small sidebar menu --> <a href="javascript:;" class="toggle-sidebar hamburger-icon v3 faa-parent animated-hover faa-ring" data-toggle="layout-small-menu"><span class="faa-horizontal"></span> <span class="faa-passing-reverse"></span> <span class="faa-passing"></span> <span class="faa-horizontal"></span> </a><!-- /toggle small sidebar menu --></div><!-- main navigation --><nav role="navigation"><ul class="nav"><li has-any-authority="ROLE_ADMIN,ROLE_CONSULAT,ROLE_USER"><a href="javascript:;"><i class="fa fa-cog"></i> <span data-translate="global.menu.sideBar.settings">Param\xE8tres</span></a><ul class="sub-menu"><li ui-sref-active="active"><a ui-sref="consulat" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.consulat">Consulat</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="country" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.country">Pays</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="states" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.states">Etat</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="city" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.city">Ville</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="zone" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Zone</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="position" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Position Candidat</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_CONSULAT"><a ui-sref="poste" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.poste">Poste</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_CONSULAT"><a ui-sref="metier" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.metier">M\xE9tier</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_CONSULAT"><a ui-sref="type-associations" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.typeAssociation">Type d\'association</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_CONSULAT"><a ui-sref="document-legal" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.documentLegal">Type de document</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_CONSULAT"><a ui-sref="profil" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.profil">Profils</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_CONSULAT"><a ui-sref="user-extra" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.user">Utilisateurs</span></a></li></ul></li><li has-any-authority="ROLE_CONSULAT"><a href="javascript:;" class="faa-parent animated-hover"><i class="fa fa-user-plus faa-falling"></i> <span data-translate="global.menu.sideBar.nationals">Ressortissants</span></a><ul class="sub-menu"><li ui-sref-active="active" has-any-authority="ROLE_CONSULAT"><a ui-sref="members" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.sideBar.addNational">Ajouter un ressortissant</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_CONSULAT"><a ui-sref="members-stats" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.sideBar.view">Consulter</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_CONSULAT"><a ui-sref="carte-historique" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.sideBar.carte">Historique des cartes</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_CONSULAT"><a ui-sref="members-resultat-vote" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>R\xE9sultats des \xE9lections</span></a></li></ul></li><li><a href="javascript:;" class="faa-parent animated-hover" has-any-authority="ROLE_CONSULAT"><i class="fa fa-users faa-falling"></i> <span data-translate="global.menu.entities.association">Association</span></a><ul class="sub-menu"><li ui-sref-active="active" has-any-authority="ROLE_CONSULAT"><a ui-sref="association" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.maj">Maj/Consultation</span></a></li></ul></li><li has-any-authority="ROLE_CONSULAT,ROLE_ASSOCIATION"><a href="javascript:;" class="faa-parent animated-hover"><i class="fa fa-newspaper-o"></i> <span data-translate="global.menu.sideBar.services">Infos et \xE9v\xE8nements</span></a><ul class="sub-menu"><li ui-sref-active="active" has-any-authority="ROLE_CONSULAT,ROLE_ASSOCIATION"><a ui-sref="membre-service" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.maj">Maj/Consultation</span></a></li></ul></li></ul></nav><!-- /main navigation --></div><!-- /sidebar panel -->');
$templateCache.put('app/layouts/partials/footer.tpl.html','<div class="page-footer"><div class="row"><div class="col-xs-12 col-sm-6"><span class="txt-color-white">SmartAdmin WebApp \xA9 2016</span></div><div class="col-xs-6 col-sm-6 text-right hidden-xs"><div class="txt-color-white inline-block"><i class="txt-color-blueLight hidden-mobile">Last account activity <i class="fa fa-clock-o"></i> <strong>52 mins ago &nbsp;</strong></i><div class="btn-group dropup"><button class="btn btn-xs dropdown-toggle bg-color-blue txt-color-white" data-toggle="dropdown"><i class="fa fa-link"></i> <span class="caret"></span></button><ul class="dropdown-menu pull-right text-left"><li><div class="padding-5"><p class="txt-color-darken font-sm no-margin">Download Progress</p><div class="progress progress-micro no-margin"><div class="progress-bar progress-bar-success" style="width: 50%"></div></div></div></li><li class="divider"></li><li><div class="padding-5"><p class="txt-color-darken font-sm no-margin">Server Load</p><div class="progress progress-micro no-margin"><div class="progress-bar progress-bar-success" style="width: 20%"></div></div></div></li><li class="divider"></li><li><div class="padding-5"><p class="txt-color-darken font-sm no-margin">Memory Load <span class="text-danger">*critical*</span></p><div class="progress progress-micro no-margin"><div class="progress-bar progress-bar-danger" style="width: 70%"></div></div></div></li><li class="divider"></li><li><div class="padding-5"><button class="btn btn-block btn-default">refresh</button></div></li></ul></div></div></div></div></div>');
$templateCache.put('app/layouts/partials/header.tpl.html','<header id="header"><div id="logo-group"><!-- PLACE YOUR LOGO HERE --> <span id="logo"><img src="styles/img/logo.png" alt="SmartAdmin"> </span><!-- END LOGO PLACEHOLDER --><!-- Note: The activity badge color changes when clicked and resets the number to 0\n    Suggestion: You may want to set a flag when this happens to tick off all checked messages / notifications --> <span id="activity" class="activity-dropdown" activities-dropdown-toggle><i class="fa fa-user"></i> <b class="badge bg-color-red">21</b></span><div smart-include="app/dashboard/activities/activities.html"></div></div><recent-projects></recent-projects><!-- pulled right: nav area --><div class="pull-right"><!-- collapse menu button --><div id="hide-menu" class="btn-header pull-right"><span><a toggle-menu title="Collapse Menu"><i class="fa fa-reorder"></i></a></span></div><!-- end collapse menu --><!-- #MOBILE --><!-- Top menu profile link : this shows only when top menu is active --><ul id="mobile-profile-img" class="header-dropdown-list hidden-xs padding-5"><li class=""><a href="#" class="dropdown-toggle no-margin userdropdown" data-toggle="dropdown"><img src="styles/img/avatars/sunny.png" alt="John Doe" class="online"></a><ul class="dropdown-menu pull-right"><li><a href-void class="padding-10 padding-top-0 padding-bottom-0"><i class="fa fa-cog"></i> Setting</a></li><li class="divider"></li><li><a ui-sref="app.appViews.profileDemo" class="padding-10 padding-top-0 padding-bottom-0"><i class="fa fa-user"></i> <u>P</u>rofile</a></li><li class="divider"></li><li><a href-void class="padding-10 padding-top-0 padding-bottom-0" data-action="toggleShortcut"><i class="fa fa-arrow-down"></i> <u>S</u>hortcut</a></li><li class="divider"></li><li><a href-void class="padding-10 padding-top-0 padding-bottom-0" data-action="launchFullscreen"><i class="fa fa-arrows-alt"></i> Full <u>S</u>creen</a></li><li class="divider"></li><li><a href="#/login" class="padding-10 padding-top-5 padding-bottom-5" data-action="userLogout"><i class="fa fa-sign-out fa-lg"></i> <strong><u>L</u>ogout</strong></a></li></ul></li></ul><!-- logout button --><div id="logout" class="btn-header transparent pull-right"><span><a ui-sref="login" title="Sign Out" data-action="userLogout" data-logout-msg="You can improve your security further after logging out by closing this opened browser"><i class="fa fa-sign-out"></i></a></span></div><!-- end logout button --><!-- search mobile button (this is hidden till mobile view port) --><div id="search-mobile" class="btn-header transparent pull-right" data-search-mobile><span><a href="#" title="Search"><i class="fa fa-search"></i></a></span></div><!-- end search mobile button --><!-- input: search field --><form action="#/search" class="header-search pull-right"><input id="search-fld" type="text" name="param" placeholder="Find reports and more" data-autocomplete=\'[\n\t\t\t\t\t"ActionScript",\n\t\t\t\t\t"AppleScript",\n\t\t\t\t\t"Asp",\n\t\t\t\t\t"BASIC",\n\t\t\t\t\t"C",\n\t\t\t\t\t"C++",\n\t\t\t\t\t"Clojure",\n\t\t\t\t\t"COBOL",\n\t\t\t\t\t"ColdFusion",\n\t\t\t\t\t"Erlang",\n\t\t\t\t\t"Fortran",\n\t\t\t\t\t"Groovy",\n\t\t\t\t\t"Haskell",\n\t\t\t\t\t"Java",\n\t\t\t\t\t"JavaScript",\n\t\t\t\t\t"Lisp",\n\t\t\t\t\t"Perl",\n\t\t\t\t\t"PHP",\n\t\t\t\t\t"Python",\n\t\t\t\t\t"Ruby",\n\t\t\t\t\t"Scala",\n\t\t\t\t\t"Scheme"]\'> <button type="submit"><i class="fa fa-search"></i></button> <a href="$" id="cancel-search-js" title="Cancel Search"><i class="fa fa-times"></i></a></form><!-- end input: search field --><!-- fullscreen button --><div id="fullscreen" class="btn-header transparent pull-right"><span><a full-screen title="Full Screen"><i class="fa fa-arrows-alt"></i></a></span></div><!-- end fullscreen button --><!-- #Voice Command: Start Speech --><div id="speech-btn" class="btn-header transparent pull-right hidden-sm hidden-xs"><div><a title="Voice Command" id="voice-command-btn" speech-recognition><i class="fa fa-microphone"></i></a><div class="popover bottom"><div class="arrow"></div><div class="popover-content"><h4 class="vc-title">Voice command activated<br><small>Please speak clearly into the mic</small></h4><h4 class="vc-title-error text-center"><i class="fa fa-microphone-slash"></i> Voice command failed<br><small class="txt-color-red">Must <strong>"Allow"</strong> Microphone</small><br><small class="txt-color-red">Must have <strong>Internet Connection</strong></small></h4><a href-void class="btn btn-success" id="speech-help-btn">See Commands</a> <a href-void class="btn bg-color-purple txt-color-white" onclick="$(\'#speech-btn .popover\').fadeOut(50);">Close Popup</a></div></div></div></div><!-- end voice command --><!-- multiple lang dropdown : find all flags in the flags page --><language-selector></language-selector><!-- end multiple lang --></div><!-- end pulled right: nav area --></header>');
$templateCache.put('app/layouts/partials/navigation.tpl.html','<aside id="left-panel"><!-- User info --><div login-info></div><!-- end user info --><nav><!-- NOTE: Notice the gaps after each icon usage <i></i>..\n        Please note that these links work a bit different than\n        traditional href="" links. See documentation for details.\n        --><ul data-smart-menu><li data-menu-collapse><a href="#" title="Dashboard"><i class="fa fa-lg fa-fw fa-home"></i> <span class="menu-item-parent">{{getWord(\'Dashboard\')}}</span></a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.dashboard">{{getWord(\'Analytics Dashboard\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.dashboard-social">{{getWord(\'Social Wall\')}}</a></li></ul></li><li data-menu-collapse class="top-menu-invisible"><a href="#"><i class="fa fa-lg fa-fw fa-cube txt-color-blue"></i> <span class="menu-item-parent">{{getWord(\'SmartAdmin Intel\')}}</span></a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.smartAdmin.appLayouts"><i class="fa fa-gear"></i> {{getWord(\'App Layouts\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.smartAdmin.prebuiltSkins"><i class="fa fa-picture-o"></i> {{getWord(\'Prebuilt Skins\')}}</a></li><!--<li data-ui-sref-active="active">\n                        <a data-ui-sref="app.smartAdmin.appLayout"><i class="fa fa-cube"></i> {{getWord(\'App Settings\')}}</a>\n                    </li>--></ul></li><li data-ui-sref-active="active"><a data-ui-sref="app.inbox.folder" title="Outlook"><i class="fa fa-lg fa-fw fa-inbox"></i> <span class="menu-item-parent">{{getWord(\'Outlook\')}}</span><span unread-messages-count class="badge pull-right inbox-badge"></span></a></li><li data-menu-collapse><a href="#"><i class="fa fa-lg fa-fw fa-bar-chart-o"></i> <span class="menu-item-parent">{{getWord(\'Graphs\')}}</span></a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.graphs.flot">{{getWord(\'Flot Chart\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.graphs.morris">{{getWord(\'Morris Charts\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.graphs.sparkline">{{getWord(\'Sparkline\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.graphs.easyPieCharts">{{getWord(\'Easy Pie Charts\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.graphs.dygraphs">{{getWord(\'Dygraphs\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.graphs.chartjs">Chart.js</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.graphs.highchartTables">Highchart Tables <span class="badge pull-right inbox-badge bg-color-yellow">new</span></a></li></ul></li><li data-menu-collapse><a href="#"><i class="fa fa-lg fa-fw fa-table"></i> <span class="menu-item-parent">{{getWord(\'Tables\')}}</span></a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.tables.normal">{{getWord(\'Normal Tables\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.tables.datatables">{{getWord(\'Data Tables\')}} <span class="badge inbox-badge bg-color-greenLight">v1.10</span></a></li><li data-ui-sref-active="active"><a data-ui-sref="app.tables.jqgrid">{{getWord(\'Jquery Grid\')}}</a></li></ul></li><li data-menu-collapse><a href="#"><i class="fa fa-lg fa-fw fa-pencil-square-o"></i> <span class="menu-item-parent">{{getWord(\'Forms\')}}</span></a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.form.elements">{{getWord(\'Smart Form Elements\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.form.layouts">{{getWord(\'Smart Form Layouts\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.form.validation">{{getWord(\'Smart Form Validation\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.form.bootstrapForms">{{getWord(\'Bootstrap Form Elements\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.form.bootstrapValidation">{{getWord(\'Bootstrap Form Validation\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.form.plugins">{{getWord(\'Form Plugins\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.form.wizards">{{getWord(\'Wizards\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.form.editors">{{getWord(\'Bootstrap Editors\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.form.dropzone">{{getWord(\'Dropzone\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.form.imageEditor">{{getWord(\'Image Cropping\')}} <span class="badge pull-right inbox-badge bg-color-yellow">new</span></a></li></ul></li><li data-menu-collapse><a href="#"><i class="fa fa-lg fa-fw fa-desktop"></i> <span class="menu-item-parent">{{getWord(\'UI Elements\')}}</span></a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.ui.general">{{getWord(\'General Elements\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.ui.buttons">{{getWord(\'Buttons\')}}</a></li><li data-menu-collapse><a href="#">{{getWord(\'Icons\')}}</a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.ui.iconsFa"><i class="fa fa-plane"></i> {{getWord(\'Font Awesome\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.ui.iconsGlyph"><i class="glyphicon glyphicon-plane"></i> {{getWord(\'Glyph Icons\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.ui.iconsFlags"><i class="fa fa-flag"></i> {{getWord(\'Flags\')}}</a></li></ul></li><li data-ui-sref-active="active"><a data-ui-sref="app.ui.grid">{{getWord(\'Grid\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.ui.treeView">{{getWord(\'Tree View\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.ui.nestableLists">{{getWord(\'Nestable Lists\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.ui.jqueryUi">{{getWord(\'JQuery UI\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.ui.typography">{{getWord(\'Typography\')}}</a></li><li data-menu-collapse><a href="#">{{getWord(\'Six Level Menu\')}}</a><ul><li data-menu-collapse><a href="#"><i class="fa fa-fw fa-folder-open"></i> {{getWord(\'Item #2\')}}</a><ul><li data-menu-collapse><a href="#"><i class="fa fa-fw fa-folder-open"></i> {{getWord(\'Sub #2.1\')}}</a><ul><li><a href="#"><i class="fa fa-fw fa-file-text"></i> {{getWord(\'Item #2.1.1\')}}</a></li><li data-menu-collapse><a href="#"><i class="fa fa-fw fa-plus"></i>{{getWord(\'Expand\')}}</a><ul><li><a href="#"><i class="fa fa-fw fa-file-text"></i> {{getWord(\'File\')}}</a></li><li><a href="#"><i class="fa fa-fw fa-trash-o"></i> {{getWord(\'Delete\')}}</a></li></ul></li></ul></li></ul></li><li data-menu-collapse><a href="#"><i class="fa fa-fw fa-folder-open"></i> {{getWord(\'Item #3\')}}</a><ul><li data-menu-collapse><a href="#"><i class="fa fa-fw fa-folder-open"></i> {{getWord(\'3ed Level\')}}</a><ul><li><a href="#"><i class="fa fa-fw fa-file-text"></i> {{getWord(\'File\')}}</a></li><li><a href="#"><i class="fa fa-fw fa-file-text"></i> {{getWord(\'File\')}}</a></li></ul></li></ul></li></ul></li></ul></li><li data-ui-sref-active="active"><a data-ui-sref="app.widgets" title="Widgets"><i class="fa fa-lg fa-fw fa-list-alt"></i><span class="menu-item-parent">{{getWord(\'Widgets\')}}</span></a></li><li data-menu-collapse><a href="#"><i class="fa fa-lg fa-fw fa-cloud"><em>3</em></i> <span class="menu-item-parent">{{getWord(\'Cool Features\')}}</span></a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.calendar" title="Calendar"><i class="fa fa-lg fa-fw fa-calendar"></i> <span class="menu-item-parent">{{getWord(\'Calendar\')}}</span></a></li><li data-ui-sref-active="active"><a data-ui-sref="app.maps"><i class="fa fa-lg fa-fw fa-map-marker"></i> <span class="menu-item-parent">{{getWord(\'GMap Skins\')}}</span><span class="badge bg-color-greenLight pull-right inbox-badge">9</span></a></li></ul></li><li data-menu-collapse><a href="#"><i class="fa fa-lg fa-fw fa-puzzle-piece"></i> <span class="menu-item-parent">{{getWord(\'App Views\')}}</span></a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.appViews.projects"><i class="fa fa-file-text-o"></i> {{getWord(\'Projects\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.appViews.blogDemo"><i class="fa fa-paragraph"></i> {{getWord(\'Blog\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.appViews.galleryDemo"><i class="fa fa-picture-o"></i> {{getWord(\'Gallery\')}}</a></li><li data-menu-collapse><a href="#"><i class="fa fa-comments"></i> {{getWord(\'Forum Layout\')}}</a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.appViews.forumDemo"><i class="fa fa-picture-o"></i> {{getWord(\'General View\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.appViews.forumTopicDemo"><i class="fa fa-picture-o"></i> {{getWord(\'Topic View\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.appViews.forumPostDemo"><i class="fa fa-picture-o"></i> {{getWord(\'Post View\')}}</a></li></ul></li><li data-ui-sref-active="active"><a data-ui-sref="app.appViews.profileDemo"><i class="fa fa-group"></i> {{getWord(\'Profile\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.appViews.timelineDemo"><i class="fa fa-clock-o"></i> {{getWord(\'Timeline\')}}</a></li></ul></li><li data-menu-collapse><a href="#"><i class="fa fa-lg fa-fw fa-shopping-cart"></i> <span class="menu-item-parent">{{getWord(\'E-Commerce\')}}</span></a><ul><li data-ui-sref-active="active"><a data-ui-sref="app.eCommerce.orders" title="Orders">{{getWord(\'Orders\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.eCommerce.products" title="Products View">{{getWord(\'Products View\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.eCommerce.detail" title="Products Detail">{{getWord(\'Products Detail\')}}</a></li></ul></li><li data-menu-collapse><a href="#"><i class="fa fa-lg fa-fw fa-windows"></i> <span class="menu-item-parent">{{getWord(\'Miscellaneous\')}}</span></a><ul><li><a href="http://bootstraphunter.com/smartadmin-landing/" target="_blank">{{getWord(\'Landing Page\')}} <i class="fa fa-external-link"></i></a></li><li data-ui-sref-active="active"><a data-ui-sref="app.misc.pricingTable">{{getWord(\'Pricing Tables\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.misc.invoice">{{getWord(\'Invoice\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="login">{{getWord(\'Login\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="register">{{getWord(\'Register\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="lock">{{getWord(\'Locked Screen\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.misc.error404">{{getWord(\'Error 404\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.misc.error500">{{getWord(\'Error 500\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.misc.blank">{{getWord(\'Blank Page\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.misc.emailTemplate">{{getWord(\'Email Template\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.misc.search">{{getWord(\'Search Page\')}}</a></li><li data-ui-sref-active="active"><a data-ui-sref="app.misc.ckeditor">{{getWord(\'CK Editor\')}}</a></li></ul></li><li data-menu-collapse class="chat-users top-menu-invisible"><a href="#"><i class="fa fa-lg fa-fw fa-comment-o"><em class="bg-color-pink flash animated">!</em></i> <span class="menu-item-parent">{{getWord(\'Smart Chat API\')}} <sup>{{getWord(\'beta\')}}</sup></span></a><div aside-chat-widget></div></li></ul><!-- NOTE: This allows you to pull menu items from server --><!-- <ul data-smart-menu-items="/api/menu-items.json"></ul> --></nav><span class="minifyme" data-action="minifyMenu" minify-menu><i class="fa fa-arrow-circle-left hit"></i></span></aside>');
$templateCache.put('app/layouts/partials/sub-header.tpl.html','<div class="col-xs-12 col-sm-5 col-md-5 col-lg-8" data-sparkline-container><ul id="sparks" class=""><li class="sparks-info"><h5>My Income <span class="txt-color-blue">$47,171</span></h5><div class="sparkline txt-color-blue hidden-mobile hidden-md hidden-sm">1300, 1877, 2500, 2577, 2000, 2100, 3000, 2700, 3631, 2471, 2700, 3631, 2471</div></li><li class="sparks-info"><h5>Site Traffic <span class="txt-color-purple"><i class="fa fa-arrow-circle-up"></i>&nbsp;45%</span></h5><div class="sparkline txt-color-purple hidden-mobile hidden-md hidden-sm">110,150,300,130,400,240,220,310,220,300, 270, 210</div></li><li class="sparks-info"><h5>Site Orders <span class="txt-color-greenDark"><i class="fa fa-shopping-cart"></i>&nbsp;2447</span></h5><div class="sparkline txt-color-greenDark hidden-mobile hidden-md hidden-sm">110,150,300,130,400,240,220,310,220,300, 270, 210</div></li></ul></div>');
$templateCache.put('app/layouts/partials/voice-commands.tpl.html','<!-- TRIGGER BUTTON:\n<a href="/my-ajax-page.html" data-toggle="modal" data-target="#remoteModal" class="btn btn-default">Open Modal</a>  --><!-- MODAL PLACE HOLDER\n<div class="modal fade" id="remoteModal" tabindex="-1" role="dialog" aria-labelledby="remoteModalLabel" aria-hidden="true">\n<div class="modal-dialog">\n<div class="modal-content"></div>\n</div>\n</div>   --><!--////////////////////////////////////--><!--<div class="modal-header">\n<button type="button" class="close" data-dismiss="modal" aria-hidden="true">\n&times;\n</button>\n<h4 class="modal-title" id="myModalLabel">Command List</h4>\n</div>--><div class="modal-body"><h1><i class="fa fa-microphone text-muted"></i>&nbsp;&nbsp; SmartAdmin Voice Command</h1><hr class="simple"><h5>Instruction</h5>Click <span class="text-success">"Allow"</span> to access your microphone and activate Voice Command. You will notice a <span class="text-primary"><strong>BLUE</strong> Flash</span> on the microphone icon indicating activation. The icon will appear <span class="text-danger"><strong>RED</strong></span> <span class="label label-danger"><i class="fa fa-microphone fa-lg"></i></span> if you <span class="text-danger">"Deny"</span> access or don\'t have any microphone installed.<br><br>As a security precaution, your browser will disconnect the microphone every 60 to 120 seconds (sooner if not being used). In which case Voice Command will prompt you again to <span class="text-success">"Allow"</span> or <span class="text-danger">"Deny"</span> access to your microphone.<br><br>If you host your page over <strong>http<span class="text-success">s</span></strong> (secure socket layer) protocol you can wave this security measure and have an unintrupted Voice Command.<br><br><h5>Commands</h5><ul><li><strong>\'show\' </strong>then say the <strong>*page*</strong> you want to go to. For example <strong>"show inbox"</strong> or <strong>"show calendar"</strong></li><li><strong>\'mute\' </strong>- mutes all sound effects for the theme.</li><li><strong>\'sound on\'</strong> - unmutes all sound effects for the theme.</li><li><span class="text-danger"><strong>\'stop\'</strong></span> - deactivates voice command.</li><li><span class="text-primary"><strong>\'help\'</strong></span> - brings up the command list</li><li><span class="text-danger"><strong>\'got it\'</strong></span> - closes help modal</li><li><strong>\'hide navigation\'</strong> - toggle navigation collapse</li><li><strong>\'show navigation\'</strong> - toggle navigation to open (can be used again to close)</li><li><strong>\'scroll up\'</strong> - scrolls to the top of the page</li><li><strong>\'scroll down\'</strong> - scrollts to the bottom of the page</li><li><strong>\'go back\' </strong>- goes back in history (history -1 click)</li><li><strong>\'logout\'</strong> - logs you out</li></ul><br><h5>Adding your own commands</h5>Voice Command supports up to 80 languages. Adding your own commands is extreamly easy. All commands are stored inside <strong>app.config.js</strong> file under the <code>var commands = {...}</code>.<hr class="simple"><div class="text-right"><button type="button" class="btn btn-success btn-lg" data-dismiss="modal">Got it!</button></div></div><!--<div class="modal-footer">\n<button type="button" class="btn btn-primary" data-dismiss="modal">Got it!</button>\n</div> -->');
$templateCache.put('app/components/confirmDialog/confirm-dialog.html','<div class="container-fluid"><div class="modal-header"><h3 class="modal-title">Confirmation</h3></div><div class="modal-body">{{text}}</div><div class="modal-footer"><button class="btn btn-warning" ng-click="cancel()">Cancel</button> <button class="btn btn-primary" ng-click="ok()">OK</button></div></div>');
$templateCache.put('app/components/login/login.html','<head><!-- Bootstrap core CSS --><!-- Custom styles for this template --></head><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button></div><div class="text-center"><span class="text-danger m5" ng-show="vm.authenticationError"><strong>Identifiants invalides</strong></span></div><form role="form" ng-submit="vm.login($event)" class="form form-layout"><div class="wrap-input100 validate-input m-b-26" data-validate="Username is required"><span class="label-input100" mf-required>Username</span> <input class="input100" type="text" name="username" placeholder="Enter username" ng-model="vm.username" required> <span class="focus-input100"></span></div><div class="wrap-input100 validate-input m-b-18" data-validate="Password is required"><span class="label-input100" mf-required>Password</span> <input class="input100" type="password" name="pass" placeholder="Enter password" ng-model="vm.password" required> <span class="focus-input100"></span></div><div class="flex-sb-m w-full p-b-30"><br><div><a href="#" class="txt1">Forgot Password?</a></div></div><br><div class="container-login100-form-btn"><button class="login100-form-btn" type="submit">Login</button></div></form>');
$templateCache.put('app/components/select/select-dialog.html','<div class="container-fluid"><div class="row"><div class="col-sm-12 mf-select-table-container"><table class="table-responsive table table-hover"><caption><input type="text" placeholder="Rechercher..." class="form-control form-control-static" name="filter_field" ng-model="ctrl.query"></caption><thead><tr ng-if="!ctrl.multiple" class="j-table-header"><th style="width:7%"><span ng-if="ctrl.multiple"><input ng-change="ctrl.toggleAll()" type="radio" class="form-control checkbox" ng-model="ctrl.allSelected"></span></th><th ng-repeat="(key, col) in ctrl.columns"><span>{{col.title}}</span></th></tr><tr ng-if="ctrl.multiple" class="j-table-header"><th style="width:7%"><span><input ng-change="ctrl.toggleAll()" type="checkbox" class="form-control checkbox" ng-model="ctrl.allSelected"></span></th><th ng-repeat="(key, col) in ctrl.columns"><span>{{col.title}}</span></th></tr></thead><tbody><tr ng-if="!ctrl.multiple" ng-repeat="item in ctrl.datas|filter:ctrl.query|orderBy:ctrl.columns[0]" ng-click="ctrl.toggle(item)"><td><input type="radio" class="form-control checkbox" ng-checked="ctrl.isChecked(item)"></td><td ng-repeat="(key, col) in ctrl.columns"><span>{{item[col.name]}}</span></td></tr><tr ng-if="ctrl.multiple" ng-repeat="item in ctrl.datas|filter:ctrl.query|orderBy:ctrl.columns[0]" ng-click="ctrl.toggle(item)"><td><input type="checkbox" class="form-control checkbox" ng-checked="ctrl.isChecked(item)"></td><td ng-repeat="(key, col) in ctrl.columns"><span>{{item[col.name]}}</span></td></tr></tbody></table></div></div><button class="btn btn-primary btn-xs" ng-if="ctrl.states==true" title="Ajouter" ng-click="ctrl.addItem()" ng-hide="vm.isViewing"><span class="glyphicon glyphicon-plus">Ajouter...</span> <span class="hidden-xs-down"></span></button> <button class="btn btn-primary btn-xs" ng-if="ctrl.states==false" title="Ajouter" ng-click="ctrl.addItemSecond()" ng-hide="vm.isViewing"><span class="glyphicon glyphicon-plus">Ajouter...</span> <span class="hidden-xs-down"></span></button><div ng-if="ctrl.states==null" class="row p10"><div class="btn-group btn-group-xs pull-right"><button ng-click="ctrl.cancel()" class="btn btn-danger">Annuler</button> <button ng-if="ctrl.multiple" ng-click="ctrl.confirm()" class="btn btn-success"><span class="fa fa-check"></span>&nbsp;Valider</button></div></div><div class="row p10"><div ng-if="ctrl.states!=null" class="btn-group btn-group-xs pull-right"><button ng-click="ctrl.cancel2()" class="btn btn-danger">Annuler</button> <button ng-if="ctrl.multiple" ng-click="ctrl.confirm2()" class="btn btn-success"><span class="fa fa-check"></span>&nbsp;Valider</button></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>R\xE9initialiser votre mot de passe</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>L\'adresse \xE9lectronique n\'est pas enregistr\xE9e!</strong> Veuillez v\xE9rifier votre adresse.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Entrer l\'adresse email utilis\xE9e lors de l\'enregistrement.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p>Consultez vos e-mails pour savoir comment r\xE9initialiser votre mot de passe.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="Your email" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button></form></div></div></div>');}]);})();